var Su = Object.defineProperty;
var Iu = (r, t, e) => t in r ? Su(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var ae = (r, t, e) => (Iu(r, typeof t != "symbol" ? t + "" : t, e), e);
var Ee = /* @__PURE__ */ ((r) => (r.SOLANA = "SOLANA", r.POLYGON = "POLYGON", r.ETHEREUM = "ETHEREUM", r.ARBITUM_ONE = "ARBITUM_ONE", r.AURORA = "AURORA", r.AVALANCHE = "AVALANCHE", r.BNB_SMART = "BNB_SMART", r.FANTOM = "FANTOM", r.HARMONY = "HARMONY", r.OPTIMISM = "OPTIMISM", r.PALM = "PALM", r.APECHAIN = "APECHAIN", r))(Ee || {}), ze = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ai(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Ni(r) {
  if (r.__esModule)
    return r;
  var t = r.default;
  if (typeof t == "function") {
    var e = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else
    e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(e, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), e;
}
var lt = {}, wr = {};
wr.byteLength = bu;
wr.toByteArray = Au;
wr.fromByteArray = Tu;
var Ye = [], ke = [], xu = typeof Uint8Array < "u" ? Uint8Array : Array, Jr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var En = 0, ju = Jr.length; En < ju; ++En)
  Ye[En] = Jr[En], ke[Jr.charCodeAt(En)] = En;
ke["-".charCodeAt(0)] = 62;
ke["_".charCodeAt(0)] = 63;
function Ys(r) {
  var t = r.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var e = r.indexOf("=");
  e === -1 && (e = t);
  var n = e === t ? 0 : 4 - e % 4;
  return [e, n];
}
function bu(r) {
  var t = Ys(r), e = t[0], n = t[1];
  return (e + n) * 3 / 4 - n;
}
function Eu(r, t, e) {
  return (t + e) * 3 / 4 - e;
}
function Au(r) {
  var t, e = Ys(r), n = e[0], s = e[1], i = new xu(Eu(r, n, s)), o = 0, a = s > 0 ? n - 4 : n, d;
  for (d = 0; d < a; d += 4)
    t = ke[r.charCodeAt(d)] << 18 | ke[r.charCodeAt(d + 1)] << 12 | ke[r.charCodeAt(d + 2)] << 6 | ke[r.charCodeAt(d + 3)], i[o++] = t >> 16 & 255, i[o++] = t >> 8 & 255, i[o++] = t & 255;
  return s === 2 && (t = ke[r.charCodeAt(d)] << 2 | ke[r.charCodeAt(d + 1)] >> 4, i[o++] = t & 255), s === 1 && (t = ke[r.charCodeAt(d)] << 10 | ke[r.charCodeAt(d + 1)] << 4 | ke[r.charCodeAt(d + 2)] >> 2, i[o++] = t >> 8 & 255, i[o++] = t & 255), i;
}
function Nu(r) {
  return Ye[r >> 18 & 63] + Ye[r >> 12 & 63] + Ye[r >> 6 & 63] + Ye[r & 63];
}
function vu(r, t, e) {
  for (var n, s = [], i = t; i < e; i += 3)
    n = (r[i] << 16 & 16711680) + (r[i + 1] << 8 & 65280) + (r[i + 2] & 255), s.push(Nu(n));
  return s.join("");
}
function Tu(r) {
  for (var t, e = r.length, n = e % 3, s = [], i = 16383, o = 0, a = e - n; o < a; o += i)
    s.push(vu(r, o, o + i > a ? a : o + i));
  return n === 1 ? (t = r[e - 1], s.push(
    Ye[t >> 2] + Ye[t << 4 & 63] + "=="
  )) : n === 2 && (t = (r[e - 2] << 8) + r[e - 1], s.push(
    Ye[t >> 10] + Ye[t >> 4 & 63] + Ye[t << 2 & 63] + "="
  )), s.join("");
}
var vi = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
vi.read = function(r, t, e, n, s) {
  var i, o, a = s * 8 - n - 1, d = (1 << a) - 1, L = d >> 1, I = -7, b = e ? s - 1 : 0, O = e ? -1 : 1, v = r[t + b];
  for (b += O, i = v & (1 << -I) - 1, v >>= -I, I += a; I > 0; i = i * 256 + r[t + b], b += O, I -= 8)
    ;
  for (o = i & (1 << -I) - 1, i >>= -I, I += n; I > 0; o = o * 256 + r[t + b], b += O, I -= 8)
    ;
  if (i === 0)
    i = 1 - L;
  else {
    if (i === d)
      return o ? NaN : (v ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), i = i - L;
  }
  return (v ? -1 : 1) * o * Math.pow(2, i - n);
};
vi.write = function(r, t, e, n, s, i) {
  var o, a, d, L = i * 8 - s - 1, I = (1 << L) - 1, b = I >> 1, O = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = n ? 0 : i - 1, B = n ? 1 : -1, E = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = I) : (o = Math.floor(Math.log(t) / Math.LN2), t * (d = Math.pow(2, -o)) < 1 && (o--, d *= 2), o + b >= 1 ? t += O / d : t += O * Math.pow(2, 1 - b), t * d >= 2 && (o++, d /= 2), o + b >= I ? (a = 0, o = I) : o + b >= 1 ? (a = (t * d - 1) * Math.pow(2, s), o = o + b) : (a = t * Math.pow(2, b - 1) * Math.pow(2, s), o = 0)); s >= 8; r[e + v] = a & 255, v += B, a /= 256, s -= 8)
    ;
  for (o = o << s | a, L += s; L > 0; r[e + v] = o & 255, v += B, o /= 256, L -= 8)
    ;
  r[e + v - B] |= E * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(r) {
  const t = wr, e = vi, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  r.Buffer = a, r.SlowBuffer = U, r.INSPECT_MAX_BYTES = 50;
  const s = 2147483647;
  r.kMaxLength = s, a.TYPED_ARRAY_SUPPORT = i(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const g = new Uint8Array(1), c = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(g, c), g.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(g) {
    if (g > s)
      throw new RangeError('The value "' + g + '" is invalid for option "size"');
    const c = new Uint8Array(g);
    return Object.setPrototypeOf(c, a.prototype), c;
  }
  function a(g, c, l) {
    if (typeof g == "number") {
      if (typeof c == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return b(g);
    }
    return d(g, c, l);
  }
  a.poolSize = 8192;
  function d(g, c, l) {
    if (typeof g == "string")
      return O(g, c);
    if (ArrayBuffer.isView(g))
      return B(g);
    if (g == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
      );
    if (ye(g, ArrayBuffer) || g && ye(g.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ye(g, SharedArrayBuffer) || g && ye(g.buffer, SharedArrayBuffer)))
      return E(g, c, l);
    if (typeof g == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const w = g.valueOf && g.valueOf();
    if (w != null && w !== g)
      return a.from(w, c, l);
    const T = N(g);
    if (T)
      return T;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof g[Symbol.toPrimitive] == "function")
      return a.from(g[Symbol.toPrimitive]("string"), c, l);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
    );
  }
  a.from = function(g, c, l) {
    return d(g, c, l);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function L(g) {
    if (typeof g != "number")
      throw new TypeError('"size" argument must be of type number');
    if (g < 0)
      throw new RangeError('The value "' + g + '" is invalid for option "size"');
  }
  function I(g, c, l) {
    return L(g), g <= 0 ? o(g) : c !== void 0 ? typeof l == "string" ? o(g).fill(c, l) : o(g).fill(c) : o(g);
  }
  a.alloc = function(g, c, l) {
    return I(g, c, l);
  };
  function b(g) {
    return L(g), o(g < 0 ? 0 : _(g) | 0);
  }
  a.allocUnsafe = function(g) {
    return b(g);
  }, a.allocUnsafeSlow = function(g) {
    return b(g);
  };
  function O(g, c) {
    if ((typeof c != "string" || c === "") && (c = "utf8"), !a.isEncoding(c))
      throw new TypeError("Unknown encoding: " + c);
    const l = z(g, c) | 0;
    let w = o(l);
    const T = w.write(g, c);
    return T !== l && (w = w.slice(0, T)), w;
  }
  function v(g) {
    const c = g.length < 0 ? 0 : _(g.length) | 0, l = o(c);
    for (let w = 0; w < c; w += 1)
      l[w] = g[w] & 255;
    return l;
  }
  function B(g) {
    if (ye(g, Uint8Array)) {
      const c = new Uint8Array(g);
      return E(c.buffer, c.byteOffset, c.byteLength);
    }
    return v(g);
  }
  function E(g, c, l) {
    if (c < 0 || g.byteLength < c)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (g.byteLength < c + (l || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let w;
    return c === void 0 && l === void 0 ? w = new Uint8Array(g) : l === void 0 ? w = new Uint8Array(g, c) : w = new Uint8Array(g, c, l), Object.setPrototypeOf(w, a.prototype), w;
  }
  function N(g) {
    if (a.isBuffer(g)) {
      const c = _(g.length) | 0, l = o(c);
      return l.length === 0 || g.copy(l, 0, 0, c), l;
    }
    if (g.length !== void 0)
      return typeof g.length != "number" || vt(g.length) ? o(0) : v(g);
    if (g.type === "Buffer" && Array.isArray(g.data))
      return v(g.data);
  }
  function _(g) {
    if (g >= s)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
    return g | 0;
  }
  function U(g) {
    return +g != g && (g = 0), a.alloc(+g);
  }
  a.isBuffer = function(c) {
    return c != null && c._isBuffer === !0 && c !== a.prototype;
  }, a.compare = function(c, l) {
    if (ye(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), ye(l, Uint8Array) && (l = a.from(l, l.offset, l.byteLength)), !a.isBuffer(c) || !a.isBuffer(l))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (c === l)
      return 0;
    let w = c.length, T = l.length;
    for (let k = 0, R = Math.min(w, T); k < R; ++k)
      if (c[k] !== l[k]) {
        w = c[k], T = l[k];
        break;
      }
    return w < T ? -1 : T < w ? 1 : 0;
  }, a.isEncoding = function(c) {
    switch (String(c).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(c, l) {
    if (!Array.isArray(c))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (c.length === 0)
      return a.alloc(0);
    let w;
    if (l === void 0)
      for (l = 0, w = 0; w < c.length; ++w)
        l += c[w].length;
    const T = a.allocUnsafe(l);
    let k = 0;
    for (w = 0; w < c.length; ++w) {
      let R = c[w];
      if (ye(R, Uint8Array))
        k + R.length > T.length ? (a.isBuffer(R) || (R = a.from(R)), R.copy(T, k)) : Uint8Array.prototype.set.call(
          T,
          R,
          k
        );
      else if (a.isBuffer(R))
        R.copy(T, k);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      k += R.length;
    }
    return T;
  };
  function z(g, c) {
    if (a.isBuffer(g))
      return g.length;
    if (ArrayBuffer.isView(g) || ye(g, ArrayBuffer))
      return g.byteLength;
    if (typeof g != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof g
      );
    const l = g.length, w = arguments.length > 2 && arguments[2] === !0;
    if (!w && l === 0)
      return 0;
    let T = !1;
    for (; ; )
      switch (c) {
        case "ascii":
        case "latin1":
        case "binary":
          return l;
        case "utf8":
        case "utf-8":
          return At(g).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return l * 2;
        case "hex":
          return l >>> 1;
        case "base64":
          return Bt(g).length;
        default:
          if (T)
            return w ? -1 : At(g).length;
          c = ("" + c).toLowerCase(), T = !0;
      }
  }
  a.byteLength = z;
  function q(g, c, l) {
    let w = !1;
    if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((l === void 0 || l > this.length) && (l = this.length), l <= 0) || (l >>>= 0, c >>>= 0, l <= c))
      return "";
    for (g || (g = "utf8"); ; )
      switch (g) {
        case "hex":
          return m(this, c, l);
        case "utf8":
        case "utf-8":
          return u(this, c, l);
        case "ascii":
          return S(this, c, l);
        case "latin1":
        case "binary":
          return M(this, c, l);
        case "base64":
          return j(this, c, l);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return A(this, c, l);
        default:
          if (w)
            throw new TypeError("Unknown encoding: " + g);
          g = (g + "").toLowerCase(), w = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function P(g, c, l) {
    const w = g[c];
    g[c] = g[l], g[l] = w;
  }
  a.prototype.swap16 = function() {
    const c = this.length;
    if (c % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let l = 0; l < c; l += 2)
      P(this, l, l + 1);
    return this;
  }, a.prototype.swap32 = function() {
    const c = this.length;
    if (c % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let l = 0; l < c; l += 4)
      P(this, l, l + 3), P(this, l + 1, l + 2);
    return this;
  }, a.prototype.swap64 = function() {
    const c = this.length;
    if (c % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let l = 0; l < c; l += 8)
      P(this, l, l + 7), P(this, l + 1, l + 6), P(this, l + 2, l + 5), P(this, l + 3, l + 4);
    return this;
  }, a.prototype.toString = function() {
    const c = this.length;
    return c === 0 ? "" : arguments.length === 0 ? u(this, 0, c) : q.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(c) {
    if (!a.isBuffer(c))
      throw new TypeError("Argument must be a Buffer");
    return this === c ? !0 : a.compare(this, c) === 0;
  }, a.prototype.inspect = function() {
    let c = "";
    const l = r.INSPECT_MAX_BYTES;
    return c = this.toString("hex", 0, l).replace(/(.{2})/g, "$1 ").trim(), this.length > l && (c += " ... "), "<Buffer " + c + ">";
  }, n && (a.prototype[n] = a.prototype.inspect), a.prototype.compare = function(c, l, w, T, k) {
    if (ye(c, Uint8Array) && (c = a.from(c, c.offset, c.byteLength)), !a.isBuffer(c))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c
      );
    if (l === void 0 && (l = 0), w === void 0 && (w = c ? c.length : 0), T === void 0 && (T = 0), k === void 0 && (k = this.length), l < 0 || w > c.length || T < 0 || k > this.length)
      throw new RangeError("out of range index");
    if (T >= k && l >= w)
      return 0;
    if (T >= k)
      return -1;
    if (l >= w)
      return 1;
    if (l >>>= 0, w >>>= 0, T >>>= 0, k >>>= 0, this === c)
      return 0;
    let R = k - T, ht = w - l;
    const ft = Math.min(R, ht), ct = this.slice(T, k), Ct = c.slice(l, w);
    for (let at = 0; at < ft; ++at)
      if (ct[at] !== Ct[at]) {
        R = ct[at], ht = Ct[at];
        break;
      }
    return R < ht ? -1 : ht < R ? 1 : 0;
  };
  function F(g, c, l, w, T) {
    if (g.length === 0)
      return -1;
    if (typeof l == "string" ? (w = l, l = 0) : l > 2147483647 ? l = 2147483647 : l < -2147483648 && (l = -2147483648), l = +l, vt(l) && (l = T ? 0 : g.length - 1), l < 0 && (l = g.length + l), l >= g.length) {
      if (T)
        return -1;
      l = g.length - 1;
    } else if (l < 0)
      if (T)
        l = 0;
      else
        return -1;
    if (typeof c == "string" && (c = a.from(c, w)), a.isBuffer(c))
      return c.length === 0 ? -1 : V(g, c, l, w, T);
    if (typeof c == "number")
      return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? T ? Uint8Array.prototype.indexOf.call(g, c, l) : Uint8Array.prototype.lastIndexOf.call(g, c, l) : V(g, [c], l, w, T);
    throw new TypeError("val must be string, number or Buffer");
  }
  function V(g, c, l, w, T) {
    let k = 1, R = g.length, ht = c.length;
    if (w !== void 0 && (w = String(w).toLowerCase(), w === "ucs2" || w === "ucs-2" || w === "utf16le" || w === "utf-16le")) {
      if (g.length < 2 || c.length < 2)
        return -1;
      k = 2, R /= 2, ht /= 2, l /= 2;
    }
    function ft(Ct, at) {
      return k === 1 ? Ct[at] : Ct.readUInt16BE(at * k);
    }
    let ct;
    if (T) {
      let Ct = -1;
      for (ct = l; ct < R; ct++)
        if (ft(g, ct) === ft(c, Ct === -1 ? 0 : ct - Ct)) {
          if (Ct === -1 && (Ct = ct), ct - Ct + 1 === ht)
            return Ct * k;
        } else
          Ct !== -1 && (ct -= ct - Ct), Ct = -1;
    } else
      for (l + ht > R && (l = R - ht), ct = l; ct >= 0; ct--) {
        let Ct = !0;
        for (let at = 0; at < ht; at++)
          if (ft(g, ct + at) !== ft(c, at)) {
            Ct = !1;
            break;
          }
        if (Ct)
          return ct;
      }
    return -1;
  }
  a.prototype.includes = function(c, l, w) {
    return this.indexOf(c, l, w) !== -1;
  }, a.prototype.indexOf = function(c, l, w) {
    return F(this, c, l, w, !0);
  }, a.prototype.lastIndexOf = function(c, l, w) {
    return F(this, c, l, w, !1);
  };
  function J(g, c, l, w) {
    l = Number(l) || 0;
    const T = g.length - l;
    w ? (w = Number(w), w > T && (w = T)) : w = T;
    const k = c.length;
    w > k / 2 && (w = k / 2);
    let R;
    for (R = 0; R < w; ++R) {
      const ht = parseInt(c.substr(R * 2, 2), 16);
      if (vt(ht))
        return R;
      g[l + R] = ht;
    }
    return R;
  }
  function xt(g, c, l, w) {
    return Nt(At(c, g.length - l), g, l, w);
  }
  function Mt(g, c, l, w) {
    return Nt(_t(c), g, l, w);
  }
  function X(g, c, l, w) {
    return Nt(Bt(c), g, l, w);
  }
  function jt(g, c, l, w) {
    return Nt(bn(c, g.length - l), g, l, w);
  }
  a.prototype.write = function(c, l, w, T) {
    if (l === void 0)
      T = "utf8", w = this.length, l = 0;
    else if (w === void 0 && typeof l == "string")
      T = l, w = this.length, l = 0;
    else if (isFinite(l))
      l = l >>> 0, isFinite(w) ? (w = w >>> 0, T === void 0 && (T = "utf8")) : (T = w, w = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const k = this.length - l;
    if ((w === void 0 || w > k) && (w = k), c.length > 0 && (w < 0 || l < 0) || l > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    T || (T = "utf8");
    let R = !1;
    for (; ; )
      switch (T) {
        case "hex":
          return J(this, c, l, w);
        case "utf8":
        case "utf-8":
          return xt(this, c, l, w);
        case "ascii":
        case "latin1":
        case "binary":
          return Mt(this, c, l, w);
        case "base64":
          return X(this, c, l, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return jt(this, c, l, w);
        default:
          if (R)
            throw new TypeError("Unknown encoding: " + T);
          T = ("" + T).toLowerCase(), R = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function j(g, c, l) {
    return c === 0 && l === g.length ? t.fromByteArray(g) : t.fromByteArray(g.slice(c, l));
  }
  function u(g, c, l) {
    l = Math.min(g.length, l);
    const w = [];
    let T = c;
    for (; T < l; ) {
      const k = g[T];
      let R = null, ht = k > 239 ? 4 : k > 223 ? 3 : k > 191 ? 2 : 1;
      if (T + ht <= l) {
        let ft, ct, Ct, at;
        switch (ht) {
          case 1:
            k < 128 && (R = k);
            break;
          case 2:
            ft = g[T + 1], (ft & 192) === 128 && (at = (k & 31) << 6 | ft & 63, at > 127 && (R = at));
            break;
          case 3:
            ft = g[T + 1], ct = g[T + 2], (ft & 192) === 128 && (ct & 192) === 128 && (at = (k & 15) << 12 | (ft & 63) << 6 | ct & 63, at > 2047 && (at < 55296 || at > 57343) && (R = at));
            break;
          case 4:
            ft = g[T + 1], ct = g[T + 2], Ct = g[T + 3], (ft & 192) === 128 && (ct & 192) === 128 && (Ct & 192) === 128 && (at = (k & 15) << 18 | (ft & 63) << 12 | (ct & 63) << 6 | Ct & 63, at > 65535 && at < 1114112 && (R = at));
        }
      }
      R === null ? (R = 65533, ht = 1) : R > 65535 && (R -= 65536, w.push(R >>> 10 & 1023 | 55296), R = 56320 | R & 1023), w.push(R), T += ht;
    }
    return y(w);
  }
  const h = 4096;
  function y(g) {
    const c = g.length;
    if (c <= h)
      return String.fromCharCode.apply(String, g);
    let l = "", w = 0;
    for (; w < c; )
      l += String.fromCharCode.apply(
        String,
        g.slice(w, w += h)
      );
    return l;
  }
  function S(g, c, l) {
    let w = "";
    l = Math.min(g.length, l);
    for (let T = c; T < l; ++T)
      w += String.fromCharCode(g[T] & 127);
    return w;
  }
  function M(g, c, l) {
    let w = "";
    l = Math.min(g.length, l);
    for (let T = c; T < l; ++T)
      w += String.fromCharCode(g[T]);
    return w;
  }
  function m(g, c, l) {
    const w = g.length;
    (!c || c < 0) && (c = 0), (!l || l < 0 || l > w) && (l = w);
    let T = "";
    for (let k = c; k < l; ++k)
      T += Tt[g[k]];
    return T;
  }
  function A(g, c, l) {
    const w = g.slice(c, l);
    let T = "";
    for (let k = 0; k < w.length - 1; k += 2)
      T += String.fromCharCode(w[k] + w[k + 1] * 256);
    return T;
  }
  a.prototype.slice = function(c, l) {
    const w = this.length;
    c = ~~c, l = l === void 0 ? w : ~~l, c < 0 ? (c += w, c < 0 && (c = 0)) : c > w && (c = w), l < 0 ? (l += w, l < 0 && (l = 0)) : l > w && (l = w), l < c && (l = c);
    const T = this.subarray(c, l);
    return Object.setPrototypeOf(T, a.prototype), T;
  };
  function p(g, c, l) {
    if (g % 1 !== 0 || g < 0)
      throw new RangeError("offset is not uint");
    if (g + c > l)
      throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(c, l, w) {
    c = c >>> 0, l = l >>> 0, w || p(c, l, this.length);
    let T = this[c], k = 1, R = 0;
    for (; ++R < l && (k *= 256); )
      T += this[c + R] * k;
    return T;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(c, l, w) {
    c = c >>> 0, l = l >>> 0, w || p(c, l, this.length);
    let T = this[c + --l], k = 1;
    for (; l > 0 && (k *= 256); )
      T += this[c + --l] * k;
    return T;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(c, l) {
    return c = c >>> 0, l || p(c, 1, this.length), this[c];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(c, l) {
    return c = c >>> 0, l || p(c, 2, this.length), this[c] | this[c + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(c, l) {
    return c = c >>> 0, l || p(c, 2, this.length), this[c] << 8 | this[c + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
  }, a.prototype.readBigUInt64LE = Ie(function(c) {
    c = c >>> 0, St(c, "offset");
    const l = this[c], w = this[c + 7];
    (l === void 0 || w === void 0) && Lt(c, this.length - 8);
    const T = l + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24, k = this[++c] + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + w * 2 ** 24;
    return BigInt(T) + (BigInt(k) << BigInt(32));
  }), a.prototype.readBigUInt64BE = Ie(function(c) {
    c = c >>> 0, St(c, "offset");
    const l = this[c], w = this[c + 7];
    (l === void 0 || w === void 0) && Lt(c, this.length - 8);
    const T = l * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c], k = this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + w;
    return (BigInt(T) << BigInt(32)) + BigInt(k);
  }), a.prototype.readIntLE = function(c, l, w) {
    c = c >>> 0, l = l >>> 0, w || p(c, l, this.length);
    let T = this[c], k = 1, R = 0;
    for (; ++R < l && (k *= 256); )
      T += this[c + R] * k;
    return k *= 128, T >= k && (T -= Math.pow(2, 8 * l)), T;
  }, a.prototype.readIntBE = function(c, l, w) {
    c = c >>> 0, l = l >>> 0, w || p(c, l, this.length);
    let T = l, k = 1, R = this[c + --T];
    for (; T > 0 && (k *= 256); )
      R += this[c + --T] * k;
    return k *= 128, R >= k && (R -= Math.pow(2, 8 * l)), R;
  }, a.prototype.readInt8 = function(c, l) {
    return c = c >>> 0, l || p(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
  }, a.prototype.readInt16LE = function(c, l) {
    c = c >>> 0, l || p(c, 2, this.length);
    const w = this[c] | this[c + 1] << 8;
    return w & 32768 ? w | 4294901760 : w;
  }, a.prototype.readInt16BE = function(c, l) {
    c = c >>> 0, l || p(c, 2, this.length);
    const w = this[c + 1] | this[c] << 8;
    return w & 32768 ? w | 4294901760 : w;
  }, a.prototype.readInt32LE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
  }, a.prototype.readInt32BE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
  }, a.prototype.readBigInt64LE = Ie(function(c) {
    c = c >>> 0, St(c, "offset");
    const l = this[c], w = this[c + 7];
    (l === void 0 || w === void 0) && Lt(c, this.length - 8);
    const T = this[c + 4] + this[c + 5] * 2 ** 8 + this[c + 6] * 2 ** 16 + (w << 24);
    return (BigInt(T) << BigInt(32)) + BigInt(l + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24);
  }), a.prototype.readBigInt64BE = Ie(function(c) {
    c = c >>> 0, St(c, "offset");
    const l = this[c], w = this[c + 7];
    (l === void 0 || w === void 0) && Lt(c, this.length - 8);
    const T = (l << 24) + // Overflow
    this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c];
    return (BigInt(T) << BigInt(32)) + BigInt(this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + w);
  }), a.prototype.readFloatLE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), e.read(this, c, !0, 23, 4);
  }, a.prototype.readFloatBE = function(c, l) {
    return c = c >>> 0, l || p(c, 4, this.length), e.read(this, c, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(c, l) {
    return c = c >>> 0, l || p(c, 8, this.length), e.read(this, c, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(c, l) {
    return c = c >>> 0, l || p(c, 8, this.length), e.read(this, c, !1, 52, 8);
  };
  function f(g, c, l, w, T, k) {
    if (!a.isBuffer(g))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (c > T || c < k)
      throw new RangeError('"value" argument is out of bounds');
    if (l + w > g.length)
      throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(c, l, w, T) {
    if (c = +c, l = l >>> 0, w = w >>> 0, !T) {
      const ht = Math.pow(2, 8 * w) - 1;
      f(this, c, l, w, ht, 0);
    }
    let k = 1, R = 0;
    for (this[l] = c & 255; ++R < w && (k *= 256); )
      this[l + R] = c / k & 255;
    return l + w;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(c, l, w, T) {
    if (c = +c, l = l >>> 0, w = w >>> 0, !T) {
      const ht = Math.pow(2, 8 * w) - 1;
      f(this, c, l, w, ht, 0);
    }
    let k = w - 1, R = 1;
    for (this[l + k] = c & 255; --k >= 0 && (R *= 256); )
      this[l + k] = c / R & 255;
    return l + w;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 1, 255, 0), this[l] = c & 255, l + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 2, 65535, 0), this[l] = c & 255, this[l + 1] = c >>> 8, l + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 2, 65535, 0), this[l] = c >>> 8, this[l + 1] = c & 255, l + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 4, 4294967295, 0), this[l + 3] = c >>> 24, this[l + 2] = c >>> 16, this[l + 1] = c >>> 8, this[l] = c & 255, l + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 4, 4294967295, 0), this[l] = c >>> 24, this[l + 1] = c >>> 16, this[l + 2] = c >>> 8, this[l + 3] = c & 255, l + 4;
  };
  function x(g, c, l, w, T) {
    pt(c, w, T, g, l, 7);
    let k = Number(c & BigInt(4294967295));
    g[l++] = k, k = k >> 8, g[l++] = k, k = k >> 8, g[l++] = k, k = k >> 8, g[l++] = k;
    let R = Number(c >> BigInt(32) & BigInt(4294967295));
    return g[l++] = R, R = R >> 8, g[l++] = R, R = R >> 8, g[l++] = R, R = R >> 8, g[l++] = R, l;
  }
  function H(g, c, l, w, T) {
    pt(c, w, T, g, l, 7);
    let k = Number(c & BigInt(4294967295));
    g[l + 7] = k, k = k >> 8, g[l + 6] = k, k = k >> 8, g[l + 5] = k, k = k >> 8, g[l + 4] = k;
    let R = Number(c >> BigInt(32) & BigInt(4294967295));
    return g[l + 3] = R, R = R >> 8, g[l + 2] = R, R = R >> 8, g[l + 1] = R, R = R >> 8, g[l] = R, l + 8;
  }
  a.prototype.writeBigUInt64LE = Ie(function(c, l = 0) {
    return x(this, c, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeBigUInt64BE = Ie(function(c, l = 0) {
    return H(this, c, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeIntLE = function(c, l, w, T) {
    if (c = +c, l = l >>> 0, !T) {
      const ft = Math.pow(2, 8 * w - 1);
      f(this, c, l, w, ft - 1, -ft);
    }
    let k = 0, R = 1, ht = 0;
    for (this[l] = c & 255; ++k < w && (R *= 256); )
      c < 0 && ht === 0 && this[l + k - 1] !== 0 && (ht = 1), this[l + k] = (c / R >> 0) - ht & 255;
    return l + w;
  }, a.prototype.writeIntBE = function(c, l, w, T) {
    if (c = +c, l = l >>> 0, !T) {
      const ft = Math.pow(2, 8 * w - 1);
      f(this, c, l, w, ft - 1, -ft);
    }
    let k = w - 1, R = 1, ht = 0;
    for (this[l + k] = c & 255; --k >= 0 && (R *= 256); )
      c < 0 && ht === 0 && this[l + k + 1] !== 0 && (ht = 1), this[l + k] = (c / R >> 0) - ht & 255;
    return l + w;
  }, a.prototype.writeInt8 = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[l] = c & 255, l + 1;
  }, a.prototype.writeInt16LE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 2, 32767, -32768), this[l] = c & 255, this[l + 1] = c >>> 8, l + 2;
  }, a.prototype.writeInt16BE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 2, 32767, -32768), this[l] = c >>> 8, this[l + 1] = c & 255, l + 2;
  }, a.prototype.writeInt32LE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 4, 2147483647, -2147483648), this[l] = c & 255, this[l + 1] = c >>> 8, this[l + 2] = c >>> 16, this[l + 3] = c >>> 24, l + 4;
  }, a.prototype.writeInt32BE = function(c, l, w) {
    return c = +c, l = l >>> 0, w || f(this, c, l, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[l] = c >>> 24, this[l + 1] = c >>> 16, this[l + 2] = c >>> 8, this[l + 3] = c & 255, l + 4;
  }, a.prototype.writeBigInt64LE = Ie(function(c, l = 0) {
    return x(this, c, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), a.prototype.writeBigInt64BE = Ie(function(c, l = 0) {
    return H(this, c, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function W(g, c, l, w, T, k) {
    if (l + w > g.length)
      throw new RangeError("Index out of range");
    if (l < 0)
      throw new RangeError("Index out of range");
  }
  function Z(g, c, l, w, T) {
    return c = +c, l = l >>> 0, T || W(g, c, l, 4), e.write(g, c, l, w, 23, 4), l + 4;
  }
  a.prototype.writeFloatLE = function(c, l, w) {
    return Z(this, c, l, !0, w);
  }, a.prototype.writeFloatBE = function(c, l, w) {
    return Z(this, c, l, !1, w);
  };
  function it(g, c, l, w, T) {
    return c = +c, l = l >>> 0, T || W(g, c, l, 8), e.write(g, c, l, w, 52, 8), l + 8;
  }
  a.prototype.writeDoubleLE = function(c, l, w) {
    return it(this, c, l, !0, w);
  }, a.prototype.writeDoubleBE = function(c, l, w) {
    return it(this, c, l, !1, w);
  }, a.prototype.copy = function(c, l, w, T) {
    if (!a.isBuffer(c))
      throw new TypeError("argument should be a Buffer");
    if (w || (w = 0), !T && T !== 0 && (T = this.length), l >= c.length && (l = c.length), l || (l = 0), T > 0 && T < w && (T = w), T === w || c.length === 0 || this.length === 0)
      return 0;
    if (l < 0)
      throw new RangeError("targetStart out of bounds");
    if (w < 0 || w >= this.length)
      throw new RangeError("Index out of range");
    if (T < 0)
      throw new RangeError("sourceEnd out of bounds");
    T > this.length && (T = this.length), c.length - l < T - w && (T = c.length - l + w);
    const k = T - w;
    return this === c && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(l, w, T) : Uint8Array.prototype.set.call(
      c,
      this.subarray(w, T),
      l
    ), k;
  }, a.prototype.fill = function(c, l, w, T) {
    if (typeof c == "string") {
      if (typeof l == "string" ? (T = l, l = 0, w = this.length) : typeof w == "string" && (T = w, w = this.length), T !== void 0 && typeof T != "string")
        throw new TypeError("encoding must be a string");
      if (typeof T == "string" && !a.isEncoding(T))
        throw new TypeError("Unknown encoding: " + T);
      if (c.length === 1) {
        const R = c.charCodeAt(0);
        (T === "utf8" && R < 128 || T === "latin1") && (c = R);
      }
    } else
      typeof c == "number" ? c = c & 255 : typeof c == "boolean" && (c = Number(c));
    if (l < 0 || this.length < l || this.length < w)
      throw new RangeError("Out of range index");
    if (w <= l)
      return this;
    l = l >>> 0, w = w === void 0 ? this.length : w >>> 0, c || (c = 0);
    let k;
    if (typeof c == "number")
      for (k = l; k < w; ++k)
        this[k] = c;
    else {
      const R = a.isBuffer(c) ? c : a.from(c, T), ht = R.length;
      if (ht === 0)
        throw new TypeError('The value "' + c + '" is invalid for argument "value"');
      for (k = 0; k < w - l; ++k)
        this[k + l] = R[k % ht];
    }
    return this;
  };
  const nt = {};
  function st(g, c, l) {
    nt[g] = class extends l {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: c.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${g}]`, this.stack, delete this.name;
      }
      get code() {
        return g;
      }
      set code(T) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: T,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${g}]: ${this.message}`;
      }
    };
  }
  st(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(g) {
      return g ? `${g} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), st(
    "ERR_INVALID_ARG_TYPE",
    function(g, c) {
      return `The "${g}" argument must be of type number. Received type ${typeof c}`;
    },
    TypeError
  ), st(
    "ERR_OUT_OF_RANGE",
    function(g, c, l) {
      let w = `The value of "${g}" is out of range.`, T = l;
      return Number.isInteger(l) && Math.abs(l) > 2 ** 32 ? T = Ut(String(l)) : typeof l == "bigint" && (T = String(l), (l > BigInt(2) ** BigInt(32) || l < -(BigInt(2) ** BigInt(32))) && (T = Ut(T)), T += "n"), w += ` It must be ${c}. Received ${T}`, w;
    },
    RangeError
  );
  function Ut(g) {
    let c = "", l = g.length;
    const w = g[0] === "-" ? 1 : 0;
    for (; l >= w + 4; l -= 3)
      c = `_${g.slice(l - 3, l)}${c}`;
    return `${g.slice(0, l)}${c}`;
  }
  function dt(g, c, l) {
    St(c, "offset"), (g[c] === void 0 || g[c + l] === void 0) && Lt(c, g.length - (l + 1));
  }
  function pt(g, c, l, w, T, k) {
    if (g > l || g < c) {
      const R = typeof c == "bigint" ? "n" : "";
      let ht;
      throw k > 3 ? c === 0 || c === BigInt(0) ? ht = `>= 0${R} and < 2${R} ** ${(k + 1) * 8}${R}` : ht = `>= -(2${R} ** ${(k + 1) * 8 - 1}${R}) and < 2 ** ${(k + 1) * 8 - 1}${R}` : ht = `>= ${c}${R} and <= ${l}${R}`, new nt.ERR_OUT_OF_RANGE("value", ht, g);
    }
    dt(w, T, k);
  }
  function St(g, c) {
    if (typeof g != "number")
      throw new nt.ERR_INVALID_ARG_TYPE(c, "number", g);
  }
  function Lt(g, c, l) {
    throw Math.floor(g) !== g ? (St(g, l), new nt.ERR_OUT_OF_RANGE(l || "offset", "an integer", g)) : c < 0 ? new nt.ERR_BUFFER_OUT_OF_BOUNDS() : new nt.ERR_OUT_OF_RANGE(
      l || "offset",
      `>= ${l ? 1 : 0} and <= ${c}`,
      g
    );
  }
  const bt = /[^+/0-9A-Za-z-_]/g;
  function Pe(g) {
    if (g = g.split("=")[0], g = g.trim().replace(bt, ""), g.length < 2)
      return "";
    for (; g.length % 4 !== 0; )
      g = g + "=";
    return g;
  }
  function At(g, c) {
    c = c || 1 / 0;
    let l;
    const w = g.length;
    let T = null;
    const k = [];
    for (let R = 0; R < w; ++R) {
      if (l = g.charCodeAt(R), l > 55295 && l < 57344) {
        if (!T) {
          if (l > 56319) {
            (c -= 3) > -1 && k.push(239, 191, 189);
            continue;
          } else if (R + 1 === w) {
            (c -= 3) > -1 && k.push(239, 191, 189);
            continue;
          }
          T = l;
          continue;
        }
        if (l < 56320) {
          (c -= 3) > -1 && k.push(239, 191, 189), T = l;
          continue;
        }
        l = (T - 55296 << 10 | l - 56320) + 65536;
      } else
        T && (c -= 3) > -1 && k.push(239, 191, 189);
      if (T = null, l < 128) {
        if ((c -= 1) < 0)
          break;
        k.push(l);
      } else if (l < 2048) {
        if ((c -= 2) < 0)
          break;
        k.push(
          l >> 6 | 192,
          l & 63 | 128
        );
      } else if (l < 65536) {
        if ((c -= 3) < 0)
          break;
        k.push(
          l >> 12 | 224,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else if (l < 1114112) {
        if ((c -= 4) < 0)
          break;
        k.push(
          l >> 18 | 240,
          l >> 12 & 63 | 128,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return k;
  }
  function _t(g) {
    const c = [];
    for (let l = 0; l < g.length; ++l)
      c.push(g.charCodeAt(l) & 255);
    return c;
  }
  function bn(g, c) {
    let l, w, T;
    const k = [];
    for (let R = 0; R < g.length && !((c -= 2) < 0); ++R)
      l = g.charCodeAt(R), w = l >> 8, T = l % 256, k.push(T), k.push(w);
    return k;
  }
  function Bt(g) {
    return t.toByteArray(Pe(g));
  }
  function Nt(g, c, l, w) {
    let T;
    for (T = 0; T < w && !(T + l >= c.length || T >= g.length); ++T)
      c[T + l] = g[T];
    return T;
  }
  function ye(g, c) {
    return g instanceof c || g != null && g.constructor != null && g.constructor.name != null && g.constructor.name === c.name;
  }
  function vt(g) {
    return g !== g;
  }
  const Tt = function() {
    const g = "0123456789abcdef", c = new Array(256);
    for (let l = 0; l < 16; ++l) {
      const w = l * 16;
      for (let T = 0; T < 16; ++T)
        c[w + T] = g[l] + g[T];
    }
    return c;
  }();
  function Ie(g) {
    return typeof BigInt > "u" ? kt : g;
  }
  function kt() {
    throw new Error("BigInt not supported");
  }
})(lt);
function Bu(r, t = 3, e = ",") {
  const n = r.toString();
  return n.split("").reduceRight((s, i, o) => (Math.abs(o - n.length + 1) % t === 0 && s && (s = e + s), s = i + s, s), "");
}
function Sh(r, t = 2) {
  if (!r)
    return "";
  const [e, n] = r.split(".");
  return Bu(e) + "." + n.substring(0, t);
}
function Ih(r) {
  if (!r)
    return "0.00";
  const t = r.toString().padStart(10, "0"), e = t.substring(0, t.length - 9), n = t.substring(t.length - 9, t.length);
  return `${e}.${n}`;
}
function di(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error(`Wrong positive integer: ${r}`);
}
function ku(r) {
  if (typeof r != "boolean")
    throw new Error(`Expected boolean, not ${r}`);
}
function Hs(r, ...t) {
  if (!(r instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(r.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${r.length}`);
}
function Cu(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  di(r.outputLen), di(r.blockLen);
}
function Du(r, t = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function _u(r, t) {
  Hs(r);
  const e = t.outputLen;
  if (r.length < e)
    throw new Error(`digestInto() expects output buffer of length at least ${e}`);
}
const ln = {
  number: di,
  bool: ku,
  bytes: Hs,
  hash: Cu,
  exists: Du,
  output: _u
};
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ou = (r) => r instanceof Uint8Array, Ru = (r) => new Uint32Array(r.buffer, r.byteOffset, Math.floor(r.byteLength / 4)), zu = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!zu)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (r, t) => t.toString(16).padStart(2, "0"));
function Ws(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function Ti(r) {
  if (typeof r == "string" && (r = Ws(r)), !Ou(r))
    throw new Error(`expected Uint8Array, got ${typeof r}`);
  return r;
}
let Uu = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function Pu(r) {
  const t = (n) => r().update(Ti(n)).digest(), e = r();
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = () => r(), t;
}
function Fu(r) {
  const t = (n, s) => r(s).update(Ti(n)).digest(), e = r({});
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = (n) => r(n), t;
}
function Yu(r) {
  return (t) => (ln.bytes(t), r(t));
}
(() => {
  const r = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, t = typeof module < "u" && typeof module.require == "function" && module.require.bind(module);
  return {
    node: t && !r ? t("crypto") : void 0,
    web: r
  };
})();
const nr = BigInt(2 ** 32 - 1), gi = BigInt(32);
function Zs(r, t = !1) {
  return t ? { h: Number(r & nr), l: Number(r >> gi & nr) } : { h: Number(r >> gi & nr) | 0, l: Number(r & nr) | 0 };
}
function Hu(r, t = !1) {
  let e = new Uint32Array(r.length), n = new Uint32Array(r.length);
  for (let s = 0; s < r.length; s++) {
    const { h: i, l: o } = Zs(r[s], t);
    [e[s], n[s]] = [i, o];
  }
  return [e, n];
}
const Wu = (r, t) => BigInt(r >>> 0) << gi | BigInt(t >>> 0), Zu = (r, t, e) => r >>> e, Gu = (r, t, e) => r << 32 - e | t >>> e, Qu = (r, t, e) => r >>> e | t << 32 - e, qu = (r, t, e) => r << 32 - e | t >>> e, Vu = (r, t, e) => r << 64 - e | t >>> e - 32, $u = (r, t, e) => r >>> e - 32 | t << 64 - e, Ku = (r, t) => t, Ju = (r, t) => r, Xu = (r, t, e) => r << e | t >>> 32 - e, ta = (r, t, e) => t << e | r >>> 32 - e, ea = (r, t, e) => t << e - 32 | r >>> 64 - e, na = (r, t, e) => r << e - 32 | t >>> 64 - e;
function ra(r, t, e, n) {
  const s = (t >>> 0) + (n >>> 0);
  return { h: r + e + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const ia = (r, t, e) => (r >>> 0) + (t >>> 0) + (e >>> 0), sa = (r, t, e, n) => t + e + n + (r / 2 ** 32 | 0) | 0, oa = (r, t, e, n) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (n >>> 0), ua = (r, t, e, n, s) => t + e + n + s + (r / 2 ** 32 | 0) | 0, aa = (r, t, e, n, s) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (n >>> 0) + (s >>> 0), ca = (r, t, e, n, s, i) => t + e + n + s + i + (r / 2 ** 32 | 0) | 0, Gn = {
  fromBig: Zs,
  split: Hu,
  toBig: Wu,
  shrSH: Zu,
  shrSL: Gu,
  rotrSH: Qu,
  rotrSL: qu,
  rotrBH: Vu,
  rotrBL: $u,
  rotr32H: Ku,
  rotr32L: Ju,
  rotlSH: Xu,
  rotlSL: ta,
  rotlBH: ea,
  rotlBL: na,
  add: ra,
  add3L: ia,
  add3H: sa,
  add4L: oa,
  add4H: ua,
  add5H: ca,
  add5L: aa
}, [Gs, Qs, qs] = [[], [], []], fa = BigInt(0), Yn = BigInt(1), la = BigInt(2), ha = BigInt(7), da = BigInt(256), ga = BigInt(113);
for (let r = 0, t = Yn, e = 1, n = 0; r < 24; r++) {
  [e, n] = [n, (2 * e + 3 * n) % 5], Gs.push(2 * (5 * n + e)), Qs.push((r + 1) * (r + 2) / 2 % 64);
  let s = fa;
  for (let i = 0; i < 7; i++)
    t = (t << Yn ^ (t >> ha) * ga) % da, t & la && (s ^= Yn << (Yn << BigInt(i)) - Yn);
  qs.push(s);
}
const [ya, pa] = Gn.split(qs, !0), ls = (r, t, e) => e > 32 ? Gn.rotlBH(r, t, e) : Gn.rotlSH(r, t, e), hs = (r, t, e) => e > 32 ? Gn.rotlBL(r, t, e) : Gn.rotlSL(r, t, e);
function Ma(r, t = 24) {
  const e = new Uint32Array(10);
  for (let n = 24 - t; n < 24; n++) {
    for (let o = 0; o < 10; o++)
      e[o] = r[o] ^ r[o + 10] ^ r[o + 20] ^ r[o + 30] ^ r[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, d = (o + 2) % 10, L = e[d], I = e[d + 1], b = ls(L, I, 1) ^ e[a], O = hs(L, I, 1) ^ e[a + 1];
      for (let v = 0; v < 50; v += 10)
        r[o + v] ^= b, r[o + v + 1] ^= O;
    }
    let s = r[2], i = r[3];
    for (let o = 0; o < 24; o++) {
      const a = Qs[o], d = ls(s, i, a), L = hs(s, i, a), I = Gs[o];
      s = r[I], i = r[I + 1], r[I] = d, r[I + 1] = L;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++)
        e[a] = r[o + a];
      for (let a = 0; a < 10; a++)
        r[o + a] ^= ~e[(a + 2) % 10] & e[(a + 4) % 10];
    }
    r[0] ^= ya[n], r[1] ^= pa[n];
  }
  e.fill(0);
}
class mr extends Uu {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, e, n, s = !1, i = 24) {
    if (super(), this.blockLen = t, this.suffix = e, this.outputLen = n, this.enableXOF = s, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, ln.number(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Ru(this.state);
  }
  keccak() {
    Ma(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    ln.exists(this);
    const { blockLen: e, state: n } = this;
    t = Ti(t);
    const s = t.length;
    for (let i = 0; i < s; ) {
      const o = Math.min(e - this.pos, s - i);
      for (let a = 0; a < o; a++)
        n[this.pos++] ^= t[i++];
      this.pos === e && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: e, pos: n, blockLen: s } = this;
    t[n] ^= e, e & 128 && n === s - 1 && this.keccak(), t[s - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    ln.exists(this, !1), ln.bytes(t), this.finish();
    const e = this.state, { blockLen: n } = this;
    for (let s = 0, i = t.length; s < i; ) {
      this.posOut >= n && this.keccak();
      const o = Math.min(n - this.posOut, i - s);
      t.set(e.subarray(this.posOut, this.posOut + o), s), this.posOut += o, s += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return ln.number(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (ln.output(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: e, suffix: n, outputLen: s, rounds: i, enableXOF: o } = this;
    return t || (t = new mr(e, n, s, o, i)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = i, t.suffix = n, t.outputLen = s, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
}
const fn = (r, t, e) => Pu(() => new mr(t, r, e));
fn(6, 144, 224 / 8);
fn(6, 136, 256 / 8);
fn(6, 104, 384 / 8);
fn(6, 72, 512 / 8);
fn(1, 144, 224 / 8);
const ds = fn(1, 136, 256 / 8);
fn(1, 104, 384 / 8);
fn(1, 72, 512 / 8);
const Vs = (r, t, e) => Fu((n = {}) => new mr(t, r, n.dkLen === void 0 ? e : n.dkLen, !0));
Vs(31, 168, 128 / 8);
Vs(31, 136, 256 / 8);
const La = (() => {
  const r = Yu(ds);
  return r.create = ds.create, r;
})();
function gs(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error(`positive integer expected, not ${r}`);
}
function wa(r) {
  return r instanceof Uint8Array || r != null && typeof r == "object" && r.constructor.name === "Uint8Array";
}
function Sr(r, ...t) {
  if (!wa(r))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(r.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${r.length}`);
}
function ma(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  gs(r.outputLen), gs(r.blockLen);
}
function fr(r, t = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function Sa(r, t) {
  Sr(r);
  const e = t.outputLen;
  if (r.length < e)
    throw new Error(`digestInto() expects output buffer of length at least ${e}`);
}
const Xr = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ti = (r) => new DataView(r.buffer, r.byteOffset, r.byteLength), Fe = (r, t) => r << 32 - t | r >>> t;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
function $s(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function Bi(r) {
  return typeof r == "string" && (r = $s(r)), Sr(r), r;
}
function Ks(...r) {
  let t = 0;
  for (let n = 0; n < r.length; n++) {
    const s = r[n];
    Sr(s), t += s.length;
  }
  const e = new Uint8Array(t);
  for (let n = 0, s = 0; n < r.length; n++) {
    const i = r[n];
    e.set(i, s), s += i.length;
  }
  return e;
}
class Js {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Xs(r) {
  const t = (n) => r().update(Bi(n)).digest(), e = r();
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = () => r(), t;
}
function to(r = 32) {
  if (Xr && typeof Xr.getRandomValues == "function")
    return Xr.getRandomValues(new Uint8Array(r));
  throw new Error("crypto.getRandomValues must be defined");
}
function Ia(r, t, e, n) {
  if (typeof r.setBigUint64 == "function")
    return r.setBigUint64(t, e, n);
  const s = BigInt(32), i = BigInt(4294967295), o = Number(e >> s & i), a = Number(e & i), d = n ? 4 : 0, L = n ? 0 : 4;
  r.setUint32(t + d, o, n), r.setUint32(t + L, a, n);
}
const xa = (r, t, e) => r & t ^ ~r & e, ja = (r, t, e) => r & t ^ r & e ^ t & e;
class eo extends Js {
  constructor(t, e, n, s) {
    super(), this.blockLen = t, this.outputLen = e, this.padOffset = n, this.isLE = s, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = ti(this.buffer);
  }
  update(t) {
    fr(this);
    const { view: e, buffer: n, blockLen: s } = this;
    t = Bi(t);
    const i = t.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(s - this.pos, i - o);
      if (a === s) {
        const d = ti(t);
        for (; s <= i - o; o += s)
          this.process(d, o);
        continue;
      }
      n.set(t.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === s && (this.process(e, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    fr(this), Sa(t, this), this.finished = !0;
    const { buffer: e, view: n, blockLen: s, isLE: i } = this;
    let { pos: o } = this;
    e[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > s - o && (this.process(n, 0), o = 0);
    for (let b = o; b < s; b++)
      e[b] = 0;
    Ia(n, s - 8, BigInt(this.length * 8), i), this.process(n, 0);
    const a = ti(t), d = this.outputLen;
    if (d % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const L = d / 4, I = this.get();
    if (L > I.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let b = 0; b < L; b++)
      a.setUint32(4 * b, I[b], i);
  }
  digest() {
    const { buffer: t, outputLen: e } = this;
    this.digestInto(t);
    const n = t.slice(0, e);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: e, buffer: n, length: s, finished: i, destroyed: o, pos: a } = this;
    return t.length = s, t.pos = a, t.finished = i, t.destroyed = o, s % e && t.buffer.set(n), t;
  }
}
const rr = /* @__PURE__ */ BigInt(2 ** 32 - 1), yi = /* @__PURE__ */ BigInt(32);
function no(r, t = !1) {
  return t ? { h: Number(r & rr), l: Number(r >> yi & rr) } : { h: Number(r >> yi & rr) | 0, l: Number(r & rr) | 0 };
}
function ba(r, t = !1) {
  let e = new Uint32Array(r.length), n = new Uint32Array(r.length);
  for (let s = 0; s < r.length; s++) {
    const { h: i, l: o } = no(r[s], t);
    [e[s], n[s]] = [i, o];
  }
  return [e, n];
}
const Ea = (r, t) => BigInt(r >>> 0) << yi | BigInt(t >>> 0), Aa = (r, t, e) => r >>> e, Na = (r, t, e) => r << 32 - e | t >>> e, va = (r, t, e) => r >>> e | t << 32 - e, Ta = (r, t, e) => r << 32 - e | t >>> e, Ba = (r, t, e) => r << 64 - e | t >>> e - 32, ka = (r, t, e) => r >>> e - 32 | t << 64 - e, Ca = (r, t) => t, Da = (r, t) => r, _a = (r, t, e) => r << e | t >>> 32 - e, Oa = (r, t, e) => t << e | r >>> 32 - e, Ra = (r, t, e) => t << e - 32 | r >>> 64 - e, za = (r, t, e) => r << e - 32 | t >>> 64 - e;
function Ua(r, t, e, n) {
  const s = (t >>> 0) + (n >>> 0);
  return { h: r + e + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const Pa = (r, t, e) => (r >>> 0) + (t >>> 0) + (e >>> 0), Fa = (r, t, e, n) => t + e + n + (r / 2 ** 32 | 0) | 0, Ya = (r, t, e, n) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (n >>> 0), Ha = (r, t, e, n, s) => t + e + n + s + (r / 2 ** 32 | 0) | 0, Wa = (r, t, e, n, s) => (r >>> 0) + (t >>> 0) + (e >>> 0) + (n >>> 0) + (s >>> 0), Za = (r, t, e, n, s, i) => t + e + n + s + i + (r / 2 ** 32 | 0) | 0, Ga = {
  fromBig: no,
  split: ba,
  toBig: Ea,
  shrSH: Aa,
  shrSL: Na,
  rotrSH: va,
  rotrSL: Ta,
  rotrBH: Ba,
  rotrBL: ka,
  rotr32H: Ca,
  rotr32L: Da,
  rotlSH: _a,
  rotlSL: Oa,
  rotlBH: Ra,
  rotlBL: za,
  add: Ua,
  add3L: Pa,
  add3H: Fa,
  add4L: Ya,
  add4H: Ha,
  add5H: Za,
  add5L: Wa
}, gt = Ga, [Qa, qa] = /* @__PURE__ */ (() => gt.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((r) => BigInt(r))))(), Xe = /* @__PURE__ */ new Uint32Array(80), tn = /* @__PURE__ */ new Uint32Array(80);
class Va extends eo {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: e, Bh: n, Bl: s, Ch: i, Cl: o, Dh: a, Dl: d, Eh: L, El: I, Fh: b, Fl: O, Gh: v, Gl: B, Hh: E, Hl: N } = this;
    return [t, e, n, s, i, o, a, d, L, I, b, O, v, B, E, N];
  }
  // prettier-ignore
  set(t, e, n, s, i, o, a, d, L, I, b, O, v, B, E, N) {
    this.Ah = t | 0, this.Al = e | 0, this.Bh = n | 0, this.Bl = s | 0, this.Ch = i | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = d | 0, this.Eh = L | 0, this.El = I | 0, this.Fh = b | 0, this.Fl = O | 0, this.Gh = v | 0, this.Gl = B | 0, this.Hh = E | 0, this.Hl = N | 0;
  }
  process(t, e) {
    for (let z = 0; z < 16; z++, e += 4)
      Xe[z] = t.getUint32(e), tn[z] = t.getUint32(e += 4);
    for (let z = 16; z < 80; z++) {
      const q = Xe[z - 15] | 0, P = tn[z - 15] | 0, F = gt.rotrSH(q, P, 1) ^ gt.rotrSH(q, P, 8) ^ gt.shrSH(q, P, 7), V = gt.rotrSL(q, P, 1) ^ gt.rotrSL(q, P, 8) ^ gt.shrSL(q, P, 7), J = Xe[z - 2] | 0, xt = tn[z - 2] | 0, Mt = gt.rotrSH(J, xt, 19) ^ gt.rotrBH(J, xt, 61) ^ gt.shrSH(J, xt, 6), X = gt.rotrSL(J, xt, 19) ^ gt.rotrBL(J, xt, 61) ^ gt.shrSL(J, xt, 6), jt = gt.add4L(V, X, tn[z - 7], tn[z - 16]), j = gt.add4H(jt, F, Mt, Xe[z - 7], Xe[z - 16]);
      Xe[z] = j | 0, tn[z] = jt | 0;
    }
    let { Ah: n, Al: s, Bh: i, Bl: o, Ch: a, Cl: d, Dh: L, Dl: I, Eh: b, El: O, Fh: v, Fl: B, Gh: E, Gl: N, Hh: _, Hl: U } = this;
    for (let z = 0; z < 80; z++) {
      const q = gt.rotrSH(b, O, 14) ^ gt.rotrSH(b, O, 18) ^ gt.rotrBH(b, O, 41), P = gt.rotrSL(b, O, 14) ^ gt.rotrSL(b, O, 18) ^ gt.rotrBL(b, O, 41), F = b & v ^ ~b & E, V = O & B ^ ~O & N, J = gt.add5L(U, P, V, qa[z], tn[z]), xt = gt.add5H(J, _, q, F, Qa[z], Xe[z]), Mt = J | 0, X = gt.rotrSH(n, s, 28) ^ gt.rotrBH(n, s, 34) ^ gt.rotrBH(n, s, 39), jt = gt.rotrSL(n, s, 28) ^ gt.rotrBL(n, s, 34) ^ gt.rotrBL(n, s, 39), j = n & i ^ n & a ^ i & a, u = s & o ^ s & d ^ o & d;
      _ = E | 0, U = N | 0, E = v | 0, N = B | 0, v = b | 0, B = O | 0, { h: b, l: O } = gt.add(L | 0, I | 0, xt | 0, Mt | 0), L = a | 0, I = d | 0, a = i | 0, d = o | 0, i = n | 0, o = s | 0;
      const h = gt.add3L(Mt, jt, u);
      n = gt.add3H(h, xt, X, j), s = h | 0;
    }
    ({ h: n, l: s } = gt.add(this.Ah | 0, this.Al | 0, n | 0, s | 0)), { h: i, l: o } = gt.add(this.Bh | 0, this.Bl | 0, i | 0, o | 0), { h: a, l: d } = gt.add(this.Ch | 0, this.Cl | 0, a | 0, d | 0), { h: L, l: I } = gt.add(this.Dh | 0, this.Dl | 0, L | 0, I | 0), { h: b, l: O } = gt.add(this.Eh | 0, this.El | 0, b | 0, O | 0), { h: v, l: B } = gt.add(this.Fh | 0, this.Fl | 0, v | 0, B | 0), { h: E, l: N } = gt.add(this.Gh | 0, this.Gl | 0, E | 0, N | 0), { h: _, l: U } = gt.add(this.Hh | 0, this.Hl | 0, _ | 0, U | 0), this.set(n, s, i, o, a, d, L, I, b, O, v, B, E, N, _, U);
  }
  roundClean() {
    Xe.fill(0), tn.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const ro = /* @__PURE__ */ Xs(() => new Va());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const io = BigInt(0), Ir = BigInt(1), $a = BigInt(2);
function Ln(r) {
  return r instanceof Uint8Array || r != null && typeof r == "object" && r.constructor.name === "Uint8Array";
}
function Kn(r) {
  if (!Ln(r))
    throw new Error("Uint8Array expected");
}
const Ka = /* @__PURE__ */ Array.from({ length: 256 }, (r, t) => t.toString(16).padStart(2, "0"));
function wn(r) {
  Kn(r);
  let t = "";
  for (let e = 0; e < r.length; e++)
    t += Ka[r[e]];
  return t;
}
function so(r) {
  const t = r.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function ki(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  return BigInt(r === "" ? "0" : `0x${r}`);
}
const Qe = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function ys(r) {
  if (r >= Qe._0 && r <= Qe._9)
    return r - Qe._0;
  if (r >= Qe._A && r <= Qe._F)
    return r - (Qe._A - 10);
  if (r >= Qe._a && r <= Qe._f)
    return r - (Qe._a - 10);
}
function kn(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  const t = r.length, e = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(e);
  for (let s = 0, i = 0; s < e; s++, i += 2) {
    const o = ys(r.charCodeAt(i)), a = ys(r.charCodeAt(i + 1));
    if (o === void 0 || a === void 0) {
      const d = r[i] + r[i + 1];
      throw new Error('hex string expected, got non-hex character "' + d + '" at index ' + i);
    }
    n[s] = o * 16 + a;
  }
  return n;
}
function pn(r) {
  return ki(wn(r));
}
function Tn(r) {
  return Kn(r), ki(wn(Uint8Array.from(r).reverse()));
}
function Cn(r, t) {
  return kn(r.toString(16).padStart(t * 2, "0"));
}
function Qn(r, t) {
  return Cn(r, t).reverse();
}
function Ja(r) {
  return kn(so(r));
}
function ce(r, t, e) {
  let n;
  if (typeof t == "string")
    try {
      n = kn(t);
    } catch (i) {
      throw new Error(`${r} must be valid hex string, got "${t}". Cause: ${i}`);
    }
  else if (Ln(t))
    n = Uint8Array.from(t);
  else
    throw new Error(`${r} must be hex string or Uint8Array`);
  const s = n.length;
  if (typeof e == "number" && s !== e)
    throw new Error(`${r} expected ${e} bytes, got ${s}`);
  return n;
}
function mn(...r) {
  let t = 0;
  for (let n = 0; n < r.length; n++) {
    const s = r[n];
    Kn(s), t += s.length;
  }
  const e = new Uint8Array(t);
  for (let n = 0, s = 0; n < r.length; n++) {
    const i = r[n];
    e.set(i, s), s += i.length;
  }
  return e;
}
function Xa(r, t) {
  if (r.length !== t.length)
    return !1;
  let e = 0;
  for (let n = 0; n < r.length; n++)
    e |= r[n] ^ t[n];
  return e === 0;
}
function tc(r) {
  if (typeof r != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof r}`);
  return new Uint8Array(new TextEncoder().encode(r));
}
function ec(r) {
  let t;
  for (t = 0; r > io; r >>= Ir, t += 1)
    ;
  return t;
}
function nc(r, t) {
  return r >> BigInt(t) & Ir;
}
function rc(r, t, e) {
  return r | (e ? Ir : io) << BigInt(t);
}
const Ci = (r) => ($a << BigInt(r - 1)) - Ir, ei = (r) => new Uint8Array(r), ps = (r) => Uint8Array.from(r);
function oo(r, t, e) {
  if (typeof r != "number" || r < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof e != "function")
    throw new Error("hmacFn must be a function");
  let n = ei(r), s = ei(r), i = 0;
  const o = () => {
    n.fill(1), s.fill(0), i = 0;
  }, a = (...b) => e(s, n, ...b), d = (b = ei()) => {
    s = a(ps([0]), b), n = a(), b.length !== 0 && (s = a(ps([1]), b), n = a());
  }, L = () => {
    if (i++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let b = 0;
    const O = [];
    for (; b < t; ) {
      n = a();
      const v = n.slice();
      O.push(v), b += n.length;
    }
    return mn(...O);
  };
  return (b, O) => {
    o(), d(b);
    let v;
    for (; !(v = O(L())); )
      d();
    return o(), v;
  };
}
const ic = {
  bigint: (r) => typeof r == "bigint",
  function: (r) => typeof r == "function",
  boolean: (r) => typeof r == "boolean",
  string: (r) => typeof r == "string",
  stringOrUint8Array: (r) => typeof r == "string" || Ln(r),
  isSafeInteger: (r) => Number.isSafeInteger(r),
  array: (r) => Array.isArray(r),
  field: (r, t) => t.Fp.isValid(r),
  hash: (r) => typeof r == "function" && Number.isSafeInteger(r.outputLen)
};
function zn(r, t, e = {}) {
  const n = (s, i, o) => {
    const a = ic[i];
    if (typeof a != "function")
      throw new Error(`Invalid validator "${i}", expected function`);
    const d = r[s];
    if (!(o && d === void 0) && !a(d, r))
      throw new Error(`Invalid param ${String(s)}=${d} (${typeof d}), expected ${i}`);
  };
  for (const [s, i] of Object.entries(t))
    n(s, i, !1);
  for (const [s, i] of Object.entries(e))
    n(s, i, !0);
  return r;
}
const sc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: Kn,
  bitGet: nc,
  bitLen: ec,
  bitMask: Ci,
  bitSet: rc,
  bytesToHex: wn,
  bytesToNumberBE: pn,
  bytesToNumberLE: Tn,
  concatBytes: mn,
  createHmacDrbg: oo,
  ensureBytes: ce,
  equalBytes: Xa,
  hexToBytes: kn,
  hexToNumber: ki,
  isBytes: Ln,
  numberToBytesBE: Cn,
  numberToBytesLE: Qn,
  numberToHexUnpadded: so,
  numberToVarBytesBE: Ja,
  utf8ToBytes: tc,
  validateObject: zn
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const fe = BigInt(0), Ft = BigInt(1), hn = BigInt(2), oc = BigInt(3), pi = BigInt(4), Ms = BigInt(5), Ls = BigInt(8);
BigInt(9);
BigInt(16);
function zt(r, t) {
  const e = r % t;
  return e >= fe ? e : t + e;
}
function uc(r, t, e) {
  if (e <= fe || t < fe)
    throw new Error("Expected power/modulo > 0");
  if (e === Ft)
    return fe;
  let n = Ft;
  for (; t > fe; )
    t & Ft && (n = n * r % e), r = r * r % e, t >>= Ft;
  return n;
}
function Yt(r, t, e) {
  let n = r;
  for (; t-- > fe; )
    n *= n, n %= e;
  return n;
}
function Mi(r, t) {
  if (r === fe || t <= fe)
    throw new Error(`invert: expected positive integers, got n=${r} mod=${t}`);
  let e = zt(r, t), n = t, s = fe, i = Ft;
  for (; e !== fe; ) {
    const a = n / e, d = n % e, L = s - i * a;
    n = e, e = d, s = i, i = L;
  }
  if (n !== Ft)
    throw new Error("invert: does not exist");
  return zt(s, t);
}
function ac(r) {
  const t = (r - Ft) / hn;
  let e, n, s;
  for (e = r - Ft, n = 0; e % hn === fe; e /= hn, n++)
    ;
  for (s = hn; s < r && uc(s, t, r) !== r - Ft; s++)
    ;
  if (n === 1) {
    const o = (r + Ft) / pi;
    return function(d, L) {
      const I = d.pow(L, o);
      if (!d.eql(d.sqr(I), L))
        throw new Error("Cannot find square root");
      return I;
    };
  }
  const i = (e + Ft) / hn;
  return function(a, d) {
    if (a.pow(d, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let L = n, I = a.pow(a.mul(a.ONE, s), e), b = a.pow(d, i), O = a.pow(d, e);
    for (; !a.eql(O, a.ONE); ) {
      if (a.eql(O, a.ZERO))
        return a.ZERO;
      let v = 1;
      for (let E = a.sqr(O); v < L && !a.eql(E, a.ONE); v++)
        E = a.sqr(E);
      const B = a.pow(I, Ft << BigInt(L - v - 1));
      I = a.sqr(B), b = a.mul(b, B), O = a.mul(O, I), L = v;
    }
    return b;
  };
}
function cc(r) {
  if (r % pi === oc) {
    const t = (r + Ft) / pi;
    return function(n, s) {
      const i = n.pow(s, t);
      if (!n.eql(n.sqr(i), s))
        throw new Error("Cannot find square root");
      return i;
    };
  }
  if (r % Ls === Ms) {
    const t = (r - Ms) / Ls;
    return function(n, s) {
      const i = n.mul(s, hn), o = n.pow(i, t), a = n.mul(s, o), d = n.mul(n.mul(a, hn), o), L = n.mul(a, n.sub(d, n.ONE));
      if (!n.eql(n.sqr(L), s))
        throw new Error("Cannot find square root");
      return L;
    };
  }
  return ac(r);
}
const fc = (r, t) => (zt(r, t) & Ft) === Ft, lc = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function hc(r) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, e = lc.reduce((n, s) => (n[s] = "function", n), t);
  return zn(r, e);
}
function dc(r, t, e) {
  if (e < fe)
    throw new Error("Expected power > 0");
  if (e === fe)
    return r.ONE;
  if (e === Ft)
    return t;
  let n = r.ONE, s = t;
  for (; e > fe; )
    e & Ft && (n = r.mul(n, s)), s = r.sqr(s), e >>= Ft;
  return n;
}
function gc(r, t) {
  const e = new Array(t.length), n = t.reduce((i, o, a) => r.is0(o) ? i : (e[a] = i, r.mul(i, o)), r.ONE), s = r.inv(n);
  return t.reduceRight((i, o, a) => r.is0(o) ? i : (e[a] = r.mul(i, e[a]), r.mul(i, o)), s), e;
}
function uo(r, t) {
  const e = t !== void 0 ? t : r.toString(2).length, n = Math.ceil(e / 8);
  return { nBitLength: e, nByteLength: n };
}
function ao(r, t, e = !1, n = {}) {
  if (r <= fe)
    throw new Error(`Expected Field ORDER > 0, got ${r}`);
  const { nBitLength: s, nByteLength: i } = uo(r, t);
  if (i > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const o = cc(r), a = Object.freeze({
    ORDER: r,
    BITS: s,
    BYTES: i,
    MASK: Ci(s),
    ZERO: fe,
    ONE: Ft,
    create: (d) => zt(d, r),
    isValid: (d) => {
      if (typeof d != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof d}`);
      return fe <= d && d < r;
    },
    is0: (d) => d === fe,
    isOdd: (d) => (d & Ft) === Ft,
    neg: (d) => zt(-d, r),
    eql: (d, L) => d === L,
    sqr: (d) => zt(d * d, r),
    add: (d, L) => zt(d + L, r),
    sub: (d, L) => zt(d - L, r),
    mul: (d, L) => zt(d * L, r),
    pow: (d, L) => dc(a, d, L),
    div: (d, L) => zt(d * Mi(L, r), r),
    // Same as above, but doesn't normalize
    sqrN: (d) => d * d,
    addN: (d, L) => d + L,
    subN: (d, L) => d - L,
    mulN: (d, L) => d * L,
    inv: (d) => Mi(d, r),
    sqrt: n.sqrt || ((d) => o(a, d)),
    invertBatch: (d) => gc(a, d),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (d, L, I) => I ? L : d,
    toBytes: (d) => e ? Qn(d, i) : Cn(d, i),
    fromBytes: (d) => {
      if (d.length !== i)
        throw new Error(`Fp.fromBytes: expected ${i}, got ${d.length}`);
      return e ? Tn(d) : pn(d);
    }
  });
  return Object.freeze(a);
}
function yc(r, t) {
  if (!r.isOdd)
    throw new Error("Field doesn't have isOdd");
  const e = r.sqrt(t);
  return r.isOdd(e) ? r.neg(e) : e;
}
function co(r) {
  if (typeof r != "bigint")
    throw new Error("field order must be bigint");
  const t = r.toString(2).length;
  return Math.ceil(t / 8);
}
function fo(r) {
  const t = co(r);
  return t + Math.ceil(t / 2);
}
function pc(r, t, e = !1) {
  const n = r.length, s = co(t), i = fo(t);
  if (n < 16 || n < i || n > 1024)
    throw new Error(`expected ${i}-1024 bytes of input, got ${n}`);
  const o = e ? pn(r) : Tn(r), a = zt(o, t - Ft) + Ft;
  return e ? Qn(a, s) : Cn(a, s);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Mc = BigInt(0), ni = BigInt(1);
function lo(r, t) {
  const e = (s, i) => {
    const o = i.negate();
    return s ? o : i;
  }, n = (s) => {
    const i = Math.ceil(t / s) + 1, o = 2 ** (s - 1);
    return { windows: i, windowSize: o };
  };
  return {
    constTimeNegate: e,
    // non-const time multiplication ladder
    unsafeLadder(s, i) {
      let o = r.ZERO, a = s;
      for (; i > Mc; )
        i & ni && (o = o.add(a)), a = a.double(), i >>= ni;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(s, i) {
      const { windows: o, windowSize: a } = n(i), d = [];
      let L = s, I = L;
      for (let b = 0; b < o; b++) {
        I = L, d.push(I);
        for (let O = 1; O < a; O++)
          I = I.add(L), d.push(I);
        L = I.double();
      }
      return d;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(s, i, o) {
      const { windows: a, windowSize: d } = n(s);
      let L = r.ZERO, I = r.BASE;
      const b = BigInt(2 ** s - 1), O = 2 ** s, v = BigInt(s);
      for (let B = 0; B < a; B++) {
        const E = B * d;
        let N = Number(o & b);
        o >>= v, N > d && (N -= O, o += ni);
        const _ = E, U = E + Math.abs(N) - 1, z = B % 2 !== 0, q = N < 0;
        N === 0 ? I = I.add(e(z, i[_])) : L = L.add(e(q, i[U]));
      }
      return { p: L, f: I };
    },
    wNAFCached(s, i, o, a) {
      const d = s._WINDOW_SIZE || 1;
      let L = i.get(s);
      return L || (L = this.precomputeWindow(s, d), d !== 1 && i.set(s, a(L))), this.wNAF(d, L, o);
    }
  };
}
function Di(r) {
  return hc(r.Fp), zn(r, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...uo(r.n, r.nBitLength),
    ...r,
    p: r.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Oe = BigInt(0), be = BigInt(1), ir = BigInt(2), Lc = BigInt(8), wc = { zip215: !0 };
function mc(r) {
  const t = Di(r);
  return zn(r, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...t });
}
function _i(r) {
  const t = mc(r), { Fp: e, n, prehash: s, hash: i, randomBytes: o, nByteLength: a, h: d } = t, L = ir << BigInt(a * 8) - be, I = e.create, b = t.uvRatio || ((M, m) => {
    try {
      return { isValid: !0, value: e.sqrt(M * e.inv(m)) };
    } catch {
      return { isValid: !1, value: Oe };
    }
  }), O = t.adjustScalarBytes || ((M) => M), v = t.domain || ((M, m, A) => {
    if (m.length || A)
      throw new Error("Contexts/pre-hash are not supported");
    return M;
  }), B = (M) => typeof M == "bigint" && Oe < M, E = (M, m) => B(M) && B(m) && M < m, N = (M) => M === Oe || E(M, L);
  function _(M, m) {
    if (E(M, m))
      return M;
    throw new Error(`Expected valid scalar < ${m}, got ${typeof M} ${M}`);
  }
  function U(M) {
    return M === Oe ? M : _(M, n);
  }
  const z = /* @__PURE__ */ new Map();
  function q(M) {
    if (!(M instanceof P))
      throw new Error("ExtendedPoint expected");
  }
  class P {
    constructor(m, A, p, f) {
      if (this.ex = m, this.ey = A, this.ez = p, this.et = f, !N(m))
        throw new Error("x required");
      if (!N(A))
        throw new Error("y required");
      if (!N(p))
        throw new Error("z required");
      if (!N(f))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(m) {
      if (m instanceof P)
        throw new Error("extended point not allowed");
      const { x: A, y: p } = m || {};
      if (!N(A) || !N(p))
        throw new Error("invalid affine point");
      return new P(A, p, be, I(A * p));
    }
    static normalizeZ(m) {
      const A = e.invertBatch(m.map((p) => p.ez));
      return m.map((p, f) => p.toAffine(A[f])).map(P.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(m) {
      this._WINDOW_SIZE = m, z.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: m, d: A } = t;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: p, ey: f, ez: x, et: H } = this, W = I(p * p), Z = I(f * f), it = I(x * x), nt = I(it * it), st = I(W * m), Ut = I(it * I(st + Z)), dt = I(nt + I(A * I(W * Z)));
      if (Ut !== dt)
        throw new Error("bad point: equation left != right (1)");
      const pt = I(p * f), St = I(x * H);
      if (pt !== St)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(m) {
      q(m);
      const { ex: A, ey: p, ez: f } = this, { ex: x, ey: H, ez: W } = m, Z = I(A * W), it = I(x * f), nt = I(p * W), st = I(H * f);
      return Z === it && nt === st;
    }
    is0() {
      return this.equals(P.ZERO);
    }
    negate() {
      return new P(I(-this.ex), this.ey, this.ez, I(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: m } = t, { ex: A, ey: p, ez: f } = this, x = I(A * A), H = I(p * p), W = I(ir * I(f * f)), Z = I(m * x), it = A + p, nt = I(I(it * it) - x - H), st = Z + H, Ut = st - W, dt = Z - H, pt = I(nt * Ut), St = I(st * dt), Lt = I(nt * dt), bt = I(Ut * st);
      return new P(pt, St, bt, Lt);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(m) {
      q(m);
      const { a: A, d: p } = t, { ex: f, ey: x, ez: H, et: W } = this, { ex: Z, ey: it, ez: nt, et: st } = m;
      if (A === BigInt(-1)) {
        const ye = I((x - f) * (it + Z)), vt = I((x + f) * (it - Z)), Tt = I(vt - ye);
        if (Tt === Oe)
          return this.double();
        const Ie = I(H * ir * st), kt = I(W * ir * nt), g = kt + Ie, c = vt + ye, l = kt - Ie, w = I(g * Tt), T = I(c * l), k = I(g * l), R = I(Tt * c);
        return new P(w, T, R, k);
      }
      const Ut = I(f * Z), dt = I(x * it), pt = I(W * p * st), St = I(H * nt), Lt = I((f + x) * (Z + it) - Ut - dt), bt = St - pt, Pe = St + pt, At = I(dt - A * Ut), _t = I(Lt * bt), bn = I(Pe * At), Bt = I(Lt * At), Nt = I(bt * Pe);
      return new P(_t, bn, Nt, Bt);
    }
    subtract(m) {
      return this.add(m.negate());
    }
    wNAF(m) {
      return J.wNAFCached(this, z, m, P.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(m) {
      const { p: A, f: p } = this.wNAF(_(m, n));
      return P.normalizeZ([A, p])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(m) {
      let A = U(m);
      return A === Oe ? V : this.equals(V) || A === be ? this : this.equals(F) ? this.wNAF(A).p : J.unsafeLadder(this, A);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(d).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return J.unsafeLadder(this, n).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(m) {
      const { ex: A, ey: p, ez: f } = this, x = this.is0();
      m == null && (m = x ? Lc : e.inv(f));
      const H = I(A * m), W = I(p * m), Z = I(f * m);
      if (x)
        return { x: Oe, y: be };
      if (Z !== be)
        throw new Error("invZ was invalid");
      return { x: H, y: W };
    }
    clearCofactor() {
      const { h: m } = t;
      return m === be ? this : this.multiplyUnsafe(m);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(m, A = !1) {
      const { d: p, a: f } = t, x = e.BYTES;
      m = ce("pointHex", m, x);
      const H = m.slice(), W = m[x - 1];
      H[x - 1] = W & -129;
      const Z = Tn(H);
      Z === Oe || (A ? _(Z, L) : _(Z, e.ORDER));
      const it = I(Z * Z), nt = I(it - be), st = I(p * it - f);
      let { isValid: Ut, value: dt } = b(nt, st);
      if (!Ut)
        throw new Error("Point.fromHex: invalid y coordinate");
      const pt = (dt & be) === be, St = (W & 128) !== 0;
      if (!A && dt === Oe && St)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return St !== pt && (dt = I(-dt)), P.fromAffine({ x: dt, y: Z });
    }
    static fromPrivateKey(m) {
      return X(m).point;
    }
    toRawBytes() {
      const { x: m, y: A } = this.toAffine(), p = Qn(A, e.BYTES);
      return p[p.length - 1] |= m & be ? 128 : 0, p;
    }
    toHex() {
      return wn(this.toRawBytes());
    }
  }
  P.BASE = new P(t.Gx, t.Gy, be, I(t.Gx * t.Gy)), P.ZERO = new P(Oe, be, be, Oe);
  const { BASE: F, ZERO: V } = P, J = lo(P, a * 8);
  function xt(M) {
    return zt(M, n);
  }
  function Mt(M) {
    return xt(Tn(M));
  }
  function X(M) {
    const m = a;
    M = ce("private key", M, m);
    const A = ce("hashed private key", i(M), 2 * m), p = O(A.slice(0, m)), f = A.slice(m, 2 * m), x = Mt(p), H = F.multiply(x), W = H.toRawBytes();
    return { head: p, prefix: f, scalar: x, point: H, pointBytes: W };
  }
  function jt(M) {
    return X(M).pointBytes;
  }
  function j(M = new Uint8Array(), ...m) {
    const A = mn(...m);
    return Mt(i(v(A, ce("context", M), !!s)));
  }
  function u(M, m, A = {}) {
    M = ce("message", M), s && (M = s(M));
    const { prefix: p, scalar: f, pointBytes: x } = X(m), H = j(A.context, p, M), W = F.multiply(H).toRawBytes(), Z = j(A.context, W, x, M), it = xt(H + Z * f);
    U(it);
    const nt = mn(W, Qn(it, e.BYTES));
    return ce("result", nt, a * 2);
  }
  const h = wc;
  function y(M, m, A, p = h) {
    const { context: f, zip215: x } = p, H = e.BYTES;
    M = ce("signature", M, 2 * H), m = ce("message", m), s && (m = s(m));
    const W = Tn(M.slice(H, 2 * H));
    let Z, it, nt;
    try {
      Z = P.fromHex(A, x), it = P.fromHex(M.slice(0, H), x), nt = F.multiplyUnsafe(W);
    } catch {
      return !1;
    }
    if (!x && Z.isSmallOrder())
      return !1;
    const st = j(f, it.toRawBytes(), Z.toRawBytes(), m);
    return it.add(Z.multiplyUnsafe(st)).subtract(nt).clearCofactor().equals(P.ZERO);
  }
  return F._setWindowSize(8), {
    CURVE: t,
    getPublicKey: jt,
    sign: u,
    verify: y,
    ExtendedPoint: P,
    utils: {
      getExtendedPublicKey: X,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => o(e.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(M = 8, m = P.BASE) {
        return m._setWindowSize(M), m.multiply(BigInt(3)), m;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Oi = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), ws = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const Sc = BigInt(1), Li = BigInt(2), Ic = BigInt(5), ms = BigInt(10), xc = BigInt(20), jc = BigInt(40), Ss = BigInt(80);
function bc(r) {
  const t = Oi, n = r * r % t * r % t, s = Yt(n, Li, t) * n % t, i = Yt(s, Sc, t) * r % t, o = Yt(i, Ic, t) * i % t, a = Yt(o, ms, t) * o % t, d = Yt(a, xc, t) * a % t, L = Yt(d, jc, t) * d % t, I = Yt(L, Ss, t) * L % t, b = Yt(I, Ss, t) * L % t, O = Yt(b, ms, t) * o % t;
  return { pow_p_5_8: Yt(O, Li, t) * r % t, b2: n };
}
function Ec(r) {
  return r[0] &= 248, r[31] &= 127, r[31] |= 64, r;
}
function Ac(r, t) {
  const e = Oi, n = zt(t * t * t, e), s = zt(n * n * t, e), i = bc(r * s).pow_p_5_8;
  let o = zt(r * n * i, e);
  const a = zt(t * o * o, e), d = o, L = zt(o * ws, e), I = a === r, b = a === zt(-r, e), O = a === zt(-r * ws, e);
  return I && (o = d), (b || O) && (o = L), fc(o, e) && (o = zt(-o, e)), { isValid: I || b, value: o };
}
const Ke = ao(Oi, void 0, !0), Ri = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: Ke,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: ro,
  randomBytes: to,
  adjustScalarBytes: Ec,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: Ac
}, xr = /* @__PURE__ */ _i(Ri);
function ho(r, t, e) {
  if (t.length > 255)
    throw new Error("Context is too big");
  return Ks($s("SigEd25519 no Ed25519 collisions"), new Uint8Array([e ? 1 : 0, t.length]), t, r);
}
({
  ...Ri
});
({
  ...Ri
});
const Nc = (Ke.ORDER + BigInt(3)) / BigInt(8);
Ke.pow(Li, Nc);
Ke.sqrt(Ke.neg(Ke.ONE));
(Ke.ORDER - BigInt(5)) / BigInt(8);
BigInt(486662);
yc(Ke, Ke.neg(BigInt(486664)));
BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var zi = { exports: {} };
const vc = {}, Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vc
}, Symbol.toStringTag, { value: "Module" })), Bc = /* @__PURE__ */ Ni(Tc);
zi.exports;
(function(r) {
  (function(t, e) {
    function n(j, u) {
      if (!j)
        throw new Error(u || "Assertion failed");
    }
    function s(j, u) {
      j.super_ = u;
      var h = function() {
      };
      h.prototype = u.prototype, j.prototype = new h(), j.prototype.constructor = j;
    }
    function i(j, u, h) {
      if (i.isBN(j))
        return j;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, j !== null && ((u === "le" || u === "be") && (h = u, u = 10), this._init(j || 0, u || 10, h || "be"));
    }
    typeof t == "object" ? t.exports = i : e.BN = i, i.BN = i, i.wordSize = 26;
    var o;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? o = window.Buffer : o = Bc.Buffer;
    } catch {
    }
    i.isBN = function(u) {
      return u instanceof i ? !0 : u !== null && typeof u == "object" && u.constructor.wordSize === i.wordSize && Array.isArray(u.words);
    }, i.max = function(u, h) {
      return u.cmp(h) > 0 ? u : h;
    }, i.min = function(u, h) {
      return u.cmp(h) < 0 ? u : h;
    }, i.prototype._init = function(u, h, y) {
      if (typeof u == "number")
        return this._initNumber(u, h, y);
      if (typeof u == "object")
        return this._initArray(u, h, y);
      h === "hex" && (h = 16), n(h === (h | 0) && h >= 2 && h <= 36), u = u.toString().replace(/\s+/g, "");
      var S = 0;
      u[0] === "-" && (S++, this.negative = 1), S < u.length && (h === 16 ? this._parseHex(u, S, y) : (this._parseBase(u, h, S), y === "le" && this._initArray(this.toArray(), h, y)));
    }, i.prototype._initNumber = function(u, h, y) {
      u < 0 && (this.negative = 1, u = -u), u < 67108864 ? (this.words = [u & 67108863], this.length = 1) : u < 4503599627370496 ? (this.words = [
        u & 67108863,
        u / 67108864 & 67108863
      ], this.length = 2) : (n(u < 9007199254740992), this.words = [
        u & 67108863,
        u / 67108864 & 67108863,
        1
      ], this.length = 3), y === "le" && this._initArray(this.toArray(), h, y);
    }, i.prototype._initArray = function(u, h, y) {
      if (n(typeof u.length == "number"), u.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(u.length / 3), this.words = new Array(this.length);
      for (var S = 0; S < this.length; S++)
        this.words[S] = 0;
      var M, m, A = 0;
      if (y === "be")
        for (S = u.length - 1, M = 0; S >= 0; S -= 3)
          m = u[S] | u[S - 1] << 8 | u[S - 2] << 16, this.words[M] |= m << A & 67108863, this.words[M + 1] = m >>> 26 - A & 67108863, A += 24, A >= 26 && (A -= 26, M++);
      else if (y === "le")
        for (S = 0, M = 0; S < u.length; S += 3)
          m = u[S] | u[S + 1] << 8 | u[S + 2] << 16, this.words[M] |= m << A & 67108863, this.words[M + 1] = m >>> 26 - A & 67108863, A += 24, A >= 26 && (A -= 26, M++);
      return this._strip();
    };
    function a(j, u) {
      var h = j.charCodeAt(u);
      if (h >= 48 && h <= 57)
        return h - 48;
      if (h >= 65 && h <= 70)
        return h - 55;
      if (h >= 97 && h <= 102)
        return h - 87;
      n(!1, "Invalid character in " + j);
    }
    function d(j, u, h) {
      var y = a(j, h);
      return h - 1 >= u && (y |= a(j, h - 1) << 4), y;
    }
    i.prototype._parseHex = function(u, h, y) {
      this.length = Math.ceil((u.length - h) / 6), this.words = new Array(this.length);
      for (var S = 0; S < this.length; S++)
        this.words[S] = 0;
      var M = 0, m = 0, A;
      if (y === "be")
        for (S = u.length - 1; S >= h; S -= 2)
          A = d(u, h, S) << M, this.words[m] |= A & 67108863, M >= 18 ? (M -= 18, m += 1, this.words[m] |= A >>> 26) : M += 8;
      else {
        var p = u.length - h;
        for (S = p % 2 === 0 ? h + 1 : h; S < u.length; S += 2)
          A = d(u, h, S) << M, this.words[m] |= A & 67108863, M >= 18 ? (M -= 18, m += 1, this.words[m] |= A >>> 26) : M += 8;
      }
      this._strip();
    };
    function L(j, u, h, y) {
      for (var S = 0, M = 0, m = Math.min(j.length, h), A = u; A < m; A++) {
        var p = j.charCodeAt(A) - 48;
        S *= y, p >= 49 ? M = p - 49 + 10 : p >= 17 ? M = p - 17 + 10 : M = p, n(p >= 0 && M < y, "Invalid character"), S += M;
      }
      return S;
    }
    i.prototype._parseBase = function(u, h, y) {
      this.words = [0], this.length = 1;
      for (var S = 0, M = 1; M <= 67108863; M *= h)
        S++;
      S--, M = M / h | 0;
      for (var m = u.length - y, A = m % S, p = Math.min(m, m - A) + y, f = 0, x = y; x < p; x += S)
        f = L(u, x, x + S, h), this.imuln(M), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
      if (A !== 0) {
        var H = 1;
        for (f = L(u, x, u.length, h), x = 0; x < A; x++)
          H *= h;
        this.imuln(H), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
      }
      this._strip();
    }, i.prototype.copy = function(u) {
      u.words = new Array(this.length);
      for (var h = 0; h < this.length; h++)
        u.words[h] = this.words[h];
      u.length = this.length, u.negative = this.negative, u.red = this.red;
    };
    function I(j, u) {
      j.words = u.words, j.length = u.length, j.negative = u.negative, j.red = u.red;
    }
    if (i.prototype._move = function(u) {
      I(u, this);
    }, i.prototype.clone = function() {
      var u = new i(null);
      return this.copy(u), u;
    }, i.prototype._expand = function(u) {
      for (; this.length < u; )
        this.words[this.length++] = 0;
      return this;
    }, i.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, i.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = b;
      } catch {
        i.prototype.inspect = b;
      }
    else
      i.prototype.inspect = b;
    function b() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var O = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], v = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], B = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    i.prototype.toString = function(u, h) {
      u = u || 10, h = h | 0 || 1;
      var y;
      if (u === 16 || u === "hex") {
        y = "";
        for (var S = 0, M = 0, m = 0; m < this.length; m++) {
          var A = this.words[m], p = ((A << S | M) & 16777215).toString(16);
          M = A >>> 24 - S & 16777215, S += 2, S >= 26 && (S -= 26, m--), M !== 0 || m !== this.length - 1 ? y = O[6 - p.length] + p + y : y = p + y;
        }
        for (M !== 0 && (y = M.toString(16) + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      if (u === (u | 0) && u >= 2 && u <= 36) {
        var f = v[u], x = B[u];
        y = "";
        var H = this.clone();
        for (H.negative = 0; !H.isZero(); ) {
          var W = H.modrn(x).toString(u);
          H = H.idivn(x), H.isZero() ? y = W + y : y = O[f - W.length] + W + y;
        }
        for (this.isZero() && (y = "0" + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      n(!1, "Base should be between 2 and 36");
    }, i.prototype.toNumber = function() {
      var u = this.words[0];
      return this.length === 2 ? u += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? u += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -u : u;
    }, i.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, o && (i.prototype.toBuffer = function(u, h) {
      return this.toArrayLike(o, u, h);
    }), i.prototype.toArray = function(u, h) {
      return this.toArrayLike(Array, u, h);
    };
    var E = function(u, h) {
      return u.allocUnsafe ? u.allocUnsafe(h) : new u(h);
    };
    i.prototype.toArrayLike = function(u, h, y) {
      this._strip();
      var S = this.byteLength(), M = y || Math.max(1, S);
      n(S <= M, "byte array longer than desired length"), n(M > 0, "Requested array length <= 0");
      var m = E(u, M), A = h === "le" ? "LE" : "BE";
      return this["_toArrayLike" + A](m, S), m;
    }, i.prototype._toArrayLikeLE = function(u, h) {
      for (var y = 0, S = 0, M = 0, m = 0; M < this.length; M++) {
        var A = this.words[M] << m | S;
        u[y++] = A & 255, y < u.length && (u[y++] = A >> 8 & 255), y < u.length && (u[y++] = A >> 16 & 255), m === 6 ? (y < u.length && (u[y++] = A >> 24 & 255), S = 0, m = 0) : (S = A >>> 24, m += 2);
      }
      if (y < u.length)
        for (u[y++] = S; y < u.length; )
          u[y++] = 0;
    }, i.prototype._toArrayLikeBE = function(u, h) {
      for (var y = u.length - 1, S = 0, M = 0, m = 0; M < this.length; M++) {
        var A = this.words[M] << m | S;
        u[y--] = A & 255, y >= 0 && (u[y--] = A >> 8 & 255), y >= 0 && (u[y--] = A >> 16 & 255), m === 6 ? (y >= 0 && (u[y--] = A >> 24 & 255), S = 0, m = 0) : (S = A >>> 24, m += 2);
      }
      if (y >= 0)
        for (u[y--] = S; y >= 0; )
          u[y--] = 0;
    }, Math.clz32 ? i.prototype._countBits = function(u) {
      return 32 - Math.clz32(u);
    } : i.prototype._countBits = function(u) {
      var h = u, y = 0;
      return h >= 4096 && (y += 13, h >>>= 13), h >= 64 && (y += 7, h >>>= 7), h >= 8 && (y += 4, h >>>= 4), h >= 2 && (y += 2, h >>>= 2), y + h;
    }, i.prototype._zeroBits = function(u) {
      if (u === 0)
        return 26;
      var h = u, y = 0;
      return h & 8191 || (y += 13, h >>>= 13), h & 127 || (y += 7, h >>>= 7), h & 15 || (y += 4, h >>>= 4), h & 3 || (y += 2, h >>>= 2), h & 1 || y++, y;
    }, i.prototype.bitLength = function() {
      var u = this.words[this.length - 1], h = this._countBits(u);
      return (this.length - 1) * 26 + h;
    };
    function N(j) {
      for (var u = new Array(j.bitLength()), h = 0; h < u.length; h++) {
        var y = h / 26 | 0, S = h % 26;
        u[h] = j.words[y] >>> S & 1;
      }
      return u;
    }
    i.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var u = 0, h = 0; h < this.length; h++) {
        var y = this._zeroBits(this.words[h]);
        if (u += y, y !== 26)
          break;
      }
      return u;
    }, i.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, i.prototype.toTwos = function(u) {
      return this.negative !== 0 ? this.abs().inotn(u).iaddn(1) : this.clone();
    }, i.prototype.fromTwos = function(u) {
      return this.testn(u - 1) ? this.notn(u).iaddn(1).ineg() : this.clone();
    }, i.prototype.isNeg = function() {
      return this.negative !== 0;
    }, i.prototype.neg = function() {
      return this.clone().ineg();
    }, i.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, i.prototype.iuor = function(u) {
      for (; this.length < u.length; )
        this.words[this.length++] = 0;
      for (var h = 0; h < u.length; h++)
        this.words[h] = this.words[h] | u.words[h];
      return this._strip();
    }, i.prototype.ior = function(u) {
      return n((this.negative | u.negative) === 0), this.iuor(u);
    }, i.prototype.or = function(u) {
      return this.length > u.length ? this.clone().ior(u) : u.clone().ior(this);
    }, i.prototype.uor = function(u) {
      return this.length > u.length ? this.clone().iuor(u) : u.clone().iuor(this);
    }, i.prototype.iuand = function(u) {
      var h;
      this.length > u.length ? h = u : h = this;
      for (var y = 0; y < h.length; y++)
        this.words[y] = this.words[y] & u.words[y];
      return this.length = h.length, this._strip();
    }, i.prototype.iand = function(u) {
      return n((this.negative | u.negative) === 0), this.iuand(u);
    }, i.prototype.and = function(u) {
      return this.length > u.length ? this.clone().iand(u) : u.clone().iand(this);
    }, i.prototype.uand = function(u) {
      return this.length > u.length ? this.clone().iuand(u) : u.clone().iuand(this);
    }, i.prototype.iuxor = function(u) {
      var h, y;
      this.length > u.length ? (h = this, y = u) : (h = u, y = this);
      for (var S = 0; S < y.length; S++)
        this.words[S] = h.words[S] ^ y.words[S];
      if (this !== h)
        for (; S < h.length; S++)
          this.words[S] = h.words[S];
      return this.length = h.length, this._strip();
    }, i.prototype.ixor = function(u) {
      return n((this.negative | u.negative) === 0), this.iuxor(u);
    }, i.prototype.xor = function(u) {
      return this.length > u.length ? this.clone().ixor(u) : u.clone().ixor(this);
    }, i.prototype.uxor = function(u) {
      return this.length > u.length ? this.clone().iuxor(u) : u.clone().iuxor(this);
    }, i.prototype.inotn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = Math.ceil(u / 26) | 0, y = u % 26;
      this._expand(h), y > 0 && h--;
      for (var S = 0; S < h; S++)
        this.words[S] = ~this.words[S] & 67108863;
      return y > 0 && (this.words[S] = ~this.words[S] & 67108863 >> 26 - y), this._strip();
    }, i.prototype.notn = function(u) {
      return this.clone().inotn(u);
    }, i.prototype.setn = function(u, h) {
      n(typeof u == "number" && u >= 0);
      var y = u / 26 | 0, S = u % 26;
      return this._expand(y + 1), h ? this.words[y] = this.words[y] | 1 << S : this.words[y] = this.words[y] & ~(1 << S), this._strip();
    }, i.prototype.iadd = function(u) {
      var h;
      if (this.negative !== 0 && u.negative === 0)
        return this.negative = 0, h = this.isub(u), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && u.negative !== 0)
        return u.negative = 0, h = this.isub(u), u.negative = 1, h._normSign();
      var y, S;
      this.length > u.length ? (y = this, S = u) : (y = u, S = this);
      for (var M = 0, m = 0; m < S.length; m++)
        h = (y.words[m] | 0) + (S.words[m] | 0) + M, this.words[m] = h & 67108863, M = h >>> 26;
      for (; M !== 0 && m < y.length; m++)
        h = (y.words[m] | 0) + M, this.words[m] = h & 67108863, M = h >>> 26;
      if (this.length = y.length, M !== 0)
        this.words[this.length] = M, this.length++;
      else if (y !== this)
        for (; m < y.length; m++)
          this.words[m] = y.words[m];
      return this;
    }, i.prototype.add = function(u) {
      var h;
      return u.negative !== 0 && this.negative === 0 ? (u.negative = 0, h = this.sub(u), u.negative ^= 1, h) : u.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = u.sub(this), this.negative = 1, h) : this.length > u.length ? this.clone().iadd(u) : u.clone().iadd(this);
    }, i.prototype.isub = function(u) {
      if (u.negative !== 0) {
        u.negative = 0;
        var h = this.iadd(u);
        return u.negative = 1, h._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(u), this.negative = 1, this._normSign();
      var y = this.cmp(u);
      if (y === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var S, M;
      y > 0 ? (S = this, M = u) : (S = u, M = this);
      for (var m = 0, A = 0; A < M.length; A++)
        h = (S.words[A] | 0) - (M.words[A] | 0) + m, m = h >> 26, this.words[A] = h & 67108863;
      for (; m !== 0 && A < S.length; A++)
        h = (S.words[A] | 0) + m, m = h >> 26, this.words[A] = h & 67108863;
      if (m === 0 && A < S.length && S !== this)
        for (; A < S.length; A++)
          this.words[A] = S.words[A];
      return this.length = Math.max(this.length, A), S !== this && (this.negative = 1), this._strip();
    }, i.prototype.sub = function(u) {
      return this.clone().isub(u);
    };
    function _(j, u, h) {
      h.negative = u.negative ^ j.negative;
      var y = j.length + u.length | 0;
      h.length = y, y = y - 1 | 0;
      var S = j.words[0] | 0, M = u.words[0] | 0, m = S * M, A = m & 67108863, p = m / 67108864 | 0;
      h.words[0] = A;
      for (var f = 1; f < y; f++) {
        for (var x = p >>> 26, H = p & 67108863, W = Math.min(f, u.length - 1), Z = Math.max(0, f - j.length + 1); Z <= W; Z++) {
          var it = f - Z | 0;
          S = j.words[it] | 0, M = u.words[Z] | 0, m = S * M + H, x += m / 67108864 | 0, H = m & 67108863;
        }
        h.words[f] = H | 0, p = x | 0;
      }
      return p !== 0 ? h.words[f] = p | 0 : h.length--, h._strip();
    }
    var U = function(u, h, y) {
      var S = u.words, M = h.words, m = y.words, A = 0, p, f, x, H = S[0] | 0, W = H & 8191, Z = H >>> 13, it = S[1] | 0, nt = it & 8191, st = it >>> 13, Ut = S[2] | 0, dt = Ut & 8191, pt = Ut >>> 13, St = S[3] | 0, Lt = St & 8191, bt = St >>> 13, Pe = S[4] | 0, At = Pe & 8191, _t = Pe >>> 13, bn = S[5] | 0, Bt = bn & 8191, Nt = bn >>> 13, ye = S[6] | 0, vt = ye & 8191, Tt = ye >>> 13, Ie = S[7] | 0, kt = Ie & 8191, g = Ie >>> 13, c = S[8] | 0, l = c & 8191, w = c >>> 13, T = S[9] | 0, k = T & 8191, R = T >>> 13, ht = M[0] | 0, ft = ht & 8191, ct = ht >>> 13, Ct = M[1] | 0, at = Ct & 8191, Wt = Ct >>> 13, rs = M[2] | 0, Zt = rs & 8191, Gt = rs >>> 13, is = M[3] | 0, Qt = is & 8191, qt = is >>> 13, ss = M[4] | 0, Vt = ss & 8191, $t = ss >>> 13, os = M[5] | 0, Kt = os & 8191, Jt = os >>> 13, us = M[6] | 0, Xt = us & 8191, te = us >>> 13, as = M[7] | 0, ee = as & 8191, ne = as >>> 13, cs = M[8] | 0, re = cs & 8191, ie = cs >>> 13, fs = M[9] | 0, se = fs & 8191, oe = fs >>> 13;
      y.negative = u.negative ^ h.negative, y.length = 19, p = Math.imul(W, ft), f = Math.imul(W, ct), f = f + Math.imul(Z, ft) | 0, x = Math.imul(Z, ct);
      var Cr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Cr >>> 26) | 0, Cr &= 67108863, p = Math.imul(nt, ft), f = Math.imul(nt, ct), f = f + Math.imul(st, ft) | 0, x = Math.imul(st, ct), p = p + Math.imul(W, at) | 0, f = f + Math.imul(W, Wt) | 0, f = f + Math.imul(Z, at) | 0, x = x + Math.imul(Z, Wt) | 0;
      var Dr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, p = Math.imul(dt, ft), f = Math.imul(dt, ct), f = f + Math.imul(pt, ft) | 0, x = Math.imul(pt, ct), p = p + Math.imul(nt, at) | 0, f = f + Math.imul(nt, Wt) | 0, f = f + Math.imul(st, at) | 0, x = x + Math.imul(st, Wt) | 0, p = p + Math.imul(W, Zt) | 0, f = f + Math.imul(W, Gt) | 0, f = f + Math.imul(Z, Zt) | 0, x = x + Math.imul(Z, Gt) | 0;
      var _r = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (_r >>> 26) | 0, _r &= 67108863, p = Math.imul(Lt, ft), f = Math.imul(Lt, ct), f = f + Math.imul(bt, ft) | 0, x = Math.imul(bt, ct), p = p + Math.imul(dt, at) | 0, f = f + Math.imul(dt, Wt) | 0, f = f + Math.imul(pt, at) | 0, x = x + Math.imul(pt, Wt) | 0, p = p + Math.imul(nt, Zt) | 0, f = f + Math.imul(nt, Gt) | 0, f = f + Math.imul(st, Zt) | 0, x = x + Math.imul(st, Gt) | 0, p = p + Math.imul(W, Qt) | 0, f = f + Math.imul(W, qt) | 0, f = f + Math.imul(Z, Qt) | 0, x = x + Math.imul(Z, qt) | 0;
      var Or = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Or >>> 26) | 0, Or &= 67108863, p = Math.imul(At, ft), f = Math.imul(At, ct), f = f + Math.imul(_t, ft) | 0, x = Math.imul(_t, ct), p = p + Math.imul(Lt, at) | 0, f = f + Math.imul(Lt, Wt) | 0, f = f + Math.imul(bt, at) | 0, x = x + Math.imul(bt, Wt) | 0, p = p + Math.imul(dt, Zt) | 0, f = f + Math.imul(dt, Gt) | 0, f = f + Math.imul(pt, Zt) | 0, x = x + Math.imul(pt, Gt) | 0, p = p + Math.imul(nt, Qt) | 0, f = f + Math.imul(nt, qt) | 0, f = f + Math.imul(st, Qt) | 0, x = x + Math.imul(st, qt) | 0, p = p + Math.imul(W, Vt) | 0, f = f + Math.imul(W, $t) | 0, f = f + Math.imul(Z, Vt) | 0, x = x + Math.imul(Z, $t) | 0;
      var Rr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, p = Math.imul(Bt, ft), f = Math.imul(Bt, ct), f = f + Math.imul(Nt, ft) | 0, x = Math.imul(Nt, ct), p = p + Math.imul(At, at) | 0, f = f + Math.imul(At, Wt) | 0, f = f + Math.imul(_t, at) | 0, x = x + Math.imul(_t, Wt) | 0, p = p + Math.imul(Lt, Zt) | 0, f = f + Math.imul(Lt, Gt) | 0, f = f + Math.imul(bt, Zt) | 0, x = x + Math.imul(bt, Gt) | 0, p = p + Math.imul(dt, Qt) | 0, f = f + Math.imul(dt, qt) | 0, f = f + Math.imul(pt, Qt) | 0, x = x + Math.imul(pt, qt) | 0, p = p + Math.imul(nt, Vt) | 0, f = f + Math.imul(nt, $t) | 0, f = f + Math.imul(st, Vt) | 0, x = x + Math.imul(st, $t) | 0, p = p + Math.imul(W, Kt) | 0, f = f + Math.imul(W, Jt) | 0, f = f + Math.imul(Z, Kt) | 0, x = x + Math.imul(Z, Jt) | 0;
      var zr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, p = Math.imul(vt, ft), f = Math.imul(vt, ct), f = f + Math.imul(Tt, ft) | 0, x = Math.imul(Tt, ct), p = p + Math.imul(Bt, at) | 0, f = f + Math.imul(Bt, Wt) | 0, f = f + Math.imul(Nt, at) | 0, x = x + Math.imul(Nt, Wt) | 0, p = p + Math.imul(At, Zt) | 0, f = f + Math.imul(At, Gt) | 0, f = f + Math.imul(_t, Zt) | 0, x = x + Math.imul(_t, Gt) | 0, p = p + Math.imul(Lt, Qt) | 0, f = f + Math.imul(Lt, qt) | 0, f = f + Math.imul(bt, Qt) | 0, x = x + Math.imul(bt, qt) | 0, p = p + Math.imul(dt, Vt) | 0, f = f + Math.imul(dt, $t) | 0, f = f + Math.imul(pt, Vt) | 0, x = x + Math.imul(pt, $t) | 0, p = p + Math.imul(nt, Kt) | 0, f = f + Math.imul(nt, Jt) | 0, f = f + Math.imul(st, Kt) | 0, x = x + Math.imul(st, Jt) | 0, p = p + Math.imul(W, Xt) | 0, f = f + Math.imul(W, te) | 0, f = f + Math.imul(Z, Xt) | 0, x = x + Math.imul(Z, te) | 0;
      var Ur = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Ur >>> 26) | 0, Ur &= 67108863, p = Math.imul(kt, ft), f = Math.imul(kt, ct), f = f + Math.imul(g, ft) | 0, x = Math.imul(g, ct), p = p + Math.imul(vt, at) | 0, f = f + Math.imul(vt, Wt) | 0, f = f + Math.imul(Tt, at) | 0, x = x + Math.imul(Tt, Wt) | 0, p = p + Math.imul(Bt, Zt) | 0, f = f + Math.imul(Bt, Gt) | 0, f = f + Math.imul(Nt, Zt) | 0, x = x + Math.imul(Nt, Gt) | 0, p = p + Math.imul(At, Qt) | 0, f = f + Math.imul(At, qt) | 0, f = f + Math.imul(_t, Qt) | 0, x = x + Math.imul(_t, qt) | 0, p = p + Math.imul(Lt, Vt) | 0, f = f + Math.imul(Lt, $t) | 0, f = f + Math.imul(bt, Vt) | 0, x = x + Math.imul(bt, $t) | 0, p = p + Math.imul(dt, Kt) | 0, f = f + Math.imul(dt, Jt) | 0, f = f + Math.imul(pt, Kt) | 0, x = x + Math.imul(pt, Jt) | 0, p = p + Math.imul(nt, Xt) | 0, f = f + Math.imul(nt, te) | 0, f = f + Math.imul(st, Xt) | 0, x = x + Math.imul(st, te) | 0, p = p + Math.imul(W, ee) | 0, f = f + Math.imul(W, ne) | 0, f = f + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, ne) | 0;
      var Pr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Pr >>> 26) | 0, Pr &= 67108863, p = Math.imul(l, ft), f = Math.imul(l, ct), f = f + Math.imul(w, ft) | 0, x = Math.imul(w, ct), p = p + Math.imul(kt, at) | 0, f = f + Math.imul(kt, Wt) | 0, f = f + Math.imul(g, at) | 0, x = x + Math.imul(g, Wt) | 0, p = p + Math.imul(vt, Zt) | 0, f = f + Math.imul(vt, Gt) | 0, f = f + Math.imul(Tt, Zt) | 0, x = x + Math.imul(Tt, Gt) | 0, p = p + Math.imul(Bt, Qt) | 0, f = f + Math.imul(Bt, qt) | 0, f = f + Math.imul(Nt, Qt) | 0, x = x + Math.imul(Nt, qt) | 0, p = p + Math.imul(At, Vt) | 0, f = f + Math.imul(At, $t) | 0, f = f + Math.imul(_t, Vt) | 0, x = x + Math.imul(_t, $t) | 0, p = p + Math.imul(Lt, Kt) | 0, f = f + Math.imul(Lt, Jt) | 0, f = f + Math.imul(bt, Kt) | 0, x = x + Math.imul(bt, Jt) | 0, p = p + Math.imul(dt, Xt) | 0, f = f + Math.imul(dt, te) | 0, f = f + Math.imul(pt, Xt) | 0, x = x + Math.imul(pt, te) | 0, p = p + Math.imul(nt, ee) | 0, f = f + Math.imul(nt, ne) | 0, f = f + Math.imul(st, ee) | 0, x = x + Math.imul(st, ne) | 0, p = p + Math.imul(W, re) | 0, f = f + Math.imul(W, ie) | 0, f = f + Math.imul(Z, re) | 0, x = x + Math.imul(Z, ie) | 0;
      var Fr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, p = Math.imul(k, ft), f = Math.imul(k, ct), f = f + Math.imul(R, ft) | 0, x = Math.imul(R, ct), p = p + Math.imul(l, at) | 0, f = f + Math.imul(l, Wt) | 0, f = f + Math.imul(w, at) | 0, x = x + Math.imul(w, Wt) | 0, p = p + Math.imul(kt, Zt) | 0, f = f + Math.imul(kt, Gt) | 0, f = f + Math.imul(g, Zt) | 0, x = x + Math.imul(g, Gt) | 0, p = p + Math.imul(vt, Qt) | 0, f = f + Math.imul(vt, qt) | 0, f = f + Math.imul(Tt, Qt) | 0, x = x + Math.imul(Tt, qt) | 0, p = p + Math.imul(Bt, Vt) | 0, f = f + Math.imul(Bt, $t) | 0, f = f + Math.imul(Nt, Vt) | 0, x = x + Math.imul(Nt, $t) | 0, p = p + Math.imul(At, Kt) | 0, f = f + Math.imul(At, Jt) | 0, f = f + Math.imul(_t, Kt) | 0, x = x + Math.imul(_t, Jt) | 0, p = p + Math.imul(Lt, Xt) | 0, f = f + Math.imul(Lt, te) | 0, f = f + Math.imul(bt, Xt) | 0, x = x + Math.imul(bt, te) | 0, p = p + Math.imul(dt, ee) | 0, f = f + Math.imul(dt, ne) | 0, f = f + Math.imul(pt, ee) | 0, x = x + Math.imul(pt, ne) | 0, p = p + Math.imul(nt, re) | 0, f = f + Math.imul(nt, ie) | 0, f = f + Math.imul(st, re) | 0, x = x + Math.imul(st, ie) | 0, p = p + Math.imul(W, se) | 0, f = f + Math.imul(W, oe) | 0, f = f + Math.imul(Z, se) | 0, x = x + Math.imul(Z, oe) | 0;
      var Yr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Yr >>> 26) | 0, Yr &= 67108863, p = Math.imul(k, at), f = Math.imul(k, Wt), f = f + Math.imul(R, at) | 0, x = Math.imul(R, Wt), p = p + Math.imul(l, Zt) | 0, f = f + Math.imul(l, Gt) | 0, f = f + Math.imul(w, Zt) | 0, x = x + Math.imul(w, Gt) | 0, p = p + Math.imul(kt, Qt) | 0, f = f + Math.imul(kt, qt) | 0, f = f + Math.imul(g, Qt) | 0, x = x + Math.imul(g, qt) | 0, p = p + Math.imul(vt, Vt) | 0, f = f + Math.imul(vt, $t) | 0, f = f + Math.imul(Tt, Vt) | 0, x = x + Math.imul(Tt, $t) | 0, p = p + Math.imul(Bt, Kt) | 0, f = f + Math.imul(Bt, Jt) | 0, f = f + Math.imul(Nt, Kt) | 0, x = x + Math.imul(Nt, Jt) | 0, p = p + Math.imul(At, Xt) | 0, f = f + Math.imul(At, te) | 0, f = f + Math.imul(_t, Xt) | 0, x = x + Math.imul(_t, te) | 0, p = p + Math.imul(Lt, ee) | 0, f = f + Math.imul(Lt, ne) | 0, f = f + Math.imul(bt, ee) | 0, x = x + Math.imul(bt, ne) | 0, p = p + Math.imul(dt, re) | 0, f = f + Math.imul(dt, ie) | 0, f = f + Math.imul(pt, re) | 0, x = x + Math.imul(pt, ie) | 0, p = p + Math.imul(nt, se) | 0, f = f + Math.imul(nt, oe) | 0, f = f + Math.imul(st, se) | 0, x = x + Math.imul(st, oe) | 0;
      var Hr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Hr >>> 26) | 0, Hr &= 67108863, p = Math.imul(k, Zt), f = Math.imul(k, Gt), f = f + Math.imul(R, Zt) | 0, x = Math.imul(R, Gt), p = p + Math.imul(l, Qt) | 0, f = f + Math.imul(l, qt) | 0, f = f + Math.imul(w, Qt) | 0, x = x + Math.imul(w, qt) | 0, p = p + Math.imul(kt, Vt) | 0, f = f + Math.imul(kt, $t) | 0, f = f + Math.imul(g, Vt) | 0, x = x + Math.imul(g, $t) | 0, p = p + Math.imul(vt, Kt) | 0, f = f + Math.imul(vt, Jt) | 0, f = f + Math.imul(Tt, Kt) | 0, x = x + Math.imul(Tt, Jt) | 0, p = p + Math.imul(Bt, Xt) | 0, f = f + Math.imul(Bt, te) | 0, f = f + Math.imul(Nt, Xt) | 0, x = x + Math.imul(Nt, te) | 0, p = p + Math.imul(At, ee) | 0, f = f + Math.imul(At, ne) | 0, f = f + Math.imul(_t, ee) | 0, x = x + Math.imul(_t, ne) | 0, p = p + Math.imul(Lt, re) | 0, f = f + Math.imul(Lt, ie) | 0, f = f + Math.imul(bt, re) | 0, x = x + Math.imul(bt, ie) | 0, p = p + Math.imul(dt, se) | 0, f = f + Math.imul(dt, oe) | 0, f = f + Math.imul(pt, se) | 0, x = x + Math.imul(pt, oe) | 0;
      var Wr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, p = Math.imul(k, Qt), f = Math.imul(k, qt), f = f + Math.imul(R, Qt) | 0, x = Math.imul(R, qt), p = p + Math.imul(l, Vt) | 0, f = f + Math.imul(l, $t) | 0, f = f + Math.imul(w, Vt) | 0, x = x + Math.imul(w, $t) | 0, p = p + Math.imul(kt, Kt) | 0, f = f + Math.imul(kt, Jt) | 0, f = f + Math.imul(g, Kt) | 0, x = x + Math.imul(g, Jt) | 0, p = p + Math.imul(vt, Xt) | 0, f = f + Math.imul(vt, te) | 0, f = f + Math.imul(Tt, Xt) | 0, x = x + Math.imul(Tt, te) | 0, p = p + Math.imul(Bt, ee) | 0, f = f + Math.imul(Bt, ne) | 0, f = f + Math.imul(Nt, ee) | 0, x = x + Math.imul(Nt, ne) | 0, p = p + Math.imul(At, re) | 0, f = f + Math.imul(At, ie) | 0, f = f + Math.imul(_t, re) | 0, x = x + Math.imul(_t, ie) | 0, p = p + Math.imul(Lt, se) | 0, f = f + Math.imul(Lt, oe) | 0, f = f + Math.imul(bt, se) | 0, x = x + Math.imul(bt, oe) | 0;
      var Zr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, p = Math.imul(k, Vt), f = Math.imul(k, $t), f = f + Math.imul(R, Vt) | 0, x = Math.imul(R, $t), p = p + Math.imul(l, Kt) | 0, f = f + Math.imul(l, Jt) | 0, f = f + Math.imul(w, Kt) | 0, x = x + Math.imul(w, Jt) | 0, p = p + Math.imul(kt, Xt) | 0, f = f + Math.imul(kt, te) | 0, f = f + Math.imul(g, Xt) | 0, x = x + Math.imul(g, te) | 0, p = p + Math.imul(vt, ee) | 0, f = f + Math.imul(vt, ne) | 0, f = f + Math.imul(Tt, ee) | 0, x = x + Math.imul(Tt, ne) | 0, p = p + Math.imul(Bt, re) | 0, f = f + Math.imul(Bt, ie) | 0, f = f + Math.imul(Nt, re) | 0, x = x + Math.imul(Nt, ie) | 0, p = p + Math.imul(At, se) | 0, f = f + Math.imul(At, oe) | 0, f = f + Math.imul(_t, se) | 0, x = x + Math.imul(_t, oe) | 0;
      var Gr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, p = Math.imul(k, Kt), f = Math.imul(k, Jt), f = f + Math.imul(R, Kt) | 0, x = Math.imul(R, Jt), p = p + Math.imul(l, Xt) | 0, f = f + Math.imul(l, te) | 0, f = f + Math.imul(w, Xt) | 0, x = x + Math.imul(w, te) | 0, p = p + Math.imul(kt, ee) | 0, f = f + Math.imul(kt, ne) | 0, f = f + Math.imul(g, ee) | 0, x = x + Math.imul(g, ne) | 0, p = p + Math.imul(vt, re) | 0, f = f + Math.imul(vt, ie) | 0, f = f + Math.imul(Tt, re) | 0, x = x + Math.imul(Tt, ie) | 0, p = p + Math.imul(Bt, se) | 0, f = f + Math.imul(Bt, oe) | 0, f = f + Math.imul(Nt, se) | 0, x = x + Math.imul(Nt, oe) | 0;
      var Qr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, p = Math.imul(k, Xt), f = Math.imul(k, te), f = f + Math.imul(R, Xt) | 0, x = Math.imul(R, te), p = p + Math.imul(l, ee) | 0, f = f + Math.imul(l, ne) | 0, f = f + Math.imul(w, ee) | 0, x = x + Math.imul(w, ne) | 0, p = p + Math.imul(kt, re) | 0, f = f + Math.imul(kt, ie) | 0, f = f + Math.imul(g, re) | 0, x = x + Math.imul(g, ie) | 0, p = p + Math.imul(vt, se) | 0, f = f + Math.imul(vt, oe) | 0, f = f + Math.imul(Tt, se) | 0, x = x + Math.imul(Tt, oe) | 0;
      var qr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, p = Math.imul(k, ee), f = Math.imul(k, ne), f = f + Math.imul(R, ee) | 0, x = Math.imul(R, ne), p = p + Math.imul(l, re) | 0, f = f + Math.imul(l, ie) | 0, f = f + Math.imul(w, re) | 0, x = x + Math.imul(w, ie) | 0, p = p + Math.imul(kt, se) | 0, f = f + Math.imul(kt, oe) | 0, f = f + Math.imul(g, se) | 0, x = x + Math.imul(g, oe) | 0;
      var Vr = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, p = Math.imul(k, re), f = Math.imul(k, ie), f = f + Math.imul(R, re) | 0, x = Math.imul(R, ie), p = p + Math.imul(l, se) | 0, f = f + Math.imul(l, oe) | 0, f = f + Math.imul(w, se) | 0, x = x + Math.imul(w, oe) | 0;
      var $r = (A + p | 0) + ((f & 8191) << 13) | 0;
      A = (x + (f >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, p = Math.imul(k, se), f = Math.imul(k, oe), f = f + Math.imul(R, se) | 0, x = Math.imul(R, oe);
      var Kr = (A + p | 0) + ((f & 8191) << 13) | 0;
      return A = (x + (f >>> 13) | 0) + (Kr >>> 26) | 0, Kr &= 67108863, m[0] = Cr, m[1] = Dr, m[2] = _r, m[3] = Or, m[4] = Rr, m[5] = zr, m[6] = Ur, m[7] = Pr, m[8] = Fr, m[9] = Yr, m[10] = Hr, m[11] = Wr, m[12] = Zr, m[13] = Gr, m[14] = Qr, m[15] = qr, m[16] = Vr, m[17] = $r, m[18] = Kr, A !== 0 && (m[19] = A, y.length++), y;
    };
    Math.imul || (U = _);
    function z(j, u, h) {
      h.negative = u.negative ^ j.negative, h.length = j.length + u.length;
      for (var y = 0, S = 0, M = 0; M < h.length - 1; M++) {
        var m = S;
        S = 0;
        for (var A = y & 67108863, p = Math.min(M, u.length - 1), f = Math.max(0, M - j.length + 1); f <= p; f++) {
          var x = M - f, H = j.words[x] | 0, W = u.words[f] | 0, Z = H * W, it = Z & 67108863;
          m = m + (Z / 67108864 | 0) | 0, it = it + A | 0, A = it & 67108863, m = m + (it >>> 26) | 0, S += m >>> 26, m &= 67108863;
        }
        h.words[M] = A, y = m, m = S;
      }
      return y !== 0 ? h.words[M] = y : h.length--, h._strip();
    }
    function q(j, u, h) {
      return z(j, u, h);
    }
    i.prototype.mulTo = function(u, h) {
      var y, S = this.length + u.length;
      return this.length === 10 && u.length === 10 ? y = U(this, u, h) : S < 63 ? y = _(this, u, h) : S < 1024 ? y = z(this, u, h) : y = q(this, u, h), y;
    }, i.prototype.mul = function(u) {
      var h = new i(null);
      return h.words = new Array(this.length + u.length), this.mulTo(u, h);
    }, i.prototype.mulf = function(u) {
      var h = new i(null);
      return h.words = new Array(this.length + u.length), q(this, u, h);
    }, i.prototype.imul = function(u) {
      return this.clone().mulTo(u, this);
    }, i.prototype.imuln = function(u) {
      var h = u < 0;
      h && (u = -u), n(typeof u == "number"), n(u < 67108864);
      for (var y = 0, S = 0; S < this.length; S++) {
        var M = (this.words[S] | 0) * u, m = (M & 67108863) + (y & 67108863);
        y >>= 26, y += M / 67108864 | 0, y += m >>> 26, this.words[S] = m & 67108863;
      }
      return y !== 0 && (this.words[S] = y, this.length++), h ? this.ineg() : this;
    }, i.prototype.muln = function(u) {
      return this.clone().imuln(u);
    }, i.prototype.sqr = function() {
      return this.mul(this);
    }, i.prototype.isqr = function() {
      return this.imul(this.clone());
    }, i.prototype.pow = function(u) {
      var h = N(u);
      if (h.length === 0)
        return new i(1);
      for (var y = this, S = 0; S < h.length && h[S] === 0; S++, y = y.sqr())
        ;
      if (++S < h.length)
        for (var M = y.sqr(); S < h.length; S++, M = M.sqr())
          h[S] !== 0 && (y = y.mul(M));
      return y;
    }, i.prototype.iushln = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26, S = 67108863 >>> 26 - h << 26 - h, M;
      if (h !== 0) {
        var m = 0;
        for (M = 0; M < this.length; M++) {
          var A = this.words[M] & S, p = (this.words[M] | 0) - A << h;
          this.words[M] = p | m, m = A >>> 26 - h;
        }
        m && (this.words[M] = m, this.length++);
      }
      if (y !== 0) {
        for (M = this.length - 1; M >= 0; M--)
          this.words[M + y] = this.words[M];
        for (M = 0; M < y; M++)
          this.words[M] = 0;
        this.length += y;
      }
      return this._strip();
    }, i.prototype.ishln = function(u) {
      return n(this.negative === 0), this.iushln(u);
    }, i.prototype.iushrn = function(u, h, y) {
      n(typeof u == "number" && u >= 0);
      var S;
      h ? S = (h - h % 26) / 26 : S = 0;
      var M = u % 26, m = Math.min((u - M) / 26, this.length), A = 67108863 ^ 67108863 >>> M << M, p = y;
      if (S -= m, S = Math.max(0, S), p) {
        for (var f = 0; f < m; f++)
          p.words[f] = this.words[f];
        p.length = m;
      }
      if (m !== 0)
        if (this.length > m)
          for (this.length -= m, f = 0; f < this.length; f++)
            this.words[f] = this.words[f + m];
        else
          this.words[0] = 0, this.length = 1;
      var x = 0;
      for (f = this.length - 1; f >= 0 && (x !== 0 || f >= S); f--) {
        var H = this.words[f] | 0;
        this.words[f] = x << 26 - M | H >>> M, x = H & A;
      }
      return p && x !== 0 && (p.words[p.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, i.prototype.ishrn = function(u, h, y) {
      return n(this.negative === 0), this.iushrn(u, h, y);
    }, i.prototype.shln = function(u) {
      return this.clone().ishln(u);
    }, i.prototype.ushln = function(u) {
      return this.clone().iushln(u);
    }, i.prototype.shrn = function(u) {
      return this.clone().ishrn(u);
    }, i.prototype.ushrn = function(u) {
      return this.clone().iushrn(u);
    }, i.prototype.testn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26, S = 1 << h;
      if (this.length <= y)
        return !1;
      var M = this.words[y];
      return !!(M & S);
    }, i.prototype.imaskn = function(u) {
      n(typeof u == "number" && u >= 0);
      var h = u % 26, y = (u - h) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= y)
        return this;
      if (h !== 0 && y++, this.length = Math.min(y, this.length), h !== 0) {
        var S = 67108863 ^ 67108863 >>> h << h;
        this.words[this.length - 1] &= S;
      }
      return this._strip();
    }, i.prototype.maskn = function(u) {
      return this.clone().imaskn(u);
    }, i.prototype.iaddn = function(u) {
      return n(typeof u == "number"), n(u < 67108864), u < 0 ? this.isubn(-u) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= u ? (this.words[0] = u - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(u), this.negative = 1, this) : this._iaddn(u);
    }, i.prototype._iaddn = function(u) {
      this.words[0] += u;
      for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
        this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
      return this.length = Math.max(this.length, h + 1), this;
    }, i.prototype.isubn = function(u) {
      if (n(typeof u == "number"), n(u < 67108864), u < 0)
        return this.iaddn(-u);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(u), this.negative = 1, this;
      if (this.words[0] -= u, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var h = 0; h < this.length && this.words[h] < 0; h++)
          this.words[h] += 67108864, this.words[h + 1] -= 1;
      return this._strip();
    }, i.prototype.addn = function(u) {
      return this.clone().iaddn(u);
    }, i.prototype.subn = function(u) {
      return this.clone().isubn(u);
    }, i.prototype.iabs = function() {
      return this.negative = 0, this;
    }, i.prototype.abs = function() {
      return this.clone().iabs();
    }, i.prototype._ishlnsubmul = function(u, h, y) {
      var S = u.length + y, M;
      this._expand(S);
      var m, A = 0;
      for (M = 0; M < u.length; M++) {
        m = (this.words[M + y] | 0) + A;
        var p = (u.words[M] | 0) * h;
        m -= p & 67108863, A = (m >> 26) - (p / 67108864 | 0), this.words[M + y] = m & 67108863;
      }
      for (; M < this.length - y; M++)
        m = (this.words[M + y] | 0) + A, A = m >> 26, this.words[M + y] = m & 67108863;
      if (A === 0)
        return this._strip();
      for (n(A === -1), A = 0, M = 0; M < this.length; M++)
        m = -(this.words[M] | 0) + A, A = m >> 26, this.words[M] = m & 67108863;
      return this.negative = 1, this._strip();
    }, i.prototype._wordDiv = function(u, h) {
      var y = this.length - u.length, S = this.clone(), M = u, m = M.words[M.length - 1] | 0, A = this._countBits(m);
      y = 26 - A, y !== 0 && (M = M.ushln(y), S.iushln(y), m = M.words[M.length - 1] | 0);
      var p = S.length - M.length, f;
      if (h !== "mod") {
        f = new i(null), f.length = p + 1, f.words = new Array(f.length);
        for (var x = 0; x < f.length; x++)
          f.words[x] = 0;
      }
      var H = S.clone()._ishlnsubmul(M, 1, p);
      H.negative === 0 && (S = H, f && (f.words[p] = 1));
      for (var W = p - 1; W >= 0; W--) {
        var Z = (S.words[M.length + W] | 0) * 67108864 + (S.words[M.length + W - 1] | 0);
        for (Z = Math.min(Z / m | 0, 67108863), S._ishlnsubmul(M, Z, W); S.negative !== 0; )
          Z--, S.negative = 0, S._ishlnsubmul(M, 1, W), S.isZero() || (S.negative ^= 1);
        f && (f.words[W] = Z);
      }
      return f && f._strip(), S._strip(), h !== "div" && y !== 0 && S.iushrn(y), {
        div: f || null,
        mod: S
      };
    }, i.prototype.divmod = function(u, h, y) {
      if (n(!u.isZero()), this.isZero())
        return {
          div: new i(0),
          mod: new i(0)
        };
      var S, M, m;
      return this.negative !== 0 && u.negative === 0 ? (m = this.neg().divmod(u, h), h !== "mod" && (S = m.div.neg()), h !== "div" && (M = m.mod.neg(), y && M.negative !== 0 && M.iadd(u)), {
        div: S,
        mod: M
      }) : this.negative === 0 && u.negative !== 0 ? (m = this.divmod(u.neg(), h), h !== "mod" && (S = m.div.neg()), {
        div: S,
        mod: m.mod
      }) : this.negative & u.negative ? (m = this.neg().divmod(u.neg(), h), h !== "div" && (M = m.mod.neg(), y && M.negative !== 0 && M.isub(u)), {
        div: m.div,
        mod: M
      }) : u.length > this.length || this.cmp(u) < 0 ? {
        div: new i(0),
        mod: this
      } : u.length === 1 ? h === "div" ? {
        div: this.divn(u.words[0]),
        mod: null
      } : h === "mod" ? {
        div: null,
        mod: new i(this.modrn(u.words[0]))
      } : {
        div: this.divn(u.words[0]),
        mod: new i(this.modrn(u.words[0]))
      } : this._wordDiv(u, h);
    }, i.prototype.div = function(u) {
      return this.divmod(u, "div", !1).div;
    }, i.prototype.mod = function(u) {
      return this.divmod(u, "mod", !1).mod;
    }, i.prototype.umod = function(u) {
      return this.divmod(u, "mod", !0).mod;
    }, i.prototype.divRound = function(u) {
      var h = this.divmod(u);
      if (h.mod.isZero())
        return h.div;
      var y = h.div.negative !== 0 ? h.mod.isub(u) : h.mod, S = u.ushrn(1), M = u.andln(1), m = y.cmp(S);
      return m < 0 || M === 1 && m === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
    }, i.prototype.modrn = function(u) {
      var h = u < 0;
      h && (u = -u), n(u <= 67108863);
      for (var y = (1 << 26) % u, S = 0, M = this.length - 1; M >= 0; M--)
        S = (y * S + (this.words[M] | 0)) % u;
      return h ? -S : S;
    }, i.prototype.modn = function(u) {
      return this.modrn(u);
    }, i.prototype.idivn = function(u) {
      var h = u < 0;
      h && (u = -u), n(u <= 67108863);
      for (var y = 0, S = this.length - 1; S >= 0; S--) {
        var M = (this.words[S] | 0) + y * 67108864;
        this.words[S] = M / u | 0, y = M % u;
      }
      return this._strip(), h ? this.ineg() : this;
    }, i.prototype.divn = function(u) {
      return this.clone().idivn(u);
    }, i.prototype.egcd = function(u) {
      n(u.negative === 0), n(!u.isZero());
      var h = this, y = u.clone();
      h.negative !== 0 ? h = h.umod(u) : h = h.clone();
      for (var S = new i(1), M = new i(0), m = new i(0), A = new i(1), p = 0; h.isEven() && y.isEven(); )
        h.iushrn(1), y.iushrn(1), ++p;
      for (var f = y.clone(), x = h.clone(); !h.isZero(); ) {
        for (var H = 0, W = 1; !(h.words[0] & W) && H < 26; ++H, W <<= 1)
          ;
        if (H > 0)
          for (h.iushrn(H); H-- > 0; )
            (S.isOdd() || M.isOdd()) && (S.iadd(f), M.isub(x)), S.iushrn(1), M.iushrn(1);
        for (var Z = 0, it = 1; !(y.words[0] & it) && Z < 26; ++Z, it <<= 1)
          ;
        if (Z > 0)
          for (y.iushrn(Z); Z-- > 0; )
            (m.isOdd() || A.isOdd()) && (m.iadd(f), A.isub(x)), m.iushrn(1), A.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), S.isub(m), M.isub(A)) : (y.isub(h), m.isub(S), A.isub(M));
      }
      return {
        a: m,
        b: A,
        gcd: y.iushln(p)
      };
    }, i.prototype._invmp = function(u) {
      n(u.negative === 0), n(!u.isZero());
      var h = this, y = u.clone();
      h.negative !== 0 ? h = h.umod(u) : h = h.clone();
      for (var S = new i(1), M = new i(0), m = y.clone(); h.cmpn(1) > 0 && y.cmpn(1) > 0; ) {
        for (var A = 0, p = 1; !(h.words[0] & p) && A < 26; ++A, p <<= 1)
          ;
        if (A > 0)
          for (h.iushrn(A); A-- > 0; )
            S.isOdd() && S.iadd(m), S.iushrn(1);
        for (var f = 0, x = 1; !(y.words[0] & x) && f < 26; ++f, x <<= 1)
          ;
        if (f > 0)
          for (y.iushrn(f); f-- > 0; )
            M.isOdd() && M.iadd(m), M.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), S.isub(M)) : (y.isub(h), M.isub(S));
      }
      var H;
      return h.cmpn(1) === 0 ? H = S : H = M, H.cmpn(0) < 0 && H.iadd(u), H;
    }, i.prototype.gcd = function(u) {
      if (this.isZero())
        return u.abs();
      if (u.isZero())
        return this.abs();
      var h = this.clone(), y = u.clone();
      h.negative = 0, y.negative = 0;
      for (var S = 0; h.isEven() && y.isEven(); S++)
        h.iushrn(1), y.iushrn(1);
      do {
        for (; h.isEven(); )
          h.iushrn(1);
        for (; y.isEven(); )
          y.iushrn(1);
        var M = h.cmp(y);
        if (M < 0) {
          var m = h;
          h = y, y = m;
        } else if (M === 0 || y.cmpn(1) === 0)
          break;
        h.isub(y);
      } while (!0);
      return y.iushln(S);
    }, i.prototype.invm = function(u) {
      return this.egcd(u).a.umod(u);
    }, i.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, i.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, i.prototype.andln = function(u) {
      return this.words[0] & u;
    }, i.prototype.bincn = function(u) {
      n(typeof u == "number");
      var h = u % 26, y = (u - h) / 26, S = 1 << h;
      if (this.length <= y)
        return this._expand(y + 1), this.words[y] |= S, this;
      for (var M = S, m = y; M !== 0 && m < this.length; m++) {
        var A = this.words[m] | 0;
        A += M, M = A >>> 26, A &= 67108863, this.words[m] = A;
      }
      return M !== 0 && (this.words[m] = M, this.length++), this;
    }, i.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, i.prototype.cmpn = function(u) {
      var h = u < 0;
      if (this.negative !== 0 && !h)
        return -1;
      if (this.negative === 0 && h)
        return 1;
      this._strip();
      var y;
      if (this.length > 1)
        y = 1;
      else {
        h && (u = -u), n(u <= 67108863, "Number is too big");
        var S = this.words[0] | 0;
        y = S === u ? 0 : S < u ? -1 : 1;
      }
      return this.negative !== 0 ? -y | 0 : y;
    }, i.prototype.cmp = function(u) {
      if (this.negative !== 0 && u.negative === 0)
        return -1;
      if (this.negative === 0 && u.negative !== 0)
        return 1;
      var h = this.ucmp(u);
      return this.negative !== 0 ? -h | 0 : h;
    }, i.prototype.ucmp = function(u) {
      if (this.length > u.length)
        return 1;
      if (this.length < u.length)
        return -1;
      for (var h = 0, y = this.length - 1; y >= 0; y--) {
        var S = this.words[y] | 0, M = u.words[y] | 0;
        if (S !== M) {
          S < M ? h = -1 : S > M && (h = 1);
          break;
        }
      }
      return h;
    }, i.prototype.gtn = function(u) {
      return this.cmpn(u) === 1;
    }, i.prototype.gt = function(u) {
      return this.cmp(u) === 1;
    }, i.prototype.gten = function(u) {
      return this.cmpn(u) >= 0;
    }, i.prototype.gte = function(u) {
      return this.cmp(u) >= 0;
    }, i.prototype.ltn = function(u) {
      return this.cmpn(u) === -1;
    }, i.prototype.lt = function(u) {
      return this.cmp(u) === -1;
    }, i.prototype.lten = function(u) {
      return this.cmpn(u) <= 0;
    }, i.prototype.lte = function(u) {
      return this.cmp(u) <= 0;
    }, i.prototype.eqn = function(u) {
      return this.cmpn(u) === 0;
    }, i.prototype.eq = function(u) {
      return this.cmp(u) === 0;
    }, i.red = function(u) {
      return new X(u);
    }, i.prototype.toRed = function(u) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), u.convertTo(this)._forceRed(u);
    }, i.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, i.prototype._forceRed = function(u) {
      return this.red = u, this;
    }, i.prototype.forceRed = function(u) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(u);
    }, i.prototype.redAdd = function(u) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, u);
    }, i.prototype.redIAdd = function(u) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, u);
    }, i.prototype.redSub = function(u) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, u);
    }, i.prototype.redISub = function(u) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, u);
    }, i.prototype.redShl = function(u) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, u);
    }, i.prototype.redMul = function(u) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.mul(this, u);
    }, i.prototype.redIMul = function(u) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.imul(this, u);
    }, i.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, i.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, i.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, i.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, i.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, i.prototype.redPow = function(u) {
      return n(this.red && !u.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, u);
    };
    var P = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function F(j, u) {
      this.name = j, this.p = new i(u, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    F.prototype._tmp = function() {
      var u = new i(null);
      return u.words = new Array(Math.ceil(this.n / 13)), u;
    }, F.prototype.ireduce = function(u) {
      var h = u, y;
      do
        this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), y = h.bitLength();
      while (y > this.n);
      var S = y < this.n ? -1 : h.ucmp(this.p);
      return S === 0 ? (h.words[0] = 0, h.length = 1) : S > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
    }, F.prototype.split = function(u, h) {
      u.iushrn(this.n, 0, h);
    }, F.prototype.imulK = function(u) {
      return u.imul(this.k);
    };
    function V() {
      F.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(V, F), V.prototype.split = function(u, h) {
      for (var y = 4194303, S = Math.min(u.length, 9), M = 0; M < S; M++)
        h.words[M] = u.words[M];
      if (h.length = S, u.length <= 9) {
        u.words[0] = 0, u.length = 1;
        return;
      }
      var m = u.words[9];
      for (h.words[h.length++] = m & y, M = 10; M < u.length; M++) {
        var A = u.words[M] | 0;
        u.words[M - 10] = (A & y) << 4 | m >>> 22, m = A;
      }
      m >>>= 22, u.words[M - 10] = m, m === 0 && u.length > 10 ? u.length -= 10 : u.length -= 9;
    }, V.prototype.imulK = function(u) {
      u.words[u.length] = 0, u.words[u.length + 1] = 0, u.length += 2;
      for (var h = 0, y = 0; y < u.length; y++) {
        var S = u.words[y] | 0;
        h += S * 977, u.words[y] = h & 67108863, h = S * 64 + (h / 67108864 | 0);
      }
      return u.words[u.length - 1] === 0 && (u.length--, u.words[u.length - 1] === 0 && u.length--), u;
    };
    function J() {
      F.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(J, F);
    function xt() {
      F.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(xt, F);
    function Mt() {
      F.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(Mt, F), Mt.prototype.imulK = function(u) {
      for (var h = 0, y = 0; y < u.length; y++) {
        var S = (u.words[y] | 0) * 19 + h, M = S & 67108863;
        S >>>= 26, u.words[y] = M, h = S;
      }
      return h !== 0 && (u.words[u.length++] = h), u;
    }, i._prime = function(u) {
      if (P[u])
        return P[u];
      var h;
      if (u === "k256")
        h = new V();
      else if (u === "p224")
        h = new J();
      else if (u === "p192")
        h = new xt();
      else if (u === "p25519")
        h = new Mt();
      else
        throw new Error("Unknown prime " + u);
      return P[u] = h, h;
    };
    function X(j) {
      if (typeof j == "string") {
        var u = i._prime(j);
        this.m = u.p, this.prime = u;
      } else
        n(j.gtn(1), "modulus must be greater than 1"), this.m = j, this.prime = null;
    }
    X.prototype._verify1 = function(u) {
      n(u.negative === 0, "red works only with positives"), n(u.red, "red works only with red numbers");
    }, X.prototype._verify2 = function(u, h) {
      n((u.negative | h.negative) === 0, "red works only with positives"), n(
        u.red && u.red === h.red,
        "red works only with red numbers"
      );
    }, X.prototype.imod = function(u) {
      return this.prime ? this.prime.ireduce(u)._forceRed(this) : (I(u, u.umod(this.m)._forceRed(this)), u);
    }, X.prototype.neg = function(u) {
      return u.isZero() ? u.clone() : this.m.sub(u)._forceRed(this);
    }, X.prototype.add = function(u, h) {
      this._verify2(u, h);
      var y = u.add(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y._forceRed(this);
    }, X.prototype.iadd = function(u, h) {
      this._verify2(u, h);
      var y = u.iadd(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y;
    }, X.prototype.sub = function(u, h) {
      this._verify2(u, h);
      var y = u.sub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y._forceRed(this);
    }, X.prototype.isub = function(u, h) {
      this._verify2(u, h);
      var y = u.isub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y;
    }, X.prototype.shl = function(u, h) {
      return this._verify1(u), this.imod(u.ushln(h));
    }, X.prototype.imul = function(u, h) {
      return this._verify2(u, h), this.imod(u.imul(h));
    }, X.prototype.mul = function(u, h) {
      return this._verify2(u, h), this.imod(u.mul(h));
    }, X.prototype.isqr = function(u) {
      return this.imul(u, u.clone());
    }, X.prototype.sqr = function(u) {
      return this.mul(u, u);
    }, X.prototype.sqrt = function(u) {
      if (u.isZero())
        return u.clone();
      var h = this.m.andln(3);
      if (n(h % 2 === 1), h === 3) {
        var y = this.m.add(new i(1)).iushrn(2);
        return this.pow(u, y);
      }
      for (var S = this.m.subn(1), M = 0; !S.isZero() && S.andln(1) === 0; )
        M++, S.iushrn(1);
      n(!S.isZero());
      var m = new i(1).toRed(this), A = m.redNeg(), p = this.m.subn(1).iushrn(1), f = this.m.bitLength();
      for (f = new i(2 * f * f).toRed(this); this.pow(f, p).cmp(A) !== 0; )
        f.redIAdd(A);
      for (var x = this.pow(f, S), H = this.pow(u, S.addn(1).iushrn(1)), W = this.pow(u, S), Z = M; W.cmp(m) !== 0; ) {
        for (var it = W, nt = 0; it.cmp(m) !== 0; nt++)
          it = it.redSqr();
        n(nt < Z);
        var st = this.pow(x, new i(1).iushln(Z - nt - 1));
        H = H.redMul(st), x = st.redSqr(), W = W.redMul(x), Z = nt;
      }
      return H;
    }, X.prototype.invm = function(u) {
      var h = u._invmp(this.m);
      return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
    }, X.prototype.pow = function(u, h) {
      if (h.isZero())
        return new i(1).toRed(this);
      if (h.cmpn(1) === 0)
        return u.clone();
      var y = 4, S = new Array(1 << y);
      S[0] = new i(1).toRed(this), S[1] = u;
      for (var M = 2; M < S.length; M++)
        S[M] = this.mul(S[M - 1], u);
      var m = S[0], A = 0, p = 0, f = h.bitLength() % 26;
      for (f === 0 && (f = 26), M = h.length - 1; M >= 0; M--) {
        for (var x = h.words[M], H = f - 1; H >= 0; H--) {
          var W = x >> H & 1;
          if (m !== S[0] && (m = this.sqr(m)), W === 0 && A === 0) {
            p = 0;
            continue;
          }
          A <<= 1, A |= W, p++, !(p !== y && (M !== 0 || H !== 0)) && (m = this.mul(m, S[A]), p = 0, A = 0);
        }
        f = 26;
      }
      return m;
    }, X.prototype.convertTo = function(u) {
      var h = u.umod(this.m);
      return h === u ? h.clone() : h;
    }, X.prototype.convertFrom = function(u) {
      var h = u.clone();
      return h.red = null, h;
    }, i.mont = function(u) {
      return new jt(u);
    };
    function jt(j) {
      X.call(this, j), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(jt, X), jt.prototype.convertTo = function(u) {
      return this.imod(u.ushln(this.shift));
    }, jt.prototype.convertFrom = function(u) {
      var h = this.imod(u.mul(this.rinv));
      return h.red = null, h;
    }, jt.prototype.imul = function(u, h) {
      if (u.isZero() || h.isZero())
        return u.words[0] = 0, u.length = 1, u;
      var y = u.imul(h), S = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), M = y.isub(S).iushrn(this.shift), m = M;
      return M.cmp(this.m) >= 0 ? m = M.isub(this.m) : M.cmpn(0) < 0 && (m = M.iadd(this.m)), m._forceRed(this);
    }, jt.prototype.mul = function(u, h) {
      if (u.isZero() || h.isZero())
        return new i(0)._forceRed(this);
      var y = u.mul(h), S = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), M = y.isub(S).iushrn(this.shift), m = M;
      return M.cmp(this.m) >= 0 ? m = M.isub(this.m) : M.cmpn(0) < 0 && (m = M.iadd(this.m)), m._forceRed(this);
    }, jt.prototype.invm = function(u) {
      var h = this.imod(u._invmp(this.m).mul(this.r2));
      return h._forceRed(this);
    };
  })(r, ze);
})(zi);
var go = zi.exports;
const Is = /* @__PURE__ */ Ai(go);
var wi = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(r, t) {
  var e = lt, n = e.Buffer;
  function s(o, a) {
    for (var d in o)
      a[d] = o[d];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? r.exports = e : (s(e, t), t.Buffer = i);
  function i(o, a, d) {
    return n(o, a, d);
  }
  i.prototype = Object.create(n.prototype), s(n, i), i.from = function(o, a, d) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return n(o, a, d);
  }, i.alloc = function(o, a, d) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var L = n(o);
    return a !== void 0 ? typeof d == "string" ? L.fill(a, d) : L.fill(a) : L.fill(0), L;
  }, i.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return n(o);
  }, i.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return e.SlowBuffer(o);
  };
})(wi, wi.exports);
var yo = wi.exports, sr = yo.Buffer;
function kc(r) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), e = 0; e < t.length; e++)
    t[e] = 255;
  for (var n = 0; n < r.length; n++) {
    var s = r.charAt(n), i = s.charCodeAt(0);
    if (t[i] !== 255)
      throw new TypeError(s + " is ambiguous");
    t[i] = n;
  }
  var o = r.length, a = r.charAt(0), d = Math.log(o) / Math.log(256), L = Math.log(256) / Math.log(o);
  function I(v) {
    if ((Array.isArray(v) || v instanceof Uint8Array) && (v = sr.from(v)), !sr.isBuffer(v))
      throw new TypeError("Expected Buffer");
    if (v.length === 0)
      return "";
    for (var B = 0, E = 0, N = 0, _ = v.length; N !== _ && v[N] === 0; )
      N++, B++;
    for (var U = (_ - N) * L + 1 >>> 0, z = new Uint8Array(U); N !== _; ) {
      for (var q = v[N], P = 0, F = U - 1; (q !== 0 || P < E) && F !== -1; F--, P++)
        q += 256 * z[F] >>> 0, z[F] = q % o >>> 0, q = q / o >>> 0;
      if (q !== 0)
        throw new Error("Non-zero carry");
      E = P, N++;
    }
    for (var V = U - E; V !== U && z[V] === 0; )
      V++;
    for (var J = a.repeat(B); V < U; ++V)
      J += r.charAt(z[V]);
    return J;
  }
  function b(v) {
    if (typeof v != "string")
      throw new TypeError("Expected String");
    if (v.length === 0)
      return sr.alloc(0);
    for (var B = 0, E = 0, N = 0; v[B] === a; )
      E++, B++;
    for (var _ = (v.length - B) * d + 1 >>> 0, U = new Uint8Array(_); v[B]; ) {
      var z = t[v.charCodeAt(B)];
      if (z === 255)
        return;
      for (var q = 0, P = _ - 1; (z !== 0 || q < N) && P !== -1; P--, q++)
        z += o * U[P] >>> 0, U[P] = z % 256 >>> 0, z = z / 256 >>> 0;
      if (z !== 0)
        throw new Error("Non-zero carry");
      N = q, B++;
    }
    for (var F = _ - N; F !== _ && U[F] === 0; )
      F++;
    var V = sr.allocUnsafe(E + (_ - F));
    V.fill(0, 0, E);
    for (var J = E; F !== _; )
      V[J++] = U[F++];
    return V;
  }
  function O(v) {
    var B = b(v);
    if (B)
      return B;
    throw new Error("Non-base" + o + " character");
  }
  return {
    encode: I,
    decodeUnsafe: b,
    decode: O
  };
}
var Cc = kc, Dc = Cc, _c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Oc = Dc(_c);
const ge = /* @__PURE__ */ Ai(Oc), Rc = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), en = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), nn = /* @__PURE__ */ new Uint32Array(64);
class zc extends eo {
  constructor() {
    super(64, 32, 8, !1), this.A = en[0] | 0, this.B = en[1] | 0, this.C = en[2] | 0, this.D = en[3] | 0, this.E = en[4] | 0, this.F = en[5] | 0, this.G = en[6] | 0, this.H = en[7] | 0;
  }
  get() {
    const { A: t, B: e, C: n, D: s, E: i, F: o, G: a, H: d } = this;
    return [t, e, n, s, i, o, a, d];
  }
  // prettier-ignore
  set(t, e, n, s, i, o, a, d) {
    this.A = t | 0, this.B = e | 0, this.C = n | 0, this.D = s | 0, this.E = i | 0, this.F = o | 0, this.G = a | 0, this.H = d | 0;
  }
  process(t, e) {
    for (let b = 0; b < 16; b++, e += 4)
      nn[b] = t.getUint32(e, !1);
    for (let b = 16; b < 64; b++) {
      const O = nn[b - 15], v = nn[b - 2], B = Fe(O, 7) ^ Fe(O, 18) ^ O >>> 3, E = Fe(v, 17) ^ Fe(v, 19) ^ v >>> 10;
      nn[b] = E + nn[b - 7] + B + nn[b - 16] | 0;
    }
    let { A: n, B: s, C: i, D: o, E: a, F: d, G: L, H: I } = this;
    for (let b = 0; b < 64; b++) {
      const O = Fe(a, 6) ^ Fe(a, 11) ^ Fe(a, 25), v = I + O + xa(a, d, L) + Rc[b] + nn[b] | 0, E = (Fe(n, 2) ^ Fe(n, 13) ^ Fe(n, 22)) + ja(n, s, i) | 0;
      I = L, L = d, d = a, a = o + v | 0, o = i, i = s, s = n, n = v + E | 0;
    }
    n = n + this.A | 0, s = s + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, d = d + this.F | 0, L = L + this.G | 0, I = I + this.H | 0, this.set(n, s, i, o, a, d, L, I);
  }
  roundClean() {
    nn.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const mi = /* @__PURE__ */ Xs(() => new zc());
var de = {}, or = yo.Buffer;
function Uc(r) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), e = 0; e < t.length; e++)
    t[e] = 255;
  for (var n = 0; n < r.length; n++) {
    var s = r.charAt(n), i = s.charCodeAt(0);
    if (t[i] !== 255)
      throw new TypeError(s + " is ambiguous");
    t[i] = n;
  }
  var o = r.length, a = r.charAt(0), d = Math.log(o) / Math.log(256), L = Math.log(256) / Math.log(o);
  function I(v) {
    if ((Array.isArray(v) || v instanceof Uint8Array) && (v = or.from(v)), !or.isBuffer(v))
      throw new TypeError("Expected Buffer");
    if (v.length === 0)
      return "";
    for (var B = 0, E = 0, N = 0, _ = v.length; N !== _ && v[N] === 0; )
      N++, B++;
    for (var U = (_ - N) * L + 1 >>> 0, z = new Uint8Array(U); N !== _; ) {
      for (var q = v[N], P = 0, F = U - 1; (q !== 0 || P < E) && F !== -1; F--, P++)
        q += 256 * z[F] >>> 0, z[F] = q % o >>> 0, q = q / o >>> 0;
      if (q !== 0)
        throw new Error("Non-zero carry");
      E = P, N++;
    }
    for (var V = U - E; V !== U && z[V] === 0; )
      V++;
    for (var J = a.repeat(B); V < U; ++V)
      J += r.charAt(z[V]);
    return J;
  }
  function b(v) {
    if (typeof v != "string")
      throw new TypeError("Expected String");
    if (v.length === 0)
      return or.alloc(0);
    for (var B = 0, E = 0, N = 0; v[B] === a; )
      E++, B++;
    for (var _ = (v.length - B) * d + 1 >>> 0, U = new Uint8Array(_); v[B]; ) {
      var z = t[v.charCodeAt(B)];
      if (z === 255)
        return;
      for (var q = 0, P = _ - 1; (z !== 0 || q < N) && P !== -1; P--, q++)
        z += o * U[P] >>> 0, U[P] = z % 256 >>> 0, z = z / 256 >>> 0;
      if (z !== 0)
        throw new Error("Non-zero carry");
      N = q, B++;
    }
    for (var F = _ - N; F !== _ && U[F] === 0; )
      F++;
    var V = or.allocUnsafe(E + (_ - F));
    V.fill(0, 0, E);
    for (var J = E; F !== _; )
      V[J++] = U[F++];
    return V;
  }
  function O(v) {
    var B = b(v);
    if (B)
      return B;
    throw new Error("Non-base" + o + " character");
  }
  return {
    encode: I,
    decodeUnsafe: b,
    decode: O
  };
}
var Pc = Uc, Fc = Pc, Yc = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Hc = Fc(Yc);
function qe(r, t, e) {
  return t <= r && r <= e;
}
function jr(r) {
  if (r === void 0)
    return {};
  if (r === Object(r))
    return r;
  throw TypeError("Could not convert argument to dictionary");
}
function Wc(r) {
  for (var t = String(r), e = t.length, n = 0, s = []; n < e; ) {
    var i = t.charCodeAt(n);
    if (i < 55296 || i > 57343)
      s.push(i);
    else if (56320 <= i && i <= 57343)
      s.push(65533);
    else if (55296 <= i && i <= 56319)
      if (n === e - 1)
        s.push(65533);
      else {
        var o = r.charCodeAt(n + 1);
        if (56320 <= o && o <= 57343) {
          var a = i & 1023, d = o & 1023;
          s.push(65536 + (a << 10) + d), n += 1;
        } else
          s.push(65533);
      }
    n += 1;
  }
  return s;
}
function Zc(r) {
  for (var t = "", e = 0; e < r.length; ++e) {
    var n = r[e];
    n <= 65535 ? t += String.fromCharCode(n) : (n -= 65536, t += String.fromCharCode(
      (n >> 10) + 55296,
      (n & 1023) + 56320
    ));
  }
  return t;
}
var lr = -1;
function Ui(r) {
  this.tokens = [].slice.call(r);
}
Ui.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : lr;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(r) {
    if (Array.isArray(r))
      for (var t = (
        /**@type {!Array.<number>}*/
        r
      ); t.length; )
        this.tokens.unshift(t.pop());
    else
      this.tokens.unshift(r);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(r) {
    if (Array.isArray(r))
      for (var t = (
        /**@type {!Array.<number>}*/
        r
      ); t.length; )
        this.tokens.push(t.shift());
    else
      this.tokens.push(r);
  }
};
var Dn = -1;
function ri(r, t) {
  if (r)
    throw TypeError("Decoder error");
  return t || 65533;
}
var hr = "utf-8";
function dr(r, t) {
  if (!(this instanceof dr))
    return new dr(r, t);
  if (r = r !== void 0 ? String(r).toLowerCase() : hr, r !== hr)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = jr(t), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!t.fatal, this._ignoreBOM = !!t.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
dr.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(t, e) {
    var n;
    typeof t == "object" && t instanceof ArrayBuffer ? n = new Uint8Array(t) : typeof t == "object" && "buffer" in t && t.buffer instanceof ArrayBuffer ? n = new Uint8Array(
      t.buffer,
      t.byteOffset,
      t.byteLength
    ) : n = new Uint8Array(0), e = jr(e), this._streaming || (this._decoder = new Gc({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!e.stream;
    for (var s = new Ui(n), i = [], o; !s.endOfStream() && (o = this._decoder.handler(s, s.read()), o !== Dn); )
      o !== null && (Array.isArray(o) ? i.push.apply(
        i,
        /**@type {!Array.<number>}*/
        o
      ) : i.push(o));
    if (!this._streaming) {
      do {
        if (o = this._decoder.handler(s, s.read()), o === Dn)
          break;
        o !== null && (Array.isArray(o) ? i.push.apply(
          i,
          /**@type {!Array.<number>}*/
          o
        ) : i.push(o));
      } while (!s.endOfStream());
      this._decoder = null;
    }
    return i.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (i[0] === 65279 ? (this._BOMseen = !0, i.shift()) : this._BOMseen = !0), Zc(i);
  }
};
function gr(r, t) {
  if (!(this instanceof gr))
    return new gr(r, t);
  if (r = r !== void 0 ? String(r).toLowerCase() : hr, r !== hr)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = jr(t), this._streaming = !1, this._encoder = null, this._options = { fatal: !!t.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
gr.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(t, e) {
    t = t ? String(t) : "", e = jr(e), this._streaming || (this._encoder = new Qc(this._options)), this._streaming = !!e.stream;
    for (var n = [], s = new Ui(Wc(t)), i; !s.endOfStream() && (i = this._encoder.handler(s, s.read()), i !== Dn); )
      Array.isArray(i) ? n.push.apply(
        n,
        /**@type {!Array.<number>}*/
        i
      ) : n.push(i);
    if (!this._streaming) {
      for (; i = this._encoder.handler(s, s.read()), i !== Dn; )
        Array.isArray(i) ? n.push.apply(
          n,
          /**@type {!Array.<number>}*/
          i
        ) : n.push(i);
      this._encoder = null;
    }
    return new Uint8Array(n);
  }
};
function Gc(r) {
  var t = r.fatal, e = 0, n = 0, s = 0, i = 128, o = 191;
  this.handler = function(a, d) {
    if (d === lr && s !== 0)
      return s = 0, ri(t);
    if (d === lr)
      return Dn;
    if (s === 0) {
      if (qe(d, 0, 127))
        return d;
      if (qe(d, 194, 223))
        s = 1, e = d - 192;
      else if (qe(d, 224, 239))
        d === 224 && (i = 160), d === 237 && (o = 159), s = 2, e = d - 224;
      else if (qe(d, 240, 244))
        d === 240 && (i = 144), d === 244 && (o = 143), s = 3, e = d - 240;
      else
        return ri(t);
      return e = e << 6 * s, null;
    }
    if (!qe(d, i, o))
      return e = s = n = 0, i = 128, o = 191, a.prepend(d), ri(t);
    if (i = 128, o = 191, n += 1, e += d - 128 << 6 * (s - n), n !== s)
      return null;
    var L = e;
    return e = s = n = 0, L;
  };
}
function Qc(r) {
  r.fatal, this.handler = function(t, e) {
    if (e === lr)
      return Dn;
    if (qe(e, 0, 127))
      return e;
    var n, s;
    qe(e, 128, 2047) ? (n = 1, s = 192) : qe(e, 2048, 65535) ? (n = 2, s = 224) : qe(e, 65536, 1114111) && (n = 3, s = 240);
    for (var i = [(e >> 6 * n) + s]; n > 0; ) {
      var o = e >> 6 * (n - 1);
      i.push(128 | o & 63), n -= 1;
    }
    return i;
  };
}
const qc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: dr,
  TextEncoder: gr
}, Symbol.toStringTag, { value: "Module" })), Vc = /* @__PURE__ */ Ni(qc);
var $c = ze && ze.__createBinding || (Object.create ? function(r, t, e, n) {
  n === void 0 && (n = e), Object.defineProperty(r, n, { enumerable: !0, get: function() {
    return t[e];
  } });
} : function(r, t, e, n) {
  n === void 0 && (n = e), r[n] = t[e];
}), Kc = ze && ze.__setModuleDefault || (Object.create ? function(r, t) {
  Object.defineProperty(r, "default", { enumerable: !0, value: t });
} : function(r, t) {
  r.default = t;
}), We = ze && ze.__decorate || function(r, t, e, n) {
  var s = arguments.length, i = s < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, e) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(r, t, e, n);
  else
    for (var a = r.length - 1; a >= 0; a--)
      (o = r[a]) && (i = (s < 3 ? o(i) : s > 3 ? o(t, e, i) : o(t, e)) || i);
  return s > 3 && i && Object.defineProperty(t, e, i), i;
}, Jc = ze && ze.__importStar || function(r) {
  if (r && r.__esModule)
    return r;
  var t = {};
  if (r != null)
    for (var e in r)
      e !== "default" && Object.hasOwnProperty.call(r, e) && $c(t, r, e);
  return Kc(t, r), t;
}, po = ze && ze.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(de, "__esModule", { value: !0 });
var Mo = de.deserializeUnchecked = xo = de.deserialize = Io = de.serialize = de.BinaryReader = de.BinaryWriter = de.BorshError = de.baseDecode = de.baseEncode = void 0;
const on = po(go), Lo = po(Hc), Xc = Jc(Vc), tf = typeof TextDecoder != "function" ? Xc.TextDecoder : TextDecoder, ef = new tf("utf-8", { fatal: !0 });
function nf(r) {
  return typeof r == "string" && (r = Buffer.from(r, "utf8")), Lo.default.encode(Buffer.from(r));
}
de.baseEncode = nf;
function rf(r) {
  return Buffer.from(Lo.default.decode(r));
}
de.baseDecode = rf;
const ii = 1024;
class Se extends Error {
  constructor(t) {
    super(t), this.fieldPath = [], this.originalMessage = t;
  }
  addToFieldPath(t) {
    this.fieldPath.splice(0, 0, t), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
de.BorshError = Se;
class wo {
  constructor() {
    this.buf = Buffer.alloc(ii), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Buffer.concat([this.buf, Buffer.alloc(ii)]));
  }
  writeU8(t) {
    this.maybeResize(), this.buf.writeUInt8(t, this.length), this.length += 1;
  }
  writeU16(t) {
    this.maybeResize(), this.buf.writeUInt16LE(t, this.length), this.length += 2;
  }
  writeU32(t) {
    this.maybeResize(), this.buf.writeUInt32LE(t, this.length), this.length += 4;
  }
  writeU64(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new on.default(t).toArray("le", 8)));
  }
  writeU128(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new on.default(t).toArray("le", 16)));
  }
  writeU256(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new on.default(t).toArray("le", 32)));
  }
  writeU512(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new on.default(t).toArray("le", 64)));
  }
  writeBuffer(t) {
    this.buf = Buffer.concat([
      Buffer.from(this.buf.subarray(0, this.length)),
      t,
      Buffer.alloc(ii)
    ]), this.length += t.length;
  }
  writeString(t) {
    this.maybeResize();
    const e = Buffer.from(t, "utf8");
    this.writeU32(e.length), this.writeBuffer(e);
  }
  writeFixedArray(t) {
    this.writeBuffer(Buffer.from(t));
  }
  writeArray(t, e) {
    this.maybeResize(), this.writeU32(t.length);
    for (const n of t)
      this.maybeResize(), e(n);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
de.BinaryWriter = wo;
function Ze(r, t, e) {
  const n = e.value;
  e.value = function(...s) {
    try {
      return n.apply(this, s);
    } catch (i) {
      if (i instanceof RangeError) {
        const o = i.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(o) >= 0)
          throw new Se("Reached the end of buffer when deserializing");
      }
      throw i;
    }
  };
}
class Be {
  constructor(t) {
    this.buf = t, this.offset = 0;
  }
  readU8() {
    const t = this.buf.readUInt8(this.offset);
    return this.offset += 1, t;
  }
  readU16() {
    const t = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, t;
  }
  readU32() {
    const t = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readU64() {
    const t = this.readBuffer(8);
    return new on.default(t, "le");
  }
  readU128() {
    const t = this.readBuffer(16);
    return new on.default(t, "le");
  }
  readU256() {
    const t = this.readBuffer(32);
    return new on.default(t, "le");
  }
  readU512() {
    const t = this.readBuffer(64);
    return new on.default(t, "le");
  }
  readBuffer(t) {
    if (this.offset + t > this.buf.length)
      throw new Se(`Expected buffer length ${t} isn't within bounds`);
    const e = this.buf.slice(this.offset, this.offset + t);
    return this.offset += t, e;
  }
  readString() {
    const t = this.readU32(), e = this.readBuffer(t);
    try {
      return ef.decode(e);
    } catch (n) {
      throw new Se(`Error decoding UTF-8 string: ${n}`);
    }
  }
  readFixedArray(t) {
    return new Uint8Array(this.readBuffer(t));
  }
  readArray(t) {
    const e = this.readU32(), n = Array();
    for (let s = 0; s < e; ++s)
      n.push(t());
    return n;
  }
}
We([
  Ze
], Be.prototype, "readU8", null);
We([
  Ze
], Be.prototype, "readU16", null);
We([
  Ze
], Be.prototype, "readU32", null);
We([
  Ze
], Be.prototype, "readU64", null);
We([
  Ze
], Be.prototype, "readU128", null);
We([
  Ze
], Be.prototype, "readU256", null);
We([
  Ze
], Be.prototype, "readU512", null);
We([
  Ze
], Be.prototype, "readString", null);
We([
  Ze
], Be.prototype, "readFixedArray", null);
We([
  Ze
], Be.prototype, "readArray", null);
de.BinaryReader = Be;
function mo(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function dn(r, t, e, n, s) {
  try {
    if (typeof n == "string")
      s[`write${mo(n)}`](e);
    else if (n instanceof Array)
      if (typeof n[0] == "number") {
        if (e.length !== n[0])
          throw new Se(`Expecting byte array of length ${n[0]}, but got ${e.length} bytes`);
        s.writeFixedArray(e);
      } else if (n.length === 2 && typeof n[1] == "number") {
        if (e.length !== n[1])
          throw new Se(`Expecting byte array of length ${n[1]}, but got ${e.length} bytes`);
        for (let i = 0; i < n[1]; i++)
          dn(r, null, e[i], n[0], s);
      } else
        s.writeArray(e, (i) => {
          dn(r, t, i, n[0], s);
        });
    else if (n.kind !== void 0)
      switch (n.kind) {
        case "option": {
          e == null ? s.writeU8(0) : (s.writeU8(1), dn(r, t, e, n.type, s));
          break;
        }
        case "map": {
          s.writeU32(e.size), e.forEach((i, o) => {
            dn(r, t, o, n.key, s), dn(r, t, i, n.value, s);
          });
          break;
        }
        default:
          throw new Se(`FieldType ${n} unrecognized`);
      }
    else
      So(r, e, s);
  } catch (i) {
    throw i instanceof Se && i.addToFieldPath(t), i;
  }
}
function So(r, t, e) {
  if (typeof t.borshSerialize == "function") {
    t.borshSerialize(e);
    return;
  }
  const n = r.get(t.constructor);
  if (!n)
    throw new Se(`Class ${t.constructor.name} is missing in schema`);
  if (n.kind === "struct")
    n.fields.map(([s, i]) => {
      dn(r, s, t[s], i, e);
    });
  else if (n.kind === "enum") {
    const s = t[n.field];
    for (let i = 0; i < n.values.length; ++i) {
      const [o, a] = n.values[i];
      if (o === s) {
        e.writeU8(i), dn(r, o, t[o], a, e);
        break;
      }
    }
  } else
    throw new Se(`Unexpected schema kind: ${n.kind} for ${t.constructor.name}`);
}
function sf(r, t, e = wo) {
  const n = new e();
  return So(r, t, n), n.toArray();
}
var Io = de.serialize = sf;
function gn(r, t, e, n) {
  try {
    if (typeof e == "string")
      return n[`read${mo(e)}`]();
    if (e instanceof Array) {
      if (typeof e[0] == "number")
        return n.readFixedArray(e[0]);
      if (typeof e[1] == "number") {
        const s = [];
        for (let i = 0; i < e[1]; i++)
          s.push(gn(r, null, e[0], n));
        return s;
      } else
        return n.readArray(() => gn(r, t, e[0], n));
    }
    if (e.kind === "option")
      return n.readU8() ? gn(r, t, e.type, n) : void 0;
    if (e.kind === "map") {
      let s = /* @__PURE__ */ new Map();
      const i = n.readU32();
      for (let o = 0; o < i; o++) {
        const a = gn(r, t, e.key, n), d = gn(r, t, e.value, n);
        s.set(a, d);
      }
      return s;
    }
    return Pi(r, e, n);
  } catch (s) {
    throw s instanceof Se && s.addToFieldPath(t), s;
  }
}
function Pi(r, t, e) {
  if (typeof t.borshDeserialize == "function")
    return t.borshDeserialize(e);
  const n = r.get(t);
  if (!n)
    throw new Se(`Class ${t.name} is missing in schema`);
  if (n.kind === "struct") {
    const s = {};
    for (const [i, o] of r.get(t).fields)
      s[i] = gn(r, i, o, e);
    return new t(s);
  }
  if (n.kind === "enum") {
    const s = e.readU8();
    if (s >= n.values.length)
      throw new Se(`Enum index: ${s} is out of range`);
    const [i, o] = n.values[s], a = gn(r, i, o, e);
    return new t({ [i]: a });
  }
  throw new Se(`Unexpected schema kind: ${n.kind} for ${t.constructor.name}`);
}
function of(r, t, e, n = Be) {
  const s = new n(e), i = Pi(r, t, s);
  if (s.offset < e.length)
    throw new Se(`Unexpected ${e.length - s.offset} bytes after deserialized data`);
  return i;
}
var xo = de.deserialize = of;
function uf(r, t, e, n = Be) {
  const s = new n(e);
  return Pi(r, t, s);
}
Mo = de.deserializeUnchecked = uf;
var D = {};
Object.defineProperty(D, "__esModule", { value: !0 });
D.s16 = D.s8 = D.nu64be = D.u48be = D.u40be = D.u32be = D.u24be = D.u16be = he = D.nu64 = D.u48 = D.u40 = rt = D.u32 = D.u24 = De = D.u16 = It = D.u8 = Mn = D.offset = D.greedy = D.Constant = D.UTF8 = D.CString = D.Blob = D.Boolean = D.BitField = D.BitStructure = D.VariantLayout = D.Union = D.UnionLayoutDiscriminator = D.UnionDiscriminator = D.Structure = D.Sequence = D.DoubleBE = D.Double = D.FloatBE = D.Float = D.NearInt64BE = D.NearInt64 = D.NearUInt64BE = D.NearUInt64 = D.IntBE = D.Int = D.UIntBE = D.UInt = D.OffsetLayout = D.GreedyCount = D.ExternalLayout = D.bindConstructorLayout = D.nameWithProperty = D.Layout = D.uint8ArrayToBuffer = D.checkUint8Array = void 0;
D.constant = D.utf8 = D.cstr = Dt = D.blob = D.unionLayoutDiscriminator = D.union = me = D.seq = D.bits = tt = D.struct = D.f64be = D.f64 = D.f32be = D.f32 = D.ns64be = D.s48be = D.s40be = D.s32be = D.s24be = D.s16be = Ae = D.ns64 = D.s48 = D.s40 = D.s32 = D.s24 = void 0;
const Fi = lt;
function Un(r) {
  if (!(r instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
D.checkUint8Array = Un;
function mt(r) {
  return Un(r), Fi.Buffer.from(r.buffer, r.byteOffset, r.length);
}
D.uint8ArrayToBuffer = mt;
class Et {
  constructor(t, e) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = e;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, e) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const e = Object.create(this.constructor.prototype);
    return Object.assign(e, this), e.property = t, e;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
}
D.Layout = Et;
function Yi(r, t) {
  return t.property ? r + "[" + t.property + "]" : r;
}
D.nameWithProperty = Yi;
function af(r, t) {
  if (typeof r != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(r, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(t && t instanceof Et))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(t, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  r.layout_ = t, t.boundConstructor_ = r, t.makeDestinationObject = () => new r(), Object.defineProperty(r.prototype, "encode", {
    value(e, n) {
      return t.encode(this, e, n);
    },
    writable: !0
  }), Object.defineProperty(r, "decode", {
    value(e, n) {
      return t.decode(e, n);
    },
    writable: !0
  });
}
D.bindConstructorLayout = af;
class xe extends Et {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
D.ExternalLayout = xe;
class jo extends xe {
  constructor(t = 1, e) {
    if (!Number.isInteger(t) || 0 >= t)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, e), this.elementSpan = t;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(t, e = 0) {
    Un(t);
    const n = t.length - e;
    return Math.floor(n / this.elementSpan);
  }
  /** @override */
  encode(t, e, n) {
    return 0;
  }
}
D.GreedyCount = jo;
class Hi extends xe {
  constructor(t, e = 0, n) {
    if (!(t instanceof Et))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(e))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, n || t.property), this.layout = t, this.offset = e;
  }
  /** @override */
  isCount() {
    return this.layout instanceof _e || this.layout instanceof Re;
  }
  /** @override */
  decode(t, e = 0) {
    return this.layout.decode(t, e + this.offset);
  }
  /** @override */
  encode(t, e, n = 0) {
    return this.layout.encode(t, e, n + this.offset);
  }
}
D.OffsetLayout = Hi;
class _e extends Et {
  constructor(t, e) {
    if (super(t, e), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readUIntLE(e, this.span);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeUIntLE(t, n, this.span), this.span;
  }
}
D.UInt = _e;
class Re extends Et {
  constructor(t, e) {
    if (super(t, e), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readUIntBE(e, this.span);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeUIntBE(t, n, this.span), this.span;
  }
}
D.UIntBE = Re;
class Sn extends Et {
  constructor(t, e) {
    if (super(t, e), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readIntLE(e, this.span);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeIntLE(t, n, this.span), this.span;
  }
}
D.Int = Sn;
class Pn extends Et {
  constructor(t, e) {
    if (super(t, e), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readIntBE(e, this.span);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeIntBE(t, n, this.span), this.span;
  }
}
D.IntBE = Pn;
const Si = Math.pow(2, 32);
function br(r) {
  const t = Math.floor(r / Si), e = r - t * Si;
  return { hi32: t, lo32: e };
}
function Er(r, t) {
  return r * Si + t;
}
class bo extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    const n = mt(t), s = n.readUInt32LE(e), i = n.readUInt32LE(e + 4);
    return Er(i, s);
  }
  /** @override */
  encode(t, e, n = 0) {
    const s = br(t), i = mt(e);
    return i.writeUInt32LE(s.lo32, n), i.writeUInt32LE(s.hi32, n + 4), 8;
  }
}
D.NearUInt64 = bo;
class Eo extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    const n = mt(t), s = n.readUInt32BE(e), i = n.readUInt32BE(e + 4);
    return Er(s, i);
  }
  /** @override */
  encode(t, e, n = 0) {
    const s = br(t), i = mt(e);
    return i.writeUInt32BE(s.hi32, n), i.writeUInt32BE(s.lo32, n + 4), 8;
  }
}
D.NearUInt64BE = Eo;
class Ao extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    const n = mt(t), s = n.readUInt32LE(e), i = n.readInt32LE(e + 4);
    return Er(i, s);
  }
  /** @override */
  encode(t, e, n = 0) {
    const s = br(t), i = mt(e);
    return i.writeUInt32LE(s.lo32, n), i.writeInt32LE(s.hi32, n + 4), 8;
  }
}
D.NearInt64 = Ao;
class No extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    const n = mt(t), s = n.readInt32BE(e), i = n.readUInt32BE(e + 4);
    return Er(s, i);
  }
  /** @override */
  encode(t, e, n = 0) {
    const s = br(t), i = mt(e);
    return i.writeInt32BE(s.hi32, n), i.writeUInt32BE(s.lo32, n + 4), 8;
  }
}
D.NearInt64BE = No;
class vo extends Et {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readFloatLE(e);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeFloatLE(t, n), 4;
  }
}
D.Float = vo;
class To extends Et {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readFloatBE(e);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeFloatBE(t, n), 4;
  }
}
D.FloatBE = To;
class Bo extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readDoubleLE(e);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeDoubleLE(t, n), 8;
  }
}
D.Double = Bo;
class ko extends Et {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, e = 0) {
    return mt(t).readDoubleBE(e);
  }
  /** @override */
  encode(t, e, n = 0) {
    return mt(e).writeDoubleBE(t, n), 8;
  }
}
D.DoubleBE = ko;
class Co extends Et {
  constructor(t, e, n) {
    if (!(t instanceof Et))
      throw new TypeError("elementLayout must be a Layout");
    if (!(e instanceof xe && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let s = -1;
    !(e instanceof xe) && 0 < t.span && (s = e * t.span), super(s, n), this.elementLayout = t, this.count = e;
  }
  /** @override */
  getSpan(t, e = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0, s = this.count;
    if (s instanceof xe && (s = s.decode(t, e)), 0 < this.elementLayout.span)
      n = s * this.elementLayout.span;
    else {
      let i = 0;
      for (; i < s; )
        n += this.elementLayout.getSpan(t, e + n), ++i;
    }
    return n;
  }
  /** @override */
  decode(t, e = 0) {
    const n = [];
    let s = 0, i = this.count;
    for (i instanceof xe && (i = i.decode(t, e)); s < i; )
      n.push(this.elementLayout.decode(t, e)), e += this.elementLayout.getSpan(t, e), s += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, e, n = 0) {
    const s = this.elementLayout, i = t.reduce((o, a) => o + s.encode(a, e, n + o), 0);
    return this.count instanceof xe && this.count.encode(t.length, e, n), i;
  }
}
D.Sequence = Co;
class Do extends Et {
  constructor(t, e, n) {
    if (!(Array.isArray(t) && t.reduce((i, o) => i && o instanceof Et, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof e == "boolean" && n === void 0 && (n = e, e = void 0);
    for (const i of t)
      if (0 > i.span && i.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let s = -1;
    try {
      s = t.reduce((i, o) => i + o.getSpan(), 0);
    } catch {
    }
    super(s, e), this.fields = t, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(t, e = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    try {
      n = this.fields.reduce((s, i) => {
        const o = i.getSpan(t, e);
        return e += o, s + o;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(t, e = 0) {
    Un(t);
    const n = this.makeDestinationObject();
    for (const s of this.fields)
      if (s.property !== void 0 && (n[s.property] = s.decode(t, e)), e += s.getSpan(t, e), this.decodePrefixes && t.length === e)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, e, n = 0) {
    const s = n;
    let i = 0, o = 0;
    for (const a of this.fields) {
      let d = a.span;
      if (o = 0 < d ? d : 0, a.property !== void 0) {
        const L = t[a.property];
        L !== void 0 && (o = a.encode(L, e, n), 0 > d && (d = a.getSpan(e, n)));
      }
      i = n, n += d;
    }
    return i + o - s;
  }
  /** @override */
  fromArray(t) {
    const e = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < t.length && (e[n.property] = t.shift());
    return e;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const e of this.fields)
      if (e.property === t)
        return e;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let e = 0;
    for (const n of this.fields) {
      if (n.property === t)
        return e;
      0 > n.span ? e = -1 : 0 <= e && (e += n.span);
    }
  }
}
D.Structure = Do;
class Wi {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(t, e) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(t, e, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
}
D.UnionDiscriminator = Wi;
class yr extends Wi {
  constructor(t, e) {
    if (!(t instanceof xe && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(e || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, e) {
    return this.layout.decode(t, e);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, e, n) {
    return this.layout.encode(t, e, n);
  }
}
D.UnionLayoutDiscriminator = yr;
class Zi extends Et {
  constructor(t, e, n) {
    let s;
    if (t instanceof _e || t instanceof Re)
      s = new yr(new Hi(t));
    else if (t instanceof xe && t.isCount())
      s = new yr(t);
    else if (t instanceof Wi)
      s = t;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (e === void 0 && (e = null), !(e === null || e instanceof Et))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (e !== null) {
      if (0 > e.span)
        throw new Error("defaultLayout must have constant span");
      e.property === void 0 && (e = e.replicate("content"));
    }
    let i = -1;
    e && (i = e.span, 0 <= i && (t instanceof _e || t instanceof Re) && (i += s.layout.span)), super(i, n), this.discriminator = s, this.usesPrefixDiscriminator = t instanceof _e || t instanceof Re, this.defaultLayout = e, this.registry = {};
    let o = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(a) {
      return o(a);
    }, this.configGetSourceVariant = function(a) {
      o = a.bind(this);
    };
  }
  /** @override */
  getSpan(t, e = 0) {
    if (0 <= this.span)
      return this.span;
    const n = this.getVariant(t, e);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(t, e);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (Object.prototype.hasOwnProperty.call(t, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(t, this.defaultLayout.property))
        return;
      const e = this.registry[t[this.discriminator.property]];
      if (e && (!e.layout || e.property && Object.prototype.hasOwnProperty.call(t, e.property)))
        return e;
    } else
      for (const e in this.registry) {
        const n = this.registry[e];
        if (n.property && Object.prototype.hasOwnProperty.call(t, n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, e = 0) {
    let n;
    const s = this.discriminator, i = s.decode(t, e), o = this.registry[i];
    if (o === void 0) {
      const a = this.defaultLayout;
      let d = 0;
      this.usesPrefixDiscriminator && (d = s.layout.span), n = this.makeDestinationObject(), n[s.property] = i, n[a.property] = a.decode(t, e + d);
    } else
      n = o.decode(t, e);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, e, n = 0) {
    const s = this.getSourceVariant(t);
    if (s === void 0) {
      const i = this.discriminator, o = this.defaultLayout;
      let a = 0;
      return this.usesPrefixDiscriminator && (a = i.layout.span), i.encode(t[i.property], e, n), a + o.encode(t[o.property], e, n + a);
    }
    return s.encode(t, e, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, e, n) {
    const s = new _o(this, t, e, n);
    return this.registry[t] = s, s;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, e = 0) {
    let n;
    return t instanceof Uint8Array ? n = this.discriminator.decode(t, e) : n = t, this.registry[n];
  }
}
D.Union = Zi;
class _o extends Et {
  constructor(t, e, n, s) {
    if (!(t instanceof Zi))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(e) || 0 > e)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && s === void 0 && (s = n, n = null), n) {
      if (!(n instanceof Et))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= n.span && n.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof s != "string")
        throw new TypeError("variant must have a String property");
    }
    let i = t.span;
    0 > t.span && (i = n ? n.span : 0, 0 <= i && t.usesPrefixDiscriminator && (i += t.discriminator.layout.span)), super(i, s), this.union = t, this.variant = e, this.layout = n || null;
  }
  /** @override */
  getSpan(t, e = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span);
    let s = 0;
    return this.layout && (s = this.layout.getSpan(t, e + n)), n + s;
  }
  /** @override */
  decode(t, e = 0) {
    const n = this.makeDestinationObject();
    if (this !== this.union.getVariant(t, e))
      throw new Error("variant mismatch");
    let s = 0;
    return this.union.usesPrefixDiscriminator && (s = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(t, e + s) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(t, e, n = 0) {
    let s = 0;
    if (this.union.usesPrefixDiscriminator && (s = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(t, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, e, n);
    let i = s;
    if (this.layout && (this.layout.encode(t[this.property], e, n + s), i += this.layout.getSpan(e, n + s), 0 <= this.union.span && i > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return i;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
}
D.VariantLayout = _o;
function An(r) {
  return 0 > r && (r += 4294967296), r;
}
class Gi extends Et {
  constructor(t, e, n) {
    if (!(t instanceof _e || t instanceof Re))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof e == "string" && n === void 0 && (n = e, e = !1), 4 < t.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(t.span, n), this.word = t, this.msb = !!e, this.fields = [];
    let s = 0;
    this._packedSetValue = function(i) {
      return s = An(i), this;
    }, this._packedGetValue = function() {
      return s;
    };
  }
  /** @override */
  decode(t, e = 0) {
    const n = this.makeDestinationObject(), s = this.word.decode(t, e);
    this._packedSetValue(s);
    for (const i of this.fields)
      i.property !== void 0 && (n[i.property] = i.decode(t));
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(t, e, n = 0) {
    const s = this.word.decode(e, n);
    this._packedSetValue(s);
    for (const i of this.fields)
      if (i.property !== void 0) {
        const o = t[i.property];
        o !== void 0 && i.encode(o);
      }
    return this.word.encode(this._packedGetValue(), e, n);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(t, e) {
    const n = new Qi(this, t, e);
    return this.fields.push(n), n;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(t) {
    const e = new Oo(this, t);
    return this.fields.push(e), e;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const e of this.fields)
      if (e.property === t)
        return e;
  }
}
D.BitStructure = Gi;
class Qi {
  constructor(t, e, n) {
    if (!(t instanceof Gi))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(e) || 0 >= e)
      throw new TypeError("bits must be positive integer");
    const s = 8 * t.span, i = t.fields.reduce((o, a) => o + a.bits, 0);
    if (e + i > s)
      throw new Error("bits too long for span remainder (" + (s - i) + " of " + s + " remain)");
    this.container = t, this.bits = e, this.valueMask = (1 << e) - 1, e === 32 && (this.valueMask = 4294967295), this.start = i, this.container.msb && (this.start = s - i - e), this.wordMask = An(this.valueMask << this.start), this.property = n;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(t, e) {
    const n = this.container._packedGetValue();
    return An(n & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(t) {
    if (typeof t != "number" || !Number.isInteger(t) || t !== An(t & this.valueMask))
      throw new TypeError(Yi("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const e = this.container._packedGetValue(), n = An(t << this.start);
    this.container._packedSetValue(An(e & ~this.wordMask) | n);
  }
}
D.BitField = Qi;
let Oo = class extends Qi {
  constructor(t, e) {
    super(t, 1, e);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(t, e) {
    return !!super.decode(t, e);
  }
  /** @override */
  encode(t) {
    typeof t == "boolean" && (t = +t), super.encode(t);
  }
};
D.Boolean = Oo;
class Ro extends Et {
  constructor(t, e) {
    if (!(t instanceof xe && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    t instanceof xe || (n = t), super(n, e), this.length = t;
  }
  /** @override */
  getSpan(t, e) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(t, e)), n;
  }
  /** @override */
  decode(t, e = 0) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(t, e)), mt(t).slice(e, e + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, e, n) {
    let s = this.length;
    if (this.length instanceof xe && (s = t.length), !(t instanceof Uint8Array && s === t.length))
      throw new TypeError(Yi("Blob.encode", this) + " requires (length " + s + ") Uint8Array as src");
    if (n + s > e.length)
      throw new RangeError("encoding overruns Uint8Array");
    const i = mt(t);
    return mt(e).write(i.toString("hex"), n, s, "hex"), this.length instanceof xe && this.length.encode(s, e, n), s;
  }
}
D.Blob = Ro;
class zo extends Et {
  constructor(t) {
    super(-1, t);
  }
  /** @override */
  getSpan(t, e = 0) {
    Un(t);
    let n = e;
    for (; n < t.length && t[n] !== 0; )
      n += 1;
    return 1 + n - e;
  }
  /** @override */
  decode(t, e = 0) {
    const n = this.getSpan(t, e);
    return mt(t).slice(e, e + n - 1).toString("utf-8");
  }
  /** @override */
  encode(t, e, n = 0) {
    typeof t != "string" && (t = String(t));
    const s = Fi.Buffer.from(t, "utf8"), i = s.length;
    if (n + i > e.length)
      throw new RangeError("encoding overruns Buffer");
    const o = mt(e);
    return s.copy(o, n), o[n + i] = 0, i + 1;
  }
}
D.CString = zo;
class Uo extends Et {
  constructor(t, e) {
    if (typeof t == "string" && e === void 0 && (e = t, t = void 0), t === void 0)
      t = -1;
    else if (!Number.isInteger(t))
      throw new TypeError("maxSpan must be an integer");
    super(-1, e), this.maxSpan = t;
  }
  /** @override */
  getSpan(t, e = 0) {
    return Un(t), t.length - e;
  }
  /** @override */
  decode(t, e = 0) {
    const n = this.getSpan(t, e);
    if (0 <= this.maxSpan && this.maxSpan < n)
      throw new RangeError("text length exceeds maxSpan");
    return mt(t).slice(e, e + n).toString("utf-8");
  }
  /** @override */
  encode(t, e, n = 0) {
    typeof t != "string" && (t = String(t));
    const s = Fi.Buffer.from(t, "utf8"), i = s.length;
    if (0 <= this.maxSpan && this.maxSpan < i)
      throw new RangeError("text length exceeds maxSpan");
    if (n + i > e.length)
      throw new RangeError("encoding overruns Buffer");
    return s.copy(mt(e), n), i;
  }
}
D.UTF8 = Uo;
class Po extends Et {
  constructor(t, e) {
    super(0, e), this.value = t;
  }
  /** @override */
  decode(t, e) {
    return this.value;
  }
  /** @override */
  encode(t, e, n) {
    return 0;
  }
}
D.Constant = Po;
D.greedy = (r, t) => new jo(r, t);
var Mn = D.offset = (r, t, e) => new Hi(r, t, e), It = D.u8 = (r) => new _e(1, r), De = D.u16 = (r) => new _e(2, r);
D.u24 = (r) => new _e(3, r);
var rt = D.u32 = (r) => new _e(4, r);
D.u40 = (r) => new _e(5, r);
D.u48 = (r) => new _e(6, r);
var he = D.nu64 = (r) => new bo(r);
D.u16be = (r) => new Re(2, r);
D.u24be = (r) => new Re(3, r);
D.u32be = (r) => new Re(4, r);
D.u40be = (r) => new Re(5, r);
D.u48be = (r) => new Re(6, r);
D.nu64be = (r) => new Eo(r);
D.s8 = (r) => new Sn(1, r);
D.s16 = (r) => new Sn(2, r);
D.s24 = (r) => new Sn(3, r);
D.s32 = (r) => new Sn(4, r);
D.s40 = (r) => new Sn(5, r);
D.s48 = (r) => new Sn(6, r);
var Ae = D.ns64 = (r) => new Ao(r);
D.s16be = (r) => new Pn(2, r);
D.s24be = (r) => new Pn(3, r);
D.s32be = (r) => new Pn(4, r);
D.s40be = (r) => new Pn(5, r);
D.s48be = (r) => new Pn(6, r);
D.ns64be = (r) => new No(r);
D.f32 = (r) => new vo(r);
D.f32be = (r) => new To(r);
D.f64 = (r) => new Bo(r);
D.f64be = (r) => new ko(r);
var tt = D.struct = (r, t, e) => new Do(r, t, e);
D.bits = (r, t, e) => new Gi(r, t, e);
var me = D.seq = (r, t, e) => new Co(r, t, e);
D.union = (r, t, e) => new Zi(r, t, e);
D.unionLayoutDiscriminator = (r, t) => new yr(r, t);
var Dt = D.blob = (r, t) => new Ro(r, t);
D.cstr = (r) => new zo(r);
D.utf8 = (r, t) => new Uo(r, t);
D.constant = (r, t) => new Po(r, t);
var Jn = {};
Object.defineProperty(Jn, "__esModule", { value: !0 });
function cf(r) {
  {
    const t = Buffer.from(r);
    t.reverse();
    const e = t.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
var ff = Jn.toBigIntLE = cf;
function lf(r) {
  {
    const t = r.toString("hex");
    return t.length === 0 ? BigInt(0) : BigInt(`0x${t}`);
  }
}
Jn.toBigIntBE = lf;
function hf(r, t) {
  {
    const e = r.toString(16), n = Buffer.from(e.padStart(t * 2, "0").slice(0, t * 2), "hex");
    return n.reverse(), n;
  }
}
var df = Jn.toBufferLE = hf;
function gf(r, t) {
  {
    const e = r.toString(16);
    return Buffer.from(e.padStart(t * 2, "0").slice(0, t * 2), "hex");
  }
}
Jn.toBufferBE = gf;
class yf extends TypeError {
  constructor(t, e) {
    let n;
    const {
      message: s,
      ...i
    } = t, {
      path: o
    } = t, a = o.length === 0 ? s : "At path: " + o.join(".") + " -- " + s;
    super(a), Object.assign(this, i), this.name = this.constructor.name, this.failures = () => {
      var d;
      return (d = n) != null ? d : n = [t, ...e()];
    };
  }
}
function pf(r) {
  return an(r) && typeof r[Symbol.iterator] == "function";
}
function an(r) {
  return typeof r == "object" && r != null;
}
function Ue(r) {
  return typeof r == "string" ? JSON.stringify(r) : "" + r;
}
function Mf(r) {
  const {
    done: t,
    value: e
  } = r.next();
  return t ? void 0 : e;
}
function Lf(r, t, e, n) {
  if (r === !0)
    return;
  r === !1 ? r = {} : typeof r == "string" && (r = {
    message: r
  });
  const {
    path: s,
    branch: i
  } = t, {
    type: o
  } = e, {
    refinement: a,
    message: d = "Expected a value of type `" + o + "`" + (a ? " with refinement `" + a + "`" : "") + ", but received: `" + Ue(n) + "`"
  } = r;
  return {
    value: n,
    type: o,
    refinement: a,
    key: s[s.length - 1],
    path: s,
    branch: i,
    ...r,
    message: d
  };
}
function* xs(r, t, e, n) {
  pf(r) || (r = [r]);
  for (const s of r) {
    const i = Lf(s, t, e, n);
    i && (yield i);
  }
}
function* qi(r, t, e = {}) {
  const {
    path: n = [],
    branch: s = [r],
    coerce: i = !1,
    mask: o = !1
  } = e, a = {
    path: n,
    branch: s
  };
  if (i && (r = t.coercer(r, a), o && t.type !== "type" && an(t.schema) && an(r) && !Array.isArray(r)))
    for (const L in r)
      t.schema[L] === void 0 && delete r[L];
  let d = !0;
  for (const L of t.validator(r, a))
    d = !1, yield [L, void 0];
  for (let [L, I, b] of t.entries(r, a)) {
    const O = qi(I, b, {
      path: L === void 0 ? n : [...n, L],
      branch: L === void 0 ? s : [...s, I],
      coerce: i,
      mask: o
    });
    for (const v of O)
      v[0] ? (d = !1, yield [v[0], void 0]) : i && (I = v[1], L === void 0 ? r = I : r instanceof Map ? r.set(L, I) : r instanceof Set ? r.add(I) : an(r) && (r[L] = I));
  }
  if (d)
    for (const L of t.refiner(r, a))
      d = !1, yield [L, void 0];
  d && (yield [void 0, r]);
}
let Ge = class {
  constructor(t) {
    const {
      type: e,
      schema: n,
      validator: s,
      refiner: i,
      coercer: o = (d) => d,
      entries: a = function* () {
      }
    } = t;
    this.type = e, this.schema = n, this.entries = a, this.coercer = o, s ? this.validator = (d, L) => {
      const I = s(d, L);
      return xs(I, L, this, d);
    } : this.validator = () => [], i ? this.refiner = (d, L) => {
      const I = i(d, L);
      return xs(I, L, this, d);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t) {
    return wf(t, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t) {
    return Q(t, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return Fo(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t) {
    return mf(t, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, e = {}) {
    return Xn(t, this, e);
  }
};
function wf(r, t) {
  const e = Xn(r, t);
  if (e[0])
    throw e[0];
}
function Q(r, t) {
  const e = Xn(r, t, {
    coerce: !0
  });
  if (e[0])
    throw e[0];
  return e[1];
}
function mf(r, t) {
  const e = Xn(r, t, {
    coerce: !0,
    mask: !0
  });
  if (e[0])
    throw e[0];
  return e[1];
}
function Fo(r, t) {
  return !Xn(r, t)[0];
}
function Xn(r, t, e = {}) {
  const n = qi(r, t, e), s = Mf(n);
  return s[0] ? [new yf(s[0], function* () {
    for (const o of n)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, s[1]];
}
function In(r, t) {
  return new Ge({
    type: r,
    schema: null,
    validator: t
  });
}
function Sf() {
  return In("any", () => !0);
}
function K(r) {
  return new Ge({
    type: "array",
    schema: r,
    *entries(t) {
      if (r && Array.isArray(t))
        for (const [e, n] of t.entries())
          yield [e, n, r];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || "Expected an array value, but received: " + Ue(t);
    }
  });
}
function He() {
  return In("boolean", (r) => typeof r == "boolean");
}
function Vi(r) {
  return In("instance", (t) => t instanceof r || "Expected a `" + r.name + "` instance, but received: " + Ue(t));
}
function Pt(r) {
  const t = Ue(r), e = typeof r;
  return new Ge({
    type: "literal",
    schema: e === "string" || e === "number" || e === "boolean" ? r : null,
    validator(n) {
      return n === r || "Expected the literal `" + t + "`, but received: " + Ue(n);
    }
  });
}
function If() {
  return In("never", () => !1);
}
function $(r) {
  return new Ge({
    ...r,
    validator: (t, e) => t === null || r.validator(t, e),
    refiner: (t, e) => t === null || r.refiner(t, e)
  });
}
function C() {
  return In("number", (r) => typeof r == "number" && !isNaN(r) || "Expected a number, but received: " + Ue(r));
}
function ot(r) {
  return new Ge({
    ...r,
    validator: (t, e) => t === void 0 || r.validator(t, e),
    refiner: (t, e) => t === void 0 || r.refiner(t, e)
  });
}
function Yo(r, t) {
  return new Ge({
    type: "record",
    schema: null,
    *entries(e) {
      if (an(e))
        for (const n in e) {
          const s = e[n];
          yield [n, n, r], yield [n, s, t];
        }
    },
    validator(e) {
      return an(e) || "Expected an object, but received: " + Ue(e);
    }
  });
}
function G() {
  return In("string", (r) => typeof r == "string" || "Expected a string, but received: " + Ue(r));
}
function $i(r) {
  const t = If();
  return new Ge({
    type: "tuple",
    schema: null,
    *entries(e) {
      if (Array.isArray(e)) {
        const n = Math.max(r.length, e.length);
        for (let s = 0; s < n; s++)
          yield [s, e[s], r[s] || t];
      }
    },
    validator(e) {
      return Array.isArray(e) || "Expected an array, but received: " + Ue(e);
    }
  });
}
function Y(r) {
  const t = Object.keys(r);
  return new Ge({
    type: "type",
    schema: r,
    *entries(e) {
      if (an(e))
        for (const n of t)
          yield [n, e[n], r[n]];
    },
    validator(e) {
      return an(e) || "Expected an object, but received: " + Ue(e);
    }
  });
}
function je(r) {
  const t = r.map((e) => e.type).join(" | ");
  return new Ge({
    type: "union",
    schema: null,
    validator(e, n) {
      const s = [];
      for (const i of r) {
        const [...o] = qi(e, i, n), [a] = o;
        if (a[0])
          for (const [d] of o)
            d && s.push(d);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + t + "`, but received: " + Ue(e), ...s];
    }
  });
}
function tr() {
  return In("unknown", () => !0);
}
function er(r, t, e) {
  return new Ge({
    ...r,
    coercer: (n, s) => Fo(n, t) ? r.coercer(e(n, s), s) : r.coercer(n, s)
  });
}
var ur, xf = new Uint8Array(16);
function Ho() {
  if (!ur && (ur = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ur))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ur(xf);
}
const jf = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ar(r) {
  return typeof r == "string" && jf.test(r);
}
var le = [];
for (var si = 0; si < 256; ++si)
  le.push((si + 256).toString(16).substr(1));
function Nr(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = (le[r[t + 0]] + le[r[t + 1]] + le[r[t + 2]] + le[r[t + 3]] + "-" + le[r[t + 4]] + le[r[t + 5]] + "-" + le[r[t + 6]] + le[r[t + 7]] + "-" + le[r[t + 8]] + le[r[t + 9]] + "-" + le[r[t + 10]] + le[r[t + 11]] + le[r[t + 12]] + le[r[t + 13]] + le[r[t + 14]] + le[r[t + 15]]).toLowerCase();
  if (!Ar(e))
    throw TypeError("Stringified UUID is invalid");
  return e;
}
var js, oi, ui = 0, ai = 0;
function bf(r, t, e) {
  var n = t && e || 0, s = t || new Array(16);
  r = r || {};
  var i = r.node || js, o = r.clockseq !== void 0 ? r.clockseq : oi;
  if (i == null || o == null) {
    var a = r.random || (r.rng || Ho)();
    i == null && (i = js = [a[0] | 1, a[1], a[2], a[3], a[4], a[5]]), o == null && (o = oi = (a[6] << 8 | a[7]) & 16383);
  }
  var d = r.msecs !== void 0 ? r.msecs : Date.now(), L = r.nsecs !== void 0 ? r.nsecs : ai + 1, I = d - ui + (L - ai) / 1e4;
  if (I < 0 && r.clockseq === void 0 && (o = o + 1 & 16383), (I < 0 || d > ui) && r.nsecs === void 0 && (L = 0), L >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  ui = d, ai = L, oi = o, d += 122192928e5;
  var b = ((d & 268435455) * 1e4 + L) % 4294967296;
  s[n++] = b >>> 24 & 255, s[n++] = b >>> 16 & 255, s[n++] = b >>> 8 & 255, s[n++] = b & 255;
  var O = d / 4294967296 * 1e4 & 268435455;
  s[n++] = O >>> 8 & 255, s[n++] = O & 255, s[n++] = O >>> 24 & 15 | 16, s[n++] = O >>> 16 & 255, s[n++] = o >>> 8 | 128, s[n++] = o & 255;
  for (var v = 0; v < 6; ++v)
    s[n + v] = i[v];
  return t || Nr(s);
}
function Wo(r) {
  if (!Ar(r))
    throw TypeError("Invalid UUID");
  var t, e = new Uint8Array(16);
  return e[0] = (t = parseInt(r.slice(0, 8), 16)) >>> 24, e[1] = t >>> 16 & 255, e[2] = t >>> 8 & 255, e[3] = t & 255, e[4] = (t = parseInt(r.slice(9, 13), 16)) >>> 8, e[5] = t & 255, e[6] = (t = parseInt(r.slice(14, 18), 16)) >>> 8, e[7] = t & 255, e[8] = (t = parseInt(r.slice(19, 23), 16)) >>> 8, e[9] = t & 255, e[10] = (t = parseInt(r.slice(24, 36), 16)) / 1099511627776 & 255, e[11] = t / 4294967296 & 255, e[12] = t >>> 24 & 255, e[13] = t >>> 16 & 255, e[14] = t >>> 8 & 255, e[15] = t & 255, e;
}
function Ef(r) {
  r = unescape(encodeURIComponent(r));
  for (var t = [], e = 0; e < r.length; ++e)
    t.push(r.charCodeAt(e));
  return t;
}
var Af = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", Nf = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function Zo(r, t, e) {
  function n(s, i, o, a) {
    if (typeof s == "string" && (s = Ef(s)), typeof i == "string" && (i = Wo(i)), i.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var d = new Uint8Array(16 + s.length);
    if (d.set(i), d.set(s, i.length), d = e(d), d[6] = d[6] & 15 | t, d[8] = d[8] & 63 | 128, o) {
      a = a || 0;
      for (var L = 0; L < 16; ++L)
        o[a + L] = d[L];
      return o;
    }
    return Nr(d);
  }
  try {
    n.name = r;
  } catch {
  }
  return n.DNS = Af, n.URL = Nf, n;
}
function vf(r) {
  if (typeof r == "string") {
    var t = unescape(encodeURIComponent(r));
    r = new Uint8Array(t.length);
    for (var e = 0; e < t.length; ++e)
      r[e] = t.charCodeAt(e);
  }
  return Tf(Bf(kf(r), r.length * 8));
}
function Tf(r) {
  for (var t = [], e = r.length * 32, n = "0123456789abcdef", s = 0; s < e; s += 8) {
    var i = r[s >> 5] >>> s % 32 & 255, o = parseInt(n.charAt(i >>> 4 & 15) + n.charAt(i & 15), 16);
    t.push(o);
  }
  return t;
}
function Go(r) {
  return (r + 64 >>> 9 << 4) + 14 + 1;
}
function Bf(r, t) {
  r[t >> 5] |= 128 << t % 32, r[Go(t) - 1] = t;
  for (var e = 1732584193, n = -271733879, s = -1732584194, i = 271733878, o = 0; o < r.length; o += 16) {
    var a = e, d = n, L = s, I = i;
    e = pe(e, n, s, i, r[o], 7, -680876936), i = pe(i, e, n, s, r[o + 1], 12, -389564586), s = pe(s, i, e, n, r[o + 2], 17, 606105819), n = pe(n, s, i, e, r[o + 3], 22, -1044525330), e = pe(e, n, s, i, r[o + 4], 7, -176418897), i = pe(i, e, n, s, r[o + 5], 12, 1200080426), s = pe(s, i, e, n, r[o + 6], 17, -1473231341), n = pe(n, s, i, e, r[o + 7], 22, -45705983), e = pe(e, n, s, i, r[o + 8], 7, 1770035416), i = pe(i, e, n, s, r[o + 9], 12, -1958414417), s = pe(s, i, e, n, r[o + 10], 17, -42063), n = pe(n, s, i, e, r[o + 11], 22, -1990404162), e = pe(e, n, s, i, r[o + 12], 7, 1804603682), i = pe(i, e, n, s, r[o + 13], 12, -40341101), s = pe(s, i, e, n, r[o + 14], 17, -1502002290), n = pe(n, s, i, e, r[o + 15], 22, 1236535329), e = Me(e, n, s, i, r[o + 1], 5, -165796510), i = Me(i, e, n, s, r[o + 6], 9, -1069501632), s = Me(s, i, e, n, r[o + 11], 14, 643717713), n = Me(n, s, i, e, r[o], 20, -373897302), e = Me(e, n, s, i, r[o + 5], 5, -701558691), i = Me(i, e, n, s, r[o + 10], 9, 38016083), s = Me(s, i, e, n, r[o + 15], 14, -660478335), n = Me(n, s, i, e, r[o + 4], 20, -405537848), e = Me(e, n, s, i, r[o + 9], 5, 568446438), i = Me(i, e, n, s, r[o + 14], 9, -1019803690), s = Me(s, i, e, n, r[o + 3], 14, -187363961), n = Me(n, s, i, e, r[o + 8], 20, 1163531501), e = Me(e, n, s, i, r[o + 13], 5, -1444681467), i = Me(i, e, n, s, r[o + 2], 9, -51403784), s = Me(s, i, e, n, r[o + 7], 14, 1735328473), n = Me(n, s, i, e, r[o + 12], 20, -1926607734), e = Le(e, n, s, i, r[o + 5], 4, -378558), i = Le(i, e, n, s, r[o + 8], 11, -2022574463), s = Le(s, i, e, n, r[o + 11], 16, 1839030562), n = Le(n, s, i, e, r[o + 14], 23, -35309556), e = Le(e, n, s, i, r[o + 1], 4, -1530992060), i = Le(i, e, n, s, r[o + 4], 11, 1272893353), s = Le(s, i, e, n, r[o + 7], 16, -155497632), n = Le(n, s, i, e, r[o + 10], 23, -1094730640), e = Le(e, n, s, i, r[o + 13], 4, 681279174), i = Le(i, e, n, s, r[o], 11, -358537222), s = Le(s, i, e, n, r[o + 3], 16, -722521979), n = Le(n, s, i, e, r[o + 6], 23, 76029189), e = Le(e, n, s, i, r[o + 9], 4, -640364487), i = Le(i, e, n, s, r[o + 12], 11, -421815835), s = Le(s, i, e, n, r[o + 15], 16, 530742520), n = Le(n, s, i, e, r[o + 2], 23, -995338651), e = we(e, n, s, i, r[o], 6, -198630844), i = we(i, e, n, s, r[o + 7], 10, 1126891415), s = we(s, i, e, n, r[o + 14], 15, -1416354905), n = we(n, s, i, e, r[o + 5], 21, -57434055), e = we(e, n, s, i, r[o + 12], 6, 1700485571), i = we(i, e, n, s, r[o + 3], 10, -1894986606), s = we(s, i, e, n, r[o + 10], 15, -1051523), n = we(n, s, i, e, r[o + 1], 21, -2054922799), e = we(e, n, s, i, r[o + 8], 6, 1873313359), i = we(i, e, n, s, r[o + 15], 10, -30611744), s = we(s, i, e, n, r[o + 6], 15, -1560198380), n = we(n, s, i, e, r[o + 13], 21, 1309151649), e = we(e, n, s, i, r[o + 4], 6, -145523070), i = we(i, e, n, s, r[o + 11], 10, -1120210379), s = we(s, i, e, n, r[o + 2], 15, 718787259), n = we(n, s, i, e, r[o + 9], 21, -343485551), e = un(e, a), n = un(n, d), s = un(s, L), i = un(i, I);
  }
  return [e, n, s, i];
}
function kf(r) {
  if (r.length === 0)
    return [];
  for (var t = r.length * 8, e = new Uint32Array(Go(t)), n = 0; n < t; n += 8)
    e[n >> 5] |= (r[n / 8] & 255) << n % 32;
  return e;
}
function un(r, t) {
  var e = (r & 65535) + (t & 65535), n = (r >> 16) + (t >> 16) + (e >> 16);
  return n << 16 | e & 65535;
}
function Cf(r, t) {
  return r << t | r >>> 32 - t;
}
function vr(r, t, e, n, s, i) {
  return un(Cf(un(un(t, r), un(n, i)), s), e);
}
function pe(r, t, e, n, s, i, o) {
  return vr(t & e | ~t & n, r, t, s, i, o);
}
function Me(r, t, e, n, s, i, o) {
  return vr(t & n | e & ~n, r, t, s, i, o);
}
function Le(r, t, e, n, s, i, o) {
  return vr(t ^ e ^ n, r, t, s, i, o);
}
function we(r, t, e, n, s, i, o) {
  return vr(e ^ (t | ~n), r, t, s, i, o);
}
var Df = Zo("v3", 48, vf);
const _f = Df;
function Of(r, t, e) {
  r = r || {};
  var n = r.random || (r.rng || Ho)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    e = e || 0;
    for (var s = 0; s < 16; ++s)
      t[e + s] = n[s];
    return t;
  }
  return Nr(n);
}
function Rf(r, t, e, n) {
  switch (r) {
    case 0:
      return t & e ^ ~t & n;
    case 1:
      return t ^ e ^ n;
    case 2:
      return t & e ^ t & n ^ e & n;
    case 3:
      return t ^ e ^ n;
  }
}
function ci(r, t) {
  return r << t | r >>> 32 - t;
}
function zf(r) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], e = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof r == "string") {
    var n = unescape(encodeURIComponent(r));
    r = [];
    for (var s = 0; s < n.length; ++s)
      r.push(n.charCodeAt(s));
  } else
    Array.isArray(r) || (r = Array.prototype.slice.call(r));
  r.push(128);
  for (var i = r.length / 4 + 2, o = Math.ceil(i / 16), a = new Array(o), d = 0; d < o; ++d) {
    for (var L = new Uint32Array(16), I = 0; I < 16; ++I)
      L[I] = r[d * 64 + I * 4] << 24 | r[d * 64 + I * 4 + 1] << 16 | r[d * 64 + I * 4 + 2] << 8 | r[d * 64 + I * 4 + 3];
    a[d] = L;
  }
  a[o - 1][14] = (r.length - 1) * 8 / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = (r.length - 1) * 8 & 4294967295;
  for (var b = 0; b < o; ++b) {
    for (var O = new Uint32Array(80), v = 0; v < 16; ++v)
      O[v] = a[b][v];
    for (var B = 16; B < 80; ++B)
      O[B] = ci(O[B - 3] ^ O[B - 8] ^ O[B - 14] ^ O[B - 16], 1);
    for (var E = e[0], N = e[1], _ = e[2], U = e[3], z = e[4], q = 0; q < 80; ++q) {
      var P = Math.floor(q / 20), F = ci(E, 5) + Rf(P, N, _, U) + z + t[P] + O[q] >>> 0;
      z = U, U = _, _ = ci(N, 30) >>> 0, N = E, E = F;
    }
    e[0] = e[0] + E >>> 0, e[1] = e[1] + N >>> 0, e[2] = e[2] + _ >>> 0, e[3] = e[3] + U >>> 0, e[4] = e[4] + z >>> 0;
  }
  return [e[0] >> 24 & 255, e[0] >> 16 & 255, e[0] >> 8 & 255, e[0] & 255, e[1] >> 24 & 255, e[1] >> 16 & 255, e[1] >> 8 & 255, e[1] & 255, e[2] >> 24 & 255, e[2] >> 16 & 255, e[2] >> 8 & 255, e[2] & 255, e[3] >> 24 & 255, e[3] >> 16 & 255, e[3] >> 8 & 255, e[3] & 255, e[4] >> 24 & 255, e[4] >> 16 & 255, e[4] >> 8 & 255, e[4] & 255];
}
var Uf = Zo("v5", 80, zf);
const Pf = Uf, Ff = "00000000-0000-0000-0000-000000000000";
function Yf(r) {
  if (!Ar(r))
    throw TypeError("Invalid UUID");
  return parseInt(r.substr(14, 1), 16);
}
const Hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: Ff,
  parse: Wo,
  stringify: Nr,
  v1: bf,
  v3: _f,
  v4: Of,
  v5: Pf,
  validate: Ar,
  version: Yf
}, Symbol.toStringTag, { value: "Module" })), Qo = /* @__PURE__ */ Ni(Hf), Wf = Qo.v4, Zf = function(r, t, e, n) {
  if (typeof r != "string")
    throw new TypeError(r + " must be a string");
  n = n || {};
  const s = typeof n.version == "number" ? n.version : 2;
  if (s !== 1 && s !== 2)
    throw new TypeError(s + " must be 1 or 2");
  const i = {
    method: r
  };
  if (s === 2 && (i.jsonrpc = "2.0"), t) {
    if (typeof t != "object" && !Array.isArray(t))
      throw new TypeError(t + " must be an object, array or omitted");
    i.params = t;
  }
  if (typeof e > "u") {
    const o = typeof n.generator == "function" ? n.generator : function() {
      return Wf();
    };
    i.id = o(i, n);
  } else
    s === 2 && e === null ? n.notificationIdNull && (i.id = null) : i.id = e;
  return i;
};
var Gf = Zf;
const Qf = Qo.v4, qf = Gf, qn = function(r, t) {
  if (!(this instanceof qn))
    return new qn(r, t);
  t || (t = {}), this.options = {
    reviver: typeof t.reviver < "u" ? t.reviver : null,
    replacer: typeof t.replacer < "u" ? t.replacer : null,
    generator: typeof t.generator < "u" ? t.generator : function() {
      return Qf();
    },
    version: typeof t.version < "u" ? t.version : 2,
    notificationIdNull: typeof t.notificationIdNull == "boolean" ? t.notificationIdNull : !1
  }, this.callServer = r;
};
var Vf = qn;
qn.prototype.request = function(r, t, e, n) {
  const s = this;
  let i = null;
  const o = Array.isArray(r) && typeof t == "function";
  if (this.options.version === 1 && o)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (o || !o && r && typeof r == "object" && typeof t == "function")
    n = t, i = r;
  else {
    typeof e == "function" && (n = e, e = void 0);
    const L = typeof n == "function";
    try {
      i = qf(r, t, e, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (I) {
      if (L)
        return n(I);
      throw I;
    }
    if (!L)
      return i;
  }
  let d;
  try {
    d = JSON.stringify(i, this.options.replacer);
  } catch (L) {
    return n(L);
  }
  return this.callServer(d, function(L, I) {
    s._parseResponse(L, I, n);
  }), i;
};
qn.prototype._parseResponse = function(r, t, e) {
  if (r) {
    e(r);
    return;
  }
  if (!t)
    return e();
  let n;
  try {
    n = JSON.parse(t, this.options.reviver);
  } catch (s) {
    return e(s);
  }
  if (e.length === 3)
    if (Array.isArray(n)) {
      const s = function(o) {
        return typeof o.error < "u";
      }, i = function(o) {
        return !s(o);
      };
      return e(null, n.filter(s), n.filter(i));
    } else
      return e(null, n.error, n.result);
  e(null, n);
};
const $f = /* @__PURE__ */ Ai(Vf);
var qo = {}, Vo = { exports: {} };
(function(r) {
  var t = Object.prototype.hasOwnProperty, e = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (e = !1));
  function s(d, L, I) {
    this.fn = d, this.context = L, this.once = I || !1;
  }
  function i(d, L, I, b, O) {
    if (typeof I != "function")
      throw new TypeError("The listener must be a function");
    var v = new s(I, b || d, O), B = e ? e + L : L;
    return d._events[B] ? d._events[B].fn ? d._events[B] = [d._events[B], v] : d._events[B].push(v) : (d._events[B] = v, d._eventsCount++), d;
  }
  function o(d, L) {
    --d._eventsCount === 0 ? d._events = new n() : delete d._events[L];
  }
  function a() {
    this._events = new n(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var L = [], I, b;
    if (this._eventsCount === 0)
      return L;
    for (b in I = this._events)
      t.call(I, b) && L.push(e ? b.slice(1) : b);
    return Object.getOwnPropertySymbols ? L.concat(Object.getOwnPropertySymbols(I)) : L;
  }, a.prototype.listeners = function(L) {
    var I = e ? e + L : L, b = this._events[I];
    if (!b)
      return [];
    if (b.fn)
      return [b.fn];
    for (var O = 0, v = b.length, B = new Array(v); O < v; O++)
      B[O] = b[O].fn;
    return B;
  }, a.prototype.listenerCount = function(L) {
    var I = e ? e + L : L, b = this._events[I];
    return b ? b.fn ? 1 : b.length : 0;
  }, a.prototype.emit = function(L, I, b, O, v, B) {
    var E = e ? e + L : L;
    if (!this._events[E])
      return !1;
    var N = this._events[E], _ = arguments.length, U, z;
    if (N.fn) {
      switch (N.once && this.removeListener(L, N.fn, void 0, !0), _) {
        case 1:
          return N.fn.call(N.context), !0;
        case 2:
          return N.fn.call(N.context, I), !0;
        case 3:
          return N.fn.call(N.context, I, b), !0;
        case 4:
          return N.fn.call(N.context, I, b, O), !0;
        case 5:
          return N.fn.call(N.context, I, b, O, v), !0;
        case 6:
          return N.fn.call(N.context, I, b, O, v, B), !0;
      }
      for (z = 1, U = new Array(_ - 1); z < _; z++)
        U[z - 1] = arguments[z];
      N.fn.apply(N.context, U);
    } else {
      var q = N.length, P;
      for (z = 0; z < q; z++)
        switch (N[z].once && this.removeListener(L, N[z].fn, void 0, !0), _) {
          case 1:
            N[z].fn.call(N[z].context);
            break;
          case 2:
            N[z].fn.call(N[z].context, I);
            break;
          case 3:
            N[z].fn.call(N[z].context, I, b);
            break;
          case 4:
            N[z].fn.call(N[z].context, I, b, O);
            break;
          default:
            if (!U)
              for (P = 1, U = new Array(_ - 1); P < _; P++)
                U[P - 1] = arguments[P];
            N[z].fn.apply(N[z].context, U);
        }
    }
    return !0;
  }, a.prototype.on = function(L, I, b) {
    return i(this, L, I, b, !1);
  }, a.prototype.once = function(L, I, b) {
    return i(this, L, I, b, !0);
  }, a.prototype.removeListener = function(L, I, b, O) {
    var v = e ? e + L : L;
    if (!this._events[v])
      return this;
    if (!I)
      return o(this, v), this;
    var B = this._events[v];
    if (B.fn)
      B.fn === I && (!O || B.once) && (!b || B.context === b) && o(this, v);
    else {
      for (var E = 0, N = [], _ = B.length; E < _; E++)
        (B[E].fn !== I || O && !B[E].once || b && B[E].context !== b) && N.push(B[E]);
      N.length ? this._events[v] = N.length === 1 ? N[0] : N : o(this, v);
    }
    return this;
  }, a.prototype.removeAllListeners = function(L) {
    var I;
    return L ? (I = e ? e + L : L, this._events[I] && o(this, I)) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = e, a.EventEmitter = a, r.exports = a;
})(Vo);
var $o = Vo.exports, _n = {};
Object.defineProperty(_n, "__esModule", { value: !0 });
_n.createError = _n.DefaultDataPack = void 0;
const Kf = /* @__PURE__ */ new Map([
  [-32e3, "Event not provided"],
  [-32600, "Invalid Request"],
  [-32601, "Method not found"],
  [-32602, "Invalid params"],
  [-32603, "Internal error"],
  [-32604, "Params not found"],
  [-32605, "Method forbidden"],
  [-32606, "Event forbidden"],
  [-32700, "Parse error"]
]);
class Jf {
  encode(t) {
    return JSON.stringify(t);
  }
  decode(t) {
    return JSON.parse(t);
  }
}
_n.DefaultDataPack = Jf;
function Xf(r, t) {
  const e = {
    code: r,
    message: Kf.get(r) || "Internal Server Error"
  };
  return t && (e.data = t), e;
}
_n.createError = Xf;
Object.defineProperty(qo, "__esModule", { value: !0 });
const t0 = $o, e0 = _n;
class n0 extends t0.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */
  constructor(e, n = "ws://localhost:8080", { autoconnect: s = !0, reconnect: i = !0, reconnect_interval: o = 1e3, max_reconnects: a = 5, ...d } = {}, L, I) {
    super();
    ae(this, "address");
    ae(this, "rpc_id");
    ae(this, "queue");
    ae(this, "options");
    ae(this, "autoconnect");
    ae(this, "ready");
    ae(this, "reconnect");
    ae(this, "reconnect_timer_id");
    ae(this, "reconnect_interval");
    ae(this, "max_reconnects");
    ae(this, "rest_options");
    ae(this, "current_reconnects");
    ae(this, "generate_request_id");
    ae(this, "socket");
    ae(this, "webSocketFactory");
    ae(this, "dataPack");
    this.webSocketFactory = e, this.queue = {}, this.rpc_id = 0, this.address = n, this.autoconnect = s, this.ready = !1, this.reconnect = i, this.reconnect_timer_id = void 0, this.reconnect_interval = o, this.max_reconnects = a, this.rest_options = d, this.current_reconnects = 0, this.generate_request_id = L || (() => ++this.rpc_id), I ? this.dataPack = I : this.dataPack = new e0.DefaultDataPack(), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(e, n, s, i) {
    return !i && typeof s == "object" && (i = s, s = null), new Promise((o, a) => {
      if (!this.ready)
        return a(new Error("socket not ready"));
      const d = this.generate_request_id(e, n), L = {
        jsonrpc: "2.0",
        method: e,
        params: n || void 0,
        id: d
      };
      this.socket.send(this.dataPack.encode(L), i, (I) => {
        if (I)
          return a(I);
        this.queue[d] = { promise: [o, a] }, s && (this.queue[d].timeout = setTimeout(() => {
          delete this.queue[d], a(new Error("reply timeout"));
        }, s));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(e) {
    const n = await this.call("rpc.login", e);
    if (!n)
      throw new Error("authentication failed");
    return n;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(e, n) {
    return new Promise((s, i) => {
      if (!this.ready)
        return i(new Error("socket not ready"));
      const o = {
        jsonrpc: "2.0",
        method: e,
        params: n
      };
      this.socket.send(this.dataPack.encode(o), (a) => {
        if (a)
          return i(a);
        s();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(e) {
    typeof e == "string" && (e = [e]);
    const n = await this.call("rpc.on", e);
    if (typeof e == "string" && n[e] !== "ok")
      throw new Error("Failed subscribing to an event '" + e + "' with: " + n[e]);
    return n;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(e) {
    typeof e == "string" && (e = [e]);
    const n = await this.call("rpc.off", e);
    if (typeof e == "string" && n[e] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + n);
    return n;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(e, n) {
    this.socket.close(e || 1e3, n);
  }
  /**
   * Enable / disable automatic reconnection.
   * @method
   * @param {Boolean} reconnect - enable / disable reconnection
   * @return {Undefined}
   */
  setAutoReconnect(e) {
    this.reconnect = e;
  }
  /**
   * Set the interval between reconnection attempts.
   * @method
   * @param {Number} interval - reconnection interval in milliseconds
   * @return {Undefined}
   */
  setReconnectInterval(e) {
    this.reconnect_interval = e;
  }
  /**
   * Set the maximum number of reconnection attempts.
   * @method
   * @param {Number} max_reconnects - maximum reconnection attempts
   * @return {Undefined}
   */
  setMaxReconnects(e) {
    this.max_reconnects = e;
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(e, n) {
    clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(e, n), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({ data: s }) => {
      s instanceof ArrayBuffer && (s = Buffer.from(s).toString());
      try {
        s = this.dataPack.decode(s);
      } catch {
        return;
      }
      if (s.notification && this.listeners(s.notification).length) {
        if (!Object.keys(s.params).length)
          return this.emit(s.notification);
        const i = [s.notification];
        if (s.params.constructor === Object)
          i.push(s.params);
        else
          for (let o = 0; o < s.params.length; o++)
            i.push(s.params[o]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, i);
        });
      }
      if (!this.queue[s.id])
        return s.method ? Promise.resolve().then(() => {
          this.emit(s.method, s == null ? void 0 : s.params);
        }) : void 0;
      "error" in s == "result" in s && this.queue[s.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue[s.id].timeout && clearTimeout(this.queue[s.id].timeout), s.error ? this.queue[s.id].promise[1](s.error) : this.queue[s.id].promise[0](s.result), delete this.queue[s.id];
    }), this.socket.addEventListener("error", (s) => this.emit("error", s)), this.socket.addEventListener("close", ({ code: s, reason: i }) => {
      this.ready && setTimeout(() => this.emit("close", s, i), 0), this.ready = !1, this.socket = void 0, s !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && (this.reconnect_timer_id = setTimeout(() => this._connect(e, n), this.reconnect_interval)));
    });
  }
}
var r0 = qo.default = n0, Ko = {};
Object.defineProperty(Ko, "__esModule", { value: !0 });
const i0 = $o;
class s0 extends i0.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(e, n, s) {
    super();
    ae(this, "socket");
    this.socket = new window.WebSocket(e, s), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (i) => this.emit("message", i.data), this.socket.onerror = (i) => this.emit("error", i), this.socket.onclose = (i) => {
      this.emit("close", i.code, i.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(e, n, s) {
    const i = s || n;
    try {
      this.socket.send(e), i();
    } catch (o) {
      i(o);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(e, n) {
    this.socket.close(e, n);
  }
  addEventListener(e, n, s) {
    this.socket.addEventListener(e, n, s);
  }
}
function o0(r, t) {
  return new s0(r, t);
}
var u0 = Ko.default = o0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function a0(r) {
  const t = Di(r);
  zn(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: e, Fp: n, a: s } = t;
  if (e) {
    if (!n.eql(s, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof e != "object" || typeof e.beta != "bigint" || typeof e.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: c0, hexToBytes: f0 } = sc, yn = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(r) {
    const { Err: t } = yn;
    if (r.length < 2 || r[0] !== 2)
      throw new t("Invalid signature integer tag");
    const e = r[1], n = r.subarray(2, e + 2);
    if (!e || n.length !== e)
      throw new t("Invalid signature integer: wrong length");
    if (n[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (n[0] === 0 && !(n[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: c0(n), l: r.subarray(e + 2) };
  },
  toSig(r) {
    const { Err: t } = yn, e = typeof r == "string" ? f0(r) : r;
    Kn(e);
    let n = e.length;
    if (n < 2 || e[0] != 48)
      throw new t("Invalid signature tag");
    if (e[1] !== n - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: s, l: i } = yn._parseInt(e.subarray(2)), { d: o, l: a } = yn._parseInt(i);
    if (a.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: s, s: o };
  },
  hexFromSig(r) {
    const t = (L) => Number.parseInt(L[0], 16) & 8 ? "00" + L : L, e = (L) => {
      const I = L.toString(16);
      return I.length & 1 ? `0${I}` : I;
    }, n = t(e(r.s)), s = t(e(r.r)), i = n.length / 2, o = s.length / 2, a = e(i), d = e(o);
    return `30${e(o + i + 4)}02${d}${s}02${a}${n}`;
  }
}, Ve = BigInt(0), Ce = BigInt(1);
BigInt(2);
const bs = BigInt(3);
BigInt(4);
function l0(r) {
  const t = a0(r), { Fp: e } = t, n = t.toBytes || ((B, E, N) => {
    const _ = E.toAffine();
    return mn(Uint8Array.from([4]), e.toBytes(_.x), e.toBytes(_.y));
  }), s = t.fromBytes || ((B) => {
    const E = B.subarray(1), N = e.fromBytes(E.subarray(0, e.BYTES)), _ = e.fromBytes(E.subarray(e.BYTES, 2 * e.BYTES));
    return { x: N, y: _ };
  });
  function i(B) {
    const { a: E, b: N } = t, _ = e.sqr(B), U = e.mul(_, B);
    return e.add(e.add(U, e.mul(B, E)), N);
  }
  if (!e.eql(e.sqr(t.Gy), i(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function o(B) {
    return typeof B == "bigint" && Ve < B && B < t.n;
  }
  function a(B) {
    if (!o(B))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function d(B) {
    const { allowedPrivateKeyLengths: E, nByteLength: N, wrapPrivateKey: _, n: U } = t;
    if (E && typeof B != "bigint") {
      if (Ln(B) && (B = wn(B)), typeof B != "string" || !E.includes(B.length))
        throw new Error("Invalid key");
      B = B.padStart(N * 2, "0");
    }
    let z;
    try {
      z = typeof B == "bigint" ? B : pn(ce("private key", B, N));
    } catch {
      throw new Error(`private key must be ${N} bytes, hex or bigint, not ${typeof B}`);
    }
    return _ && (z = zt(z, U)), a(z), z;
  }
  const L = /* @__PURE__ */ new Map();
  function I(B) {
    if (!(B instanceof b))
      throw new Error("ProjectivePoint expected");
  }
  class b {
    constructor(E, N, _) {
      if (this.px = E, this.py = N, this.pz = _, E == null || !e.isValid(E))
        throw new Error("x required");
      if (N == null || !e.isValid(N))
        throw new Error("y required");
      if (_ == null || !e.isValid(_))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(E) {
      const { x: N, y: _ } = E || {};
      if (!E || !e.isValid(N) || !e.isValid(_))
        throw new Error("invalid affine point");
      if (E instanceof b)
        throw new Error("projective point not allowed");
      const U = (z) => e.eql(z, e.ZERO);
      return U(N) && U(_) ? b.ZERO : new b(N, _, e.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(E) {
      const N = e.invertBatch(E.map((_) => _.pz));
      return E.map((_, U) => _.toAffine(N[U])).map(b.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(E) {
      const N = b.fromAffine(s(ce("pointHex", E)));
      return N.assertValidity(), N;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(E) {
      return b.BASE.multiply(d(E));
    }
    // "Private method", don't use it directly
    _setWindowSize(E) {
      this._WINDOW_SIZE = E, L.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !e.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: E, y: N } = this.toAffine();
      if (!e.isValid(E) || !e.isValid(N))
        throw new Error("bad point: x or y not FE");
      const _ = e.sqr(N), U = i(E);
      if (!e.eql(_, U))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: E } = this.toAffine();
      if (e.isOdd)
        return !e.isOdd(E);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(E) {
      I(E);
      const { px: N, py: _, pz: U } = this, { px: z, py: q, pz: P } = E, F = e.eql(e.mul(N, P), e.mul(z, U)), V = e.eql(e.mul(_, P), e.mul(q, U));
      return F && V;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new b(this.px, e.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: E, b: N } = t, _ = e.mul(N, bs), { px: U, py: z, pz: q } = this;
      let P = e.ZERO, F = e.ZERO, V = e.ZERO, J = e.mul(U, U), xt = e.mul(z, z), Mt = e.mul(q, q), X = e.mul(U, z);
      return X = e.add(X, X), V = e.mul(U, q), V = e.add(V, V), P = e.mul(E, V), F = e.mul(_, Mt), F = e.add(P, F), P = e.sub(xt, F), F = e.add(xt, F), F = e.mul(P, F), P = e.mul(X, P), V = e.mul(_, V), Mt = e.mul(E, Mt), X = e.sub(J, Mt), X = e.mul(E, X), X = e.add(X, V), V = e.add(J, J), J = e.add(V, J), J = e.add(J, Mt), J = e.mul(J, X), F = e.add(F, J), Mt = e.mul(z, q), Mt = e.add(Mt, Mt), J = e.mul(Mt, X), P = e.sub(P, J), V = e.mul(Mt, xt), V = e.add(V, V), V = e.add(V, V), new b(P, F, V);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(E) {
      I(E);
      const { px: N, py: _, pz: U } = this, { px: z, py: q, pz: P } = E;
      let F = e.ZERO, V = e.ZERO, J = e.ZERO;
      const xt = t.a, Mt = e.mul(t.b, bs);
      let X = e.mul(N, z), jt = e.mul(_, q), j = e.mul(U, P), u = e.add(N, _), h = e.add(z, q);
      u = e.mul(u, h), h = e.add(X, jt), u = e.sub(u, h), h = e.add(N, U);
      let y = e.add(z, P);
      return h = e.mul(h, y), y = e.add(X, j), h = e.sub(h, y), y = e.add(_, U), F = e.add(q, P), y = e.mul(y, F), F = e.add(jt, j), y = e.sub(y, F), J = e.mul(xt, h), F = e.mul(Mt, j), J = e.add(F, J), F = e.sub(jt, J), J = e.add(jt, J), V = e.mul(F, J), jt = e.add(X, X), jt = e.add(jt, X), j = e.mul(xt, j), h = e.mul(Mt, h), jt = e.add(jt, j), j = e.sub(X, j), j = e.mul(xt, j), h = e.add(h, j), X = e.mul(jt, h), V = e.add(V, X), X = e.mul(y, h), F = e.mul(u, F), F = e.sub(F, X), X = e.mul(u, jt), J = e.mul(y, J), J = e.add(J, X), new b(F, V, J);
    }
    subtract(E) {
      return this.add(E.negate());
    }
    is0() {
      return this.equals(b.ZERO);
    }
    wNAF(E) {
      return v.wNAFCached(this, L, E, (N) => {
        const _ = e.invertBatch(N.map((U) => U.pz));
        return N.map((U, z) => U.toAffine(_[z])).map(b.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(E) {
      const N = b.ZERO;
      if (E === Ve)
        return N;
      if (a(E), E === Ce)
        return this;
      const { endo: _ } = t;
      if (!_)
        return v.unsafeLadder(this, E);
      let { k1neg: U, k1: z, k2neg: q, k2: P } = _.splitScalar(E), F = N, V = N, J = this;
      for (; z > Ve || P > Ve; )
        z & Ce && (F = F.add(J)), P & Ce && (V = V.add(J)), J = J.double(), z >>= Ce, P >>= Ce;
      return U && (F = F.negate()), q && (V = V.negate()), V = new b(e.mul(V.px, _.beta), V.py, V.pz), F.add(V);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(E) {
      a(E);
      let N = E, _, U;
      const { endo: z } = t;
      if (z) {
        const { k1neg: q, k1: P, k2neg: F, k2: V } = z.splitScalar(N);
        let { p: J, f: xt } = this.wNAF(P), { p: Mt, f: X } = this.wNAF(V);
        J = v.constTimeNegate(q, J), Mt = v.constTimeNegate(F, Mt), Mt = new b(e.mul(Mt.px, z.beta), Mt.py, Mt.pz), _ = J.add(Mt), U = xt.add(X);
      } else {
        const { p: q, f: P } = this.wNAF(N);
        _ = q, U = P;
      }
      return b.normalizeZ([_, U])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(E, N, _) {
      const U = b.BASE, z = (P, F) => F === Ve || F === Ce || !P.equals(U) ? P.multiplyUnsafe(F) : P.multiply(F), q = z(this, N).add(z(E, _));
      return q.is0() ? void 0 : q;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(E) {
      const { px: N, py: _, pz: U } = this, z = this.is0();
      E == null && (E = z ? e.ONE : e.inv(U));
      const q = e.mul(N, E), P = e.mul(_, E), F = e.mul(U, E);
      if (z)
        return { x: e.ZERO, y: e.ZERO };
      if (!e.eql(F, e.ONE))
        throw new Error("invZ was invalid");
      return { x: q, y: P };
    }
    isTorsionFree() {
      const { h: E, isTorsionFree: N } = t;
      if (E === Ce)
        return !0;
      if (N)
        return N(b, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: E, clearCofactor: N } = t;
      return E === Ce ? this : N ? N(b, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(E = !0) {
      return this.assertValidity(), n(b, this, E);
    }
    toHex(E = !0) {
      return wn(this.toRawBytes(E));
    }
  }
  b.BASE = new b(t.Gx, t.Gy, e.ONE), b.ZERO = new b(e.ZERO, e.ONE, e.ZERO);
  const O = t.nBitLength, v = lo(b, t.endo ? Math.ceil(O / 2) : O);
  return {
    CURVE: t,
    ProjectivePoint: b,
    normPrivateKeyToScalar: d,
    weierstrassEquation: i,
    isWithinCurveOrder: o
  };
}
function h0(r) {
  const t = Di(r);
  return zn(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function d0(r) {
  const t = h0(r), { Fp: e, n } = t, s = e.BYTES + 1, i = 2 * e.BYTES + 1;
  function o(h) {
    return Ve < h && h < e.ORDER;
  }
  function a(h) {
    return zt(h, n);
  }
  function d(h) {
    return Mi(h, n);
  }
  const { ProjectivePoint: L, normPrivateKeyToScalar: I, weierstrassEquation: b, isWithinCurveOrder: O } = l0({
    ...t,
    toBytes(h, y, S) {
      const M = y.toAffine(), m = e.toBytes(M.x), A = mn;
      return S ? A(Uint8Array.from([y.hasEvenY() ? 2 : 3]), m) : A(Uint8Array.from([4]), m, e.toBytes(M.y));
    },
    fromBytes(h) {
      const y = h.length, S = h[0], M = h.subarray(1);
      if (y === s && (S === 2 || S === 3)) {
        const m = pn(M);
        if (!o(m))
          throw new Error("Point is not on curve");
        const A = b(m);
        let p;
        try {
          p = e.sqrt(A);
        } catch (H) {
          const W = H instanceof Error ? ": " + H.message : "";
          throw new Error("Point is not on curve" + W);
        }
        const f = (p & Ce) === Ce;
        return (S & 1) === 1 !== f && (p = e.neg(p)), { x: m, y: p };
      } else if (y === i && S === 4) {
        const m = e.fromBytes(M.subarray(0, e.BYTES)), A = e.fromBytes(M.subarray(e.BYTES, 2 * e.BYTES));
        return { x: m, y: A };
      } else
        throw new Error(`Point of length ${y} was invalid. Expected ${s} compressed bytes or ${i} uncompressed bytes`);
    }
  }), v = (h) => wn(Cn(h, t.nByteLength));
  function B(h) {
    const y = n >> Ce;
    return h > y;
  }
  function E(h) {
    return B(h) ? a(-h) : h;
  }
  const N = (h, y, S) => pn(h.slice(y, S));
  class _ {
    constructor(y, S, M) {
      this.r = y, this.s = S, this.recovery = M, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(y) {
      const S = t.nByteLength;
      return y = ce("compactSignature", y, S * 2), new _(N(y, 0, S), N(y, S, 2 * S));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(y) {
      const { r: S, s: M } = yn.toSig(ce("DER", y));
      return new _(S, M);
    }
    assertValidity() {
      if (!O(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!O(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(y) {
      return new _(this.r, this.s, y);
    }
    recoverPublicKey(y) {
      const { r: S, s: M, recovery: m } = this, A = V(ce("msgHash", y));
      if (m == null || ![0, 1, 2, 3].includes(m))
        throw new Error("recovery id invalid");
      const p = m === 2 || m === 3 ? S + t.n : S;
      if (p >= e.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const f = m & 1 ? "03" : "02", x = L.fromHex(f + v(p)), H = d(p), W = a(-A * H), Z = a(M * H), it = L.BASE.multiplyAndAddUnsafe(x, W, Z);
      if (!it)
        throw new Error("point at infinify");
      return it.assertValidity(), it;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return B(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new _(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return kn(this.toDERHex());
    }
    toDERHex() {
      return yn.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return kn(this.toCompactHex());
    }
    toCompactHex() {
      return v(this.r) + v(this.s);
    }
  }
  const U = {
    isValidPrivateKey(h) {
      try {
        return I(h), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: I,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const h = fo(t.n);
      return pc(t.randomBytes(h), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(h = 8, y = L.BASE) {
      return y._setWindowSize(h), y.multiply(BigInt(3)), y;
    }
  };
  function z(h, y = !0) {
    return L.fromPrivateKey(h).toRawBytes(y);
  }
  function q(h) {
    const y = Ln(h), S = typeof h == "string", M = (y || S) && h.length;
    return y ? M === s || M === i : S ? M === 2 * s || M === 2 * i : h instanceof L;
  }
  function P(h, y, S = !0) {
    if (q(h))
      throw new Error("first arg must be private key");
    if (!q(y))
      throw new Error("second arg must be public key");
    return L.fromHex(y).multiply(I(h)).toRawBytes(S);
  }
  const F = t.bits2int || function(h) {
    const y = pn(h), S = h.length * 8 - t.nBitLength;
    return S > 0 ? y >> BigInt(S) : y;
  }, V = t.bits2int_modN || function(h) {
    return a(F(h));
  }, J = Ci(t.nBitLength);
  function xt(h) {
    if (typeof h != "bigint")
      throw new Error("bigint expected");
    if (!(Ve <= h && h < J))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return Cn(h, t.nByteLength);
  }
  function Mt(h, y, S = X) {
    if (["recovered", "canonical"].some((st) => st in S))
      throw new Error("sign() legacy options not supported");
    const { hash: M, randomBytes: m } = t;
    let { lowS: A, prehash: p, extraEntropy: f } = S;
    A == null && (A = !0), h = ce("msgHash", h), p && (h = ce("prehashed msgHash", M(h)));
    const x = V(h), H = I(y), W = [xt(H), xt(x)];
    if (f != null && f !== !1) {
      const st = f === !0 ? m(e.BYTES) : f;
      W.push(ce("extraEntropy", st));
    }
    const Z = mn(...W), it = x;
    function nt(st) {
      const Ut = F(st);
      if (!O(Ut))
        return;
      const dt = d(Ut), pt = L.BASE.multiply(Ut).toAffine(), St = a(pt.x);
      if (St === Ve)
        return;
      const Lt = a(dt * a(it + St * H));
      if (Lt === Ve)
        return;
      let bt = (pt.x === St ? 0 : 2) | Number(pt.y & Ce), Pe = Lt;
      return A && B(Lt) && (Pe = E(Lt), bt ^= 1), new _(St, Pe, bt);
    }
    return { seed: Z, k2sig: nt };
  }
  const X = { lowS: t.lowS, prehash: !1 }, jt = { lowS: t.lowS, prehash: !1 };
  function j(h, y, S = X) {
    const { seed: M, k2sig: m } = Mt(h, y, S), A = t;
    return oo(A.hash.outputLen, A.nByteLength, A.hmac)(M, m);
  }
  L.BASE._setWindowSize(8);
  function u(h, y, S, M = jt) {
    var pt;
    const m = h;
    if (y = ce("msgHash", y), S = ce("publicKey", S), "strict" in M)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: A, prehash: p } = M;
    let f, x;
    try {
      if (typeof m == "string" || Ln(m))
        try {
          f = _.fromDER(m);
        } catch (St) {
          if (!(St instanceof yn.Err))
            throw St;
          f = _.fromCompact(m);
        }
      else if (typeof m == "object" && typeof m.r == "bigint" && typeof m.s == "bigint") {
        const { r: St, s: Lt } = m;
        f = new _(St, Lt);
      } else
        throw new Error("PARSE");
      x = L.fromHex(S);
    } catch (St) {
      if (St.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (A && f.hasHighS())
      return !1;
    p && (y = t.hash(y));
    const { r: H, s: W } = f, Z = V(y), it = d(W), nt = a(Z * it), st = a(H * it), Ut = (pt = L.BASE.multiplyAndAddUnsafe(x, nt, st)) == null ? void 0 : pt.toAffine();
    return Ut ? a(Ut.x) === H : !1;
  }
  return {
    CURVE: t,
    getPublicKey: z,
    getSharedSecret: P,
    sign: j,
    verify: u,
    ProjectivePoint: L,
    Signature: _,
    utils: U
  };
}
class Jo extends Js {
  constructor(t, e) {
    super(), this.finished = !1, this.destroyed = !1, ma(t);
    const n = Bi(e);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const s = this.blockLen, i = new Uint8Array(s);
    i.set(n.length > s ? t.create().update(n).digest() : n);
    for (let o = 0; o < i.length; o++)
      i[o] ^= 54;
    this.iHash.update(i), this.oHash = t.create();
    for (let o = 0; o < i.length; o++)
      i[o] ^= 106;
    this.oHash.update(i), i.fill(0);
  }
  update(t) {
    return fr(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    fr(this), Sr(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: e, iHash: n, finished: s, destroyed: i, blockLen: o, outputLen: a } = this;
    return t = t, t.finished = s, t.destroyed = i, t.blockLen = o, t.outputLen = a, t.oHash = e._cloneInto(t.oHash), t.iHash = n._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Xo = (r, t, e) => new Jo(r, t).update(e).digest();
Xo.create = (r, t) => new Jo(r, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function g0(r) {
  return {
    hash: r,
    hmac: (t, ...e) => Xo(r, t, Ks(...e)),
    randomBytes: to
  };
}
function y0(r, t) {
  const e = (n) => d0({ ...r, ...g0(n) });
  return Object.freeze({ ...e(t), create: e });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const tu = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Es = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), p0 = BigInt(1), Ii = BigInt(2), As = (r, t) => (r + t / Ii) / t;
function M0(r) {
  const t = tu, e = BigInt(3), n = BigInt(6), s = BigInt(11), i = BigInt(22), o = BigInt(23), a = BigInt(44), d = BigInt(88), L = r * r * r % t, I = L * L * r % t, b = Yt(I, e, t) * I % t, O = Yt(b, e, t) * I % t, v = Yt(O, Ii, t) * L % t, B = Yt(v, s, t) * v % t, E = Yt(B, i, t) * B % t, N = Yt(E, a, t) * E % t, _ = Yt(N, d, t) * N % t, U = Yt(_, a, t) * E % t, z = Yt(U, e, t) * I % t, q = Yt(z, o, t) * B % t, P = Yt(q, n, t) * L % t, F = Yt(P, Ii, t);
  if (!xi.eql(xi.sqr(F), r))
    throw new Error("Cannot find square root");
  return F;
}
const xi = ao(tu, void 0, void 0, { sqrt: M0 }), Ki = y0({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: xi,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: Es,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (r) => {
      const t = Es, e = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -p0 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), s = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = e, o = BigInt("0x100000000000000000000000000000000"), a = As(i * r, t), d = As(-n * r, t);
      let L = zt(r - a * e - d * s, t), I = zt(-a * n - d * i, t);
      const b = L > o, O = I > o;
      if (b && (L = t - L), O && (I = t - I), L > o || I > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + r);
      return { k1neg: b, k1: L, k2neg: O, k2: I };
    }
  }
}, mi);
BigInt(0);
Ki.ProjectivePoint;
xr.utils.randomPrivateKey;
function Ns(r) {
  try {
    return xr.ExtendedPoint.fromHex(r), !0;
  } catch {
    return !1;
  }
}
const eu = (r, t) => xr.sign(r, t.slice(0, 32)), L0 = xr.verify, On = (r) => lt.Buffer.isBuffer(r) ? r : r instanceof Uint8Array ? lt.Buffer.from(r.buffer, r.byteOffset, r.byteLength) : lt.Buffer.from(r);
class w0 {
  constructor(t) {
    Object.assign(this, t);
  }
  encode() {
    return lt.Buffer.from(Io(cr, this));
  }
  static decode(t) {
    return xo(cr, this, t);
  }
  static decodeUnchecked(t) {
    return Mo(cr, this, t);
  }
}
const cr = /* @__PURE__ */ new Map();
var nu;
const m0 = 32, cn = 32;
function S0(r) {
  return r._bn !== void 0;
}
let vs = 1;
class ut extends w0 {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(t) {
    if (super({}), this._bn = void 0, S0(t))
      this._bn = t._bn;
    else {
      if (typeof t == "string") {
        const e = ge.decode(t);
        if (e.length != cn)
          throw new Error("Invalid public key input");
        this._bn = new Is(e);
      } else
        this._bn = new Is(t);
      if (this._bn.byteLength() > cn)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const t = new ut(vs);
    return vs += 1, new ut(t.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(t) {
    return this._bn.eq(t._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return ge.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const t = this.toBuffer();
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const t = this._bn.toArrayLike(lt.Buffer);
    if (t.length === cn)
      return t;
    const e = lt.Buffer.alloc(32);
    return t.copy(e, 32 - t.length), e;
  }
  get [Symbol.toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(t, e, n) {
    const s = lt.Buffer.concat([t.toBuffer(), lt.Buffer.from(e), n.toBuffer()]), i = mi(s);
    return new ut(i);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(t, e) {
    let n = lt.Buffer.alloc(0);
    t.forEach(function(i) {
      if (i.length > m0)
        throw new TypeError("Max seed length exceeded");
      n = lt.Buffer.concat([n, On(i)]);
    }), n = lt.Buffer.concat([n, e.toBuffer(), lt.Buffer.from("ProgramDerivedAddress")]);
    const s = mi(n);
    if (Ns(s))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new ut(s);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(t, e) {
    return this.createProgramAddressSync(t, e);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(t, e) {
    let n = 255, s;
    for (; n != 0; ) {
      try {
        const i = t.concat(lt.Buffer.from([n]));
        s = this.createProgramAddressSync(i, e);
      } catch (i) {
        if (i instanceof TypeError)
          throw i;
        n--;
        continue;
      }
      return [s, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(t, e) {
    return this.findProgramAddressSync(t, e);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(t) {
    const e = new ut(t);
    return Ns(e.toBytes());
  }
}
nu = ut;
ut.default = new nu("11111111111111111111111111111111");
cr.set(ut, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new ut("BPFLoader1111111111111111111111111111111111");
const Bn = 1280 - 40 - 8, Ji = 127, pr = 64;
class ru extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: block height exceeded.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(ru.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class iu extends Error {
  constructor(t, e) {
    super(`Transaction was not confirmed in ${e.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${t} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(iu.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class Wn extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(Wn.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
class Mr {
  constructor(t, e) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = t, this.accountKeysFromLookups = e;
  }
  keySegments() {
    const t = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (t.push(this.accountKeysFromLookups.writable), t.push(this.accountKeysFromLookups.readonly)), t;
  }
  get(t) {
    for (const e of this.keySegments()) {
      if (t < e.length)
        return e[t];
      t -= e.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(t) {
    if (this.length > 255 + 1)
      throw new Error("Account index overflow encountered during compilation");
    const n = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((i, o) => {
      n.set(i.toBase58(), o);
    });
    const s = (i) => {
      const o = n.get(i.toBase58());
      if (o === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return o;
    };
    return t.map((i) => ({
      programIdIndex: s(i.programId),
      accountKeyIndexes: i.keys.map((o) => s(o.pubkey)),
      data: i.data
    }));
  }
}
const wt = (r = "publicKey") => Dt(32, r), I0 = (r = "signature") => Dt(64, r), vn = (r = "string") => {
  const t = tt([rt("length"), rt("lengthPadding"), Dt(Mn(rt(), -8), "chars")], r), e = t.decode.bind(t), n = t.encode.bind(t), s = t;
  return s.decode = (i, o) => e(i, o).chars.toString(), s.encode = (i, o, a) => {
    const d = {
      chars: lt.Buffer.from(i, "utf8")
    };
    return n(d, o, a);
  }, s.alloc = (i) => rt().span + rt().span + lt.Buffer.from(i, "utf8").length, s;
}, x0 = (r = "authorized") => tt([wt("staker"), wt("withdrawer")], r), j0 = (r = "lockup") => tt([Ae("unixTimestamp"), Ae("epoch"), wt("custodian")], r), b0 = (r = "voteInit") => tt([wt("nodePubkey"), wt("authorizedVoter"), wt("authorizedWithdrawer"), It("commission")], r), E0 = (r = "voteAuthorizeWithSeedArgs") => tt([rt("voteAuthorizationType"), wt("currentAuthorityDerivedKeyOwnerPubkey"), vn("currentAuthorityDerivedKeySeed"), wt("newAuthorized")], r);
function Ne(r) {
  let t = 0, e = 0;
  for (; ; ) {
    let n = r.shift();
    if (t |= (n & 127) << e * 7, e += 1, !(n & 128))
      break;
  }
  return t;
}
function ve(r, t) {
  let e = t;
  for (; ; ) {
    let n = e & 127;
    if (e >>= 7, e == 0) {
      r.push(n);
      break;
    } else
      n |= 128, r.push(n);
  }
}
function Rt(r, t) {
  if (!r)
    throw new Error(t || "Assertion failed");
}
class Tr {
  constructor(t, e) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = t, this.keyMetaMap = e;
  }
  static compile(t, e) {
    const n = /* @__PURE__ */ new Map(), s = (o) => {
      const a = o.toBase58();
      let d = n.get(a);
      return d === void 0 && (d = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, n.set(a, d)), d;
    }, i = s(e);
    i.isSigner = !0, i.isWritable = !0;
    for (const o of t) {
      s(o.programId).isInvoked = !0;
      for (const a of o.keys) {
        const d = s(a.pubkey);
        d.isSigner || (d.isSigner = a.isSigner), d.isWritable || (d.isWritable = a.isWritable);
      }
    }
    return new Tr(e, n);
  }
  getMessageComponents() {
    const t = [...this.keyMetaMap.entries()];
    Rt(t.length <= 256, "Max static account keys length exceeded");
    const e = t.filter(([, d]) => d.isSigner && d.isWritable), n = t.filter(([, d]) => d.isSigner && !d.isWritable), s = t.filter(([, d]) => !d.isSigner && d.isWritable), i = t.filter(([, d]) => !d.isSigner && !d.isWritable), o = {
      numRequiredSignatures: e.length + n.length,
      numReadonlySignedAccounts: n.length,
      numReadonlyUnsignedAccounts: i.length
    };
    {
      Rt(e.length > 0, "Expected at least one writable signer key");
      const [d] = e[0];
      Rt(d === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const a = [...e.map(([d]) => new ut(d)), ...n.map(([d]) => new ut(d)), ...s.map(([d]) => new ut(d)), ...i.map(([d]) => new ut(d))];
    return [o, a];
  }
  extractTableLookup(t) {
    const [e, n] = this.drainKeysFoundInLookupTable(t.state.addresses, (o) => !o.isSigner && !o.isInvoked && o.isWritable), [s, i] = this.drainKeysFoundInLookupTable(t.state.addresses, (o) => !o.isSigner && !o.isInvoked && !o.isWritable);
    if (!(e.length === 0 && s.length === 0))
      return [{
        accountKey: t.key,
        writableIndexes: e,
        readonlyIndexes: s
      }, {
        writable: n,
        readonly: i
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(t, e) {
    const n = new Array(), s = new Array();
    for (const [i, o] of this.keyMetaMap.entries())
      if (e(o)) {
        const a = new ut(i), d = t.findIndex((L) => L.equals(a));
        d >= 0 && (Rt(d < 256, "Max lookup table index exceeded"), n.push(d), s.push(a), this.keyMetaMap.delete(i));
      }
    return [n, s];
  }
}
const su = "Reached end of buffer unexpectedly";
function $e(r) {
  if (r.length === 0)
    throw new Error(su);
  return r.shift();
}
function Te(r, ...t) {
  const [e] = t;
  if (t.length === 2 ? e + (t[1] ?? 0) > r.length : e >= r.length)
    throw new Error(su);
  return r.splice(...t);
}
class Je {
  constructor(t) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = t.header, this.accountKeys = t.accountKeys.map((e) => new ut(e)), this.recentBlockhash = t.recentBlockhash, this.instructions = t.instructions, this.instructions.forEach((e) => this.indexToProgramIds.set(e.programIdIndex, this.accountKeys[e.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((t) => ({
      programIdIndex: t.programIdIndex,
      accountKeyIndexes: t.accounts,
      data: ge.decode(t.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new Mr(this.staticAccountKeys);
  }
  static compile(t) {
    const e = Tr.compile(t.instructions, t.payerKey), [n, s] = e.getMessageComponents(), o = new Mr(s).compileInstructions(t.instructions).map((a) => ({
      programIdIndex: a.programIdIndex,
      accounts: a.accountKeyIndexes,
      data: ge.encode(a.data)
    }));
    return new Je({
      header: n,
      accountKeys: s,
      recentBlockhash: t.recentBlockhash,
      instructions: o
    });
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const e = this.header.numRequiredSignatures;
    if (t >= this.header.numRequiredSignatures) {
      const n = t - e, i = this.accountKeys.length - e - this.header.numReadonlyUnsignedAccounts;
      return n < i;
    } else {
      const n = e - this.header.numReadonlySignedAccounts;
      return t < n;
    }
  }
  isProgramId(t) {
    return this.indexToProgramIds.has(t);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((t, e) => !this.isProgramId(e));
  }
  serialize() {
    const t = this.accountKeys.length;
    let e = [];
    ve(e, t);
    const n = this.instructions.map((b) => {
      const {
        accounts: O,
        programIdIndex: v
      } = b, B = Array.from(ge.decode(b.data));
      let E = [];
      ve(E, O.length);
      let N = [];
      return ve(N, B.length), {
        programIdIndex: v,
        keyIndicesCount: lt.Buffer.from(E),
        keyIndices: O,
        dataLength: lt.Buffer.from(N),
        data: B
      };
    });
    let s = [];
    ve(s, n.length);
    let i = lt.Buffer.alloc(Bn);
    lt.Buffer.from(s).copy(i);
    let o = s.length;
    n.forEach((b) => {
      const v = tt([It("programIdIndex"), Dt(b.keyIndicesCount.length, "keyIndicesCount"), me(It("keyIndex"), b.keyIndices.length, "keyIndices"), Dt(b.dataLength.length, "dataLength"), me(It("userdatum"), b.data.length, "data")]).encode(b, i, o);
      o += v;
    }), i = i.slice(0, o);
    const a = tt([Dt(1, "numRequiredSignatures"), Dt(1, "numReadonlySignedAccounts"), Dt(1, "numReadonlyUnsignedAccounts"), Dt(e.length, "keyCount"), me(wt("key"), t, "keys"), wt("recentBlockhash")]), d = {
      numRequiredSignatures: lt.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: lt.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: lt.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: lt.Buffer.from(e),
      keys: this.accountKeys.map((b) => On(b.toBytes())),
      recentBlockhash: ge.decode(this.recentBlockhash)
    };
    let L = lt.Buffer.alloc(2048);
    const I = a.encode(d, L);
    return i.copy(L, I), L.slice(0, I + i.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(t) {
    let e = [...t];
    const n = $e(e);
    if (n !== (n & Ji))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const s = $e(e), i = $e(e), o = Ne(e);
    let a = [];
    for (let O = 0; O < o; O++) {
      const v = Te(e, 0, cn);
      a.push(new ut(lt.Buffer.from(v)));
    }
    const d = Te(e, 0, cn), L = Ne(e);
    let I = [];
    for (let O = 0; O < L; O++) {
      const v = $e(e), B = Ne(e), E = Te(e, 0, B), N = Ne(e), _ = Te(e, 0, N), U = ge.encode(lt.Buffer.from(_));
      I.push({
        programIdIndex: v,
        accounts: E,
        data: U
      });
    }
    const b = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: s,
        numReadonlyUnsignedAccounts: i
      },
      recentBlockhash: ge.encode(lt.Buffer.from(d)),
      accountKeys: a,
      instructions: I
    };
    return new Je(b);
  }
}
class Vn {
  constructor(t) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = t.header, this.staticAccountKeys = t.staticAccountKeys, this.recentBlockhash = t.recentBlockhash, this.compiledInstructions = t.compiledInstructions, this.addressTableLookups = t.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let t = 0;
    for (const e of this.addressTableLookups)
      t += e.readonlyIndexes.length + e.writableIndexes.length;
    return t;
  }
  getAccountKeys(t) {
    let e;
    if (t && "accountKeysFromLookups" in t && t.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != t.accountKeysFromLookups.writable.length + t.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      e = t.accountKeysFromLookups;
    } else if (t && "addressLookupTableAccounts" in t && t.addressLookupTableAccounts)
      e = this.resolveAddressTableLookups(t.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new Mr(this.staticAccountKeys, e);
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const e = this.header.numRequiredSignatures, n = this.staticAccountKeys.length;
    if (t >= n) {
      const s = t - n, i = this.addressTableLookups.reduce((o, a) => o + a.writableIndexes.length, 0);
      return s < i;
    } else if (t >= this.header.numRequiredSignatures) {
      const s = t - e, o = n - e - this.header.numReadonlyUnsignedAccounts;
      return s < o;
    } else {
      const s = e - this.header.numReadonlySignedAccounts;
      return t < s;
    }
  }
  resolveAddressTableLookups(t) {
    const e = {
      writable: [],
      readonly: []
    };
    for (const n of this.addressTableLookups) {
      const s = t.find((i) => i.key.equals(n.accountKey));
      if (!s)
        throw new Error(`Failed to find address lookup table account for table key ${n.accountKey.toBase58()}`);
      for (const i of n.writableIndexes)
        if (i < s.state.addresses.length)
          e.writable.push(s.state.addresses[i]);
        else
          throw new Error(`Failed to find address for index ${i} in address lookup table ${n.accountKey.toBase58()}`);
      for (const i of n.readonlyIndexes)
        if (i < s.state.addresses.length)
          e.readonly.push(s.state.addresses[i]);
        else
          throw new Error(`Failed to find address for index ${i} in address lookup table ${n.accountKey.toBase58()}`);
    }
    return e;
  }
  static compile(t) {
    const e = Tr.compile(t.instructions, t.payerKey), n = new Array(), s = {
      writable: new Array(),
      readonly: new Array()
    }, i = t.addressLookupTableAccounts || [];
    for (const I of i) {
      const b = e.extractTableLookup(I);
      if (b !== void 0) {
        const [O, {
          writable: v,
          readonly: B
        }] = b;
        n.push(O), s.writable.push(...v), s.readonly.push(...B);
      }
    }
    const [o, a] = e.getMessageComponents(), L = new Mr(a, s).compileInstructions(t.instructions);
    return new Vn({
      header: o,
      staticAccountKeys: a,
      recentBlockhash: t.recentBlockhash,
      compiledInstructions: L,
      addressTableLookups: n
    });
  }
  serialize() {
    const t = Array();
    ve(t, this.staticAccountKeys.length);
    const e = this.serializeInstructions(), n = Array();
    ve(n, this.compiledInstructions.length);
    const s = this.serializeAddressTableLookups(), i = Array();
    ve(i, this.addressTableLookups.length);
    const o = tt([It("prefix"), tt([It("numRequiredSignatures"), It("numReadonlySignedAccounts"), It("numReadonlyUnsignedAccounts")], "header"), Dt(t.length, "staticAccountKeysLength"), me(wt(), this.staticAccountKeys.length, "staticAccountKeys"), wt("recentBlockhash"), Dt(n.length, "instructionsLength"), Dt(e.length, "serializedInstructions"), Dt(i.length, "addressTableLookupsLength"), Dt(s.length, "serializedAddressTableLookups")]), a = new Uint8Array(Bn), d = 128, L = o.encode({
      prefix: d,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(t),
      staticAccountKeys: this.staticAccountKeys.map((I) => I.toBytes()),
      recentBlockhash: ge.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(n),
      serializedInstructions: e,
      addressTableLookupsLength: new Uint8Array(i),
      serializedAddressTableLookups: s
    }, a);
    return a.slice(0, L);
  }
  serializeInstructions() {
    let t = 0;
    const e = new Uint8Array(Bn);
    for (const n of this.compiledInstructions) {
      const s = Array();
      ve(s, n.accountKeyIndexes.length);
      const i = Array();
      ve(i, n.data.length);
      const o = tt([It("programIdIndex"), Dt(s.length, "encodedAccountKeyIndexesLength"), me(It(), n.accountKeyIndexes.length, "accountKeyIndexes"), Dt(i.length, "encodedDataLength"), Dt(n.data.length, "data")]);
      t += o.encode({
        programIdIndex: n.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(s),
        accountKeyIndexes: n.accountKeyIndexes,
        encodedDataLength: new Uint8Array(i),
        data: n.data
      }, e, t);
    }
    return e.slice(0, t);
  }
  serializeAddressTableLookups() {
    let t = 0;
    const e = new Uint8Array(Bn);
    for (const n of this.addressTableLookups) {
      const s = Array();
      ve(s, n.writableIndexes.length);
      const i = Array();
      ve(i, n.readonlyIndexes.length);
      const o = tt([wt("accountKey"), Dt(s.length, "encodedWritableIndexesLength"), me(It(), n.writableIndexes.length, "writableIndexes"), Dt(i.length, "encodedReadonlyIndexesLength"), me(It(), n.readonlyIndexes.length, "readonlyIndexes")]);
      t += o.encode({
        accountKey: n.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(s),
        writableIndexes: n.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(i),
        readonlyIndexes: n.readonlyIndexes
      }, e, t);
    }
    return e.slice(0, t);
  }
  static deserialize(t) {
    let e = [...t];
    const n = $e(e), s = n & Ji;
    Rt(n !== s, "Expected versioned message but received legacy message");
    const i = s;
    Rt(i === 0, `Expected versioned message with version 0 but found version ${i}`);
    const o = {
      numRequiredSignatures: $e(e),
      numReadonlySignedAccounts: $e(e),
      numReadonlyUnsignedAccounts: $e(e)
    }, a = [], d = Ne(e);
    for (let B = 0; B < d; B++)
      a.push(new ut(Te(e, 0, cn)));
    const L = ge.encode(Te(e, 0, cn)), I = Ne(e), b = [];
    for (let B = 0; B < I; B++) {
      const E = $e(e), N = Ne(e), _ = Te(e, 0, N), U = Ne(e), z = new Uint8Array(Te(e, 0, U));
      b.push({
        programIdIndex: E,
        accountKeyIndexes: _,
        data: z
      });
    }
    const O = Ne(e), v = [];
    for (let B = 0; B < O; B++) {
      const E = new ut(Te(e, 0, cn)), N = Ne(e), _ = Te(e, 0, N), U = Ne(e), z = Te(e, 0, U);
      v.push({
        accountKey: E,
        writableIndexes: _,
        readonlyIndexes: z
      });
    }
    return new Vn({
      header: o,
      staticAccountKeys: a,
      recentBlockhash: L,
      compiledInstructions: b,
      addressTableLookups: v
    });
  }
}
const ou = {
  deserializeMessageVersion(r) {
    const t = r[0], e = t & Ji;
    return e === t ? "legacy" : e;
  },
  deserialize: (r) => {
    const t = ou.deserializeMessageVersion(r);
    if (t === "legacy")
      return Je.from(r);
    if (t === 0)
      return Vn.deserialize(r);
    throw new Error(`Transaction message version ${t} deserialization is not supported`);
  }
};
let rn = /* @__PURE__ */ function(r) {
  return r[r.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", r[r.PROCESSED = 1] = "PROCESSED", r[r.TIMED_OUT = 2] = "TIMED_OUT", r[r.NONCE_INVALID = 3] = "NONCE_INVALID", r;
}({});
const A0 = lt.Buffer.alloc(pr).fill(0);
class Ts {
  constructor(t) {
    this.keys = void 0, this.programId = void 0, this.data = lt.Buffer.alloc(0), this.programId = t.programId, this.keys = t.keys, t.data && (this.data = t.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: t,
        isSigner: e,
        isWritable: n
      }) => ({
        pubkey: t.toJSON(),
        isSigner: e,
        isWritable: n
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class sn {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(t) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!t)
      if (t.feePayer && (this.feePayer = t.feePayer), t.signatures && (this.signatures = t.signatures), Object.prototype.hasOwnProperty.call(t, "nonceInfo")) {
        const {
          minContextSlot: e,
          nonceInfo: n
        } = t;
        this.minNonceContextSlot = e, this.nonceInfo = n;
      } else if (Object.prototype.hasOwnProperty.call(t, "lastValidBlockHeight")) {
        const {
          blockhash: e,
          lastValidBlockHeight: n
        } = t;
        this.recentBlockhash = e, this.lastValidBlockHeight = n;
      } else {
        const {
          recentBlockhash: e,
          nonceInfo: n
        } = t;
        n && (this.nonceInfo = n), this.recentBlockhash = e;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((t) => t.toJSON()),
      signers: this.signatures.map(({
        publicKey: t
      }) => t.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...t) {
    if (t.length === 0)
      throw new Error("No instructions");
    return t.forEach((e) => {
      "instructions" in e ? this.instructions = this.instructions.concat(e.instructions) : "data" in e && "programId" in e && "keys" in e ? this.instructions.push(e) : this.instructions.push(new Ts(e));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let t, e;
    if (this.nonceInfo ? (t = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? e = [this.nonceInfo.nonceInstruction, ...this.instructions] : e = this.instructions) : (t = this.recentBlockhash, e = this.instructions), !t)
      throw new Error("Transaction recentBlockhash required");
    e.length < 1 && console.warn("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let E = 0; E < e.length; E++)
      if (e[E].programId === void 0)
        throw new Error(`Transaction instruction index ${E} has undefined program id`);
    const s = [], i = [];
    e.forEach((E) => {
      E.keys.forEach((_) => {
        i.push({
          ..._
        });
      });
      const N = E.programId.toString();
      s.includes(N) || s.push(N);
    }), s.forEach((E) => {
      i.push({
        pubkey: new ut(E),
        isSigner: !1,
        isWritable: !1
      });
    });
    const o = [];
    i.forEach((E) => {
      const N = E.pubkey.toString(), _ = o.findIndex((U) => U.pubkey.toString() === N);
      _ > -1 ? (o[_].isWritable = o[_].isWritable || E.isWritable, o[_].isSigner = o[_].isSigner || E.isSigner) : o.push(E);
    }), o.sort(function(E, N) {
      if (E.isSigner !== N.isSigner)
        return E.isSigner ? -1 : 1;
      if (E.isWritable !== N.isWritable)
        return E.isWritable ? -1 : 1;
      const _ = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return E.pubkey.toBase58().localeCompare(N.pubkey.toBase58(), "en", _);
    });
    const a = o.findIndex((E) => E.pubkey.equals(n));
    if (a > -1) {
      const [E] = o.splice(a, 1);
      E.isSigner = !0, E.isWritable = !0, o.unshift(E);
    } else
      o.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    for (const E of this.signatures) {
      const N = o.findIndex((_) => _.pubkey.equals(E.publicKey));
      if (N > -1)
        o[N].isSigner || (o[N].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${E.publicKey.toString()}`);
    }
    let d = 0, L = 0, I = 0;
    const b = [], O = [];
    o.forEach(({
      pubkey: E,
      isSigner: N,
      isWritable: _
    }) => {
      N ? (b.push(E.toString()), d += 1, _ || (L += 1)) : (O.push(E.toString()), _ || (I += 1));
    });
    const v = b.concat(O), B = e.map((E) => {
      const {
        data: N,
        programId: _
      } = E;
      return {
        programIdIndex: v.indexOf(_.toString()),
        accounts: E.keys.map((U) => v.indexOf(U.pubkey.toString())),
        data: ge.encode(N)
      };
    });
    return B.forEach((E) => {
      Rt(E.programIdIndex >= 0), E.accounts.forEach((N) => Rt(N >= 0));
    }), new Je({
      header: {
        numRequiredSignatures: d,
        numReadonlySignedAccounts: L,
        numReadonlyUnsignedAccounts: I
      },
      accountKeys: v,
      recentBlockhash: t,
      instructions: B
    });
  }
  /**
   * @internal
   */
  _compile() {
    const t = this.compileMessage(), e = t.accountKeys.slice(0, t.header.numRequiredSignatures);
    return this.signatures.length === e.length && this.signatures.every((s, i) => e[i].equals(s.publicKey)) || (this.signatures = e.map((n) => ({
      signature: null,
      publicKey: n
    }))), t;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(t) {
    return (await t.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const e = /* @__PURE__ */ new Set();
    this.signatures = t.filter((n) => {
      const s = n.toString();
      return e.has(s) ? !1 : (e.add(s), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const e = /* @__PURE__ */ new Set(), n = [];
    for (const i of t) {
      const o = i.publicKey.toString();
      e.has(o) || (e.add(o), n.push(i));
    }
    this.signatures = n.map((i) => ({
      signature: null,
      publicKey: i.publicKey
    }));
    const s = this._compile();
    this._partialSign(s, ...n);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const e = /* @__PURE__ */ new Set(), n = [];
    for (const i of t) {
      const o = i.publicKey.toString();
      e.has(o) || (e.add(o), n.push(i));
    }
    const s = this._compile();
    this._partialSign(s, ...n);
  }
  /**
   * @internal
   */
  _partialSign(t, ...e) {
    const n = t.serialize();
    e.forEach((s) => {
      const i = eu(n, s.secretKey);
      this._addSignature(s.publicKey, On(i));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(t, e) {
    this._compile(), this._addSignature(t, e);
  }
  /**
   * @internal
   */
  _addSignature(t, e) {
    Rt(e.length === 64);
    const n = this.signatures.findIndex((s) => t.equals(s.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${t.toString()}`);
    this.signatures[n].signature = lt.Buffer.from(e);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(t = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), t);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(t, e) {
    const n = {};
    for (const {
      signature: s,
      publicKey: i
    } of this.signatures)
      s === null ? e && (n.missing || (n.missing = [])).push(i) : L0(s, t, i.toBytes()) || (n.invalid || (n.invalid = [])).push(i);
    return n.invalid || n.missing ? n : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(t) {
    const {
      requireAllSignatures: e,
      verifySignatures: n
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, t), s = this.serializeMessage();
    if (n) {
      const i = this._getMessageSignednessErrors(s, e);
      if (i) {
        let o = "Signature verification failed.";
        throw i.invalid && (o += `
Invalid signature for public key${i.invalid.length === 1 ? "" : "(s)"} [\`${i.invalid.map((a) => a.toBase58()).join("`, `")}\`].`), i.missing && (o += `
Missing signature for public key${i.missing.length === 1 ? "" : "(s)"} [\`${i.missing.map((a) => a.toBase58()).join("`, `")}\`].`), new Error(o);
      }
    }
    return this._serialize(s);
  }
  /**
   * @internal
   */
  _serialize(t) {
    const {
      signatures: e
    } = this, n = [];
    ve(n, e.length);
    const s = n.length + e.length * 64 + t.length, i = lt.Buffer.alloc(s);
    return Rt(e.length < 256), lt.Buffer.from(n).copy(i, 0), e.forEach(({
      signature: o
    }, a) => {
      o !== null && (Rt(o.length === 64, "signature has invalid length"), lt.Buffer.from(o).copy(i, n.length + a * 64));
    }), t.copy(i, n.length + e.length * 64), Rt(i.length <= Bn, `Transaction too large: ${i.length} > ${Bn}`), i;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return Rt(this.instructions.length === 1), this.instructions[0].keys.map((t) => t.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return Rt(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return Rt(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(t) {
    let e = [...t];
    const n = Ne(e);
    let s = [];
    for (let i = 0; i < n; i++) {
      const o = Te(e, 0, pr);
      s.push(ge.encode(lt.Buffer.from(o)));
    }
    return sn.populate(Je.from(e), s);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(t, e = []) {
    const n = new sn();
    return n.recentBlockhash = t.recentBlockhash, t.header.numRequiredSignatures > 0 && (n.feePayer = t.accountKeys[0]), e.forEach((s, i) => {
      const o = {
        signature: s == ge.encode(A0) ? null : ge.decode(s),
        publicKey: t.accountKeys[i]
      };
      n.signatures.push(o);
    }), t.instructions.forEach((s) => {
      const i = s.accounts.map((o) => {
        const a = t.accountKeys[o];
        return {
          pubkey: a,
          isSigner: n.signatures.some((d) => d.publicKey.toString() === a.toString()) || t.isAccountSigner(o),
          isWritable: t.isAccountWritable(o)
        };
      });
      n.instructions.push(new Ts({
        keys: i,
        programId: t.accountKeys[s.programIdIndex],
        data: ge.decode(s.data)
      }));
    }), n._message = t, n._json = n.toJSON(), n;
  }
}
class uu {
  get version() {
    return this.message.version;
  }
  constructor(t, e) {
    if (this.signatures = void 0, this.message = void 0, e !== void 0)
      Rt(e.length === t.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = e;
    else {
      const n = [];
      for (let s = 0; s < t.header.numRequiredSignatures; s++)
        n.push(new Uint8Array(pr));
      this.signatures = n;
    }
    this.message = t;
  }
  serialize() {
    const t = this.message.serialize(), e = Array();
    ve(e, this.signatures.length);
    const n = tt([Dt(e.length, "encodedSignaturesLength"), me(I0(), this.signatures.length, "signatures"), Dt(t.length, "serializedMessage")]), s = new Uint8Array(2048), i = n.encode({
      encodedSignaturesLength: new Uint8Array(e),
      signatures: this.signatures,
      serializedMessage: t
    }, s);
    return s.slice(0, i);
  }
  static deserialize(t) {
    let e = [...t];
    const n = [], s = Ne(e);
    for (let o = 0; o < s; o++)
      n.push(new Uint8Array(Te(e, 0, pr)));
    const i = ou.deserialize(new Uint8Array(e));
    return new uu(i, n);
  }
  sign(t) {
    const e = this.message.serialize(), n = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const s of t) {
      const i = n.findIndex((o) => o.equals(s.publicKey));
      Rt(i >= 0, `Cannot sign with non signer key ${s.publicKey.toBase58()}`), this.signatures[i] = eu(e, s.secretKey);
    }
  }
  addSignature(t, e) {
    Rt(e.byteLength === 64, "Signature must be 64 bytes long");
    const s = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((i) => i.equals(t));
    Rt(s >= 0, `Can not add signature; \`${t.toBase58()}\` is not required to sign this transaction`), this.signatures[s] = e;
  }
}
const N0 = 160, v0 = 64, T0 = N0 / v0, B0 = 1e3 / T0;
new ut("SysvarC1ock11111111111111111111111111111111");
new ut("SysvarEpochSchedu1e111111111111111111111111");
new ut("Sysvar1nstructions1111111111111111111111111");
new ut("SysvarRecentB1ockHashes11111111111111111111");
new ut("SysvarRent111111111111111111111111111111111");
new ut("SysvarRewards111111111111111111111111111111");
new ut("SysvarS1otHashes111111111111111111111111111");
new ut("SysvarS1otHistory11111111111111111111111111");
new ut("SysvarStakeHistory1111111111111111111111111");
function Nn(r) {
  return new Promise((t) => setTimeout(t, r));
}
const k0 = he("lamportsPerSignature"), au = tt([rt("version"), rt("state"), wt("authorizedPubkey"), wt("nonce"), tt([k0], "feeCalculator")]);
au.span;
class Xi {
  /**
   * @internal
   */
  constructor(t) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = t.authorizedPubkey, this.nonce = t.nonce, this.feeCalculator = t.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(t) {
    const e = au.decode(On(t), 0);
    return new Xi({
      authorizedPubkey: new ut(e.authorizedPubkey),
      nonce: new ut(e.nonce).toString(),
      feeCalculator: e.feeCalculator
    });
  }
}
const C0 = (r) => {
  const t = r.decode.bind(r), e = r.encode.bind(r);
  return {
    decode: t,
    encode: e
  };
}, D0 = (r) => (t) => {
  const e = Dt(r, t), {
    encode: n,
    decode: s
  } = C0(e), i = e;
  return i.decode = (o, a) => {
    const d = s(o, a);
    return ff(lt.Buffer.from(d));
  }, i.encode = (o, a, d) => {
    const L = df(o, r);
    return n(L, a, d);
  }, i;
}, Rn = D0(8);
Object.freeze({
  Create: {
    index: 0,
    layout: tt([rt("instruction"), Ae("lamports"), Ae("space"), wt("programId")])
  },
  Assign: {
    index: 1,
    layout: tt([rt("instruction"), wt("programId")])
  },
  Transfer: {
    index: 2,
    layout: tt([rt("instruction"), Rn("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: tt([rt("instruction"), wt("base"), vn("seed"), Ae("lamports"), Ae("space"), wt("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: tt([rt("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: tt([rt("instruction"), Ae("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: tt([rt("instruction"), wt("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: tt([rt("instruction"), wt("authorized")])
  },
  Allocate: {
    index: 8,
    layout: tt([rt("instruction"), Ae("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: tt([rt("instruction"), wt("base"), vn("seed"), Ae("space"), wt("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: tt([rt("instruction"), wt("base"), vn("seed"), wt("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: tt([rt("instruction"), Rn("lamports"), vn("seed"), wt("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: tt([rt("instruction")])
  }
});
new ut("11111111111111111111111111111111");
new ut("BPFLoader2111111111111111111111111111111111");
function _0(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var O0 = Object.prototype.toString, R0 = Object.keys || function(r) {
  var t = [];
  for (var e in r)
    t.push(e);
  return t;
};
function Zn(r, t) {
  var e, n, s, i, o, a, d;
  if (r === !0)
    return "true";
  if (r === !1)
    return "false";
  switch (typeof r) {
    case "object":
      if (r === null)
        return null;
      if (r.toJSON && typeof r.toJSON == "function")
        return Zn(r.toJSON(), t);
      if (d = O0.call(r), d === "[object Array]") {
        for (s = "[", n = r.length - 1, e = 0; e < n; e++)
          s += Zn(r[e], !0) + ",";
        return n > -1 && (s += Zn(r[e], !0)), s + "]";
      } else if (d === "[object Object]") {
        for (i = R0(r).sort(), n = i.length, s = "", e = 0; e < n; )
          o = i[e], a = Zn(r[o], !1), a !== void 0 && (s && (s += ","), s += JSON.stringify(o) + ":" + a), e++;
        return "{" + s + "}";
      } else
        return JSON.stringify(r);
    case "function":
    case "undefined":
      return t ? null : void 0;
    case "string":
      return JSON.stringify(r);
    default:
      return isFinite(r) ? r : null;
  }
}
var z0 = function(r) {
  var t = Zn(r, !1);
  if (t !== void 0)
    return "" + t;
}, Bs = /* @__PURE__ */ _0(z0);
const Hn = 32;
function fi(r) {
  let t = 0;
  for (; r > 1; )
    r /= 2, t++;
  return t;
}
function U0(r) {
  return r === 0 ? 1 : (r--, r |= r >> 1, r |= r >> 2, r |= r >> 4, r |= r >> 8, r |= r >> 16, r |= r >> 32, r + 1);
}
class P0 {
  constructor(t, e, n, s, i) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = t, this.leaderScheduleSlotOffset = e, this.warmup = n, this.firstNormalEpoch = s, this.firstNormalSlot = i;
  }
  getEpoch(t) {
    return this.getEpochAndSlotIndex(t)[0];
  }
  getEpochAndSlotIndex(t) {
    if (t < this.firstNormalSlot) {
      const e = fi(U0(t + Hn + 1)) - fi(Hn) - 1, n = this.getSlotsInEpoch(e), s = t - (n - Hn);
      return [e, s];
    } else {
      const e = t - this.firstNormalSlot, n = Math.floor(e / this.slotsPerEpoch), s = this.firstNormalEpoch + n, i = e % this.slotsPerEpoch;
      return [s, i];
    }
  }
  getFirstSlotInEpoch(t) {
    return t <= this.firstNormalEpoch ? (Math.pow(2, t) - 1) * Hn : (t - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(t) {
    return this.getFirstSlotInEpoch(t) + this.getSlotsInEpoch(t) - 1;
  }
  getSlotsInEpoch(t) {
    return t < this.firstNormalEpoch ? Math.pow(2, t + fi(Hn)) : this.slotsPerEpoch;
  }
}
class ks extends Error {
  constructor(t, e) {
    super(t), this.logs = void 0, this.logs = e;
  }
}
class et extends Error {
  constructor({
    code: t,
    message: e,
    data: n
  }, s) {
    super(s != null ? `${s}: ${e}` : e), this.code = void 0, this.data = void 0, this.code = t, this.data = n, this.name = "SolanaJSONRPCError";
  }
}
var F0 = globalThis.fetch;
class Y0 extends r0 {
  constructor(t, e, n) {
    const s = (i) => {
      const o = u0(i, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...e
      });
      return "socket" in o ? this.underlyingSocket = o.socket : this.underlyingSocket = o, o;
    };
    super(s, t, e, n), this.underlyingSocket = void 0;
  }
  call(...t) {
    var n;
    const e = (n = this.underlyingSocket) == null ? void 0 : n.readyState;
    return e === 1 ? super.call(...t) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + e + ")"));
  }
  notify(...t) {
    var n;
    const e = (n = this.underlyingSocket) == null ? void 0 : n.readyState;
    return e === 1 ? super.notify(...t) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + e + ")"));
  }
}
function H0(r, t) {
  let e;
  try {
    e = r.layout.decode(t);
  } catch (n) {
    throw new Error("invalid instruction; " + n);
  }
  if (e.typeIndex !== r.index)
    throw new Error(`invalid account data; account type mismatch ${e.typeIndex} != ${r.index}`);
  return e;
}
const Cs = 56;
class Ds {
  constructor(t) {
    this.key = void 0, this.state = void 0, this.key = t.key, this.state = t.state;
  }
  isActive() {
    const t = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === t;
  }
  static deserialize(t) {
    const e = H0(W0, t), n = t.length - Cs;
    Rt(n >= 0, "lookup table is invalid"), Rt(n % 32 === 0, "lookup table is invalid");
    const s = n / 32, {
      addresses: i
    } = tt([me(wt(), s, "addresses")]).decode(t.slice(Cs));
    return {
      deactivationSlot: e.deactivationSlot,
      lastExtendedSlot: e.lastExtendedSlot,
      lastExtendedSlotStartIndex: e.lastExtendedStartIndex,
      authority: e.authority.length !== 0 ? new ut(e.authority[0]) : void 0,
      addresses: i.map((o) => new ut(o))
    };
  }
}
const W0 = {
  index: 1,
  layout: tt([
    rt("typeIndex"),
    Rn("deactivationSlot"),
    he("lastExtendedSlot"),
    It("lastExtendedStartIndex"),
    It(),
    // option
    me(wt(), Mn(It(), -1), "authority")
  ])
}, Z0 = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function G0(r) {
  const t = r.match(Z0);
  if (t == null)
    throw TypeError(`Failed to validate endpoint URL \`${r}\``);
  const [
    e,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    n,
    s,
    i
  ] = t, o = r.startsWith("https:") ? "wss:" : "ws:", a = s == null ? null : parseInt(s.slice(1), 10), d = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    a == null ? "" : `:${a + 1}`
  );
  return `${o}//${n}${d}${i}`;
}
const ue = er(Vi(ut), G(), (r) => new ut(r)), cu = $i([G(), Pt("base64")]), ts = er(Vi(lt.Buffer), cu, (r) => lt.Buffer.from(r[0], "base64")), Q0 = 30 * 1e3;
function q0(r) {
  if (/^https?:/.test(r) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return r;
}
function Ot(r) {
  let t, e;
  if (typeof r == "string")
    t = r;
  else if (r) {
    const {
      commitment: n,
      ...s
    } = r;
    t = n, e = s;
  }
  return {
    commitment: t,
    config: e
  };
}
function fu(r) {
  return je([Y({
    jsonrpc: Pt("2.0"),
    id: G(),
    result: r
  }), Y({
    jsonrpc: Pt("2.0"),
    id: G(),
    error: Y({
      code: tr(),
      message: G(),
      data: ot(Sf())
    })
  })]);
}
const V0 = fu(tr());
function yt(r) {
  return er(fu(r), V0, (t) => "error" in t ? t : {
    ...t,
    result: Q(t.result, r)
  });
}
function Ht(r) {
  return yt(Y({
    context: Y({
      slot: C()
    }),
    value: r
  }));
}
function Br(r) {
  return Y({
    context: Y({
      slot: C()
    }),
    value: r
  });
}
function li(r, t) {
  return r === 0 ? new Vn({
    header: t.header,
    staticAccountKeys: t.accountKeys.map((e) => new ut(e)),
    recentBlockhash: t.recentBlockhash,
    compiledInstructions: t.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: ge.decode(e.data)
    })),
    addressTableLookups: t.addressTableLookups
  }) : new Je(t);
}
const $0 = Y({
  foundation: C(),
  foundationTerm: C(),
  initial: C(),
  taper: C(),
  terminal: C()
}), K0 = yt(K($(Y({
  epoch: C(),
  effectiveSlot: C(),
  amount: C(),
  postBalance: C(),
  commission: ot($(C()))
})))), J0 = K(Y({
  slot: C(),
  prioritizationFee: C()
})), X0 = Y({
  total: C(),
  validator: C(),
  foundation: C(),
  epoch: C()
}), tl = Y({
  epoch: C(),
  slotIndex: C(),
  slotsInEpoch: C(),
  absoluteSlot: C(),
  blockHeight: ot(C()),
  transactionCount: ot(C())
}), el = Y({
  slotsPerEpoch: C(),
  leaderScheduleSlotOffset: C(),
  warmup: He(),
  firstNormalEpoch: C(),
  firstNormalSlot: C()
}), nl = Yo(G(), K(C())), xn = $(je([Y({}), G()])), rl = Y({
  err: xn
}), il = Pt("receivedSignature"), sl = Y({
  "solana-core": G(),
  "feature-set": ot(C())
}), _s = Ht(Y({
  err: $(je([Y({}), G()])),
  logs: $(K(G())),
  accounts: ot($(K($(Y({
    executable: He(),
    owner: G(),
    lamports: C(),
    data: K(G()),
    rentEpoch: ot(C())
  }))))),
  unitsConsumed: ot(C()),
  returnData: ot($(Y({
    programId: G(),
    data: $i([G(), Pt("base64")])
  })))
})), ol = Ht(Y({
  byIdentity: Yo(G(), K(C())),
  range: Y({
    firstSlot: C(),
    lastSlot: C()
  })
}));
function ul(r, t, e, n, s, i) {
  const o = e || F0;
  let a;
  i != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let d;
  return n && (d = async (I, b) => {
    const O = await new Promise((v, B) => {
      try {
        n(I, b, (E, N) => v([E, N]));
      } catch (E) {
        B(E);
      }
    });
    return await o(...O);
  }), new $f(async (I, b) => {
    const O = {
      method: "POST",
      body: I,
      agent: a,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, t || {}, ah)
    };
    try {
      let v = 5, B, E = 500;
      for (; d ? B = await d(r, O) : B = await o(r, O), !(B.status !== 429 || s === !0 || (v -= 1, v === 0)); )
        console.error(`Server responded with ${B.status} ${B.statusText}.  Retrying after ${E}ms delay...`), await Nn(E), E *= 2;
      const N = await B.text();
      B.ok ? b(null, N) : b(new Error(`${B.status} ${B.statusText}: ${N}`));
    } catch (v) {
      v instanceof Error && b(v);
    }
  }, {});
}
function al(r) {
  return (t, e) => new Promise((n, s) => {
    r.request(t, e, (i, o) => {
      if (i) {
        s(i);
        return;
      }
      n(o);
    });
  });
}
function cl(r) {
  return (t) => new Promise((e, n) => {
    t.length === 0 && e([]);
    const s = t.map((i) => r.request(i.methodName, i.args));
    r.request(s, (i, o) => {
      if (i) {
        n(i);
        return;
      }
      e(o);
    });
  });
}
const fl = yt($0), ll = yt(X0), hl = yt(J0), dl = yt(tl), gl = yt(el), yl = yt(nl), pl = yt(C()), Ml = Ht(Y({
  total: C(),
  circulating: C(),
  nonCirculating: C(),
  nonCirculatingAccounts: K(ue)
})), ji = Y({
  amount: G(),
  uiAmount: $(C()),
  decimals: C(),
  uiAmountString: ot(G())
}), Ll = Ht(K(Y({
  address: ue,
  amount: G(),
  uiAmount: $(C()),
  decimals: C(),
  uiAmountString: ot(G())
}))), wl = Ht(K(Y({
  pubkey: ue,
  account: Y({
    executable: He(),
    owner: ue,
    lamports: C(),
    data: ts,
    rentEpoch: C()
  })
}))), bi = Y({
  program: G(),
  parsed: tr(),
  space: C()
}), ml = Ht(K(Y({
  pubkey: ue,
  account: Y({
    executable: He(),
    owner: ue,
    lamports: C(),
    data: bi,
    rentEpoch: C()
  })
}))), Sl = Ht(K(Y({
  lamports: C(),
  address: ue
}))), $n = Y({
  executable: He(),
  owner: ue,
  lamports: C(),
  data: ts,
  rentEpoch: C()
}), Il = Y({
  pubkey: ue,
  account: $n
}), xl = er(je([Vi(lt.Buffer), bi]), je([cu, bi]), (r) => Array.isArray(r) ? Q(r, ts) : r), Ei = Y({
  executable: He(),
  owner: ue,
  lamports: C(),
  data: xl,
  rentEpoch: C()
}), jl = Y({
  pubkey: ue,
  account: Ei
}), bl = Y({
  state: je([Pt("active"), Pt("inactive"), Pt("activating"), Pt("deactivating")]),
  active: C(),
  inactive: C()
}), El = yt(K(Y({
  signature: G(),
  slot: C(),
  err: xn,
  memo: $(G()),
  blockTime: ot($(C()))
}))), Al = yt(K(Y({
  signature: G(),
  slot: C(),
  err: xn,
  memo: $(G()),
  blockTime: ot($(C()))
}))), Nl = Y({
  subscription: C(),
  result: Br($n)
}), vl = Y({
  pubkey: ue,
  account: $n
}), Tl = Y({
  subscription: C(),
  result: Br(vl)
}), Bl = Y({
  parent: C(),
  slot: C(),
  root: C()
}), kl = Y({
  subscription: C(),
  result: Bl
}), Cl = je([Y({
  type: je([Pt("firstShredReceived"), Pt("completed"), Pt("optimisticConfirmation"), Pt("root")]),
  slot: C(),
  timestamp: C()
}), Y({
  type: Pt("createdBank"),
  parent: C(),
  slot: C(),
  timestamp: C()
}), Y({
  type: Pt("frozen"),
  slot: C(),
  timestamp: C(),
  stats: Y({
    numTransactionEntries: C(),
    numSuccessfulTransactions: C(),
    numFailedTransactions: C(),
    maxTransactionsPerEntry: C()
  })
}), Y({
  type: Pt("dead"),
  slot: C(),
  timestamp: C(),
  err: G()
})]), Dl = Y({
  subscription: C(),
  result: Cl
}), _l = Y({
  subscription: C(),
  result: Br(je([rl, il]))
}), Ol = Y({
  subscription: C(),
  result: C()
}), Rl = Y({
  pubkey: G(),
  gossip: $(G()),
  tpu: $(G()),
  rpc: $(G()),
  version: $(G())
}), Os = Y({
  votePubkey: G(),
  nodePubkey: G(),
  activatedStake: C(),
  epochVoteAccount: He(),
  epochCredits: K($i([C(), C(), C()])),
  commission: C(),
  lastVote: C(),
  rootSlot: $(C())
}), zl = yt(Y({
  current: K(Os),
  delinquent: K(Os)
})), Ul = je([Pt("processed"), Pt("confirmed"), Pt("finalized")]), Pl = Y({
  slot: C(),
  confirmations: $(C()),
  err: xn,
  confirmationStatus: ot(Ul)
}), Fl = Ht(K($(Pl))), Yl = yt(C()), lu = Y({
  accountKey: ue,
  writableIndexes: K(C()),
  readonlyIndexes: K(C())
}), es = Y({
  signatures: K(G()),
  message: Y({
    accountKeys: K(G()),
    header: Y({
      numRequiredSignatures: C(),
      numReadonlySignedAccounts: C(),
      numReadonlyUnsignedAccounts: C()
    }),
    instructions: K(Y({
      accounts: K(C()),
      data: G(),
      programIdIndex: C()
    })),
    recentBlockhash: G(),
    addressTableLookups: ot(K(lu))
  })
}), hu = Y({
  pubkey: ue,
  signer: He(),
  writable: He(),
  source: ot(je([Pt("transaction"), Pt("lookupTable")]))
}), du = Y({
  accountKeys: K(hu),
  signatures: K(G())
}), gu = Y({
  parsed: tr(),
  program: G(),
  programId: ue
}), yu = Y({
  accounts: K(ue),
  data: G(),
  programId: ue
}), Hl = je([yu, gu]), Wl = je([Y({
  parsed: tr(),
  program: G(),
  programId: G()
}), Y({
  accounts: K(G()),
  data: G(),
  programId: G()
})]), pu = er(Hl, Wl, (r) => "accounts" in r ? Q(r, yu) : Q(r, gu)), Mu = Y({
  signatures: K(G()),
  message: Y({
    accountKeys: K(hu),
    instructions: K(pu),
    recentBlockhash: G(),
    addressTableLookups: ot($(K(lu)))
  })
}), Lr = Y({
  accountIndex: C(),
  mint: G(),
  owner: ot(G()),
  uiTokenAmount: ji
}), Lu = Y({
  writable: K(ue),
  readonly: K(ue)
}), kr = Y({
  err: xn,
  fee: C(),
  innerInstructions: ot($(K(Y({
    index: C(),
    instructions: K(Y({
      accounts: K(C()),
      data: G(),
      programIdIndex: C()
    }))
  })))),
  preBalances: K(C()),
  postBalances: K(C()),
  logMessages: ot($(K(G()))),
  preTokenBalances: ot($(K(Lr))),
  postTokenBalances: ot($(K(Lr))),
  loadedAddresses: ot(Lu),
  computeUnitsConsumed: ot(C())
}), ns = Y({
  err: xn,
  fee: C(),
  innerInstructions: ot($(K(Y({
    index: C(),
    instructions: K(pu)
  })))),
  preBalances: K(C()),
  postBalances: K(C()),
  logMessages: ot($(K(G()))),
  preTokenBalances: ot($(K(Lr))),
  postTokenBalances: ot($(K(Lr))),
  loadedAddresses: ot(Lu),
  computeUnitsConsumed: ot(C())
}), Fn = je([Pt(0), Pt("legacy")]), jn = Y({
  pubkey: G(),
  lamports: C(),
  postBalance: $(C()),
  rewardType: $(G()),
  commission: ot($(C()))
}), Zl = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  transactions: K(Y({
    transaction: es,
    meta: $(kr),
    version: ot(Fn)
  })),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), Gl = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), Ql = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  transactions: K(Y({
    transaction: du,
    meta: $(kr),
    version: ot(Fn)
  })),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), ql = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  transactions: K(Y({
    transaction: Mu,
    meta: $(ns),
    version: ot(Fn)
  })),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), Vl = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  transactions: K(Y({
    transaction: du,
    meta: $(ns),
    version: ot(Fn)
  })),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), $l = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  rewards: ot(K(jn)),
  blockTime: $(C()),
  blockHeight: $(C())
}))), Kl = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  transactions: K(Y({
    transaction: es,
    meta: $(kr)
  })),
  rewards: ot(K(jn)),
  blockTime: $(C())
}))), Rs = yt($(Y({
  blockhash: G(),
  previousBlockhash: G(),
  parentSlot: C(),
  signatures: K(G()),
  blockTime: $(C())
}))), hi = yt($(Y({
  slot: C(),
  meta: $(kr),
  blockTime: ot($(C())),
  transaction: es,
  version: ot(Fn)
}))), ar = yt($(Y({
  slot: C(),
  transaction: Mu,
  meta: $(ns),
  blockTime: ot($(C())),
  version: ot(Fn)
}))), Jl = Ht(Y({
  blockhash: G(),
  feeCalculator: Y({
    lamportsPerSignature: C()
  })
})), Xl = Ht(Y({
  blockhash: G(),
  lastValidBlockHeight: C()
})), th = Ht(He()), eh = Y({
  slot: C(),
  numTransactions: C(),
  numSlots: C(),
  samplePeriodSecs: C()
}), nh = yt(K(eh)), rh = Ht($(Y({
  feeCalculator: Y({
    lamportsPerSignature: C()
  })
}))), ih = yt(G()), sh = yt(G()), oh = Y({
  err: xn,
  logs: K(G()),
  signature: G()
}), uh = Y({
  result: Br(oh),
  subscription: C()
}), ah = {
  "solana-client": "js/0.0.0-development"
};
class Ah {
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(t, e) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = (() => {
      const L = {};
      return async (I) => {
        const {
          commitment: b,
          config: O
        } = Ot(I), v = this._buildArgs([], b, void 0, O), B = Bs(v);
        return L[B] = L[B] ?? (async () => {
          try {
            const E = await this._rpcRequest("getBlockHeight", v), N = Q(E, yt(C()));
            if ("error" in N)
              throw new et(N.error, "failed to get block height information");
            return N.result;
          } finally {
            delete L[B];
          }
        })(), await L[B];
      };
    })();
    let n, s, i, o, a, d;
    e && typeof e == "string" ? this._commitment = e : e && (this._commitment = e.commitment, this._confirmTransactionInitialTimeout = e.confirmTransactionInitialTimeout, n = e.wsEndpoint, s = e.httpHeaders, i = e.fetch, o = e.fetchMiddleware, a = e.disableRetryOnRateLimit, d = e.httpAgent), this._rpcEndpoint = q0(t), this._rpcWsEndpoint = n || G0(t), this._rpcClient = ul(t, s, i, o, a, d), this._rpcRequest = al(this._rpcClient), this._rpcBatchRequest = cl(this._rpcClient), this._rpcWebSocket = new Y0(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgs([t.toBase58()], n, void 0, s), o = await this._rpcRequest("getBalance", i), a = Q(o, Ht(C()));
    if ("error" in a)
      throw new et(a.error, `failed to get balance for ${t.toBase58()}`);
    return a.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(t, e) {
    return await this.getBalanceAndContext(t, e).then((n) => n.value).catch((n) => {
      throw new Error("failed to get balance of account " + t.toBase58() + ": " + n);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(t) {
    const e = await this._rpcRequest("getBlockTime", [t]), n = Q(e, yt($(C())));
    if ("error" in n)
      throw new et(n.error, `failed to get block time for slot ${t}`);
    return n.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const t = await this._rpcRequest("minimumLedgerSlot", []), e = Q(t, yt(C()));
    if ("error" in e)
      throw new et(e.error, "failed to get minimum ledger slot");
    return e.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const t = await this._rpcRequest("getFirstAvailableBlock", []), e = Q(t, pl);
    if ("error" in e)
      throw new et(e.error, "failed to get first available block");
    return e.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(t) {
    let e = {};
    typeof t == "string" ? e = {
      commitment: t
    } : t ? e = {
      ...t,
      commitment: t && t.commitment || this.commitment
    } : e = {
      commitment: this.commitment
    };
    const n = await this._rpcRequest("getSupply", [e]), s = Q(n, Ml);
    if ("error" in s)
      throw new et(s.error, "failed to get supply");
    return s.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(t, e) {
    const n = this._buildArgs([t.toBase58()], e), s = await this._rpcRequest("getTokenSupply", n), i = Q(s, Ht(ji));
    if ("error" in i)
      throw new et(i.error, "failed to get token supply");
    return i.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(t, e) {
    const n = this._buildArgs([t.toBase58()], e), s = await this._rpcRequest("getTokenAccountBalance", n), i = Q(s, Ht(ji));
    if ("error" in i)
      throw new et(i.error, "failed to get token account balance");
    return i.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */
  async getTokenAccountsByOwner(t, e, n) {
    const {
      commitment: s,
      config: i
    } = Ot(n);
    let o = [t.toBase58()];
    "mint" in e ? o.push({
      mint: e.mint.toBase58()
    }) : o.push({
      programId: e.programId.toBase58()
    });
    const a = this._buildArgs(o, s, "base64", i), d = await this._rpcRequest("getTokenAccountsByOwner", a), L = Q(d, wl);
    if ("error" in L)
      throw new et(L.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return L.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(t, e, n) {
    let s = [t.toBase58()];
    "mint" in e ? s.push({
      mint: e.mint.toBase58()
    }) : s.push({
      programId: e.programId.toBase58()
    });
    const i = this._buildArgs(s, n, "jsonParsed"), o = await this._rpcRequest("getTokenAccountsByOwner", i), a = Q(o, ml);
    if ("error" in a)
      throw new et(a.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return a.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(t) {
    const e = {
      ...t,
      commitment: t && t.commitment || this.commitment
    }, n = e.filter || e.commitment ? [e] : [], s = await this._rpcRequest("getLargestAccounts", n), i = Q(s, Sl);
    if ("error" in i)
      throw new et(i.error, "failed to get largest accounts");
    return i.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(t, e) {
    const n = this._buildArgs([t.toBase58()], e), s = await this._rpcRequest("getTokenLargestAccounts", n), i = Q(s, Ll);
    if ("error" in i)
      throw new et(i.error, "failed to get token largest accounts");
    return i.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgs([t.toBase58()], n, "base64", s), o = await this._rpcRequest("getAccountInfo", i), a = Q(o, Ht($($n)));
    if ("error" in a)
      throw new et(a.error, `failed to get info about account ${t.toBase58()}`);
    return a.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgs([t.toBase58()], n, "jsonParsed", s), o = await this._rpcRequest("getAccountInfo", i), a = Q(o, Ht($(Ei)));
    if ("error" in a)
      throw new et(a.error, `failed to get info about account ${t.toBase58()}`);
    return a.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(t, e) {
    try {
      return (await this.getAccountInfoAndContext(t, e)).value;
    } catch (n) {
      throw new Error("failed to get info about account " + t.toBase58() + ": " + n);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = t.map((L) => L.toBase58()), o = this._buildArgs([i], n, "jsonParsed", s), a = await this._rpcRequest("getMultipleAccounts", o), d = Q(a, Ht(K($(Ei))));
    if ("error" in d)
      throw new et(d.error, `failed to get info for accounts ${i}`);
    return d.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = t.map((L) => L.toBase58()), o = this._buildArgs([i], n, "base64", s), a = await this._rpcRequest("getMultipleAccounts", o), d = Q(a, Ht(K($($n))));
    if ("error" in d)
      throw new et(d.error, `failed to get info for accounts ${i}`);
    return d.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(t, e) {
    return (await this.getMultipleAccountsInfoAndContext(t, e)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   */
  async getStakeActivation(t, e, n) {
    const {
      commitment: s,
      config: i
    } = Ot(e), o = this._buildArgs([t.toBase58()], s, void 0, {
      ...i,
      epoch: n ?? (i == null ? void 0 : i.epoch)
    }), a = await this._rpcRequest("getStakeActivation", o), d = Q(a, yt(bl));
    if ("error" in d)
      throw new et(d.error, `failed to get Stake Activation ${t.toBase58()}`);
    return d.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getProgramAccounts(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), {
      encoding: i,
      ...o
    } = s || {}, a = this._buildArgs([t.toBase58()], n, i || "base64", o), d = await this._rpcRequest("getProgramAccounts", a), L = K(Il), I = o.withContext === !0 ? Q(d, Ht(L)) : Q(d, yt(L));
    if ("error" in I)
      throw new et(I.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return I.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgs([t.toBase58()], n, "jsonParsed", s), o = await this._rpcRequest("getProgramAccounts", i), a = Q(o, yt(K(jl)));
    if ("error" in a)
      throw new et(a.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return a.result;
  }
  /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(t, e) {
    var i;
    let n;
    if (typeof t == "string")
      n = t;
    else {
      const o = t;
      if ((i = o.abortSignal) != null && i.aborted)
        return Promise.reject(o.abortSignal.reason);
      n = o.signature;
    }
    let s;
    try {
      s = ge.decode(n);
    } catch {
      throw new Error("signature must be base58 encoded: " + n);
    }
    return Rt(s.length === 64, "signature has invalid length"), typeof t == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: e || this.commitment,
      signature: n
    }) : "lastValidBlockHeight" in t ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: e || this.commitment,
      strategy: t
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: e || this.commitment,
      strategy: t
    });
  }
  getCancellationPromise(t) {
    return new Promise((e, n) => {
      t != null && (t.aborted ? n(t.reason) : t.addEventListener("abort", () => {
        n(t.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: t,
    signature: e
  }) {
    let n, s, i = !1;
    const o = new Promise((d, L) => {
      try {
        n = this.onSignature(e, (b, O) => {
          n = void 0;
          const v = {
            context: O,
            value: b
          };
          d({
            __type: rn.PROCESSED,
            response: v
          });
        }, t);
        const I = new Promise((b) => {
          n == null ? b() : s = this._onSubscriptionStateChange(n, (O) => {
            O === "subscribed" && b();
          });
        });
        (async () => {
          if (await I, i)
            return;
          const b = await this.getSignatureStatus(e);
          if (i || b == null)
            return;
          const {
            context: O,
            value: v
          } = b;
          if (v != null)
            if (v != null && v.err)
              L(v.err);
            else {
              switch (t) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if (v.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if (v.confirmationStatus === "processed" || v.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              i = !0, d({
                __type: rn.PROCESSED,
                response: {
                  context: O,
                  value: v
                }
              });
            }
        })();
      } catch (I) {
        L(I);
      }
    });
    return {
      abortConfirmation: () => {
        s && (s(), s = void 0), n != null && (this.removeSignatureListener(n), n = void 0);
      },
      confirmationPromise: o
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: t,
    strategy: {
      abortSignal: e,
      lastValidBlockHeight: n,
      signature: s
    }
  }) {
    let i = !1;
    const o = new Promise((b) => {
      const O = async () => {
        try {
          return await this.getBlockHeight(t);
        } catch {
          return -1;
        }
      };
      (async () => {
        let v = await O();
        if (!i) {
          for (; v <= n; )
            if (await Nn(1e3), i || (v = await O(), i))
              return;
          b({
            __type: rn.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: a,
      confirmationPromise: d
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: s
    }), L = this.getCancellationPromise(e);
    let I;
    try {
      const b = await Promise.race([L, d, o]);
      if (b.__type === rn.PROCESSED)
        I = b.response;
      else
        throw new ru(s);
    } finally {
      i = !0, a();
    }
    return I;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: t,
    strategy: {
      abortSignal: e,
      minContextSlot: n,
      nonceAccountPubkey: s,
      nonceValue: i,
      signature: o
    }
  }) {
    let a = !1;
    const d = new Promise((v) => {
      let B = i, E = null;
      const N = async () => {
        try {
          const {
            context: _,
            value: U
          } = await this.getNonceAndContext(s, {
            commitment: t,
            minContextSlot: n
          });
          return E = _.slot, U == null ? void 0 : U.nonce;
        } catch {
          return B;
        }
      };
      (async () => {
        if (B = await N(), !a)
          for (; ; ) {
            if (i !== B) {
              v({
                __type: rn.NONCE_INVALID,
                slotInWhichNonceDidAdvance: E
              });
              return;
            }
            if (await Nn(2e3), a || (B = await N(), a))
              return;
          }
      })();
    }), {
      abortConfirmation: L,
      confirmationPromise: I
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: o
    }), b = this.getCancellationPromise(e);
    let O;
    try {
      const v = await Promise.race([b, I, d]);
      if (v.__type === rn.PROCESSED)
        O = v.response;
      else {
        let B;
        for (; ; ) {
          const E = await this.getSignatureStatus(o);
          if (E == null)
            break;
          if (E.context.slot < (v.slotInWhichNonceDidAdvance ?? n)) {
            await Nn(400);
            continue;
          }
          B = E;
          break;
        }
        if (B != null && B.value) {
          const E = t || "finalized", {
            confirmationStatus: N
          } = B.value;
          switch (E) {
            case "processed":
            case "recent":
              if (N !== "processed" && N !== "confirmed" && N !== "finalized")
                throw new Wn(o);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (N !== "confirmed" && N !== "finalized")
                throw new Wn(o);
              break;
            case "finalized":
            case "max":
            case "root":
              if (N !== "finalized")
                throw new Wn(o);
              break;
            default:
          }
          O = {
            context: B.context,
            value: {
              err: B.value.err
            }
          };
        } else
          throw new Wn(o);
      }
    } finally {
      a = !0, L();
    }
    return O;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: t,
    signature: e
  }) {
    let n;
    const s = new Promise((d) => {
      let L = this._confirmTransactionInitialTimeout || 6e4;
      switch (t) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          L = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      n = setTimeout(() => d({
        __type: rn.TIMED_OUT,
        timeoutMs: L
      }), L);
    }), {
      abortConfirmation: i,
      confirmationPromise: o
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: e
    });
    let a;
    try {
      const d = await Promise.race([o, s]);
      if (d.__type === rn.PROCESSED)
        a = d.response;
      else
        throw new iu(e, d.timeoutMs / 1e3);
    } finally {
      clearTimeout(n), i();
    }
    return a;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const t = await this._rpcRequest("getClusterNodes", []), e = Q(t, yt(K(Rl)));
    if ("error" in e)
      throw new et(e.error, "failed to get cluster nodes");
    return e.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(t) {
    const e = this._buildArgs([], t), n = await this._rpcRequest("getVoteAccounts", e), s = Q(n, zl);
    if ("error" in s)
      throw new et(s.error, "failed to get vote accounts");
    return s.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, void 0, n), i = await this._rpcRequest("getSlot", s), o = Q(i, yt(C()));
    if ("error" in o)
      throw new et(o.error, "failed to get slot");
    return o.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, void 0, n), i = await this._rpcRequest("getSlotLeader", s), o = Q(i, yt(G()));
    if ("error" in o)
      throw new et(o.error, "failed to get slot leader");
    return o.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(t, e) {
    const n = [t, e], s = await this._rpcRequest("getSlotLeaders", n), i = Q(s, yt(K(ue)));
    if ("error" in i)
      throw new et(i.error, "failed to get slot leaders");
    return i.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(t, e) {
    const {
      context: n,
      value: s
    } = await this.getSignatureStatuses([t], e);
    Rt(s.length === 1);
    const i = s[0];
    return {
      context: n,
      value: i
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(t, e) {
    const n = [t];
    e && n.push(e);
    const s = await this._rpcRequest("getSignatureStatuses", n), i = Q(s, Fl);
    if ("error" in i)
      throw new et(i.error, "failed to get signature status");
    return i.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, void 0, n), i = await this._rpcRequest("getTransactionCount", s), o = Q(i, yt(C()));
    if ("error" in o)
      throw new et(o.error, "failed to get transaction count");
    return o.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(t) {
    return (await this.getSupply({
      commitment: t,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(t) {
    const e = this._buildArgs([], t), n = await this._rpcRequest("getInflationGovernor", e), s = Q(n, fl);
    if ("error" in s)
      throw new et(s.error, "failed to get inflation");
    return s.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(t, e, n) {
    const {
      commitment: s,
      config: i
    } = Ot(n), o = this._buildArgs([t.map((L) => L.toBase58())], s, void 0, {
      ...i,
      epoch: e ?? (i == null ? void 0 : i.epoch)
    }), a = await this._rpcRequest("getInflationReward", o), d = Q(a, K0);
    if ("error" in d)
      throw new et(d.error, "failed to get inflation reward");
    return d.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const t = await this._rpcRequest("getInflationRate", []), e = Q(t, ll);
    if ("error" in e)
      throw new et(e.error, "failed to get inflation rate");
    return e.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, void 0, n), i = await this._rpcRequest("getEpochInfo", s), o = Q(i, dl);
    if ("error" in o)
      throw new et(o.error, "failed to get epoch info");
    return o.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const t = await this._rpcRequest("getEpochSchedule", []), e = Q(t, gl);
    if ("error" in e)
      throw new et(e.error, "failed to get epoch schedule");
    const n = e.result;
    return new P0(n.slotsPerEpoch, n.leaderScheduleSlotOffset, n.warmup, n.firstNormalEpoch, n.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const t = await this._rpcRequest("getLeaderSchedule", []), e = Q(t, yl);
    if ("error" in e)
      throw new et(e.error, "failed to get leader schedule");
    return e.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(t, e) {
    const n = this._buildArgs([t], e), s = await this._rpcRequest("getMinimumBalanceForRentExemption", n), i = Q(s, Yl);
    return "error" in i ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : i.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(t) {
    const e = this._buildArgs([], t), n = await this._rpcRequest("getRecentBlockhash", e), s = Q(n, Jl);
    if ("error" in s)
      throw new et(s.error, "failed to get recent blockhash");
    return s.result;
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(t) {
    const e = await this._rpcRequest("getRecentPerformanceSamples", t ? [t] : []), n = Q(e, nh);
    if ("error" in n)
      throw new et(n.error, "failed to get recent performance samples");
    return n.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(t, e) {
    const n = this._buildArgs([t], e), s = await this._rpcRequest("getFeeCalculatorForBlockhash", n), i = Q(s, rh);
    if ("error" in i)
      throw new et(i.error, "failed to get fee calculator");
    const {
      context: o,
      value: a
    } = i.result;
    return {
      context: o,
      value: a !== null ? a.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(t, e) {
    const n = On(t.serialize()).toString("base64"), s = this._buildArgs([n], e), i = await this._rpcRequest("getFeeForMessage", s), o = Q(i, Ht($(C())));
    if ("error" in o)
      throw new et(o.error, "failed to get fee for message");
    if (o.result === null)
      throw new Error("invalid blockhash");
    return o.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(t) {
    var o;
    const e = (o = t == null ? void 0 : t.lockedWritableAccounts) == null ? void 0 : o.map((a) => a.toBase58()), n = e != null && e.length ? [e] : [], s = await this._rpcRequest("getRecentPrioritizationFees", n), i = Q(s, hl);
    if ("error" in i)
      throw new et(i.error, "failed to get recent prioritization fees");
    return i.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(t) {
    try {
      return (await this.getRecentBlockhashAndContext(t)).value;
    } catch (e) {
      throw new Error("failed to get recent blockhash: " + e);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(t) {
    try {
      return (await this.getLatestBlockhashAndContext(t)).value;
    } catch (e) {
      throw new Error("failed to get recent blockhash: " + e);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, void 0, n), i = await this._rpcRequest("getLatestBlockhash", s), o = Q(i, Xl);
    if ("error" in o)
      throw new et(o.error, "failed to get latest blockhash");
    return o.result;
  }
  /**
   * Returns whether a blockhash is still valid or not
   */
  async isBlockhashValid(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgs([t], n, void 0, s), o = await this._rpcRequest("isBlockhashValid", i), a = Q(o, th);
    if ("error" in a)
      throw new et(a.error, "failed to determine if the blockhash `" + t + "`is valid");
    return a.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const t = await this._rpcRequest("getVersion", []), e = Q(t, yt(sl));
    if ("error" in e)
      throw new et(e.error, "failed to get version");
    return e.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const t = await this._rpcRequest("getGenesisHash", []), e = Q(t, yt(G()));
    if ("error" in e)
      throw new et(e.error, "failed to get genesis hash");
    return e.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgsAtLeastConfirmed([t], n, void 0, s), o = await this._rpcRequest("getBlock", i);
    try {
      switch (s == null ? void 0 : s.transactionDetails) {
        case "accounts": {
          const a = Q(o, Ql);
          if ("error" in a)
            throw a.error;
          return a.result;
        }
        case "none": {
          const a = Q(o, Gl);
          if ("error" in a)
            throw a.error;
          return a.result;
        }
        default: {
          const a = Q(o, Zl);
          if ("error" in a)
            throw a.error;
          const {
            result: d
          } = a;
          return d ? {
            ...d,
            transactions: d.transactions.map(({
              transaction: L,
              meta: I,
              version: b
            }) => ({
              meta: I,
              transaction: {
                ...L,
                message: li(b, L.message)
              },
              version: b
            }))
          } : null;
        }
      }
    } catch (a) {
      throw new et(a, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgsAtLeastConfirmed([t], n, "jsonParsed", s), o = await this._rpcRequest("getBlock", i);
    try {
      switch (s == null ? void 0 : s.transactionDetails) {
        case "accounts": {
          const a = Q(o, Vl);
          if ("error" in a)
            throw a.error;
          return a.result;
        }
        case "none": {
          const a = Q(o, $l);
          if ("error" in a)
            throw a.error;
          return a.result;
        }
        default: {
          const a = Q(o, ql);
          if ("error" in a)
            throw a.error;
          return a.result;
        }
      }
    } catch (a) {
      throw new et(a, "failed to get block");
    }
  }
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(t) {
    let e, n;
    if (typeof t == "string")
      n = t;
    else if (t) {
      const {
        commitment: a,
        ...d
      } = t;
      n = a, e = d;
    }
    const s = this._buildArgs([], n, "base64", e), i = await this._rpcRequest("getBlockProduction", s), o = Q(i, ol);
    if ("error" in o)
      throw new et(o.error, "failed to get block production information");
    return o.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgsAtLeastConfirmed([t], n, void 0, s), o = await this._rpcRequest("getTransaction", i), a = Q(o, hi);
    if ("error" in a)
      throw new et(a.error, "failed to get transaction");
    const d = a.result;
    return d && {
      ...d,
      transaction: {
        ...d.transaction,
        message: li(d.version, d.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = this._buildArgsAtLeastConfirmed([t], n, "jsonParsed", s), o = await this._rpcRequest("getTransaction", i), a = Q(o, ar);
    if ("error" in a)
      throw new et(a.error, "failed to get transaction");
    return a.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = t.map((d) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([d], n, "jsonParsed", s)
    }));
    return (await this._rpcBatchRequest(i)).map((d) => {
      const L = Q(d, ar);
      if ("error" in L)
        throw new et(L.error, "failed to get transactions");
      return L.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(t, e) {
    const {
      commitment: n,
      config: s
    } = Ot(e), i = t.map((d) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([d], n, void 0, s)
    }));
    return (await this._rpcBatchRequest(i)).map((d) => {
      const L = Q(d, hi);
      if ("error" in L)
        throw new et(L.error, "failed to get transactions");
      const I = L.result;
      return I && {
        ...I,
        transaction: {
          ...I.transaction,
          message: li(I.version, I.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(t, e) {
    const n = this._buildArgsAtLeastConfirmed([t], e), s = await this._rpcRequest("getConfirmedBlock", n), i = Q(s, Kl);
    if ("error" in i)
      throw new et(i.error, "failed to get confirmed block");
    const o = i.result;
    if (!o)
      throw new Error("Confirmed block " + t + " not found");
    const a = {
      ...o,
      transactions: o.transactions.map(({
        transaction: d,
        meta: L
      }) => {
        const I = new Je(d.message);
        return {
          meta: L,
          transaction: {
            ...d,
            message: I
          }
        };
      })
    };
    return {
      ...a,
      transactions: a.transactions.map(({
        transaction: d,
        meta: L
      }) => ({
        meta: L,
        transaction: sn.populate(d.message, d.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(t, e, n) {
    const s = this._buildArgsAtLeastConfirmed(e !== void 0 ? [t, e] : [t], n), i = await this._rpcRequest("getBlocks", s), o = Q(i, yt(K(C())));
    if ("error" in o)
      throw new et(o.error, "failed to get blocks");
    return o.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(t, e) {
    const n = this._buildArgsAtLeastConfirmed([t], e, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), s = await this._rpcRequest("getBlock", n), i = Q(s, Rs);
    if ("error" in i)
      throw new et(i.error, "failed to get block");
    const o = i.result;
    if (!o)
      throw new Error("Block " + t + " not found");
    return o;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(t, e) {
    const n = this._buildArgsAtLeastConfirmed([t], e, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), s = await this._rpcRequest("getConfirmedBlock", n), i = Q(s, Rs);
    if ("error" in i)
      throw new et(i.error, "failed to get confirmed block");
    const o = i.result;
    if (!o)
      throw new Error("Confirmed block " + t + " not found");
    return o;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(t, e) {
    const n = this._buildArgsAtLeastConfirmed([t], e), s = await this._rpcRequest("getConfirmedTransaction", n), i = Q(s, hi);
    if ("error" in i)
      throw new et(i.error, "failed to get transaction");
    const o = i.result;
    if (!o)
      return o;
    const a = new Je(o.transaction.message), d = o.transaction.signatures;
    return {
      ...o,
      transaction: sn.populate(a, d)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(t, e) {
    const n = this._buildArgsAtLeastConfirmed([t], e, "jsonParsed"), s = await this._rpcRequest("getConfirmedTransaction", n), i = Q(s, ar);
    if ("error" in i)
      throw new et(i.error, "failed to get confirmed transaction");
    return i.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(t, e) {
    const n = t.map((o) => ({
      methodName: "getConfirmedTransaction",
      args: this._buildArgsAtLeastConfirmed([o], e, "jsonParsed")
    }));
    return (await this._rpcBatchRequest(n)).map((o) => {
      const a = Q(o, ar);
      if ("error" in a)
        throw new et(a.error, "failed to get confirmed transactions");
      return a.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(t, e, n) {
    let s = {}, i = await this.getFirstAvailableBlock();
    for (; !("until" in s) && (e--, !(e <= 0 || e < i)); )
      try {
        const d = await this.getConfirmedBlockSignatures(e, "finalized");
        d.signatures.length > 0 && (s.until = d.signatures[d.signatures.length - 1].toString());
      } catch (d) {
        if (d instanceof Error && d.message.includes("skipped"))
          continue;
        throw d;
      }
    let o = await this.getSlot("finalized");
    for (; !("before" in s) && (n++, !(n > o)); )
      try {
        const d = await this.getConfirmedBlockSignatures(n);
        d.signatures.length > 0 && (s.before = d.signatures[d.signatures.length - 1].toString());
      } catch (d) {
        if (d instanceof Error && d.message.includes("skipped"))
          continue;
        throw d;
      }
    return (await this.getConfirmedSignaturesForAddress2(t, s)).map((d) => d.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getConfirmedSignaturesForAddress2(t, e, n) {
    const s = this._buildArgsAtLeastConfirmed([t.toBase58()], n, void 0, e), i = await this._rpcRequest("getConfirmedSignaturesForAddress2", s), o = Q(i, El);
    if ("error" in o)
      throw new et(o.error, "failed to get confirmed signatures for address");
    return o.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(t, e, n) {
    const s = this._buildArgsAtLeastConfirmed([t.toBase58()], n, void 0, e), i = await this._rpcRequest("getSignaturesForAddress", s), o = Q(i, Al);
    if ("error" in o)
      throw new et(o.error, "failed to get signatures for address");
    return o.result;
  }
  async getAddressLookupTable(t, e) {
    const {
      context: n,
      value: s
    } = await this.getAccountInfoAndContext(t, e);
    let i = null;
    return s !== null && (i = new Ds({
      key: t,
      state: Ds.deserialize(s.data)
    })), {
      context: n,
      value: i
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(t, e) {
    const {
      context: n,
      value: s
    } = await this.getAccountInfoAndContext(t, e);
    let i = null;
    return s !== null && (i = Xi.fromAccountData(s.data)), {
      context: n,
      value: i
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(t, e) {
    return await this.getNonceAndContext(t, e).then((n) => n.value).catch((n) => {
      throw new Error("failed to get nonce for account " + t.toBase58() + ": " + n);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(t, e) {
    const n = await this._rpcRequest("requestAirdrop", [t.toBase58(), e]), s = Q(n, ih);
    if ("error" in s)
      throw new et(s.error, `airdrop to ${t.toBase58()} failed`);
    return s.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(t) {
    if (!t) {
      for (; this._pollingBlockhash; )
        await Nn(100);
      const n = Date.now() - this._blockhashInfo.lastFetch >= Q0;
      if (this._blockhashInfo.latestBlockhash !== null && !n)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const t = Date.now(), e = this._blockhashInfo.latestBlockhash, n = e ? e.blockhash : null;
      for (let s = 0; s < 50; s++) {
        const i = await this.getLatestBlockhash("finalized");
        if (n !== i.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: i,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, i;
        await Nn(B0 / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - t}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(t) {
    const {
      commitment: e,
      config: n
    } = Ot(t), s = this._buildArgs([], e, "base64", n), i = await this._rpcRequest("getStakeMinimumDelegation", s), o = Q(i, Ht(C()));
    if ("error" in o)
      throw new et(o.error, "failed to get stake minimum delegation");
    return o.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(t, e, n) {
    if ("message" in t) {
      const E = t.serialize(), N = lt.Buffer.from(E).toString("base64");
      if (Array.isArray(e) || n !== void 0)
        throw new Error("Invalid arguments");
      const _ = e || {};
      _.encoding = "base64", "commitment" in _ || (_.commitment = this.commitment);
      const U = [N, _], z = await this._rpcRequest("simulateTransaction", U), q = Q(z, _s);
      if ("error" in q)
        throw new Error("failed to simulate transaction: " + q.error.message);
      return q.result;
    }
    let s;
    if (t instanceof sn) {
      let B = t;
      s = new sn(), s.feePayer = B.feePayer, s.instructions = t.instructions, s.nonceInfo = B.nonceInfo, s.signatures = B.signatures;
    } else
      s = sn.populate(t), s._message = s._json = void 0;
    if (e !== void 0 && !Array.isArray(e))
      throw new Error("Invalid arguments");
    const i = e;
    if (s.nonceInfo && i)
      s.sign(...i);
    else {
      let B = this._disableBlockhashCaching;
      for (; ; ) {
        const E = await this._blockhashWithExpiryBlockHeight(B);
        if (s.lastValidBlockHeight = E.lastValidBlockHeight, s.recentBlockhash = E.blockhash, !i)
          break;
        if (s.sign(...i), !s.signature)
          throw new Error("!signature");
        const N = s.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(N) && !this._blockhashInfo.transactionSignatures.includes(N)) {
          this._blockhashInfo.simulatedSignatures.push(N);
          break;
        } else
          B = !0;
      }
    }
    const o = s._compile(), a = o.serialize(), L = s._serialize(a).toString("base64"), I = {
      encoding: "base64",
      commitment: this.commitment
    };
    if (n) {
      const B = (Array.isArray(n) ? n : o.nonProgramIds()).map((E) => E.toBase58());
      I.accounts = {
        encoding: "base64",
        addresses: B
      };
    }
    i && (I.sigVerify = !0);
    const b = [L, I], O = await this._rpcRequest("simulateTransaction", b), v = Q(O, _s);
    if ("error" in v) {
      let B;
      if ("data" in v.error && (B = v.error.data.logs, B && Array.isArray(B))) {
        const E = `
    `, N = E + B.join(E);
        console.error(v.error.message, N);
      }
      throw new ks("failed to simulate transaction: " + v.error.message, B);
    }
    return v.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Send a signed transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(t, e, n) {
    if ("version" in t) {
      if (e && Array.isArray(e))
        throw new Error("Invalid arguments");
      const o = t.serialize();
      return await this.sendRawTransaction(o, e);
    }
    if (e === void 0 || !Array.isArray(e))
      throw new Error("Invalid arguments");
    const s = e;
    if (t.nonceInfo)
      t.sign(...s);
    else {
      let o = this._disableBlockhashCaching;
      for (; ; ) {
        const a = await this._blockhashWithExpiryBlockHeight(o);
        if (t.lastValidBlockHeight = a.lastValidBlockHeight, t.recentBlockhash = a.blockhash, t.sign(...s), !t.signature)
          throw new Error("!signature");
        const d = t.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(d))
          o = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(d);
          break;
        }
      }
    }
    const i = t.serialize();
    return await this.sendRawTransaction(i, n);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(t, e) {
    const n = On(t).toString("base64");
    return await this.sendEncodedTransaction(n, e);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(t, e) {
    const n = {
      encoding: "base64"
    }, s = e && e.skipPreflight, i = s === !0 ? "processed" : e && e.preflightCommitment || this.commitment;
    e && e.maxRetries != null && (n.maxRetries = e.maxRetries), e && e.minContextSlot != null && (n.minContextSlot = e.minContextSlot), s && (n.skipPreflight = s), i && (n.preflightCommitment = i);
    const o = [t, n], a = await this._rpcRequest("sendTransaction", o), d = Q(a, sh);
    if ("error" in d) {
      let L;
      throw "data" in d.error && (L = d.error.data.logs), new ks("failed to send transaction: " + d.error.message, L);
    }
    return d.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(t) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", t.message);
  }
  /**
   * @internal
   */
  _wsOnClose(t) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), t === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([e, n]) => {
      this._setSubscription(e, {
        ...n,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(t, e) {
    var s;
    const n = (s = this._subscriptionsByHash[t]) == null ? void 0 : s.state;
    if (this._subscriptionsByHash[t] = e, n !== e.state) {
      const i = this._subscriptionStateChangeCallbacksByHash[t];
      i && i.forEach((o) => {
        try {
          o(e.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(t, e) {
    var i;
    const n = this._subscriptionHashByClientSubscriptionId[t];
    if (n == null)
      return () => {
      };
    const s = (i = this._subscriptionStateChangeCallbacksByHash)[n] || (i[n] = /* @__PURE__ */ new Set());
    return s.add(e), () => {
      s.delete(e), s.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[n];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch (n) {
          n instanceof Error && console.log(`Error when closing socket connection: ${n.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const t = this._rpcWebSocketGeneration, e = () => t === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async (n) => {
        const s = this._subscriptionsByHash[n];
        if (s !== void 0)
          switch (s.state) {
            case "pending":
            case "unsubscribed":
              if (s.callbacks.size === 0) {
                delete this._subscriptionsByHash[n], s.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[s.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: i,
                  method: o
                } = s;
                try {
                  this._setSubscription(n, {
                    ...s,
                    state: "subscribing"
                  });
                  const a = await this._rpcWebSocket.call(o, i);
                  this._setSubscription(n, {
                    ...s,
                    serverSubscriptionId: a,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[a] = s.callbacks, await this._updateSubscriptions();
                } catch (a) {
                  if (a instanceof Error && console.error(`${o} error for argument`, i, a.message), !e())
                    return;
                  this._setSubscription(n, {
                    ...s,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              s.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: i,
                  unsubscribeMethod: o
                } = s;
                if (this._subscriptionsAutoDisposedByRpc.has(i))
                  this._subscriptionsAutoDisposedByRpc.delete(i);
                else {
                  this._setSubscription(n, {
                    ...s,
                    state: "unsubscribing"
                  }), this._setSubscription(n, {
                    ...s,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(o, [i]);
                  } catch (a) {
                    if (a instanceof Error && console.error(`${o} error:`, a.message), !e())
                      return;
                    this._setSubscription(n, {
                      ...s,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription(n, {
                  ...s,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(t, e) {
    const n = this._subscriptionCallbacksByServerSubscriptionId[t];
    n !== void 0 && n.forEach((s) => {
      try {
        s(
          ...e
        );
      } catch (i) {
        console.error(i);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, Nl);
    this._handleServerNotification(n, [e.value, e.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(t, e) {
    const n = this._nextClientSubscriptionId++, s = Bs([t.method, e]), i = this._subscriptionsByHash[s];
    return i === void 0 ? this._subscriptionsByHash[s] = {
      ...t,
      args: e,
      callbacks: /* @__PURE__ */ new Set([t.callback]),
      state: "pending"
    } : i.callbacks.add(t.callback), this._subscriptionHashByClientSubscriptionId[n] = s, this._subscriptionDisposeFunctionsByClientSubscriptionId[n] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[n], delete this._subscriptionHashByClientSubscriptionId[n];
      const o = this._subscriptionsByHash[s];
      Rt(o !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${n}`), o.callbacks.delete(t.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), n;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */
  onAccountChange(t, e, n) {
    const s = this._buildArgs(
      [t.toBase58()],
      n || this._commitment || "finalized",
      // Apply connection/server default.
      "base64"
    );
    return this._makeSubscription({
      callback: e,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, s);
  }
  /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, Tl);
    this._handleServerNotification(n, [{
      accountId: e.value.pubkey,
      accountInfo: e.value.account
    }, e.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */
  onProgramAccountChange(t, e, n, s) {
    const i = this._buildArgs(
      [t.toBase58()],
      n || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      s ? {
        filters: s
      } : void 0
      /* extra */
    );
    return this._makeSubscription({
      callback: e,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, i);
  }
  /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeProgramAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(t, e, n) {
    const s = this._buildArgs(
      [typeof t == "object" ? {
        mentions: [t.toString()]
      } : t],
      n || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: e,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, s);
  }
  /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */
  async removeOnLogsListener(t) {
    await this._unsubscribeClientSubscription(t, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, uh);
    this._handleServerNotification(n, [e.value, e.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, kl);
    this._handleServerNotification(n, [e]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSlotChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, Dl);
    this._handleServerNotification(n, [e]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSlotUpdateListener(t) {
    await this._unsubscribeClientSubscription(t, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(t, e) {
    const n = this._subscriptionDisposeFunctionsByClientSubscriptionId[t];
    n ? await n() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${t}\` for '${e}' events could not be found.`);
  }
  _buildArgs(t, e, n, s) {
    const i = e || this._commitment;
    if (i || n || s) {
      let o = {};
      n && (o.encoding = n), i && (o.commitment = i), s && (o = Object.assign(o, s)), t.push(o);
    }
    return t;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(t, e, n, s) {
    const i = e || this._commitment;
    if (i && !["confirmed", "finalized"].includes(i))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(t, e, n, s);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, _l);
    e.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add(n), this._handleServerNotification(n, e.value === "receivedSignature" ? [{
      type: "received"
    }, e.context] : [{
      type: "status",
      result: e.value
    }, e.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(t, e, n) {
    const s = this._buildArgs(
      [t],
      n || this._commitment || "finalized"
      // Apply connection/server default.
    ), i = this._makeSubscription({
      callback: (o, a) => {
        if (o.type === "status") {
          e(o.result, a);
          try {
            this.removeSignatureListener(i);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, s);
    return i;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(t, e, n) {
    const {
      commitment: s,
      ...i
    } = {
      ...n,
      commitment: n && n.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, o = this._buildArgs([t], s, void 0, i), a = this._makeSubscription({
      callback: (d, L) => {
        e(d, L);
        try {
          this.removeSignatureListener(a);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, o);
    return a;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeSignatureListener(t) {
    await this._unsubscribeClientSubscription(t, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(t) {
    const {
      result: e,
      subscription: n
    } = Q(t, Ol);
    this._handleServerNotification(n, [e]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */
  async removeRootChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "root change");
  }
}
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: tt([rt("instruction"), Rn("recentSlot"), It("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: tt([rt("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: tt([rt("instruction"), Rn(), me(wt(), Mn(rt(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: tt([rt("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: tt([rt("instruction")])
  }
});
new ut("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: tt([It("instruction"), rt("units"), rt("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: tt([It("instruction"), rt("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: tt([It("instruction"), rt("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: tt([It("instruction"), Rn("microLamports")])
  }
});
new ut("ComputeBudget111111111111111111111111111111");
tt([It("numSignatures"), It("padding"), De("signatureOffset"), De("signatureInstructionIndex"), De("publicKeyOffset"), De("publicKeyInstructionIndex"), De("messageDataOffset"), De("messageDataSize"), De("messageInstructionIndex")]);
new ut("Ed25519SigVerify111111111111111111111111111");
Ki.utils.isValidPrivateKey;
Ki.getPublicKey;
tt([It("numSignatures"), De("signatureOffset"), It("signatureInstructionIndex"), De("ethAddressOffset"), It("ethAddressInstructionIndex"), De("messageDataOffset"), De("messageDataSize"), It("messageInstructionIndex"), Dt(20, "ethAddress"), Dt(64, "signature"), It("recoveryId")]);
new ut("KeccakSecp256k11111111111111111111111111111");
var wu;
new ut("StakeConfig11111111111111111111111111111111");
class mu {
  /**
   * Create a new Lockup object
   */
  constructor(t, e, n) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = t, this.epoch = e, this.custodian = n;
  }
  /**
   * Default, inactive Lockup value
   */
}
wu = mu;
mu.default = new wu(0, 0, ut.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: tt([rt("instruction"), x0(), j0()])
  },
  Authorize: {
    index: 1,
    layout: tt([rt("instruction"), wt("newAuthorized"), rt("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: tt([rt("instruction")])
  },
  Split: {
    index: 3,
    layout: tt([rt("instruction"), Ae("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: tt([rt("instruction"), Ae("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: tt([rt("instruction")])
  },
  Merge: {
    index: 7,
    layout: tt([rt("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: tt([rt("instruction"), wt("newAuthorized"), rt("stakeAuthorizationType"), vn("authoritySeed"), wt("authorityOwner")])
  }
});
new ut("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: tt([rt("instruction"), b0()])
  },
  Authorize: {
    index: 1,
    layout: tt([rt("instruction"), wt("newAuthorized"), rt("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: tt([rt("instruction"), Ae("lamports")])
  },
  UpdateValidatorIdentity: {
    index: 4,
    layout: tt([rt("instruction")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: tt([rt("instruction"), E0()])
  }
});
new ut("Vote111111111111111111111111111111111111111");
new ut("Va1idator1nfo111111111111111111111111111111");
Y({
  name: G(),
  website: ot(G()),
  details: ot(G()),
  keybaseUsername: ot(G())
});
new ut("Vote111111111111111111111111111111111111111");
tt([
  wt("nodePubkey"),
  wt("authorizedWithdrawer"),
  It("commission"),
  he(),
  // votes.length
  me(tt([he("slot"), rt("confirmationCount")]), Mn(rt(), -8), "votes"),
  It("rootSlotValid"),
  he("rootSlot"),
  he(),
  // authorizedVoters.length
  me(tt([he("epoch"), wt("authorizedVoter")]), Mn(rt(), -8), "authorizedVoters"),
  tt([me(tt([wt("authorizedPubkey"), he("epochOfLastAuthorizedSwitch"), he("targetEpoch")]), 32, "buf"), he("idx"), It("isEmpty")], "priorVoters"),
  he(),
  // epochCredits.length
  me(tt([he("epoch"), he("credits"), he("prevCredits")]), Mn(rt(), -8), "epochCredits"),
  tt([he("slot"), he("timestamp")], "lastTimestamp")
]);
async function Nh(r, t, e, n) {
  let s, i;
  e && Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight") || e && Object.prototype.hasOwnProperty.call(e, "nonceValue") ? (s = e, i = n) : i = e;
  const o = i && {
    skipPreflight: i.skipPreflight,
    preflightCommitment: i.preflightCommitment || i.commitment,
    minContextSlot: i.minContextSlot
  }, a = await r.sendRawTransaction(t, o), d = i && i.commitment, I = (await (s ? r.confirmTransaction(s, d) : r.confirmTransaction(a, d))).value;
  if (I.err)
    throw new Error(`Raw transaction ${a} failed (${JSON.stringify(I)})`);
  return a;
}
function ch(r) {
  let t = "0x";
  for (const e of r) {
    const n = e.toString(16);
    t += n.length === 1 ? `0${n}` : n;
  }
  return t;
}
const fh = /^0x[0-9a-f]{40}$/i, vh = "0x70a08231000000000000000000000000", Th = 4902;
function Bh(r, t) {
  switch (r) {
    case Ee.ARBITUM_ONE:
    case Ee.AURORA:
    case Ee.AVALANCHE:
    case Ee.BNB_SMART:
    case Ee.ETHEREUM:
    case Ee.FANTOM:
    case Ee.HARMONY:
    case Ee.OPTIMISM:
    case Ee.PALM:
    case Ee.POLYGON:
    case Ee.APECHAIN:
      return lh(t);
    case Ee.SOLANA:
      return hh(t);
    default:
      return !1;
  }
}
function lh(r) {
  if (!fh.test(r))
    return !1;
  if (r.toLowerCase() === r || r.toUpperCase() === r)
    return !0;
  const t = r.slice(2), e = Ws(t.toLowerCase()), n = ch(La(e)).slice(2);
  for (let s = 0; s < 40; s += 1)
    if (parseInt(n[s], 16) > 7 && t[s].toUpperCase() !== t[s] || parseInt(n[s], 16) <= 7 && t[s].toLowerCase() !== t[s])
      return !1;
  return !0;
}
function hh(r) {
  try {
    return ut.isOnCurve(r);
  } catch {
    return !1;
  }
}
function kh(r) {
  return r;
}
class dh {
  get target() {
    return globalThis || window;
  }
  get userAgent() {
    var t, e;
    return ((t = this.target.navigator) == null ? void 0 : t.userAgent) || ((e = this.target.navigator) == null ? void 0 : e.vendor) || this.target.opera || "";
  }
  get android() {
    return /android/i.test(this.userAgent);
  }
  get ios13() {
    return this.userAgent.includes("Mac") && "ontouchend" in document;
  }
  get ios() {
    return /iPad|iPhone|iPod/i.test(this.userAgent) && !window.MSStream || this.ios13;
  }
  get huawei() {
    return /HUAWEI/i.test(this.userAgent);
  }
  get windowsPhone() {
    return /windows phone/i.test(this.userAgent);
  }
  get mobile() {
    var t;
    return ((t = window.navigator.userAgentData) == null ? void 0 : t.mobile) || this.android || this.ios || this.huawei || this.windowsPhone;
  }
}
const Ch = new dh();
class gh {
  constructor() {
    ae(this, "target", globalThis || window);
  }
  get isInIframe() {
    return this.target.self !== this.target.top;
  }
  get isInTab() {
    var t;
    return !!this.target.opener && ((t = this.target.toolbar) == null ? void 0 : t.visible);
  }
  get isInPopup() {
    var t;
    return !!this.target.opener && !((t = this.target.toolbar) != null && t.visible);
  }
  get isMainWindow() {
    return !this.isInIframe && !this.isInTab && !this.isInPopup;
  }
}
const Dh = new gh(), yh = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiB0ZXh0LXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiBpbWFnZS1yZW5kZXJpbmc9Im9wdGltaXplUXVhbGl0eSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHZpZXdCb3g9IjAgMCA3ODQuMzcgMTI3Ny4zOSI+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBmaWxsPSIjMzQzNDM0IiBkPSJNMzkyLjA3IDBsLTguNTcgMjkuMTF2ODQ0LjYzbDguNTcgOC41NSAzOTIuMDYtMjMxLjc1eiIvPjxwYXRoIGZpbGw9IiM4QzhDOEMiIGQ9Ik0zOTIuMDcgMEwwIDY1MC41NGwzOTIuMDcgMjMxLjc1VjQ3Mi4zM3oiLz48cGF0aCBmaWxsPSIjM0MzQzNCIiBkPSJNMzkyLjA3IDk1Ni41MmwtNC44MyA1Ljg5djMwMC44N2w0LjgzIDE0LjEgMzkyLjMtNTUyLjQ5eiIvPjxwYXRoIGZpbGw9IiM4QzhDOEMiIGQ9Ik0zOTIuMDcgMTI3Ny4zOFY5NTYuNTJMMCA3MjQuODl6Ii8+PHBhdGggZmlsbD0iIzE0MTQxNCIgZD0iTTM5Mi4wNyA4ODIuMjlsMzkyLjA2LTIzMS43NS0zOTIuMDYtMTc4LjIxeiIvPjxwYXRoIGZpbGw9IiMzOTM5MzkiIGQ9Ik0wIDY1MC41NGwzOTIuMDcgMjMxLjc1VjQ3Mi4zM3oiLz48L2c+PC9zdmc+", ph = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjODI0N0U1IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOC40IDMzLjUiPjxwYXRoIGQ9Ik0yOSAxMC4yYy0uNy0uNC0xLjYtLjQtMi40IDBMMjEgMTMuNWwtMy44IDIuMS01LjUgMy4zYy0uNy40LTEuNi40LTIuNCAwTDUgMTYuM2MtLjctLjQtMS4yLTEuMi0xLjItMi4xdi01YzAtLjguNC0xLjYgMS4yLTIuMWw0LjMtMi41Yy43LS40IDEuNi0uNCAyLjQgMEwxNiA3LjJjLjcuNCAxLjIgMS4yIDEuMiAyLjF2My4zbDMuOC0yLjJWN2MwLS44LS40LTEuNi0xLjItMi4xbC04LTQuN2MtLjctLjQtMS42LS40LTIuNCAwTDEuMiA1Qy40IDUuNCAwIDYuMiAwIDd2OS40YzAgLjguNCAxLjYgMS4yIDIuMWw4LjEgNC43Yy43LjQgMS42LjQgMi40IDBsNS41LTMuMiAzLjgtMi4yIDUuNS0zLjJjLjctLjQgMS42LS40IDIuNCAwbDQuMyAyLjVjLjcuNCAxLjIgMS4yIDEuMiAyLjF2NWMwIC44LS40IDEuNi0xLjIgMi4xTDI5IDI4LjhjLS43LjQtMS42LjQtMi40IDBsLTQuMy0yLjVjLS43LS40LTEuMi0xLjItMS4yLTIuMVYyMWwtMy44IDIuMnYzLjNjMCAuOC40IDEuNiAxLjIgMi4xbDguMSA0LjdjLjcuNCAxLjYuNCAyLjQgMGw4LjEtNC43Yy43LS40IDEuMi0xLjIgMS4yLTIuMVYxN2MwLS44LS40LTEuNi0xLjItMi4xTDI5IDEwLjJ6Ii8+PC9zdmc+", Mh = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOTcuNyAzMTEuNyI+PGxpbmVhckdyYWRpZW50IGlkPSJwcmVmaXhfX2EiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMzYwLjg3OSIgeTE9IjM1MS40NTUiIHgyPSIxNDEuMjEzIiB5Mj0iLTY5LjI5NCIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDMxNCkiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzAwZmZhMyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2RjMWZmZiIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZD0iTTY0LjYgMjM3LjljMi40LTIuNCA1LjctMy44IDkuMi0zLjhoMzE3LjRjNS44IDAgOC43IDcgNC42IDExLjFsLTYyLjcgNjIuN2MtMi40IDIuNC01LjcgMy44LTkuMiAzLjhINi41Yy01LjggMC04LjctNy00LjYtMTEuMWw2Mi43LTYyLjd6IiBmaWxsPSJ1cmwoI3ByZWZpeF9fYSkiLz48bGluZWFyR3JhZGllbnQgaWQ9InByZWZpeF9fYiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyNjQuODI5IiB5MT0iNDAxLjYwMSIgeDI9IjQ1LjE2MyIgeTI9Ii0xOS4xNDgiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCAzMTQpIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGZmYTMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNkYzFmZmYiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik02NC42IDMuOEM2Ny4xIDEuNCA3MC40IDAgNzMuOCAwaDMxNy40YzUuOCAwIDguNyA3IDQuNiAxMS4xbC02Mi43IDYyLjdjLTIuNCAyLjQtNS43IDMuOC05LjIgMy44SDYuNWMtNS44IDAtOC43LTctNC42LTExLjFMNjQuNiAzLjh6IiBmaWxsPSJ1cmwoI3ByZWZpeF9fYikiLz48bGluZWFyR3JhZGllbnQgaWQ9InByZWZpeF9fYyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIzMTIuNTQ4IiB5MT0iMzc2LjY4OCIgeDI9IjkyLjg4MiIgeTI9Ii00NC4wNjEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCAzMTQpIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGZmYTMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNkYzFmZmYiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik0zMzMuMSAxMjAuMWMtMi40LTIuNC01LjctMy44LTkuMi0zLjhINi41Yy01LjggMC04LjcgNy00LjYgMTEuMWw2Mi43IDYyLjdjMi40IDIuNCA1LjcgMy44IDkuMiAzLjhoMzE3LjRjNS44IDAgOC43LTcgNC42LTExLjFsLTYyLjctNjIuN3oiIGZpbGw9InVybCgjcHJlZml4X19jKSIvPjwvc3ZnPg==", Lh = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJwcmVmaXhfX0xheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCAxODUuNiAxODUuNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlPi5wcmVmaXhfX3N0MXtmaWxsOiNmZmZ9PC9zdHlsZT48ZyBpZD0icHJlZml4X19MYXllcl8zIj48cmFkaWFsR3JhZGllbnQgaWQ9InByZWZpeF9fU1ZHSURfMV8iIGN4PSItMTA5LjcwNyIgY3k9Ii0xLjExMyIgcj0iMSIgZ3JhZGllbnRUcmFuc2Zvcm09InJvdGF0ZSg5MCAtNTc4MC40OTIgNTc1Ny4yNzEpIHNjYWxlKDEwNC4yMzUpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIuMTY3IiBzdG9wLWNvbG9yPSIjMDczMTgzIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDA1NGY5Ii8+PC9yYWRpYWxHcmFkaWVudD48cGF0aCBkPSJNMTg1LjYgOTIuOEMxODUuNiA0MS41IDE0NCAwIDkyLjggMCA0MS41IDAgMCA0MS41IDAgOTIuOGMwIDUxLjIgNDEuNSA5Mi44IDkyLjggOTIuOCA1MS4yIDAgOTIuOC00MS42IDkyLjgtOTIuOHoiIGZpbGw9InVybCgjcHJlZml4X19TVkdJRF8xXykiLz48L2c+PGcgaWQ9InByZWZpeF9fTGF5ZXJfMV8wMDAwMDAxOTY3ODIxNjE5NzU2ODI5MjcwMDAwMDAwOTQ4NDIzMTg1MDI5ODI3MTkxNl8iPjxwYXRoIGNsYXNzPSJwcmVmaXhfX3N0MSIgZD0iTTE1NS45IDYzLjhjLS40IDIuMy0uOCAzLjQtMS40IDQuNi0uNiAxLjQtMS4yIDIuOS0xLjggNi4xLS4yIDEuMi0uNCAyLjItLjUgM3YuMWMtLjIgMS4zLS4zIDIuMi0uOCAzLjctLjQgMS4zLTEuMSAzLjQtMi44IDUuNi0xLjQgMS44LTMuNyA0LjktNi44IDUuMy0uMyAwLS44IDAtMS4xLS4xLTguOC00LjUtMTYuMy03LjgtMTguOS04LjUtMy0uOS0yLjYtNy41LTIuMy0xMy4zLjItMi42LjMtNS4xLjItNy4yLS40LTcuNC0xLjctMTUuNC04LjEtMTkuMy0zLjgtMi4zLTguOC0zLTEzLjUtMyAuOS0uNCAxLjgtMSAyLjktMS42IDIuOC0xLjYgNi4yLTMuNiA5LjctNCAxLjEtLjEgMi4yLS4yIDMuMy0uNCA2LjktLjggMTIuOS0xLjUgMTkuMi43IDIuOSAxIDguNyA0LjIgMTAuMiA3LjMgMS4xIDIuMSAyLjkgMy44IDYuNCA3LjEgMS45IDEuNyAzLjEgMi43IDQgMy41IDEuMyAxIDEuNSAxLjMgMS45IDIgMS4yIDIuNC44IDQuOS4yIDguNHpNMTI0IDk0LjFjLjQuMS42LjYuMyAxLS45IDEuNC0yIDMuNC0zLjMgNS43LS42IDEuMS0xLjIgMi4yLTEuNyAzLTEuNyAyLjktMS44IDUuNC0xLjkgNy4zLS4xIDIuMS0uMiAzLTEuNSAzLjgtMSAuNy0yLjEuOS05LjMgMi0xLjMuMi0xLjguNC0yLjMuNy0uMS4xLS4zLjEtLjQuMi0uNC4yLS44LS4yLS44LS42LjEtMSAuMS0yLjMuMS00di0uM2MwLTEuNCAwLTIuNi0uMS0zLjUtLjEtMS44LS4xLTIuNi40LTMuNC42LTEgMS4xLTEuMyAxLjgtMS44IDEuMS0uNyAyLjYtMS42IDQuNy00LjYgMS4yLTEuNiAxLjQtMi41IDEuNi0zLjIuMS0uMy4xLS40IDEtMS4xczMuOC0yLjkgNy41LTIuM2MxLjIuMiAyLjUuNiAzLjkgMS4xek05NS4zIDEyNy4zYy0uMi4yLS4zLjMtLjYuMy0uOCAwLTEuMy0uMi0xLjYtLjYtLjctLjktLjYtMi43LS41LTMuOGwzLjEtLjhjLjIgMS43LjMgNC0uNCA0Ljl6TTk1LjUgMTE2LjNjLS4xLjQtLjEuOS0uMSAxLjV2Mi4zYy0xIC4zLTEuOC4zLTIuOC4zdi0xLjEtLjctLjhjMC0uNiAwLTEuNS4xLTEuOC4zIDAgLjYtLjEuOS0uMi42LS4xIDEuNS0uMyAyLS4yIDAgLjIgMCAuNS0uMS43ek04OS45IDEyNi40Yy0uMSAxLjYtLjYgMy41LTIuMSAzLjgtLjcuMS0xLS4xLTEuMi0uMy0xLS45LTEuMS0zLjctMS01LjcuNyAwIDEuNS0uMSAyLjUtLjMuNi0uMSAxLjItLjMgMS43LS40LjEuOC4yIDEuOC4xIDIuOXpNODkuMiAxMjAuOGwtMy4zIDEuMmMuMi0xLjMuNC0zLjEuNS00LjMuMS0uOC4zLTEuMS40LTEuMiAwIDAgLjEtLjEuMi0uMWguMmwyLjEtLjFjLS4xIDEtLjEgMy4yLS4xIDQuNXpNODMuOCAxMTkuOGMtLjIuNS0uNCAxLjktLjUgMi45bC00LjEtLjFjLjItMS4zLjYtMi42LjktMy42LjQtMSAuNy0xLjggMS4xLTJzMS4zLS4zIDEuOS4yYy45LjYgMS4xIDEuNS43IDIuNnpNODIuMyAxMzIuNWMtLjMuNC0uNy43LTEuMS43LS41LjEtLjgtLjEtMS4xLS4zLTEuMy0xLjItMS4yLTUuMS0xLjEtNyAxLjctLjQgMy42LS43IDQuNS0uOCAwIDEuNS4xIDUuNi0xLjIgNy40ek03Ni45IDEyMi40Yy0uMi41LS40IDEtLjUgMS41LS41LjItMiAwLTMuNS0uM2wxLTYuNWMxLjctLjUgMy43LS42IDQuMS0uMS43LjctLjYgNC0xLjEgNS40ek03NSAxMzMuNGMtLjggMS0yIDEuNS0zLjcgMS40LTEuMiAwLTEuNi0uNS0xLjgtLjgtLjktMS41IDAtNSAuOS03LjJsNS42LjNjLjEuNC4xLjkuMSAxLjQuMSAxLjctLjEgMy43LTEuMSA0Ljl6Ii8+PHBhdGggY2xhc3M9InByZWZpeF9fc3QxIiBkPSJNMTIxLjQgODYuMWMtNS4xLTEuNC00LjYtOC44LTQuMi0xNiAuMS0yLjUuMy00LjkuMi02LjktLjQtNi43LTEuNS0xNC02LjktMTcuMy01LjgtMy41LTE1LjMtMi43LTIxLjEtMi0yLjEuNi00LjEgMS4xLTUuNyAxLTMuNC0uMi02LjEtMS42LTguNS0yLjktMS44LTEtMy40LTEuOS01LTEuOUg3MGMtNC41LjMtNi42IDEuNC04LjUgMy4xLS41LjQtMS4xIDEuNi0zIDcuMS0xIDIuOC0xLjEgNC4zLTEuMyA1LjctLjIgMS4zLS4zIDIuNy0xIDQuOC0uNSAxLjQtLjkgMi42LTEuMiAzLjgtLjkgMy4xLTEuNyA1LjYtMy45IDguNi0uMy4zLS42LjktMSAxLjQtLjUuOC0xLjEgMS44LTIgMi45LS42LjgtMS45IDMuOC0xLjggNC43LjEgMS41LjYgMi40IDEuMSAzLjRzMS4yIDIuMiAxLjMgMy45di4zYy4yIDIuNi0uMiAzLjktNS4xIDguMy0zLjEgMi44LTUuNCA1LjUtNi45IDcuNS0uMS4yIDAgLjQuMy40aDFjMS4yLjEgMi40LjYgMy4yIDEuNS4xLjIuNC4yLjYuMS44LS4zIDEuNy0uMyAyLjUtLjIgMSAuMSAyLjEuNCAyLjggMS4xLjIuMi41LjMuOC4yLjgtLjIgMS43LS4yIDIuNS4xLjYuMiAxLjIuNiAxLjYgMS4xLjMuMy44LjQgMS4yLjIuMi0uMS41LS4zLjgtLjQgMS4xLS40IDIuMy0uMiAzLjMuMi41LjIgMSAuMyAxLjUuNy44LjYgMS40IDEuNCAxLjcgMi4zLjIuNS45LjcgMS4zLjMuOC0uNiAxLjQtLjcgMi0uNS4zLjEuNS4zLjcuNi4zLjQuOC44IDEuMi42IDEuNy0uNSAzLjctLjIgNS4yLjYuNS4zIDEuMS43IDEuNCAxLjN2LS4zYzAtLjEuMS0uMi4yLS4zbC4zLS4xYy44LS4zIDUtMS41IDYuNi4yLjEuMS4yLjEuMyAwIC4yLS4yLjQtLjQuNS0uNCAxLjEtLjYgMi45LS43IDQuMS40LjIuMi42LjEuOC0uMS4xLS4yLjItLjMuNC0uNC40LS40IDEtLjUgMS42LS41bDIuMy0uMWMuNiAwIDIuNC0uMiAyLjktLjNoLjFjLjIgMCAuNS0uMS44LS4yIDEuMS0uMiAyLjQtLjUgMy40IDBzLjkgMS42LjggMi42YzAgLjQtLjEuOC0uMSAxLjJ2LjZjMCAuOSAwIDEuNy0uMSAyLjNsLjEuNXYuMWMuMS40LjYuNy45LjQuOC0uNSAxLjYtMS4xIDEuOS0xLjV2LS4xYzAtLjEuMS0uMy4yLS43LjEtLjkuMy0yLjYuMy02LjF2LS40YzAtMS4zIDAtMi40LS4xLTMuMy0uMS0xLjktLjItMy40LjgtNC45LjktMS41IDEuOC0yIDIuNy0yLjYgMS0uNiAyLjEtMS4zIDQtMy45LjktMS4zIDEtMS44IDEuMS0yLjIuMi0xIC41LTEuNiAyLTIuNiAxLjItLjkgNC43LTMuNiA5LjUtMi44IDEuNi4zIDQuMSAxLjEgNi43IDIuMS4xIDAgLjIuMS4zLjFoLjFjMi4zLjkgNC40IDEuOSA1LjkgMi43LjMuMi43LjEgMS0uMi41LS42IDEtLjkgMS41LTEuMy4yLS4xLjQtLjIuNS0uMy4xIDAgLjEtLjEuMS0uMS40LS4zLjQtMS4xLS4xLTEuMy02LjctMy4zLTEzLjEtNS4zLTE1LjItNS45em0tNDguMiAxLjVDNzEuNiA5NC40IDYxIDEwMiA1Ni4yIDEwMkg1NS45Yy0uMSAwLS4yIDAtLjMtLjFoLS4yYy0uOS0uMy0yLjEtLjktMy0xLjgtLjYtLjYtMS4xLTEuNC0xLjMtMi4xIDAtLjEtLjEtLjMtLjEtLjQtLjMtMS4yLS42LTIuNi40LTUgLjEtLjMuMy0uNi40LS45IDAtLjEuMS0uMi4xLS4zLjEtLjMuMi0uNS4zLS43LjEtLjQuMy0uNy40LS45IDAtLjEuMS0uMi4xLS4zLjMtLjguMy0xLjEuNC0xLjQgMC0uMi4xLS42LjItMSAuMy0xLjMuNS0yLjQuNi0zLjMuMi0xLjcuNS0zLjIgMS40LTQuNi4yLS4yLjMtLjQuNS0uNmwuMi0uMi4yLS4yYy4yLS4yLjUtLjMuNy0uNC4xIDAgLjItLjEuMy0uMS4yLS4xLjQtLjEuNi0uMi45LS4yIDEuOS0uMiAzLjEtLjEgMS4zLjEgMi41LjMgMy41LjYuOS4yIDEuNy41IDIuMy44LjEgMCAuMS4xLjIuMS4xLjEuMi4xLjQuMnMuMy4xLjUuMmwuNi4zLjIuMWMuNy4zIDEuNC43IDEuOSAxLjEuMy4yLjUuNC43LjYuMS4xLjIuMS4yLjJsLjIuMmMyLjEgMS44IDIgNC4zIDEuNiA1Ljh6bTUtMjUuOWwtLjIgMS4yYy0uNSAyLjgtMS42IDYuNi01LjYgNy42LTMuOS45LTQuOCAxLjEtNy41IDEuM2gtLjJjLTIgMC01LjktMS4zLTYuNi00LjQtLjQtMiAuNS0zLjUgMS45LTUuOS4yLS40LjUtLjguOC0xLjMgMi0zLjMgMi43LTUuNyAzLjMtNy42LjYtMS45IDEuMS0zLjQgMi40LTQuNy4zLS4zLjYtLjYgMS0uOC4yLS4yLjUtLjMuOC0uNS40LS4yLjgtLjMgMS4yLS41LjktLjMgMS45LS40IDIuOC0uNCAxLjkgMCAzLjguNSA1LjEgMS42LjYuNSAxLjUgMS40IDIgNC4zLjIgMS41LS4yIDQuMi0xLjIgMTAuMXptMjguNyA4Yy0xLjQgMi40LTIuMSAzLjctMy4zIDQuNy0yLjQgMi01LjEgMi40LTcuNCAyLjQtMS42IDAtMy0uMy0zLjktLjQtMi40LS40LTYuNy0xLjItOC4yLTQuNy0uMy0uNy0uMy0xLjEtLjMtMS43IDAtLjUgMC0xLjUtLjMtMy42di0uMWMtLjEtMS0uMi0yLjEgMC0zLjV2LS4yYy44LTQuMiAxLjEtNC44IDEuMi01LjIuNC0uOCAxLjQtMS4yIDIuMy0uNy44LjQgMS4xIDEuNC44IDIuMi0uMS4yLS4zIDEuMS0xIDQuNHYuMmMtLjIuOS0uMSAxLjYgMCAyLjV2LjFjLjMgMi40LjMgMy40LjMgNHYuNGMuMy43LjkgMS4xIDEuNiAxLjUuNS4yIDEtLjIuOS0uNy0uNy0zLjctLjctOCAuNy0xMC43LjUtLjkgMS4zLTIuMyAyLjEtMy43LjEtLjEuMi0uMy4yLS40LjEtLjEuMS0uMi4yLS4zLjQtLjYuNy0xLjEgMS0xLjYgMC0uMS4xLS4xLjEtLjJsLjEtLjFjLjEtLjEuMS0uMi4yLS4zIDAgMCAwLS4xLjEtLjFsLjEtLjFjMC0uMS4xLS4xLjEtLjIuMy0uNC42LS44LjgtMS4yLjQtLjUtLjEtMS4xLS42LS45LTEuNC42LTIuMyAxLjMtMi41IDEuNC0uNy42LTEuOC41LTIuNC0uMy0uNi0uNy0uNS0xLjguMy0yLjQuOS0uNyA1LjUtNCAxMS0yLjUgNCAxLjEgNiA0LjIgNi44IDUuMy42LjkgMi42IDMuNyAyLjUgNy43IDAgMi45LTEuMiA1LjEtMy41IDl6Ii8+PHBhdGggY2xhc3M9InByZWZpeF9fc3QxIiBkPSJNNzEuMSA0OS4yYy0uMy43LS42IDEuNS0xIDIuNC0uOCAyLjEtMS44IDQuNS0yLjMgNS40LS44IDEuNS0xLjQgMi41LTEuOSAzLjItLjYuOS0xIDEuNi0xLjQgMi42LS42IDEuNy0uNyAzLjYtLjMgNS43LTEuMS0uMS0yLjgtLjgtMy0xLjgtLjEtLjcuMy0xLjQgMS41LTMuNS4yLS40LjUtLjkuOC0xLjMgMi4xLTMuNiAzLTYuMyAzLjYtOC4zLjctMi4xIDEtMyAyLjEtMy44LjctLjMgMS4zLS41IDEuOS0uNnpNNjkgMTI0LjhjLTEuMiAyLjQtMi42IDQuNi0zLjUgNS43LS44LTItMi4xLTYuNy0xLjctMTAuNHYtLjNjLjEtMS4yLjQtMi4yIDEtMy4xLjQtLjYgMS40LS45IDIuNS0uOS44IDAgMS43LjIgMi41LjYuNC4yIDEgLjcgMSAyIC4yIDEuOC0uNyA0LjItMS44IDYuNHoiLz48cGF0aCBjbGFzcz0icHJlZml4X19zdDEiIGQ9Ik0xMzMgOTguMWMuMS4xLjEuMi4xLjMtLjMuNy0uOCAxLjItMS4zIDEuOC0uNi43LTEuMyAxLjUtMS45IDIuOC0uOSAxLjgtMS4yIDMuNC0xLjMgNy42LS4yIDQuOSAwIDcuNi4yIDkuNi4xIDEuOS4yIDMuMS0uMSA1LS43IDMuOC0yLjMgNi4zLTQuNCA5LjUtMi42IDQtNS4yIDguMS05LjYgOS40LS40LjEtLjQuMS0xLjYuMS0xIDAtMi43IDAtNS44LjEtNS44LjItOC43LjMtMTEuMS44LTIuNi41LTMuOSAxLjEtNS4zIDEuNi0xLjIuNS0yLjMuOS00LjQgMS40LTEuMy4zLTMuMi41LTkuNy42LTYuOCAwLTEwLjkgMC0xNi4yLS42LTcuNC0uOC0xMS4xLTEuMy0xMy42LTIuNi01LjgtMy4xLTguMy04LjctMTIuMy0xNy45IDAtLjEuMS0uMi4yLS4ybC42LjNjLjIuMS40LjEuNS4xLjQuMS44LjEgMS4yIDAgLjEgMCAuMSAwIC4yLS4xLjEgMCAuMiAwIC4yLjEuMy43LjcgMS4zIDEuNCAxLjdzMS41LjQgMi4yLjRjLjggMCAxLjYtLjEgMi40LS4yLjQgMCAuOC4yIDEgLjUuNyAxLjggMS42IDMgMyAzLjJoLjNjLjMgMCAuOC0uMSAxLjQtLjUuNS0uNCAxLjMtLjEgMS43LjQuMy41LjcuOCAxLjEgMS4xIDEuNCAxLjQgNC44IDIuMSA3LjYgMi4xIDEuNSAwIDIuOS0uMiAzLjctLjYgMS4yLS42IDEuMi0xLjQgMS4xLTEuOC0uMS0uNi0uMi0xLjMtLjMtMS45IDAtLjEuMS0uMS4xIDAgLjIuNC40LjguOS45aC4yYy44IDAgMiAuMyAyLjIgMSAuMS40LjMuNy41IDEuMS41LjcgMS40IDEuNiAzLjMgMS43aC4xYzIuMiAwIDMuOS0uNyA1LTIuMS4xLS4xLjEtLjIuMi0uMy40LS42IDEuNi0uNiAyLjEtLjEuNi41IDEuMy44IDIuMS44aC40YzEtLjEgMS44LS42IDIuNS0xLjUuNC0uNi43LTEuMy45LTIuMS4xLS4yLjQtLjMuNi0uMS40LjQgMS4xLjggMi4xLjguMiAwIC41IDAgLjgtLjEgMS45LS40IDIuOS0yIDMuMy0zLjcgMC0uMS4xLS4xLjEgMCAuNS42IDEuNCAxLjMgMi45IDEuM2guMmMuOCAwIDEuNS0uNCAyLTEgLjYtLjguOC0yIC45LTMuMSAwLS4zLjItLjYuNi0uOCAxLjYtLjcgMy42LTIuMiA0LjItMy4yIDAgMCAwLS4xLjEtLjEuMS0uMy40LS41LjYtLjUgMS4zLS4yIDEuOC0uNSAyLjMtLjcuNC0uMi43LS4zIDEuNy0uNSA3LjMtMS4xIDguNy0xLjQgMTAuMy0yLjQgMi40LTEuNiAyLjUtMy44IDIuNi01LjkuMS0xLjguMi0zLjggMS42LTYuMi41LS45IDEuMS0xLjkgMS43LTMuMSAxLjEtMiAyLjYtNC44IDMuNy02LjMuMi0uMy42LS40LjktLjIgMi41LjkgNC43IDEuOSA1LjEgMi4zeiIvPjxwYXRoIGNsYXNzPSJwcmVmaXhfX3N0MSIgZD0iTTYyIDExOS45Yy0uMyAyLjUtLjUgNS45LS4xIDEwLjMuMSAxLjIuMyAyLjUuNSAzLjgtLjMuMi0xLjQuNS0zLjIuNC0yLjYtLjEtNS4yLS43LTYtMS42bC0uMS0uMWMtLjYtLjUtMS4xLS45LTEuMS0xLjggMC0uMy4xLS42LjQtMS4xLjItLjIuNC0uNS42LS45LjQtLjYgMS0xLjMgMS42LTIuMyAxLjctMi44IDIuMy0zLjcgMy4xLTQuOC4xLS4xLjEtLjIuMi0uMy41LS42IDEtMS40IDEuOS0yLjcuNi0uOSAxLjEtMS43IDEuNi0yLjMuNy0xIDEuMi0xLjUgMS41LTEuOCAwIC40LS4xIDEtLjIgMS42LS40IDEuMi0uNiAyLjMtLjcgMy42ek02MC43IDgwLjVjMCAuMSAwIC4xIDAgMC0uNC41LS44IDEuMS0xLjMgMi4xLTEuMyAyLjgtMS4zIDQuNC0xLjMgNS43IDAgLjcgMCAxLjItLjIgMS44LS4xLjQtLjMuOS0uNiAxLjQtLjcgMS43LTEuNyAzLjktMS4zIDYuOS0uNi0uMy0xLjUtMS0xLjctMS4zIDAtLjItLjEtLjMtLjEtLjUtLjItLjktLjMtMS41LjItMi45IDEuNi0zLjYgMS44LTQuNSAxLjktNS41IDAtLjIuMS0uNC4xLS43LjMtMS40LjUtMi42LjYtMy42LjItMS41LjQtMi41LjktMy4yLjItLjMuNy0uNCAxLjQtLjQuMyAwIC42IDAgMSAuMWguMWwuMy4xek01OC43IDExNi4yYy0uMS0uOS0uMi0xLjctLjYtMi42IDAgMC0uMS0uMi0uMS0uMy0uMS0uMS0uMS0uMi0uMi0uM2wtLjEtLjFjLS4xLS4xLS4xLS4xLS4yLS4xbC0uMS0uMWMtLjEgMC0uMS0uMS0uMi0uMWgtLjFjLS41LS4yLTEtLjQtMS42LS41SDU1Yy0uMSAwLS4yLjEtLjQuMS0uMSAwLS4xLjEtLjIuMWwtLjEuMS0uMi4yLS4xLjF2LjFsLS42LjljLS41LjctMSAxLjUtMS41IDIuMnMtLjkgMS4zLTEuNCAyYy0uMy40LS41LjctLjggMS4xIDAgLjEtLjEuMS0uMS4yLjMuMS42LjEuOS4yLjcuMSAxLjQuMiAyIC4zIDEuNC4yIDIuOS4zIDQuMy4yaC4yYy4zLS41LjgtMS4xIDEuMy0xLjkuMy0uNC42LS44LjgtMS4yLS4zLS4xLS40LS40LS40LS42ek01My42IDEyMi4xYy0uMSAxLjEtMS4zIDMuOS0zLjIgNi42LTEuNiAyLjItMi42IDIuOC0yLjggMi44LS44LS4xLTEuNS0yLTIuMS0zLjktLjItLjgtLjUtMS41LS42LTIuMi0uNC0xLjQtLjUtMy40LS40LTQuNiAxLjYuOSA0LjQgMS4xIDguNCAxLjEuMi4xLjUuMS43LjJ6TTUwLjggMTEzLjFjLS43IDEuMS0xLjQgMi4xLTIuMSAzLjEtLjQuNS0uNyAxLTEuMSAxLjUtLjIuMy0uNS42LS43LjktLjYtLjEtMS4xLS4zLTEuNy0uNC0uNS0uMS0uOS0uMy0xLjQtLjUtLjEgMC0uMi0uMS0uMy0uMS0uMS0uMS0uMi0uMy0uMy0uNC4yLS4zLjMtLjcuNS0xIC4zLS42LjYtMS4yIDEtMS44LjYtMSAxLjMtMi4xIDIuNC0yLjguMSAwIC4xLS4xLjItLjEuNC0uMi44LS40IDEuMy0uNUg0OS40Yy4xIDAgLjIuMS40LjEgMCAwIC4xIDAgLjEuMS4xLjEuMi4xLjMuMi0uMi0uMS4yLjMuMi4yLjIuNi4zLjkuNCAxLjV6TTQ1LjQgMTEwLjJjLTEuMyAxLTIuMiAyLjQtMi45IDMuOWwtMS4yIDIuNGMwIC4xLS4xLjItLjEuMi0uNC0uMS0uOC0uMi0xLjEtLjMtLjQtLjEtLjgtLjMtMS4yLS40LS4yLS4xLS4zLS4yLS41LS4zLjQtLjcuOC0xLjQgMS4zLTIuMS42LS45IDEuMy0xLjkgMi0yLjcuMy0uMy42LS43LjktLjkuNC0uMi44LS4yIDEuMy0uMS41IDAgMSAwIDEuNC4yLS4xIDAgMCAuMS4xLjF6TTQzLjQgMTI3LjJsLS4yLjJoLS4xYy0uMyAwLS42LjEtLjkuMS0uNiAwLTEuMi4xLTEuOCAwLS4zIDAtLjYtLjEtLjgtLjMtLjItLjMtLjMtLjktLjQtMS4zLS40LTIuMi0uNC00LjQtLjItNi42IDEuMS40IDIuMy43IDMuNS45LS4zIDIgLjIgNC45LjQgNS43LjMuNC40LjkuNSAxLjN6TTM5LjggMTA5LjVjLTEgMS4yLTEuOSAyLjUtMi43IDMuOS0uMy41LS43IDEuMS0xIDEuNy0uNC0uMS0uOC0uMy0xLjEtLjVzLS42LS40LS44LS42Yy0uMS0uMS0uMy0uMi0uNC0uMyAwIDAtLjEgMC0uMS0uMS4xLS4zLjMtLjUuMy0uNy4yLS41LjQtLjkuNy0xLjMuNS0uOCAxLTEuNiAxLjYtMi40LjItLjMuNC0uNi44LS43LjMtLjEuNyAwIDEgMCAuNi4xIDEuMi41IDEuNyAxek0zMi4xIDExNC44YzAtLjEuMS0uMSAwIDAgLjQuNC43LjcgMS4xIDEgLjIuMS4zLjMuNS40di4xYy0uNCAxLjctLjcgMy41LS43IDUuMyAwIC4xLS4xLjEtLjEgMC0uNS0yLjEtMS4xLTUuNS0uOC02Ljh6TTM3IDExOC41Yy0uMiAxLjUtLjMgMy0uMiA0LjUgMCAuOC4xIDEuNi4yIDIuNUgzNi4ybC0uNC0uMmMtLjItLjEtLjQtLjQtLjYtLjctLjQtLjctLjUtMS41LS41LTIuMy0uMS0xLjUuMS0zLjEuNC00LjYuMi4xLjUuMi44LjMuNC4yLjcuNCAxLjEuNXoiLz48L2c+PGRlZnM+PHBhdGggaWQ9InByZWZpeF9fU1ZHSURfMDAwMDAxMjg0NTQ1Mjk3Mjc3MTc5NzUzMjAwMDAwMTI0ODY4OTU5NTA2MTg4NDczODlfIiBkPSJNMTg1LjYgOTIuOEMxODUuNiA0MS41IDE0NCAwIDkyLjggMCA0MS41IDAgMCA0MS41IDAgOTIuOGMwIDUxLjIgNDEuNSA5Mi44IDkyLjggOTIuOCA1MS4yIDAgOTIuOC00MS42IDkyLjgtOTIuOHoiLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJwcmVmaXhfX1NWR0lEXzAwMDAwMTEyNjMyODI1NjgwMTUyODEzMTkwMDAwMDE2MzI1OTA0MDA0MDAwODk0MzY2XyI+PHVzZSB4bGluazpocmVmPSIjcHJlZml4X19TVkdJRF8wMDAwMDEyODQ1NDUyOTcyNzcxNzk3NTMyMDAwMDAxMjQ4Njg5NTk1MDYxODg0NzM4OV8iIG92ZXJmbG93PSJ2aXNpYmxlIi8+PC9jbGlwUGF0aD48ZyBvcGFjaXR5PSIuOCIgaWQ9InByZWZpeF9fTGF5ZXJfMl8wMDAwMDEwNzU3MjE1MTAwODk5NjUyNzAzMDAwMDAxNjI5MDA2MTc5NDkyNDY5MDg2Nl8iIGNsaXAtcGF0aD0idXJsKCNwcmVmaXhfX1NWR0lEXzAwMDAwMTEyNjMyODI1NjgwMTUyODEzMTkwMDAwMDE2MzI1OTA0MDA0MDAwODk0MzY2XykiPjxsaW5lYXJHcmFkaWVudCBpZD0icHJlZml4X19TVkdJRF8wMDAwMDE3NDU3NjcyMzUxMTY1OTk1Nzk5MDAwMDAxMjA5OTI1MTQ1NTEyMzE5NjgyNF8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iLTEyLjk5NiIgeTE9IjYzNS4xMzUiIHgyPSIxOTkuNjMyIiB5Mj0iODU4LjMiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjU2KSI+PHN0b3Agb2Zmc2V0PSIuMjA2IiBzdG9wLWNvbG9yPSIjODlkMGZmIi8+PHN0b3Agb2Zmc2V0PSIuMzk4IiBzdG9wLWNvbG9yPSIjZWJiZjlhIi8+PHN0b3Agb2Zmc2V0PSIuNjAyIiBzdG9wLWNvbG9yPSIjZWI4MjgwIi8+PHN0b3Agb2Zmc2V0PSIuODQxIiBzdG9wLWNvbG9yPSIjYTI4MWZmIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNNzYuNCAxOTYuNWMtNi44IDAtMTMuMi0uNC0xOC42LS44bC0xLjUtLjEtMS41LS4yYy0uNy0uMS0xLjUtLjItMi40LS4zLTUuMi0uNi0xNC45LTEuNi0yNS42LTYuNmwtMS43LS44LTEuNS0uOUMzIDE3NS4yLTQuNiAxNTcuOS04LjggMTQ4LjZjLS4zLS42LS42LTEuMy0uOS0yLTIuMS00LjMtMy40LTguMS00LjUtMTEuN2wtLjItLjgtLjItLjhjLTMtMTAuNi0zLjctMTkuNy0yLjQtMjguOCAxLjQtOS4xIDQuNy0xNy4zIDEwLjYtMjZsMy00LjljLjYtMSAxLTIuMSAxLjMtMy4yQy4yIDU5IDUuNCA1MC45IDggNDdjLjctNC43IDEuOS05LjMgMy41LTEzLjhsLjItLjcuMy0uN2MwLS4xLjEtLjMuMi0uNkMxMy40IDI3LjcgMTYuMSAxOS42IDIzIDExbDIuNi0zIDIuNy0yLjRjNi44LTYuMiAxNS0xMC44IDIzLjgtMTMuNCA0LjktMS41IDEwLTIuNCAxNS4yLTIuN2gxLjJjLjkgMCAxLjgtLjEgMi42LS4xIDMuMiAwIDYuNC4zIDkuNi44IDIgLjMgNCAuMSA1LjktLjcgNS41LTIuMyAxMS4yLTMuOCAxNy4xLTQuNi41LS4xLjktLjEgMS4zLS4yLjktLjEgMi40LS4zIDQuMi0uNSAzLjEtLjMgNy45LS43IDEzLS43IDEwLjEgMCAxOC44IDEuMyAyNi42IDRsLjcuMi42LjJjMTcuMiA2LjUgMjUuOSAxNS42IDMyLjIgMjMuNWwuMy40LjkuOGM1LjcgNC40IDEwLjUgOS45IDE0LjMgMTZsMS4yIDEuOSAxIDJjOC40IDE3LjEgNS43IDMzIDQuNyAzOC45bC0uMS4zYy0uNyA0LjQtMS45IDguNy0zLjQgMTIuOS0uNiA0LTEuNSA4LTIuOCAxMS44LTIuMiA2LjgtNS41IDEzLjMtOS43IDE5LjEtMi40IDMuNC01LjIgNi43LTguMiA5LjYtMS4xIDEtMS44IDIuNC0yIDMuOS0uMS45LS4zIDEuOC0uNCAyLjctMi41IDEzLjItOC4yIDIyLjQtMTAuNiAyNi4xbC03LjEgMTAuMmMtOC42IDEwLjctMTguOCAxNy43LTMxLjEgMjEuNWwtMyAuOS0zLjIuNmMtMy43LjctNy40IDEtMTEuMiAxSDEwOC44aDBjLTEuNCAwLTIuOC4zLTQuMi43LTguMiAyLjYtMTcuMiAzLjgtMjguMiAzLjh6IiBvcGFjaXR5PSIuOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ1cmwoI3ByZWZpeF9fU1ZHSURfMDAwMDAxNzQ1NzY3MjM1MTE2NTk5NTc5OTAwMDAwMTIwOTkyNTE0NTUxMjMxOTY4MjRfKSIgc3Ryb2tlLXdpZHRoPSIxLjA1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGxpbmVhckdyYWRpZW50IGlkPSJwcmVmaXhfX1NWR0lEXzAwMDAwMDc4MDA3MjkwMzExNDQzNTI2NzgwMDAwMDAyNjQ1MDM2MTgyOTQ5NDk5MDE4XyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSItNC43NTEiIHkxPSI2NDQuNzM3IiB4Mj0iMTkxLjI2OCIgeTI9Ijg1MS4zMTMiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjU2KSI+PHN0b3Agb2Zmc2V0PSIuMjA2IiBzdG9wLWNvbG9yPSIjODlkMGZmIi8+PHN0b3Agb2Zmc2V0PSIuMzk4IiBzdG9wLWNvbG9yPSIjZWJiZjlhIi8+PHN0b3Agb2Zmc2V0PSIuNjAyIiBzdG9wLWNvbG9yPSIjZWI4MGRhIi8+PHN0b3Agb2Zmc2V0PSIuODQxIiBzdG9wLWNvbG9yPSIjYTI4MWZmIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNNzYuNCAxODkuNGMtNi41IDAtMTIuOC0uNC0xOC0uOGwtMS4yLS4xLTEuMi0uMmMtLjgtLjEtMS43LS4yLTIuNi0uMy01LjEtLjUtMTMuNS0xLjUtMjIuOS01LjlsLTEuNC0uNy0xLjMtLjdjLTE4LjMtMTAuMS0yNS0yNS4yLTI5LTM0LjItLjMtLjYtLjYtMS40LTEtMi4xLTEuOS0zLjgtMy4xLTcuNC00LjEtMTAuNmwtLjItLjctLjItLjZDLTkuMyAxMjMtMTAgMTE1LTguOCAxMDcuMS03LjYgOTkuMy00LjYgOTIgLjYgODQuNGwzLjktNi4zYy43LTEuMSAxLjItMi40IDEuNC0zLjcgMS45LTEwLjggNy0xOC40IDkuMy0yMS45bC4zLS40LjEtLjJjMC0uMS4xLS4yLjEtLjMuMS0uNS4zLS45LjQtMS4zLjYtNC40IDEuNy04LjggMy4yLTEzbC4yLS42LjItLjZjLjEtLjIuMS0uNC4zLTEgMS4xLTMuMyAzLjQtMTAuMiA5LjQtMTcuNmwyLjItMi42IDIuMi0yYzUuOS01LjQgMTMtOS40IDIwLjYtMTEuNkM1OC44IDAgNjMuMi0uOCA2Ny44LTFoMWMuOCAwIDEuNS0uMSAyLjItLjEgMy4zIDAgNi41LS45IDkuNy0uMyAyLjUuNSA1IC4yIDcuMy0uOCA0LjMtMS45IDEwLjEtMi42IDE2LjctMy41LjUtLjEuOS0uMSAxLjItLjIuOS0uMSAyLjMtLjMgMy45LS40IDIuOS0uMyA3LjQtLjYgMTIuMy0uNiA5LjIgMCAxNyAxLjIgMjMuOSAzLjVsLjYuMi41LjJjMTUuMiA1LjggMjIuNyAxMy40IDI4LjYgMjAuOS4zLjQuNy44LjggMWwuMS4xIDEuMSAxIC4xLjJjNS4xIDMuOSA5LjQgOC43IDEyLjcgMTQuMWwxIDEuNi44IDEuN2M3LjIgMTQuNyA1IDI4LjIgNCAzMy45bC0uMS4zYy0uNyA0LjItMS44IDguMi0zLjMgMTIuMi0uNSAzLjgtMS40IDcuNi0yLjYgMTEuMi0yIDYtNC45IDExLjctOC42IDE2LjktMi41IDMuNi01LjUgNi45LTguNyA5LjgtMS41IDEuNC0yLjUgMy4yLTIuNyA1LjMtLjIgMS41LS40IDIuOS0uNiA0LjQtMi4yIDExLjctNy4yIDE5LjctOS42IDIzLjNsLTUuOCA4LjRjLTcuNyA5LjktMTYuOCAxNi4zLTI3LjggMTkuN2wtMi41LjgtMi43LjVjLTMuMi42LTYuNS45LTkuNy44SDEwOS43aC0yLjZjLTEuNS4xLTMgLjMtNC41LjgtNy4zIDIuNC0xNS44IDMuNS0yNi4yIDMuNXoiIG9wYWNpdHk9Ii44IiBmaWxsPSJub25lIiBzdHJva2U9InVybCgjcHJlZml4X19TVkdJRF8wMDAwMDA3ODAwNzI5MDMxMTQ0MzUyNjc4MDAwMDAwMjY0NTAzNjE4Mjk0OTQ5OTAxOF8pIiBzdHJva2Utd2lkdGg9IjEuMDU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48bGluZWFyR3JhZGllbnQgaWQ9InByZWZpeF9fU1ZHSURfMDAwMDAwMTg5NDM2OTY5MTU2MTI0MTQ3MjAwMDAwMDE0NzY4MDQ0Njc5Mjk1Njk5NjZfIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjMuNTc2IiB5MT0iNjUzLjA0IiB4Mj0iMTgyLjk4NCIgeTI9Ijg0My4wMjEiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjU2KSI+PHN0b3Agb2Zmc2V0PSIuMjA2IiBzdG9wLWNvbG9yPSIjODlkMGZmIi8+PHN0b3Agb2Zmc2V0PSIuMzk4IiBzdG9wLWNvbG9yPSIjZWJiZjlhIi8+PHN0b3Agb2Zmc2V0PSIuNjAyIiBzdG9wLWNvbG9yPSIjZWI4MjgwIi8+PHN0b3Agb2Zmc2V0PSIuODQxIiBzdG9wLWNvbG9yPSIjYTI4MWZmIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNNzYuNCAxODEuMWMtNi4yIDAtMTIuMy0uNC0xNy40LS44bC0xLS4xLTEtLjFjLS45LS4xLTEuOS0uMi0yLjktLjMtNC44LS41LTEyLjEtMS4zLTIwLjMtNS4ybC0xLjEtLjUtMS0uNmMtMTUuNy04LjgtMjEuNS0yMS44LTI1LjMtMzAuNC0uMy0uNy0uNy0xLjYtMS0yLjMtMS43LTMuNC0yLjgtNi42LTMuNy05LjZsLS4yLS41LS4xLS41Qy0uOSAxMjItMS41IDExNS0uNSAxMDguNGMxLTYuNyAzLjctMTMgOC4zLTE5LjdsLjYtLjguNi0uOGMuNC0uNS43LTEgMS4xLTEuNGwyLjMtNC4zYy44LTEuNCAxLjMtMi45IDEuNS00LjUgMS41LTkuNiA2LjEtMTYuNSA4LjItMTkuN2gwYy4xLS4yLjMtLjQuNC0uNWwuNS0uN2MuMi0uNC40LS45LjYtMS41cy41LTEuNS43LTIuM2MuNS00LjEgMS41LTguMSAyLjktMTJsLjItLjUuMi0uNWMuMS0uNC4zLS43LjUtMS40IDEtMy4xIDIuOS04LjggOC0xNWwxLjctMi4xIDEuOC0xLjZjNS00LjYgMTEtNy45IDE3LjUtOS45IDMuOC0xLjEgNy42LTEuOCAxMS42LTJoMi43YzMuNCAwIDYuNy40IDEwIDEuMyAyLjguNyA1LjguNCA4LjQtLjkgNC4yLTIgOS44LTQuMiAxNi4zLTUgLjQtLjEuOC0uMSAxLjEtLjIuOC0uMSAyLjEtLjMgMy43LS40IDIuNy0uMyA3LS42IDExLjUtLjYgOC4yIDAgMTUuMSAxIDIxLjIgMy4xbC40LjIuNC4yYzE0IDUuMyAyMC4yIDEyLjIgMjUgMTguMyAxLjEgMS4zIDEuMiAxLjUgMS45IDIuMmwuOS44LjMuNGMyLjMgMS44IDcgNS41IDExLjEgMTIuMmwuOCAxLjMuNyAxLjNjNi4xIDEyLjMgNC4yIDIzLjUgMy4zIDI4LjlsLS4xLjNjLS42IDMuOS0xLjcgNy44LTMuMyAxMS41di4zYy0uNCAzLjUtMS4yIDctMi4zIDEwLjMtMS43IDUuMy00LjIgMTAuMi03LjUgMTQuNy0yLjcgMy45LTYgNy40LTkuNyAxMC40LS45LjctMS42IDEuNi0yLjEgMi42cy0uOCAyLjEtLjkgMy4yYy0uMSAyLjItLjQgNC40LS44IDYuNi0xLjkgMTAuMS02LjMgMTcuMS04LjUgMjAuNmwtNC41IDYuNmMtNi43IDktMTQuNyAxNC44LTI0LjQgMTcuOGwtMiAuNi0yLjIuNGMtMi43LjUtNS41LjctOC4zLjdIMTA4LjFsLTIuMy4xYy0xLjYuMS0zLjIuMy00LjcuOS02LjkgMi4yLTE0LjggMy4yLTI0LjcgMy4yeiIgb3BhY2l0eT0iLjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0idXJsKCNwcmVmaXhfX1NWR0lEXzAwMDAwMDE4OTQzNjk2OTE1NjEyNDE0NzIwMDAwMDAxNDc2ODA0NDY3OTI5NTY5OTY2XykiIHN0cm9rZS13aWR0aD0iLjk4OSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGxpbmVhckdyYWRpZW50IGlkPSJwcmVmaXhfX1NWR0lEXzAwMDAwMDI0Njg5MjEwNjg4MzAzMTYwNjMwMDAwMDE3Mjg0MzcyODUxMzI2NjkyNzk5XyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIxMS44OTMiIHkxPSI2NjEuMzcxIiB4Mj0iMTc0LjY1MSIgeTI9IjgzNC43MDciIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjU2KSI+PHN0b3Agb2Zmc2V0PSIuMjA2IiBzdG9wLWNvbG9yPSIjODlkMGZmIi8+PHN0b3Agb2Zmc2V0PSIuMzk4IiBzdG9wLWNvbG9yPSIjZWJiZjlhIi8+PHN0b3Agb2Zmc2V0PSIuNjAyIiBzdG9wLWNvbG9yPSIjZWI4MGU3Ii8+PHN0b3Agb2Zmc2V0PSIuODQxIiBzdG9wLWNvbG9yPSIjYTI4MWZmIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNNzYuNCAxNzIuOGMtNS45IDAtMTEuOC0uNC0xNi43LS44bC0uNy0uMS0uNy0uMWMtMS0uMS0yLjEtLjMtMy4xLS40LTQuNS0uNS0xMC43LTEuMi0xNy43LTQuNGwtLjgtLjQtLjgtLjRjLTEzLjMtNy41LTE4LjItMTguNS0yMS44LTI2LjUtLjQtLjgtLjgtMS43LTEuMS0yLjUtMS41LTMuMS0yLjUtNi0zLjMtOC41bC0uMS0uNC0uMy0uM2MtMy45LTEzLjgtMi40LTIzLjUgNS4yLTM0LjZsLjQtLjYuNC0uNmMuNS0uNiAxLTEuMyAxLjUtMS45LjctLjkgMS40LTEuOSAyLjItMi44LjUtLjYuOS0xLjMgMS4yLTJsLjktMi4yYy40LTEgLjYtMiAuNy0zIC44LTguOSA1LjEtMTUuMyA3LjItMTguNWgwYy4yLS4yLjQtLjYuNS0uN2wuNS0uOC4yLS4yYy4zLS41LjgtMS43IDEuMi0yLjkuMi0uOC42LTIuMSAxLTMuMnYtLjFjLjQtMy43IDEuMy03LjQgMi42LTEwLjlsLjEtLjMuMS0uM2MuMi0uNi40LTEuMS42LTEuOC45LTIuNyAyLjQtNy4zIDYuNS0xMi40bDEuMy0xLjYgMS4zLTEuMmM5LjctOC44IDIwLjUtOS41IDI0LjEtOS44aDIuMWM0LjMgMCA4LjUuOSAxMi41IDIuNi43LjMgMS41LjQgMi4yLjQuOCAwIDEuNS0uMiAyLjItLjZoMGMzLjctMi4xIDEwLjQtNiAxOS03IC40LS4xLjgtLjEgMS4xLS4xLjgtLjEgMi0uMiAzLjQtLjQgMi42LS4yIDYuNS0uNSAxMC43LS41IDcuMyAwIDEzLjMuOSAxOC40IDIuNmwuMy4xLjMuMWMxMiA0LjUgMTcuMSAxMC4yIDIxLjQgMTUuNiAxLjEgMS41IDEuNyAyLjEgMi45IDMuM2wuNy42LjUuNi40LjNjMiAxLjYgNS44IDQuNSA5LjIgMTBsLjYgMSAuNSAxYzQuOSAxMCAzLjMgMTkgMi41IDIzLjh2LjNjLS42IDMuNS0xLjYgNy0zIDEwLjNsLS4xLjNjMCAuMSAwIC4xLS4xLjMtLjEuMy0uMS42LS4xLjlsLS4xLjRjLS4zIDMtMSA1LjktMiA4LjctMS41IDQuNS0zLjYgOC43LTYuNCAxMi41LTIuNyAzLjktNS44IDcuMS05LjIgOS42LTEuNSAxLjEtMi43IDIuNS0zLjYgNC4yLS45IDEuNy0xLjMgMy41LTEuMyA1LjQgMCAyLjMtLjMgNC43LS43IDctMS42IDguNi01LjIgMTQuNC03LjUgMTcuOWwtMy4zIDQuOWMtNS44IDguMS0xMi43IDEzLjMtMjEgMTUuOWwtLjQuMWMtLjcuMi0xLjQuNC0yLjEuNWwtLjUuMWMtMi4zLjQtNC42LjYtNi45LjZIMTA3LjdjLTEuMSAwLTIuNS4xLTMuNy4xLTEuNy4xLTMuMy40LTQuOSAxLTYgMS44LTEzLjMgMi44LTIyLjcgMi44eiIgb3BhY2l0eT0iLjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0idXJsKCNwcmVmaXhfX1NWR0lEXzAwMDAwMDI0Njg5MjEwNjg4MzAzMTYwNjMwMDAwMDE3Mjg0MzcyODUxMzI2NjkyNzk5XykiIHN0cm9rZS13aWR0aD0iLjkyMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGxpbmVhckdyYWRpZW50IGlkPSJwcmVmaXhfX1NWR0lEXzAwMDAwMDg1OTMwNDIyNDMyODI2NDc5NzMwMDAwMDE2MTQ2MTg4NjgyNzkzNzA3NDIyXyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyMC4xNiIgeTE9IjY2OS43MTgiIHgyPSIxNjYuMzAyIiB5Mj0iODI2LjM5NiIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgwIC02NTYpIj48c3RvcCBvZmZzZXQ9Ii4yMDYiIHN0b3AtY29sb3I9IiM4OWQwZmYiLz48c3RvcCBvZmZzZXQ9Ii4zOTgiIHN0b3AtY29sb3I9IiNlYmJmOWEiLz48c3RvcCBvZmZzZXQ9Ii42MDIiIHN0b3AtY29sb3I9IiNlYjgwZDMiLz48c3RvcCBvZmZzZXQ9Ii44NDEiIHN0b3AtY29sb3I9IiNhMjgxZmYiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik03Ni40IDE2NC41Yy01LjcgMC0xMS4zLS40LTE2LjEtLjhoLS41bC0uNS0uMWMtMS4xLS4yLTIuMy0uMy0zLjQtLjQtNC4yLS41LTkuNC0xLTE1LTMuN2wtLjYtLjMtLjUtLjNjLTEwLjktNi4xLTE1LTE1LjMtMTguMi0yMi43LS40LS45LS44LTEuOC0xLjItMi44LTEuMy0yLjYtMi4yLTUuMi0yLjktNy40bC0uMS0uMy0uMS0uM2MtMy4yLTExLjQtMi4xLTE4LjYgNC4xLTI3LjZsLjMtLjQuMy0uNGMuNS0uNyAxLTEuMyAxLjUtMiAxLjYtMi4xIDMuMi00LjIgNS41LTYuNy41LS41LjgtMS4zLjktMkwzMCA4NGwtLjEtLjl2LS45Yy4yLTcuNCAzLjktMTIuOSA1LjktMTUuOS4yLS4zLjUtLjcuNi0uOWwuMy0uNS4zLS40Yy40LS42IDEuMy0yLjcgMi4xLTQuNi4zLS44LjctMi40IDEuMi0zLjcuMS0uNC4xLS41LjItMS40LjMtMy4xIDEuMS02LjIgMi4xLTkuMWwuMS0uMi4xLS4yYy4zLS44LjUtMS40LjgtMi4yLjgtMi40IDItNS45IDUuMS05LjhsLjktMS4xLjktLjhjNi44LTYuMSAxNC4xLTcuMyAxOS4xLTcuNmgxLjVjNC4yIDAgOS4zIDIgMTIgMy4zLjYuMyAxLjMuNSAyIC41czEuNC0uMSAyLjEtLjNjMS43LS42IDMuMy0xLjMgNC44LTIuMSAzLjQtMiA5LTUuMiAxNi02IC40LS4xLjctLjEgMS0uMS43LS4xIDEuOC0uMiAzLjItLjQgMi40LS4yIDYtLjUgOS45LS41IDYuMyAwIDExLjUuNyAxNS43IDIuMmwuMi4xLjIuMWMxMCAzLjggMTQgOC4xIDE3LjggMTMgMS4yIDEuNiAyLjEgMi43IDMuOSA0LjNsLjQuNC40LjRjLjQuNC44LjcgMS4yIDEgMS43IDEuMyA0LjYgMy42IDcuMSA3LjhsLjQuNi4zLjdjMy43IDcuNSAyLjUgMTQuNiAxLjggMTguOHYuM2MtLjUgMi45LTEuMyA1LjctMi41IDguNGgwYy0uMy43LS41IDEuNC0uNyAyLjItLjEuNS0uMiAxLS4yIDEuNGwtLjEuNGMtLjMgMi40LS44IDQuOC0xLjYgNy4xLTEuMiAzLjctMyA3LjItNS4yIDEwLjMtMy40IDQuOC03LjMgOC4yLTEyIDEwLjQtMS4xLjUtMi4xIDEuMy0yLjggMi40LS43IDEtMS4xIDIuMy0xLjIgMy41djEuMmMuMiAzLjYuNSA3LjctLjMgMTItMS4zIDctNC4zIDExLjctNi41IDE1LjIgMCAwLTEwLjIgMTQuMi0xOS41IDE3LjFsLTEgLjMtMS4xLjJjLTEuOC4zLTMuNi41LTUuNS41aC0xLjEgMC0uOGMtLjQgMC0xIDAtMS45LjFoLS40Yy0zLjYuMS02LjkuMi03LjkuNC0uNS4xLTEgLjItMS41LjQtNC45IDIuMS0xMS44IDMuMS0yMS4zIDMuMXoiIG9wYWNpdHk9Ii44IiBmaWxsPSJub25lIiBzdHJva2U9InVybCgjcHJlZml4X19TVkdJRF8wMDAwMDA4NTkzMDQyMjQzMjgyNjQ3OTczMDAwMDAxNjE0NjE4ODY4Mjc5MzcwNzQyMl8pIiBzdHJva2Utd2lkdGg9Ii44NTgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxsaW5lYXJHcmFkaWVudCBpZD0icHJlZml4X19TVkdJRF8wMDAwMDAzODM3OTg4MTUwMjQyMDI2ODA4MDAwMDAxMTA1MjQ3ODgxODUwODkzMzU2NF8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjguNTM1IiB5MT0iNjc3Ljk2NSIgeDI9IjE1OC4wNDUiIHkyPSI4MTguMDQ4IiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTY1NikiPjxzdG9wIG9mZnNldD0iLjIwNiIgc3RvcC1jb2xvcj0iIzg5ZDBmZiIvPjxzdG9wIG9mZnNldD0iLjM5OCIgc3RvcC1jb2xvcj0iI2ViYmY5YSIvPjxzdG9wIG9mZnNldD0iLjYwMiIgc3RvcC1jb2xvcj0iI2EyODBlYiIvPjxzdG9wIG9mZnNldD0iLjg0MSIgc3RvcC1jb2xvcj0iI2EyODFmZiIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZD0iTTc2LjQgMTU2LjNjLTUuNCAwLTEwLjgtLjQtMTUuNC0uN2gtLjRjLTEuMy0uMi0yLjUtLjMtMy42LS40LTMuOS0uNC04LS45LTEyLjQtMi45bC0uMy0uMS0uMy0uMWMtOC41LTQuOC0xMS43LTExLjktMTQuNy0xOC44LS40LTEtLjktMi0xLjQtMy0xLTItMS44LTQuMi0yLjQtNi4zdi0uMmMtMi42LTkuMS0xLjktMTMuNyAyLjktMjAuN2wuMS0uMi4xLS4yYy42LS43IDEuMS0xLjQgMS42LTIgMi4zLTMgNC4zLTUuNiA4LjgtOS44aDBjLjMtLjMuNi0uNy43LTEuMi4xLS40LjEtLjktLjEtMS4zbC0uOC0yLjNjLS4yLS43LS4zLTEuNS0uMy0yLjJoMHYtMS4xYy4yLTUgMi44LTguOSA0LjUtMTEuNS4zLS40LjUtLjguNy0xLjFsLjItLjMuMi0uM2MuOS0xLjIgMi40LTQuNyAzLjItNi44LjItLjcuNy0yLjQgMS4yLTMuNy4zLTEgLjUtMiAuNi0zIC4zLTIuNS44LTUgMS43LTcuM3YtLjJjLjQtMSAuNy0xLjguOS0yLjYuNy0yLjEgMS41LTQuNSAzLjctNy4ybC40LS41LjQtLjRjNC44LTQuNCAxMC4xLTUuMiAxNC4xLTUuNUg3MS4yYzQgMCA3IDEuNiA5IDIuN2wuNS4yaC4xYy42LjMgMSAuNiAxLjUuOCAxLjIuNiAyLjcuOCA0IC40IDIuOC0uNyA3LjEtMi40IDkuOS00aC4xYzMtMS44IDcuNi00LjQgMTMtNSAuMy0uMS43LS4xIDEtLjEuNi0uMSAxLjctLjIgMi45LS4zIDIuMi0uMiA1LjYtLjUgOS4xLS41IDUuNCAwIDkuNy42IDEzIDEuN2guMmM4IDMgMTEgNi4yIDE0LjIgMTAuNCAxLjMgMS43IDIuNiAzLjMgNSA1LjRsLjIuMi4yLjJjLjYuNiAxLjMgMS4yIDIuMSAxLjggMS40IDEuMSAzLjQgMi42IDUuMSA1LjVsLjIuMy4yLjNjMi41IDUuMiAxLjcgMTAuMSAxLjEgMTMuOHYuM2MtLjQgMi4zLTEgNC41LTIgNi43LS41IDEuMi0uOSAyLjUtMS4xIDMuOC0uMS44LS4yIDEuNC0uMyAxLjlsLS4xLjRjLS4yIDEuOS0uNiAzLjctMS4yIDUuNS0uOSAyLjktMi4zIDUuNi00LjEgOC4xLTMgNC40LTYuNCA3LjEtMTAuOSA4LjUtMi4yLjctNCAyLjEtNS4yIDRsLS40LjUtLjQuNWMtMS4xIDEuMy0uOCA2LjMtLjYgOS4zLjIgMy4zLjQgNi43LS4yIDkuOS0xIDUuNS0zLjQgOS4yLTUuNSAxMi40IDAgMC03LjggMTEuMy0xNC45IDEzLjRsLS41LjItLjUuMWMtMS4zLjItMi43LjQtNC4xLjRoLTJjLS41IDAtMS4yIDAtMi40LjFoLS4yYy00LjcuMi03LjYuMy05LjIuNi0xLjEuMi0yLjEuNS0zLjEuOS00LjMgMS43LTEwLjEgMi42LTE4LjUgMi42eiIgb3BhY2l0eT0iLjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0idXJsKCNwcmVmaXhfX1NWR0lEXzAwMDAwMDM4Mzc5ODgxNTAyNDIwMjY4MDgwMDAwMDExMDUyNDc4ODE4NTA4OTMzNTY0XykiIHN0cm9rZS13aWR0aD0iLjg1OCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PC9nPjwvc3ZnPg==", zs = {
  name: "Ethereum",
  symbol: "ETH",
  image: yh,
  decimals: 18
}, Us = {
  name: "Polygon",
  symbol: "POL",
  image: ph,
  decimals: 18
}, Ps = {
  name: "Solana",
  symbol: "SOL",
  image: Mh,
  decimals: 9
}, Fs = {
  name: "Ape",
  symbol: "APE",
  image: Lh,
  decimals: 18
}, _h = /* @__PURE__ */ new Map([
  [zs.symbol, zs],
  [Us.symbol, Us],
  [Ps.symbol, Ps],
  [Fs.symbol, Fs]
]);
export {
  Fs as A,
  Ee as B,
  Ah as C,
  vh as E,
  Us as P,
  Ps as S,
  sn as T,
  uu as V,
  zs as a,
  lt as b,
  ut as c,
  ze as d,
  Ch as e,
  Ih as f,
  Ai as g,
  kh as h,
  lh as i,
  Th as j,
  Sh as k,
  Bu as l,
  hh as m,
  _h as n,
  Dh as o,
  Nh as s,
  ch as u,
  Bh as v
};
